const puzzles = [
{
    id: "b7f16edd-b1be-45ab-b0c8-3304ada5e239",
    dateId: "20250809",
    number: 1,
    puzzle: {
        letters: "PMXCWSOUAHTKQLRNEVIYJBDGF",
        words: ["BENT","DIVE","JET","MUCH","POUCH","QUALIFY","RIG","STOKE","WARY","WAX"]
    }    
},
{
    id: "75909750-ebf0-4116-8ffd-673aa5d254b8",
    dateId: "20250810",
    number: 2,
    puzzle: {
        letters: "QGNYXDULIRHEFKBVASOMWCTPJ",
        words: ["BRING","CAVE","DUG","DULY","FEAT","HELIX","JOKING","QUEST","SOB","TOMB","WASP"]
    }
},
{
    id: "8b54d0ee-39c4-4d7b-bf5d-05a806e75af1",
    dateId: "20250811",
    number: 3,
    puzzle: {
        letters: "PYVXMWANIFLQRSTKOUEHBCJGD",
        words: ["BOUGHT", "CORNY","COURSE","JOURNAL","MINX","PARQUET","RAY","SIFT","VARNISHED","WALK"]
    }
},
{
    id: "8b54d0ee-39c4-4d7b-bf5d-05a806e75af1",
    dateId: "20250812",
    number: 4,
    puzzle: {
        letters: "HMXIVWOSCDBRTEFPAQULJKNGY",
        words: ["BANQUET","BOX","HORSEFLY","JANGLE","MOST","PRANK","SIDE","TORQUE","VICTOR","WRAP"]
    }
},
{
    id: "7c3643aa-67d0-4a8c-88aa-514a938ad385",
    dateId: "20250813",
    number: 5,
    puzzle: {
        letters: "YHMDFKEWAPLRVSGCUOINQBTXJ", //HD KEWAP RS CUOIN BX
        words: ["BULKY","CREW","DAME","FAVOUR","JIGSAW","QUOIT","SPAM","SWERVING","TOXIN","WHELK"]
    }
},
{
    id: "a80cd9fe-d5ec-4814-8e78-5d28b80d7dd2",
    dateId: "20250814",
    number: 6,
    puzzle: {
        letters: "BTSQJVOCUKGARIXWMLYDNFPEH",
        words: ["BOAR","BOG","AMPED","CURL","FLY","HELIX","JUST","KID","LAWN","SQUID","VALEDICTORY"]
    }
},
{
    id: "a80cd9fe-d5ec-4814-8e78-5d28b80d7dd2",
    dateId: "20250815",
    number: 7,
    puzzle: {
        letters: "GNBWMXDIUCREVLQPSYKOAJHTF",
        words: ["APEX","ASYLUM","BULKY","CUB","JASPER","LOFTY","QUIVER","SHY","WIDES","WING"]
    }
},
{
    id: "6978b404-3e36-414e-8168-1ad1970d5c81",
    dateId: "20250816",
    number: 8,
    puzzle: {
        letters: "NDKFPETGRYMXOUQVIHCJBWALS",
        words: ["BIOG","CORK","FROG","GUY","JUG","JURY","MIXED","OXEN","PROCLAIMED","QUOTE","SCHWA","VIALS"]
    }
},
{
    id: "ea80f35d-49d7-4aa7-8104-0c3468550bb0",
    dateId: "20250817",
    number: 9,
    puzzle: {
        letters: "PYVXMWANIFLQRSTKOUEHBCJGD",
        words: ["JOCK", "PARQUET", "MINARET", "IVY", "WAY", "SIFTED", "BOUGHT", "MINX", "LORE"]
    }
},
{
    id: "c8287dcf-dff8-44e0-80ff-c9550f82cea6",
    dateId: "20250818",
    number: 10,
    puzzle: {
        letters: "CLISDPEVNKMOTUQRXWAFGBHJY",
        words: ["QUAY", "SINK", "CLINK", "JAY", "VILE", "FUND", "TEMPO", "MEOW", "ORB", "POX", "WHAT", "GROW"]
    }
},
{
	id: "e494cfee-02c9-443c-830b-9c6b56a8e292",
	dateId: "20250819",
    number: 11,
	puzzle: {
		letters: "VDHYMEXWRKCTIOQAJLNUBFSGP",
		words: ["VEX", "ACTINGS", "JILTED", "FLOW", "WHY", "IRK", "PUN", "QUOINS", "NORM", "BATING"]
	}
},
{
	id: "92c75047-2f79-4bc6-be66-ba8176b2cde3",
	dateId: "20250820",
    number: 12,
	puzzle: {
		letters: "JRYIXOWMPVHSLDBGTENAQUFCK",
		words: ["LEFTS", "VIMS", "MIX", "SETH", "IMP", "WORMS", "BANE", "TUG", "HOSED", "WORMY", "DANK", "QUEST", "JOSTLED", "CAB"]
	}
},
{
	id: "54408847-b5c6-4b0d-98f6-b5f7f616ce39",
	dateId: "20250821",
    number: 13,
	puzzle: {
		letters: "HIGDXMRWOKBEPFVLUJATCNQYS",
		words: ["BUN", "OPAQUE", "POX", "FAST", "WOK", "VAST", "DOWEL", "BRIG", "CUE", "REM", "HIM", "JAY"]
	}
},
{
	id: "9885c715-c3ca-49ae-82b6-a16c22d46c80",
	dateId: "20250822",
    number: 14,
	puzzle: {
		letters: "QUIOXKNPYLHAFJVTRDEBGSMCW",
		words: ["BEVY", "CEDARS", "QUIP", "DRANK", "LOP", "INFRA", "HARM", "JEW", "TRADE", "POX", "GRADE"]
	}
},
{
	id: "9c14997f-70e5-443d-a651-3df8a80a9eea",
	dateId: "20250823",
    number: 15,
	puzzle: {
		letters: "XESGLHCRABTDVNMYFUIPJOKQW",
		words: ["BAN", "HEX", "OFT", "LARCHES", "KINA", "JOY", "DRAM", "WIN", "YOU", "QUIP", "VASE", "MAG"]
	}
},
{
	id: "6cd37cc7-dab8-4996-b18e-f5ebbdc908bc",
	dateId: "20250824",
    number: 16,
	puzzle: {
		letters: "PLJDOBEWXFSTVHMIQGYCUKANR",
		words: ["CRY", "LEVY", "FOX", "YAK", "QUITS", "GYM", "LEWD", "WHY", "JEW", "PLEBS", "ANY"]
	}
},
{
	id: "d8670d56-fcf0-47e6-ad5c-af09805e7ac6",
	dateId: "20250825",
    number: 17,
	puzzle: {
		letters: "YTVFICNREBDHMKQPOGSUJXWAL",
		words: ["LAGS", "DOGS", "TREKS", "REV", "POX", "BIER", "RHO", "EQUAL", "FERNY", "LAW", "SMOG", "CHOW", "JOGS"]
	}
},
{
	id: "a0127c93-4aea-4b0f-87ea-eeb532597531",
	dateId: "20250826",
    number: 18,
	puzzle: {
		letters: "CSBAJKOXMLQNGYDFUTVIREWHP",
		words: ["CONQUER", "IDLY", "CONK", "BOXY", "JAMB", "RUTH", "REF", "GYM", "DIP", "IVY", "FEW", "KNOBS"]
	}
},
{
	id: "c15e99e3-5ce8-4911-b562-1aab6db9e748",
	dateId: "20250827",
	puzzle: {
		letters: "HTSWQJIAUGPMVYFKCBEXNODLR",
		words: ["AMBLER", "FUG", "VISTA", "QUAY", "OBEY", "YAWS", "NOBLE", "IMP", "DOCK", "JIVED", "PITH", "CODEX"]
	}
},
{
	id: "cae46dc3-f4c0-41d3-9fb6-9a056ab1dbca",
	dateId: "20250828",
	puzzle: {
		letters: "TOJDBSVCUQXMAPRLINYGEFKHW",
		words: ["WHY", "BUD", "MILE", "JOTS", "QUAY", "MINK", "CUB", "CAP", "FIX", "BURG", "VAN"]
	}
},
{
	id: "0733ec74-cf8b-4090-ad67-1ca0e9f1fb83",
	dateId: "20250829",
	puzzle: {
		letters: "QRNKSIUBCVTPDEXGALHWMYJFO",
		words: ["QUIT", "FLY", "DECK", "VELD", "JADE", "DAM", "URN", "PUB", "HELD", "OWED", "DEBUNKS", "FLAG", "VEX"]
	}
},
{
	id: "e2be7763-ba53-4693-8a54-6e676e34c691",
	dateId: "20250830",
	puzzle: {
		letters: "REPSMVGWBOJKYCHNITFAXLUQD",
		words: ["PEG", "LIT", "CAD", "MOBS", "REV", "HAD", "INKY", "QUILT", "PEWS", "JINX", "FACT"]
	}
},
{
	id: "8e2c6a60-edf2-46c4-aa4d-b32f53f951b3",
	dateId: "20250831",
	puzzle: {
		letters: "QRVYBKUNAPWECDFSHXIGMOJLT",
		words: ["GILT", "BAP", "DANCE", "SOH", "RUE", "JILT", "PAY", "OHM", "EXIT", "QUENCH", "WHO", "KEN", "FIXES", "CURVY"]
	}
},
{
	id: "63a272e2-6c96-4a8a-aea7-ec97b34de16e",
	dateId: "20290901",
	puzzle: {
		letters: "QUGCFRYATESHXJNBOWLKVPMID",
		words: ["CENTAURS", "MILD", "SHAG", "BOXY", "JAG", "MILK", "FEN", "HOWL", "HOP", "QUA", "VOW"]
	}
},
{
	id: "00814cf9-0a24-4a7f-bf04-96c8547c168b",
	dateId: "20250902",
	puzzle: {
		letters: "QUPAXWOTKMBVRLCFIENYHJSDG",
		words: ["JERK", "FIRE", "VIE", "POT", "LEND", "CLERK", "QUOTA", "SIR", "WOVE", "TAX", "ELM", "HIRE", "BORED", "APTLY", "EDGY"]
	}
},
{
	id: "cb4e8a2b-eaef-4d39-bef9-d30680cf9cff",
	dateId: "20250903",
	puzzle: {
		letters: "LISTWFDPVRNHGEKQAJOCUBXYM",
		words: ["FLIPS", "IDS", "GECKO", "QUA", "LIST", "HAG", "JAB", "MOCKER", "COX", "VEGAN", "YOKE", "WRECK"]
	}
},
{
	id: "aab30c34-696d-468b-b441-42447b8ed409",
	dateId: "20250904",
	puzzle: {
		letters: "JKWBPDIFMRCHGTONLXSYQUEAV",
		words: ["MOST", "KID", "PROSE", "TOMB", "QUEST", "QUEASY", "GIFTS", "HID", "EXT", "WIGS", "JIGS", "VAST", "LEAST", "CLUES", "UNCLES"]
	}
},
{
	id: "c9676918-a961-4be9-bf82-8187f5f54e30",
	dateId: "20250905",
	puzzle: {
		letters: "OWITPGNYRFMSVLHQUEABDCJKX",
		words: ["WIT", "GOWNS", "CUE", "PRYINGS", "SELF", "BAKE", "BAH", "HAVES", "JAB", "SQUEAL", "FLAX", "MUD"]
	}
},
{
	id: "b8063d54-46aa-4919-bbaf-7b5906e55ead",
	dateId: "20250906",
	puzzle: {
		letters: "FBCSGRDWOKAELVXYMJITNPQUH",
		words: ["BREWS", "SCOWLED", "FREYA", "GOLD", "JUT", "QUIT", "HIT", "OLM", "COX", "WOKS", "RAMP", "DAMN", "VOWS"]
	}
},
{
	id: "b0d21df3-60bf-4f02-8c51-e26f9773ffd9",
	dateId: "20250907",
	puzzle: {
		letters: "SLVOPMQUIWKCHABTENRYGJXDF",
		words: ["JET", "FRANCE", "HAULMS", "YAW", "KEN", "AND", "VIA", "POUCH", "XRAY", "GET", "QUIP", "BRA"]
	}
},
{
	id: "545d43fc-da7e-484e-9f48-659eecbe1bc8",
	dateId: "20250908",
	puzzle: {
		letters: "YONCGWXVKEFLAMDRUQIHBJTSP",
		words: ["RUB", "NOW", "SIT", "GEM", "JUTS", "QUAKE", "FLAKE", "AVOW", "HIS", "MAID", "YON", "ONCE", "SHIP", "FLAX"]
	}
},
{
	id: "b3663413-d714-4409-86d2-b132524b29fc",
	dateId: "20250909",
	puzzle: {
		letters: "OYCXTLGISPUAVMDRQKEHNBJWF",
		words: ["URN", "LOGICS", "QUAKE", "AIMED", "JEW", "HEMP", "MIST", "VIMS", "BRAVE", "MIX", "FEW", "UGLY"]
	}
},
{
	id: "4b2d3eb9-a744-4f95-8794-ab6e27bc54fb",
	dateId: "20250910",
	puzzle: {
		letters: "FJYISBOURHTDMQKWVGLAPENXC",
		words: ["JURY", "MUD", "QUIRK", "LAX", "DOT", "VEG", "PEW", "FOB", "BOYISH", "GEN", "CALM"]
	}
},
{
	id: "a036347c-aefb-491f-adac-b644766dd4fb",
	dateId: "20250911",
	puzzle: {
		letters: "FGSLYIDURTMQHAPWKCVBNEJOX",
		words: ["TRY", "ACE", "BAUD", "KNEW", "CAP", "RUG", "FIGS", "DIM", "QUACK", "JOB", "COX", "HAT", "OVA", "VAULT"]
	}
},
{
	id: "add3b1e8-599a-43c8-bd62-6c60bdadb93e",
	dateId: "20250912",
	puzzle: {
		letters: "NHSQXEBKUAVIMCLJRPWDFYTOG",
		words: ["SHE", "JIVE", "QUA", "LUMPY", "DOG", "TRIPOD", "MUSK", "LUCK", "BEN", "FRY", "LUX", "OWL"]
	}
},
{
	id: "3153f431-9454-4727-8843-e476bba51aac",
	dateId: "20250913",
	puzzle: {
		letters: "GMLNJOBQEHFXUSIWYKTDCRVAP",
		words: ["BUSK", "IDS", "QUEST", "APT", "BOXY", "FOG", "BUSH", "HELM", "CRY", "JEST", "NEST", "WRY", "VATS"]
	}
},
{
	id: "74be03cd-af96-4a86-b577-674b68755893",
	dateId: "20250914",
	puzzle: {
		letters: "MTIRPEGCFSQULYJKNBXODVAWH",
		words: ["WAXY", "JOY", "WHO", "IFS", "AND", "SPRIG", "CLUB", "VAN", "CITE", "GEM", "GUNK", "BANQUET"]
	}
},
{
	id: "942397e1-55e8-4a28-90fa-a3effbd6604e",
	dateId: "20250915",
	puzzle: {
		letters: "NYHJXAUTEBKQWFVSLORCPMIDG",
		words: ["FOLKS", "VEX", "JET", "RIMS", "HEW", "AUK", "NAY", "QUAY", "CRIM", "GROWL", "WEB", "IMP", "MOD"]
	}
},
{
	id: "f98f59d6-1cf6-4e19-9dd9-ae5d59fa755b",
	dateId: "20250916",
	puzzle: {
		letters: "INTAQDVRUMPYWKGBOLXHFJCES",
		words: ["POLE", "COB", "TURK", "JOY", "SEC", "QUARK", "GUT", "FOB", "DIN", "MUG", "HEX", "IVY", "WRY"]
	}
},
{
	id: "24261439-817c-4285-b661-747616be97b8",
	dateId: "20250917",
	puzzle: {
		letters: "YEJICKXTFUARVHQWBODPGNMLS",
		words: ["HOLDS", "JET", "VORTEX", "CITRON", "EXTRA", "BARKY", "FIT", "OLM", "QUIT", "WRONG", "PLOD"]
	}
},
{
	id: "019bc83c-539c-48c0-9054-ec80204adc3c",
	dateId: "20251019",
	puzzle: {
		letters: "AJTHIQUCDRSVWXBPENYGFKMOL",
		words: ["THIRD", "FEW", "QUA", "SEW", "CUSP", "KNEW", "BYGONES", "MEW", "LONE", "ONYX", "JUT", "VENOM"]
	}
},
{
	id: "d523c006-d13d-4f45-b670-39c86936100c",
	dateId: "20251020",
	puzzle: {
		letters: "DGVIMSEUQYFTWRABNXHLJOPKC",
		words: ["RUTS", "CHALK", "JOB", "VIM", "BOP", "TEDS", "RUGS", "WRY", "QUEST", "SEWN", "FEST", "POX"]
	}
},
{
	id: "cfeafabe-7f1b-4c66-8129-e4f7ee7f4ddc",
	dateId: "20251021",
	puzzle: {
		letters: "BODSIFHNVXGMACKJUTYWRQLEP",
		words: ["JUT", "VAULT", "QUAY", "TYPE", "TUG", "WELT", "RUG", "BONDS", "OHM", "SIX", "HACK", "FOB"]
	}
},
{
	id: "d6b9cfd8-eebe-4f97-ab2d-3ab88ec4c3eb",
	dateId: "20251022",
	puzzle: {
		letters: "PVKNAMRECWBJOLGIQDTYUFSXH",
		words: ["PRODS", "FIBRE", "JOLTS", "WANE", "STYLE", "VELDT", "STYX", "SQUIB", "DOCKER", "GLEN", "STORM", "BROTH"]
	}
},
{
	id: "c8864621-babc-4a74-ac59-b3d2975bf1c8",
	dateId: "20251023",
	puzzle: {
		letters: "GYIVPWMTURKEDBQCHSLANOFXJ",
		words: ["SHOCKED", "MITES", "FLABS", "PRUDE", "MESON", "VIM", "CHEWY", "JABS", "FLAX", "GYM", "QUITE"]
	}
},
{
	id: "6124c02d-0c68-47db-abaf-95afa51e6d76",
	dateId: "20251024",
	puzzle: {
		letters: "BHJARLMPGNDEVWKYCTIXOQUSF",
		words: ["DECOY", "SUITED", "JAPE", "FIVE", "KITE", "ITEM", "QUITE", "BLED", "GRAPH", "WITS", "FIX", "NAPE"]
	}
},
{
	id: "25d1720a-3742-4a09-85ff-f19768f7d444",
	dateId: "20251025",
	puzzle: {
		letters: "JEXSLTOPABVGIFHRMNUQWYDCK",
		words: ["QUIPS", "DUCK", "TEXAS", "HUNGRY", "MIND", "VOTE", "WRY", "JOIN", "FUNGI", "OPALS", "BLAH"]
	}
},
{
	id: "3f6d96c9-3869-4db0-903f-b0c53337b0ee",
	dateId: "20251026",
	puzzle: {
		letters: "APECQTKBUJWRIDGVOYNSHMLFX",
		words: ["MORBID", "FLORINS", "TAKINGS", "FLYING", "INDUCE", "LYNX", "VOIDS", "QUIDS", "WORKINGS", "HOLY", "PATROL", "JUGS"]
	}
},
{
	id: "edf0f685-c4da-4a83-be56-40088d8d5da5",
	dateId: "20251027",
	puzzle: {
		letters: "IHDFKNROCJGVTAYBUEPLQSXWM",
		words: ["SQUEAL", "DROVES", "LACY", "WEAL", "TUBS", "DOCK", "GROVES", "CALM", "GRIN", "HOCK", "FOCAL", "CORTEX", "JAPES"]
	}
},
{
	id: "fb994740-a1dc-4f98-869d-16a97a4bc0f5",
	dateId: "20251028",
	puzzle: {
		letters: "XKVOBNEFTCIPDLHUMSYAQJRWG",
		words: ["JUMPED", "DEFTLY", "ALCOVE", "AWRY", "QUIPS", "BOTCH", "FLAG", "PINKED", "MINX"]
	}
},
{
	id: "2c92c3d0-d68f-46f3-bd57-cd53bf13f897",
	dateId: "20251029",
	puzzle: {
		letters: "HPFNGXUATMYEQLSVDROWIBJCK",
		words: ["EQUALS", "KOREAN", "COLTS", "DEAF", "BROWS", "WORDY", "PALMS", "VEX", "JOLTS", "GNATS", "IDEALS", "HUE"]
	}
},
{
	id: "5e2a827e-a2b2-49be-94ef-58a2417cece0",
	dateId: "20251030",
	puzzle: {
		letters: "XBSJQOTAUGDLMNERYIPWVKFHC",
		words: ["STAMPING", "QUALIFY", "KILTS", "DOLING", "JUMPING", "WHINE", "BOX", "CHILD", "VYING", "DRYING"]
	}
},
{
	id: "1cea4d02-fadc-44ae-b1c1-c1ef69ba5673",
	dateId: "20251031",
	puzzle: {
		letters: "GOCQHBXSUMRKIPNJALDWYVFET",
		words: ["SUNDIAL", "COBRA", "BOG", "UNWED", "LARKS", "TEDIUM", "HUMPS", "DISPLAY", "QUIPS", "OXIDE", "JAILED", "VALET", "FAILED"]
	}
},
{
	id: "be60493c-3eff-4191-a79a-393a5a4ba2c9",
	dateId: "20251101",
	puzzle: {
		letters: "CNVXRPEBUFDSQALJKGHMIOYWT",
		words: ["NEBULA", "FLUX", "PESKY", "JOGS", "RUBS", "SPEC", "HAGS", "THY", "MAUVE", "WHAM", "EQUAL", "SKI", "BEDS"]
	}
},
{
	id: "e15d0986-526f-43c3-b192-116a94ed33b2",
	dateId: "20251102",
	puzzle: {
		letters: "HIMQBJKTSUCEXOVFANLWGDPRY",
		words: ["PACKETS", "QUOTE", "VOTE", "FACETS", "STEAD", "BUST", "HIKE", "GAD", "EXTOL", "STOW", "TEXAN", "SMITE", "ONLY", "JETS", "PRY"]
	}
},
{
	id: "58903f38-ade6-40ae-a72a-5025c1df1d51",
	dateId: "20251103",
	puzzle: {
		letters: "VCQGDSIMUEXATJYONHLRBFKWP",
		words: ["ANTIQUE", "LYE", "WHAM", "BOAS", "SAXON", "ANTICS", "JUDGE", "PRY", "THANK", "VISA", "FOAM"]
	}
},
{
	id: "34c87059-21e6-4706-97f9-74159527feed",
	dateId: "20251104",
	puzzle: {
		letters: "CVDTHYOLGSKFREBPXNAUJIWQM",
		words: ["PINES", "LODGES", "JINX", "BAREST", "INQUEST", "WINES", "VOLES", "KOREAN", "CORNEA", "FLESH", "GLEAM", "YORE"]
	}
},
{
	id: "6869ee49-0d71-48cc-af6b-86aa66b97ff3",
	dateId: "20251105",
	puzzle: {
		letters: "WOLYIKNCGVDSBXHUQRAFJETMP",
		words: ["PARQUET", "CLOWNS", "ABSCOND", "IVY", "MARQUE", "MARX", "HATERS", "JET", "CONK", "FARE", "GLOW"]
	}
},
{
	id: "2470db31-e486-42e7-95b1-bfd20109adf6",
	dateId: "20251106",
	puzzle: {
		letters: "LHPBMTIUGYXCKQNFEJAWOSVDR",
		words: ["LIKES", "RAVES", "EXIT", "BUILT", "HIKES", "WAKES", "PIKES", "MYNA", "DRAKES", "FOES", "GUILT", "QUICK", "JAR"]
	}
},
{
	id: "98151751-9e1d-48e2-83f6-ba5591520521",
	dateId: "20251107",
	puzzle: {
		letters: "HKSPBOTQUVENCAYJIXRLMFDGW",
		words: ["DINTS", "JINX", "GRAVY", "HONE", "BUSK", "LARD", "MINTS", "WRY", "QUAY", "FICUS", "CUPS"]
	}
},
{
	id: "710901ce-4f76-43b4-b3f8-3433347be783",
	dateId: "20251108",
	puzzle: {
		letters: "PALHSTIUNKVQJOBEMRCXDFWYG",
		words: ["JIVED", "BOXY", "HUNKS", "UNLIT", "ALIVE", "CONK", "GYRO", "LIQUOR", "NORMED", "WRY", "FED", "EQUIP"]
	}
},
{
	id: "de4d49ee-cc6e-440a-ab49-47151c995f05",
	dateId: "20251109",
	puzzle: {
		letters: "QATLYURSMPKNGFHIDWOCVEJXB",
		words: ["LYMPH", "QUARTS", "COWED", "JOGS", "DINGO", "FOGS", "BOWED", "KINGS", "BOX", "VEINS"]
	}
},
{
	id: "6c6445ba-7ee9-4f67-9e18-5edc0acaf190",
	dateId: "20251110",
	puzzle: {
		letters: "WDGCYQENALUBTKMPOFRSJVIXH",
		words: ["JOB", "FIRMLY", "SHRIFT", "POTENCY", "CLANGED", "VOTED", "ANEW", "QUOTED", "SKATED", "MATRIX"]
	}
},
{
	id: "da3e4b03-7e7c-4942-b1de-5071574afc04",
	dateId: "20251111",
	puzzle: {
		letters: "MRAVHFJSWIGOXKNCUTELYQBPD",
		words: ["SWARM", "QUOTED", "CUBED", "RAVINE", "WINKLED", "JARS", "DEBUG", "BUY", "WHINED", "INEPT", "FOXED"]
	}
},
{
	id: "f4d408d8-a4b9-4855-ab97-44cbe72cd2de",
	dateId: "20251112",
	puzzle: {
		letters: "TQWYLDAUHFNSMXRKCIOJEPBGV",
		words: ["QUASI", "GOBI", "JOB", "FLY", "ROMANCE", "TANKS", "WANDS", "EPICS", "VOICE", "XMAS", "HUMANS"]
	}
},
{
	id: "b3ce1f01-921b-48af-b02d-f85e7641ec52",
	dateId: "20251113",
	puzzle: {
		letters: "SXBRYPVALCIKFJNUHTOMDQGWE",
		words: ["JARL", "ABLY", "MEOW", "VARY", "ONLY", "GOTH", "THUD", "CRAFT", "FLAK", "QUIPS", "FLAX"]
	}
},
{
	id: "6c899b38-250c-414b-9908-3f8617172ee9",
	dateId: "20251114",
	puzzle: {
		letters: "VWBSGDOCLMTJEKIARXUHNYFQP",
		words: ["VOW", "GLIM", "BOTANY", "SMILER", "DOCKER", "HIKER", "FUELS", "QUERN", "XRAY", "JOBS", "PUKE"]
	}
},
{
	id: "3ed06ceb-9aad-4122-8f90-d408994d337c",
	dateId: "20251115",
	puzzle: {
		letters: "LFYSNXEDUQGCPAJTIKWRHVMBO",
		words: ["AKIMBO", "NUDE", "DEPICT", "APEX", "FEDUP", "THICK", "JADE", "FLECK", "DEFY", "VICE", "SQUAWK", "GEL", "CEDAR"]
	}
},
{
	id: "1c00f9a6-38b9-4fda-99b9-1d39fe932069",
	dateId: "20251116",
	puzzle: {
		letters: "NJTBMGILEFSUXYVQADORPHCKW",
		words: ["BELTINGS", "CHASING", "JIGS", "PAUSING", "FELT", "COVETING", "EXULTING", "DOWRY", "MELTING", "QUACK"]
	}
},
{
	id: "104c9555-a2c3-4631-8473-9072fb6a07bd",
	dateId: "20251117",
	puzzle: {
		letters: "OQBJSKAULMRVXTIGENYHDPFCW",
		words: ["GRAVEN", "OAK", "SMITHY", "DEFY", "WHIMS", "CHIT", "QUAVER", "EXULT", "JUT", "BARGED", "PENT"]
	}
},
{
	id: "eb6014c8-1047-4376-9999-9f5224be4838",
	dateId: "20251118",
	puzzle: {
		letters: "QGHTCLUJOFNEYMIRKSXBPWVAD",
		words: ["GLUES", "JUNKER", "HUNKS", "BASER", "FOYER", "VASE", "PREYS", "AXIOMS", "MOTH", "BAD", "WREN", "QUERN", "COMB"]
	}
},
{
	id: "06be825a-f48f-4a61-8492-234c30462893",
	dateId: "20251119",
	puzzle: {
		letters: "BPVJDWOUNALQGIMFHTKRYEXSC",
		words: ["GUNITE", "CRIM", "THEY", "BOWL", "VOW", "EXT", "BOUND", "UNJAM", "RIGHTS", "FLOG", "POUND", "QUIRKS"]
	}
},
{
	id: "08391aa2-1e83-425c-8606-a588f933682f",
	dateId: "20251120",
	puzzle: {
		letters: "YQSDPUBVTIHALMFJECNRGXWKO",
		words: ["HALTS", "FITS", "QUACK", "PITS", "HEWN", "ABY", "JABS", "GECKO", "MIDST", "VALE", "NORM", "HEX"]
	}
},
{
	id: "f35fd34f-43bc-48b6-a174-14b4b9a196ad",
	dateId: "20251121",
	puzzle: {
		letters: "CYXJQSNOUBPITMEDWAVHFRGLK",
		words: ["RATIONS", "GAWPIN", "FRAME", "BUXOM", "GRAVE", "JOINS", "TALK", "OUTWARD", "HEM", "DISC", "QUOINS", "GRAINY"]
	}
},
{
	id: "6fb7289f-5432-474f-8df6-757d27fb964d",
	dateId: "20251122",
	puzzle: {
		letters: "PJQFYVEUXBDNWACGOTSMHKRLI",
		words: ["EQUATOR", "WAXY", "BASIL", "RODENTS", "VENDORS", "FUND", "HONED", "PENT", "JUNTAS", "STORK", "MATRON", "CASTOR", "GOWNED"]
	}
},
{
	id: "d45303e6-48b8-4af4-a611-625e828997a4",
	dateId: "20251123",
	puzzle: {
		letters: "OPLSTQUEFICNGJXDWAHKYVRMB",
		words: ["CUES", "ENGULFS", "QUEST", "ITSELF", "FIX", "VAGUEST", "JAMB", "WAGES", "HANDY", "POUND", "RANGES", "KHAN"]
	}
},
{
	id: "674987fa-b377-4bb9-959e-98f6e93f265c",
	dateId: "20251124",
	puzzle: {
		letters: "QDMGNIUCVAXRSTLHWBEYOKPJF",
		words: ["HOW", "CRUSTAL", "FESTAL", "WOK", "CRUX", "BELTS", "MUSTANG", "JEST", "CRUSTY", "VALETS", "DUCTS", "PELTS", "QUID"]
	}
},
{
	id: "e4db3f58-3461-40d9-b89f-51408725231d",
	dateId: "20251125",
	puzzle: {
		letters: "MOQRJDBUEVHASPGCIKTYWFLNX",
		words: ["CHASER", "EGYPT", "DOUSE", "KAISER", "KILN", "FIST", "MOUSE", "VEST", "QUAIL", "JEST", "WILTS", "ABUSER", "STYX"]
	}
},
{
	id: "02ae4641-dec4-40ea-bf1b-418b0bfa6337",
	dateId: "20251126",
	puzzle: {
		letters: "BIRYWKNMSOPLTVDACQEGHUXJF",
		words: ["QUALMS", "WODGE", "BIN", "JETS", "CHALK", "PALMY", "VEX", "FETCH", "RIMS"]
	}
},
{
	id: "6a7717b1-fe99-420f-8dbb-7e077fd187bf",
	dateId: "20251127",
	puzzle: {
		letters: "WLQIKEBUGCJSRDYMOHANPFTVX",
		words: ["ROSEBUD", "QUICK", "MORSEL", "THORAX", "ATOP", "SHANDY", "JOT", "BLEW", "VAN", "FORAY", "GRAND"]
	}
},
{
	id: "8648c29c-65c9-43c3-a1ea-3d0973e34e6b",
	dateId: "20251128",
	puzzle: {
		letters: "ORBTLMNUIWPYFQJGDSKHVAXEC",
		words: ["WILT", "HECK", "ORBIT", "GAD", "QUILT", "AXES", "UNFIT", "VASE", "JILT", "ROMP", "BUYS"]
	}
},
{
	id: "f43ca9ac-a286-43bb-a06f-1fbc4c20a9ea",
	dateId: "20251129",
	puzzle: {
		letters: "DMHACVIORWFNEGLQUKSYJPBXT",
		words: ["INQUEST", "BUNKER", "STYX", "CRONIES", "FINEST", "SENORA", "NEGROID", "PUNIEST", "CRAWLS", "VINES", "JUNIOR", "HOMIEST"]
	}
},
{
	id: "d35c5e35-c126-45bf-964d-da557b05604a",
	dateId: "20251130",
	puzzle: {
		letters: "LXIWKQUDFNHSGTOJYVEBPARCM",
		words: ["FIDGET", "WIDGEON", "GUSH", "CRAVE", "KNOB", "PYRE", "GEM", "QUIDS", "JAYS", "DUX", "LUGS"]
	}
},
{
	id: "fcdcb497-9459-4f32-963b-0c49e88af567",
	dateId: "20251201",
	puzzle: {
		letters: "MJQFYIVULTBKAPWEDXRSNHGCO",
		words: ["BIKE", "FLAKED", "HEN", "QUAKED", "FLAX", "RAKED", "CORAL", "WRAPS", "MIKE", "VAULT", "JULY", "GRADE"]
	}
},
{
	id: "8996d8f5-8c1d-417b-bba2-3ff989d5acb8",
	dateId: "20251202",
	puzzle: {
		letters: "FHPJOYATWDKBSXLUMGENQIRCV",
		words: ["FAST", "DOWSER", "VELD", "BASER", "NEST", "JOWL", "MIRES", "QUIRE", "GERMS", "NEXT", "PHASE", "STAY", "CREST", "YAK"]
	}
},
{
	id: "38982af5-bf86-4543-97b3-1de6460ab1d6",
	dateId: "20251203",
	puzzle: {
		letters: "KJFDTMCAIWNRLOVPYESQBGXUH",
		words: ["JAILER", "QUERN", "SLACK", "SEXY", "RADIOS", "WILES", "PYRES", "BYES", "FALSER", "RELIT", "CLEG", "HUES", "VIALS", "FARM"]
	}
},
{
	id: "9fbc7e7f-2ab8-49a7-b3de-a9b3287eca48",
	dateId: "20251204",
	puzzle: {
		letters: "WFOYBCISMTVEKADXHRJUPLNGQ",
		words: ["QUARKS", "QUAKES", "SOMA", "SOY", "HEX", "JARL", "FIVER", "WISER", "DARES", "DARN", "JAMB", "VICES", "GRAMS", "PHRASE", "TAKER"]
	}
},
{
	id: "f1eabe08-e830-4615-a841-74195d303c6e",
	dateId: "20251205",
	puzzle: {
		letters: "TBJHCIQNOYUAWDSFLVXEKGMRP",
		words: ["QUIT", "FAWN", "ANODES", "CHOSE", "GLANDS", "BIT", "CODEX", "VAN", "LANDER", "JOHN", "YONDER", "PERM", "WALK"]
	}
},
{
	id: "fdbb00f7-19a5-4b02-9450-3c00fac58f45",
	dateId: "20251206",
	puzzle: {
		letters: "MQKICVAULPTHBYRXSGODEJWFN",
		words: ["FOBS", "SHAKILY", "JEST", "PROWS", "QUIP", "VATS", "CLUBS", "BOGS", "DROWSE", "EXT", "NOBLY", "MATHS"]
	}
},
{
	id: "5934ed87-7a49-49eb-bff0-feb6c1de4f8e",
	dateId: "20251207",
	puzzle: {
		letters: "KYPCBSMVFLAEDITWUJNOXHQGR",
		words: ["DUX", "FIVES", "CLING", "QUEASY", "SEAMY", "AUDITOR", "DESK", "BLIND", "HUES", "SAWED", "AMP", "JINGO"]
	}
},
{
	id: "7e32a43f-356a-47f4-ac22-3e1af163dcfd",
	dateId: "20251208",
	puzzle: {
		letters: "VQUPHTALGIDKMNWCSBFRYEJOX",
		words: ["DAUPHIN", "TALKS", "VAT", "OBEYS", "QUALMS", "FOBS", "ROBES", "BECKS", "WING", "JOBS", "BOX"]
	}
},
{
	id: "a3078e66-b4c6-4cea-8128-ec0b5ce4bc53",
	dateId: "20251209",
	puzzle: {
		letters: "GDHOCSLIMFKNRXPUBAEYJQVWT",
		words: ["GLIM", "PEARLS", "MINARET", "JUNKS", "VERMIN", "YEARNS", "WARNS", "DINAR", "TEXANS", "COINS", "HIRE", "IRAQ", "BRINKS", "FOILS"]
	}
},
{
	id: "12ea67e6-abb5-4749-951c-9897fcad7789",
	dateId: "20251210",
	puzzle: {
		letters: "NFPYGQUKOHMIXJLAVTECWSRDB",
		words: ["HYPOXIA", "MIXUP", "WASTREL", "BETS", "QUITE", "FUN", "CLOG", "KITE", "CERVIX", "JETSAM", "MASTED"]
	}
},
{
	id: "fc9e1d12-d788-4099-89dd-4a8280eefb17",
	dateId: "20251211",
	puzzle: {
		letters: "FQXYLRIUWATSMCDNOKPEJVGBH",
		words: ["BECKONS", "TRIUMPHED", "QUITS", "FIX", "DECAY", "JOTS", "WADE", "VOMITS", "LACED", "SMOG"]
	}
},
{
	id: "0f26aee4-3812-4a58-9c6b-de7764d69cd6",
	dateId: "20251212",
	puzzle: {
		letters: "VKQYJGEUITXDHRSCAWOPBLNMF",
		words: ["SPORTY", "CADGE", "EQUITY", "JIHAD", "BLADE", "VEG", "PRISON", "DUKE", "WAXED", "ROMPS", "FORTS"]
	}
},
{
	id: "a8f2436d-82e6-449d-b566-a3e78130953e",
	dateId: "20251213",
	puzzle: {
		letters: "CAYGDPUQTERKSNHJFBIXLOWMV",
		words: ["VINE", "MINTED", "FLOW", "RUSTED", "CAP", "HINTED", "QUAY", "GENTS", "AUKS", "BINS", "MINX", "JOBS"]
	}
},
{
	id: "274d7499-5250-44ef-9c78-a9fdc7b03fc7",
	dateId: "20251214",
	puzzle: {
		letters: "VWMHQJOIUBGNFTPDRECSAXKLY",
		words: ["PUTS", "QUITE", "MONGRELS", "CYSTINE", "DARKEN", "HIND", "REFUTING", "VOWING", "JOINER", "AXE", "BUTS"]
	}
},
{
	id: "97206aed-a856-4e4a-8094-6a8500957ffe",
	dateId: "20251215",
	puzzle: {
		letters: "GKILBDNTFQJMYUCEOSAPXVHWR",
		words: ["SHOVE", "JOYS", "FLINTY", "PRAYS", "QUASH", "BLIND", "FLING", "WASH", "VEX", "HOME", "CARP", "BLINK"]
	}
},
{
	id: "2e905d70-ace8-47a4-b330-6e77a143d547",
	dateId: "20251216",
	puzzle: {
		letters: "NSTWJVOFLAHXICBDUKEGPQRMY",
		words: ["DUIKER", "STOICAL", "GERM", "HOST", "LIONS", "BACKUP", "VOICE", "JACK", "WACKIER", "FOXIER", "LACKEY", "QUICKER"]
	}
},
{
	id: "45b81ccc-6dca-4f1b-b05e-bfaec83c4290",
	dateId: "20251217",
	puzzle: {
		letters: "CHBXMLGORYQUWTFJENAIPSKVD",
		words: ["BROGUES", "PEKAN", "DIVANS", "CLUES", "WAKENS", "BOXY", "FROWNS", "TROUGH", "QUOTA", "JUNKS", "WORMY"]
	}
},
{
	id: "76fd8c83-b944-4007-b8a1-3e9f22722c49",
	dateId: "20251218",
	puzzle: {
		letters: "MWOVEULGSNDQFIBKARXPJTYCH",
		words: ["ARTY", "ARISEN", "GLOVES", "BIRCH", "GLUM", "DART", "IRAQ", "XRAY", "PINES", "YAK", "WOVEN", "JAR", "FINES"]
	}
},
{
	id: "d3975544-5fa3-4eb5-95a6-1c08c62fd89e",
	dateId: "20251219",
	puzzle: {
		letters: "RPXQBLEMUNVWFKICYDJTSHAGO",
		words: ["BUMPER", "TOGA", "VEX", "QUIT", "CHAD", "LEVY", "BUNK", "SHADY", "FUME", "LEWD", "JAYS"]
	}
},
{
	id: "eee9dd5b-b42b-41a8-8f47-b6696d677b14",
	dateId: "20251220",
	puzzle: {
		letters: "FLPVEMONIHTYQBJGUADKCWSRX",
		words: ["XRAY", "QUARK", "FLOP", "GYM", "RAYON", "HIVE", "GUARDS", "CUT", "BARDS", "JIVE", "SWARD"]
	}
},
{
	id: "485f0631-81e2-47bd-a4b3-c1ba9ead0e63",
	dateId: "20251221",
	puzzle: {
		letters: "IXQHCJSUGPTOMABYEVRWKLNDF",
		words: ["SUAVELY", "BAGMEN", "CHUMS", "SIX", "AMEND", "BRAVELY", "DWARF", "GARNETS", "BRAVO", "PAVE", "TYKE", "QUOTE", "JOUST"]
	}
},
{
	id: "f5e1d940-8145-4730-90b7-30650baec00a",
	dateId: "20251222",
	puzzle: {
		letters: "VIXAKMQURLNCTSBPEFWGDYHJO",
		words: ["JOGS", "QUARTS", "CURBS", "CURLS", "FETUS", "DEFY", "HYPE", "NETS", "VIM", "LAX", "KARST", "WHEN"]
	}
},
{
	id: "05c06aca-8ec6-41bb-9194-bbec1e8e6bda",
	dateId: "20251223",
	puzzle: {
		letters: "YXHUTKRENQVMLISDOFGPCBWAJ",
		words: ["RHEIN", "SILENT", "KREMLIN", "PIQUE", "VOLGA", "JAG", "WOMEN", "FINERY", "DOLMEN", "COMER", "BOLE", "FLEX"]
	}
},
{
	id: "a31810df-ab0d-4108-817b-7833cf782650",
	dateId: "20251224",
	puzzle: {
		letters: "KLDYHOCNJTMWXEVBIFAUGSPRQ",
		words: ["COMBS", "PARQUET", "FEAR", "CLOWN", "FIGS", "LOCK", "AXIS", "JET", "RAVEN", "MOLDY", "THY"]
	}
},
{
	id: "7bb3e178-9ec4-4576-bc65-1c00491794c0",
	dateId: "20251225",
	puzzle: {
		letters: "YQGDPCUBAJKSONXMHTFIWERVL",
		words: ["BUCKSHOT", "FLINTS", "QUOTER", "ANTHEMS", "HOAX", "JABS", "PANTHER", "DANTE", "VINO", "GUSHER", "YUCK", "SHREW"]
	}
},
{
	id: "d0cd8430-6c4b-4d5b-b99c-4804b895f3a2",
	dateId: "20251226",
	puzzle: {
		letters: "QHYRKTUAJBFNLWGPOXEMICDVS",
		words: ["GEMS", "QUARK", "COXED", "UNARY", "ALOFT", "HAULED", "BRAWLED", "HANOI", "POLAR", "VELAR", "JAUNT"]
	}
},
{
	id: "ed981682-72cf-4f61-bc1a-0fe521624e9e",
	dateId: "20251227",
	puzzle: {
		letters: "XGESOFUKDNQLVRYHITABPWCMJ",
		words: ["ULTRA", "WHIP", "BARKED", "CARDS", "FLUX", "PIQUED", "JAMB", "VICAR", "YARNS", "NOSED", "GULF"]
	}
},
{
	id: "97eba18a-1d40-4b75-b62a-a0200622c0e2",
	dateId: "20251228",
	puzzle: {
		letters: "YMFWGBDOLEXRHPKUINAJQTSVC",
		words: ["QUITS", "DOWEL", "JAPE", "CAKE", "GLOW", "FLORIST", "STURDY", "DOLPHINS", "APLOMB", "SIX", "VANS"]
	}
},
{
	id: "5834e403-178b-4e0a-91a6-6c10cbdfc9ee",
	dateId: "20251229",
	puzzle: {
		letters: "YFHVEABCXPSGMLDORUITNKQJW",
		words: ["VEX", "QUILT", "PLUMBAGO", "GUILD", "RUGBY", "FAB", "MULCH", "JILT", "CLIMBS", "NORM", "LURK", "WILD"]
	}
},
{
	id: "982ec6e3-09aa-4f7a-8ea7-527a35ccd31a",
	dateId: "20251230",
	puzzle: {
		letters: "DITUQMHCABFKWGYREJNSLXVOP",
		words: ["MICA", "THICKER", "NOVEL", "SPONGY", "JERK", "QUACK", "VEX", "THWACK", "DITCH", "BACKER", "FEW"]
	}
},
{
	id: "41858d93-7e7f-4b7b-a87b-301430e4d379",
	dateId: "20251231",
	puzzle: {
		letters: "STJACKFYUMLNHQPVOIDERWGBX",
		words: ["CAMPED", "INFLOW", "QUAY", "VOID", "STY", "JUMPED", "HUMPED", "HONKS", "GIBED", "NOR", "IBEX"]
	}
},
{
	id: "a27665d2-1b66-4944-a123-9b8c6cb1225e",
	dateId: "20260101",
	puzzle: {
		letters: "VNERBYOWPDKSIFHTUJALQCGMX",
		words: ["JUST", "ENVOYS", "WIPER", "HALF", "BREWS", "GUTSY", "DREW", "TUSK", "SIAM", "FLAX", "CUTS", "QUIP"]
	}
},
{
	id: "eb71bb91-8345-455b-87f4-c3985be4742b",
	dateId: "20260102",
	puzzle: {
		letters: "BANVGLPTHEKSOWDCXQJRIUMFY",
		words: ["JOHN", "STOWED", "TOXIC", "GHOST", "MUCKS", "QUICK", "FRY", "VEG", "BATHED", "POSTAL"]
	}
},
{
	id: "1cf885b8-e0bc-4093-a05b-85ca09867ea7",
	dateId: "20260103",
	puzzle: {
		letters: "GEBXTCKODSFJLIQMANYUPRVWH",
		words: ["INJOKE", "GECKO", "VALID", "DINAR", "MANLY", "QUIDS", "JOIST", "BODILY", "BOX", "WHY", "FARM", "LAMP"]
	}
},
{
	id: "cc20e6f0-89fa-493f-9e9e-4355d1f99266",
	dateId: "20260104",
	puzzle: {
		letters: "TJWVCOGNADSXLFHQEPBMYUIRK",
		words: ["DANGLES", "CALF", "TOGS", "VALES", "SQUIB", "QUIRK", "EQUIP", "SQUIRM", "HANGS", "FLEX", "JOGS", "WALES", "YELP"]
	}
},
{
	id: "000f1110-bef9-454a-a3c4-cc087c0aca94",
	dateId: "20260105",
	puzzle: {
		letters: "CGKXOHWLBDJANUMYTEQVPRFSI",
		words: ["JAW", "BLUNTER", "SQUEAL", "GLUES", "VISE", "FETAL", "ALBUM", "CHANTRY", "CHALK", "OBLATE", "DUNES", "PYRES", "BOX"]
	}
},
{
	id: "31b8164a-ac74-4004-9fb9-ee7b0dc259d1",
	dateId: "20260106",
	puzzle: {
		letters: "YHJUQBGKIDLMNVROEXCATWPFS",
		words: ["PEN", "BLEW", "JINX", "RINGLET", "SCARING", "FARING", "DRINK", "QUID", "DINGHY", "MOTEL", "CARVING"]
	}
},
{
	id: "94b4fa9f-fee9-493e-be81-1afbba03e553",
	dateId: "20260107",
	puzzle: {
		letters: "MIUBSRTDQPYLJKEVOCWXNFHAG",
		words: ["GAWK", "IDLY", "WHACK", "SQUIRT", "SQUIRM", "FOLD", "SPEW", "AXE", "JOCK", "VOLT", "LYON", "DUBS"]
	}
},
{
	id: "1d38b2a0-9f5d-43fa-bccd-4bbefb1a6dc2",
	dateId: "20260108",
	puzzle: {
		letters: "DJYBAMOQWHPNUCSIGFETVKXLR",
		words: ["FLEX", "INQUEST", "DOPING", "VINO", "MOPING", "KING", "HAWSER", "INFLECTS", "JOY", "SWAB"]
	}
},
{
	id: "51cd1d4c-3218-47cd-894f-9f58e842ab55",
	dateId: "20260109",
	puzzle: {
		letters: "XGHVSATLIPBNUEJYCDQWMKFOR",
		words: ["DELTA", "PELVIS", "FOR", "MYNA", "DELHI", "EQUIPS", "TAX", "GLUED", "LUCKY", "JILT", "DOWEL", "BAND"]
	}
},
{
	id: "4ef068fd-84c1-44aa-82bb-bd272d8e093d",
	dateId: "20260110",
	puzzle: {
		letters: "KHILFPNGSWROMAQTBJUXYVEDC",
		words: ["MORPH", "DUX", "BEVY", "MASQUE", "FLINGS", "CUED", "JUMBO", "INKPOT", "SQUAW"]
	}
},
{
	id: "4c18a10c-9de0-404e-ac93-65381c2edb42",
	dateId: "20260111",
	puzzle: {
		letters: "SXMYHBADOLFKWIVTENUPJCGRQ",
		words: ["LOWING", "WADING", "BAWDY", "XMAS", "PRUNE", "LOVING", "HOLING", "QUINCE", "DAFT", "JET", "VODKA"]
	}
},
{
	id: "16c948ad-a778-49e2-b22a-2adb9679f043",
	dateId: "20260112",
	puzzle: {
		letters: "FKRYJISCOMQUHBTVALEGPDNXW",
		words: ["AHOY", "PANEL", "CHALET", "BLUISH", "MOCKS", "JOCK", "FISH", "HEX", "HANDLE", "BEG", "ANEW", "SQUAD", "VALET", "ROCKS"]
	}
},
{
	id: "15dfc679-e199-42f1-a6d0-8a799ca4f76a",
	dateId: "20260113",
	puzzle: {
		letters: "FQBYXURNCTDIGOJEWHAVKSMPL",
		words: ["AGONIES", "WEIGHS", "CONGA", "SKEIN", "INGOT", "QUID", "SHOAL", "ONYX", "FURIES", "APHID", "HAVOC", "JAMS", "BRIDES"]
	}
},
{
	id: "9530d462-39d0-4270-be79-c411c45e6790",
	dateId: "20260114",
	puzzle: {
		letters: "MPFXYONUDGSQELKRHCWJVITAB",
		words: ["SQUELCH", "GLENS", "VICE", "DUX", "POSH", "WATCHED", "BATCHED", "THRICE", "FUEL", "EDGY", "MOSQUE", "JAWED", "ELK"]
	}
},
{
	id: "da9a880e-5fab-434e-a5cb-6ac862db1127",
	dateId: "20260115",
	puzzle: {
		letters: "NIXOBFDGWHTQVLYJEUMPSCARK",
		words: ["JET", "FIND", "QUARK", "BOWL", "ESCARP", "HOWL", "GLUES", "LUMPY", "BOX", "MAUVE"]
	}
},
{
	id: "1f921298-c3a6-4593-bdae-85185c7cbb45",
	dateId: "20260116",
	puzzle: {
		letters: "VGWKYTOSMCJPBEDFUNRXLHQAI",
		words: ["VOWS", "BECKS", "LUNAR", "AIRED", "JOBS", "HUBS", "FLUB", "DESPOT", "BOWMEN", "BOGS", "IRAQ", "AXED", "SKY"]
	}
},
{
	id: "5d95a1e3-47f5-4fbe-9777-2845483e9dc4",
	dateId: "20260117",
	puzzle: {
		letters: "JTGDCAXQUKMYIPFBNVELOWHRS",
		words: ["BONY", "DUCK", "TAXIES", "RHEIN", "QUIVERS", "WHELP", "JAMB", "SELF", "DUG"]
	}
},
{
	id: "1f73756e-8e6f-476f-91a8-752862594699",
	dateId: "20260118",
	puzzle: {
		letters: "FLKNCMXOQUTEPIBVDJSRAGWHY",
		words: ["POEM", "FLOPS", "NOISY", "WHYS", "CUBS", "POET", "JET", "EXPIRY", "GAVE", "BUNK", "BIPED", "QUIPS"]
	}
},
{
	id: "12d7f9c1-cfea-4d9c-8b35-fe48d4b6ab99",
	dateId: "20260119",
	puzzle: {
		letters: "WHFIYNEBUTGMVRQLOCAPSXKDJ",
		words: ["JACK", "OXCART", "GLOVE", "HEMLOCK", "BURP", "BEFIT", "SLOVAK", "PARTY", "CRAVEN", "DART", "HEWN", "QUIT"]
	}
},
{
	id: "1fdb0940-55f2-45e6-833e-03208dd7f93d",
	dateId: "20260120",
	puzzle: {
		letters: "QRBVWUAYOLJEMPFSXKNDTGIHC",
		words: ["CHINK", "HIND", "INFLOW", "MARQUES", "EMPLOY", "JAMES", "QUEST", "BOWL", "GIN", "EXT", "VOYEUR"]
	}
},
{
	id: "1c7e627f-9f89-4e47-b299-1f9d42f004bb",
	dateId: "20260121",
	puzzle: {
		letters: "JOKPDCEXLVRNUAFTQBWGHYMIS",
		words: ["CENT", "IMBUE", "JOKER", "VALUER", "FLAGS", "MYTH", "BALD", "FLAXEN", "ALP", "QUERN", "WALKER"]
	}
},
{
	id: "f7e83ee7-8d45-4d8e-ad2f-3940119f7716",
	dateId: "20260122",
	puzzle: {
		letters: "TLJHWFNAXDGIPRMYCUVEKBQSO",
		words: ["PANICKY", "FLAX", "WHARVES", "OVER", "SQUINT", "JAR", "HAREM", "HARPING", "DRAPING", "BURPING"]
	}
},
{
	id: "a7b559da-0a90-45f4-8114-b7a612f9433c",
	dateId: "20260123",
	puzzle: {
		letters: "JIFPBYHROXDAQNMCKVUTGEWSL",
		words: ["LUST", "JIHAD", "BOX", "CAKE", "CAVE", "KEG", "MORAY", "CARP", "SWUM", "FRONTS", "IRAQ"]
	}
},
{
	id: "4e64ecff-6da7-4a4e-8fad-d244351e56b6",
	dateId: "20260124",
	puzzle: {
		letters: "XAHWKGBFIRYOJMSCUTEVNLQDP",
		words: ["ABOUT", "WHIMS", "LUTES", "FIRMED", "BOUNCY", "JUTE", "KISMET", "PET", "VETO", "FOGY", "FAX", "QUOTED"]
	}
},
{
	id: "acb248b5-6b11-40ef-849c-1edfa1b5a6d2",
	dateId: "20260125",
	puzzle: {
		letters: "HQRMPVUDXACIGJFSNEWOYKBLT",
		words: ["CUDGEL", "BEGINS", "FOWL", "KNELT", "HUGE", "FAX", "AMP", "JOLT", "DINKY", "QUID", "INCUR", "VIEW"]
	}
},
{
	id: "1c4d0868-cb1a-45f0-afc1-8530f96384c1",
	dateId: "20260126",
	puzzle: {
		letters: "GPMQUAJSIBLYVNFTEWXRKCDOH",
		words: ["GALE", "DWELT", "IMPALED", "FROWNS", "MINX", "DELAYS", "DECK", "JAYS", "SQUIB", "SNIVEL", "HORNS"]
	}
},
{
	id: "dd2e686c-312a-4f77-8e19-73316387edad",
	dateId: "20260127",
	puzzle: {
		letters: "NRSXVPALIQEGWDUCKOYMHTJFB",
		words: ["VISAGE", "JOWLS", "DUMB", "AWOKE", "EARN", "GOTH", "QUID", "FOWLS", "GECKO", "SIX", "YOGA", "PEARLS"]
	}
},
{
	id: "f889d5d7-40d2-428d-b1a8-a47dfc6079cc",
	dateId: "20260128",
	puzzle: {
		letters: "INVSTLRYOBGHWPJFUCKXDQAME",
		words: ["DUCHY", "CHUG", "EXPO", "BOYS", "GRIN", "QUACK", "LINY", "ACME", "JOTS", "STOW", "VOW", "FUG"]
	}
},
{
	id: "ffd871ce-a0a9-4c4c-8567-236c802827ea",
	dateId: "20260129",
	puzzle: {
		letters: "ULTYHQAJPVNSBGEXOWRIFDCKM",
		words: ["BOWS", "BRIM", "COBALT", "JABS", "VERBAL", "SQUAT", "FOBS", "CREPT", "SALTY", "NABS", "DOCK", "BRIG", "HYPE", "BOX"]
	}
},
{
	id: "067b43dd-b140-4537-9f64-13b4263d2642",
	dateId: "20260130",
	puzzle: {
		letters: "HGXSPWFIDNVARUQLCKOMBETYJ",
		words: ["ECLAIR", "VALET", "BLACK", "WACKY", "ROUNDS", "SIGH", "CRISP", "FIX", "JOKE", "QUIRKY", "MORALE"]
	}
},
{
	id: "bb3ce518-d633-4e3f-bc0e-977af426e613",
	dateId: "20260131",
	puzzle: {
		letters: "FIRPTNSWEHMXACLGUJKBQDVOY",
		words: ["SACHET", "PRISM", "WREAK", "BLEACH", "FINS", "DUX", "JACK", "LEAKY", "OVUM", "GUMS", "QUACK"]
	}
},
{
	id: "93764856-a615-4fa2-8054-432fe411cb3c",
	dateId: "20260201",
	puzzle: {
		letters: "WNQFGRDUJLEASHIXCTVMOKYBP",
		words: ["LIMB", "WREATHS", "LIMP", "QUACK", "ASUNDER", "COXED", "JUDAS", "GLIM", "IVY", "FUNDS"]
	}
},
{
	id: "c29e9568-6ebd-411d-ae92-a50b343500ed",
	dateId: "20260202",
	puzzle: {
		letters: "SIVFOMEKTNGXQDJCLBURWHAPY",
		words: ["FONT", "MIKES", "GEMS", "BURP", "EQUAL", "SEX", "KIEV", "BLAH", "WHAP", "BURY", "CHAP", "JURY", "BAUD"]
	}
},
{
	id: "9ca90a2b-a85a-4350-a526-fee47a3d6f7e",
	dateId: "20260203",
	puzzle: {
		letters: "OVAKQHYRUJDTGXMLICNEBPWSF",
		words: ["QUARTICS", "OVARY", "BLIP", "PITHY", "QUARK", "JURY", "FEMUR", "XRAY", "WIDTH", "GRAVY", "RUMEN"]
	}
},
{
	id: "b817bf25-c948-47f1-b9a3-85bd884cb937",
	dateId: "20260204",
	puzzle: {
		letters: "OGRJTBFQANVUMSIXEWYPDKCLH",
		words: ["MASQUE", "FRAMED", "GRAINS", "VEX", "JAMS", "BOG", "DECK", "RASPY", "SYLPH", "GRANT", "DEWS"]
	}
},
{
	id: "cde1a0c1-89e6-47e5-9e82-f8ada1a82001",
	dateId: "20260205",
	puzzle: {
		letters: "YAHIKTXUQNRVWDCMESPOLFBGJ",
		words: ["TREWS", "KINDS", "COPSE", "HINDU", "WEBS", "JOGS", "DUX", "MEWS", "FLEW", "QUAY", "REVS"]
	}
},
{
	id: "697032d9-fbdb-43d5-921a-85d2703b12cf",
	dateId: "20260206",
	puzzle: {
		letters: "KQDTNMSUORJAHGBYXWEVPLFIC",
		words: ["VICE", "WAXY", "SHORN", "SHAWL", "PLY", "MASK", "DOUGHS", "FIVE", "JAMS", "WASHOUT", "BOUGHS", "QUASH"]
	}
},
{
	id: "2cb30d59-53d3-4a3e-a663-86bec7bc187e",
	dateId: "20260207",
	puzzle: {
		letters: "TFYJCXUNOKQIALRVWMEBSPDHG",
		words: ["INLAWS", "FUN", "LAMPS", "HEMLOCK", "BLAMED", "QUALM", "JOCK", "BEG", "VIAL", "BEAUX", "BEANY", "ROAMED", "WALNUT"]
	}
},
{
	id: "06862a79-5ab9-462e-bf11-add4b7298a40",
	dateId: "20260208",
	puzzle: {
		letters: "GJDUQKAEFNBRSXMWITYHCLVOP",
		words: ["MYSTIC", "PHYSIC", "WISER", "FEARS", "QUEASY", "JADES", "VISA", "EXTRAS", "POTS", "STREAK", "BAREST", "NUDES", "BRASIL", "GASTRIC"]
	}
},
{
	id: "a517fa62-ce55-47bd-a85d-eaddee8b031b",
	dateId: "20260209",
	puzzle: {
		letters: "JIRLWNAVYHQGXBFUMCODTESKP",
		words: ["RAVING", "BOXY", "IRAQ", "DOCKS", "GNARL", "WHY", "FOXY", "JARL", "MUTES", "POCKS"]
	}
},
{
	id: "5bdc3523-02f9-467d-8676-cbdb3158a633",
	dateId: "20260210",
	puzzle: {
		letters: "NVEBKJOFRSMITALPUYHXGDQWC",
		words: ["OVERTAX", "BEFIT", "PITHY", "HARKS", "RATION", "QUIP", "OVERLAY", "DUMP", "CHAFE", "GUITARS", "WHARF", "JOT"]
	}
},
{
	id: "38ca3b10-3245-43bf-bcea-73c4136656cb",
	dateId: "20260211",
	puzzle: {
		letters: "SWRQUGDKITVEHFNXPLOJYACBM",
		words: ["DELPHI", "APEX", "KEGS", "DRIFT", "QUIRK", "APLOMB", "DELAY", "WRIT", "VEG", "ELFIN", "JOB", "CAPED"]
	}
},
{
	id: "6caea33b-3aac-4091-b0e6-a4d0dc508a99",
	dateId: "20260212",
	puzzle: {
		letters: "FNQJHVAUSEGMLXPCDBYORITWK",
		words: ["SEXUAL", "JULY", "GAMBIT", "CITY", "FALSE", "POKY", "QUALM", "TWO", "BIRD", "NUMBLY", "SLAV", "BLUSH"]
	}
},
{
	id: "6c155d7a-64a1-4516-98b1-45f117fa54cc",
	dateId: "20260213",
	puzzle: {
		letters: "FWLHTOBGPSKREJAMINUQVYXCD",
		words: ["WORMY", "MINX", "JERKIN", "FORGE", "REPAST", "QUASH", "DUNE", "BORNE", "VIER", "CUD", "GROWL"]
	}
},
{
	id: "6dd78a85-f00c-4981-9653-73bfb60d68a6",
	dateId: "20260214",
	puzzle: {
		letters: "VHPEWQIXASBUCRTDNJFMKGLOY",
		words: ["PARSE", "HIC", "BUNK", "SWARM", "LOFTS", "QUIP", "TAXES", "VICARS", "ARMY", "JUNK", "DUNG"]
	}
},
{
	id: "2587d96f-d3b4-484b-bcc9-4dc06c69dc38",
	dateId: "20260215",
	puzzle: {
		letters: "CDSLTRXOIBGEWKJVUFMHPAQNY",
		words: ["QUAVER", "DOER", "HYMN", "JILT", "KILO", "CREW", "VEX", "AUGER", "FEW", "SLOWER", "BLOWER", "BLOWUP"]
	}
},
{
	id: "44296e51-de35-4c55-9af8-0871c74c00c4",
	dateId: "20260216",
	puzzle: {
		letters: "JFLGYROCIVPDEBMWNXTSKHAUQ",
		words: ["EXHAUST", "STANK", "CLIMBED", "IVY", "SQUAT", "MILORD", "WHAT", "POLICED", "FJORD", "GIBED"]
	}
},
{
	id: "3cf4538e-e7e5-42e3-a1a7-69019694f8fa",
	dateId: "20260217",
	puzzle: {
		letters: "FIWGNVLDOYKPESTCRUQABMHJX",
		words: ["WILDEST", "STONY", "FILED", "SUPERB", "CRUSTY", "SAT", "MURK", "HUES", "JUST", "TAX", "STODGY", "QUEST", "VIDEOS"]
	}
},
{
	id: "34c0ed15-4dc8-42a3-995e-7b761dbe8767",
	dateId: "20260218",
	puzzle: {
		letters: "PQNCHIUMSAJVGRKWEDTLBYXFO",
		words: ["UNCHARGED", "EXTRAS", "CHARMS", "JIVED", "FOLKART", "QUIP", "HARDY", "BEGUN", "DEWY"]
	}
},
{
	id: "c6ee9e16-f0e8-4a30-b100-6eaf06c969eb",
	dateId: "20260219",
	puzzle: {
		letters: "MKVIDALCXPQUFENTRWBHGJOYS",
		words: ["LUCID", "HECK", "QUALM", "GROW", "BECK", "VIXEN", "CURFEW", "BOYS", "TRUCE", "JOBS", "EPIC"]
	}
},
{
	id: "39840b92-c35f-4733-912b-56da4acb7981",
	dateId: "20260220",
	puzzle: {
		letters: "SWBAJKNRGXMITLYVFUEHOCPQD",
		words: ["ARTFUL", "BARLEY", "QUITE", "MINTED", "SKIRTED", "WRITE", "GLUED", "JARL", "AXLE", "VIRTUE", "OFT", "PELT", "HEY", "CUTELY"]
	}
},
{
	id: "33c30d65-8800-4901-8f0e-6ae23eb291ab",
	dateId: "20260221",
	puzzle: {
		letters: "TFQMCJUGOVAELYWBXRHISKNDP",
		words: ["FUEL", "QUERN", "DIP", "PHLEGM", "BELOW", "AUGER", "JERKS", "GLUT", "VOGUE", "COLE", "EULOGY", "AXLE"]
	}
},
{
	id: "ac1959d2-71ac-435f-887a-3b3650bda596",
	dateId: "20260222",
	puzzle: {
		letters: "QDBYVRUTENWIXKGASHOMPJFCL",
		words: ["BUXOM", "WRITE", "CHOKE", "YETIS", "QUITE", "DRUB", "FOGEY", "JAWS", "PAIR", "ENVY", "LOCHS"]
	}
},
{
	id: "84f91d63-c9a5-45a0-b1f5-dacc779e2524",
	dateId: "20260223",
	puzzle: {
		letters: "PHDIKJOMWSYVFLQNEGCUBRTAX",
		words: ["CAGEY", "SQUAT", "JOY", "SKID", "OVERTAX", "REFLUX", "BEGAT", "ENVOY", "FOP", "SWIM", "HOVER"]
	}
},
{
	id: "1ae0ac45-b313-4f02-9d8a-e6ff884507b0",
	dateId: "20260224",
	puzzle: {
		letters: "MQDNOUGRPBLEVFXAWYKIJHSTC",
		words: ["QUERN", "STICKY", "PREYS", "FITS", "VELUM", "BOND", "GLUEY", "JAWS", "WHALER", "FIX"]
	}
},
{
	id: "a7b0427e-8362-4cf4-8503-5985029aa548",
	dateId: "20260225",
	puzzle: {
		letters: "FNVORPEXDJWHSICLKGUBAYMQT",
		words: ["QUIDS", "NEWLY", "DROVES", "JIGS", "OXEN", "FEN", "BUSH", "TUGS", "MUSIC", "MUSKY", "PESKY", "YAKS"]
	}
},
{
	id: "a4722b8e-85ce-420f-a5ba-25457e92f5bf",
	dateId: "20260226",
	puzzle: {
		letters: "XGQCTKAJUDYBLRIHFPONMEVWS",
		words: ["QUID", "FLAKY", "BLOWN", "HEM", "DROVE", "PRIONS", "FLAX", "CURIO", "JAB", "GALOP", "TURIN"]
	}
},
{
	id: "10fb6841-7d30-41c2-b813-3abff8184d1b",
	dateId: "20260227",
	puzzle: {
		letters: "QULFMGOBAKTENJCDVSRHXIWPY",
		words: ["WISPY", "CANOED", "JACK", "FLACK", "NEBULA", "MANED", "QUOTED", "SIX", "DIVES", "SPRY", "BEGOT", "ACHY"]
	}
},
{
	id: "ebaf3f0c-84cb-4f82-8f58-1c9869f6e421",
	dateId: "20260228",
	puzzle: {
		letters: "NLRWAQEXPKMUBDCVIFOGTSJYH",
		words: ["FUEL", "QUITS", "DOCK", "REMITS", "WREN", "BOGY", "PAW", "VIM", "JOCK", "IBEX", "HOCK"]
	}
},
{
	id: "9062403f-72bf-4872-acd0-435af66c0e97",
	dateId: "20260301",
	puzzle: {
		letters: "MWDHORFGYLPENKQBVSUCIJXAT",
		words: ["GENUS", "JIVES", "GERM", "YOLKS", "TAX", "VIBES", "QUACKS", "WRENS", "PESKY", "FENS", "HOLY", "DYNE"]
	}
},
{
	id: "62daadc2-ba9d-4d9b-84de-e9a94cbb9aae",
	dateId: "20260302",
	puzzle: {
		letters: "LFCBEPRHKDVAYIXNUMTJQGWOS",
		words: ["GNARL", "FRAY", "CHIDE", "BED", "OMITS", "VARY", "PARCH", "MIX", "HIKED", "JOTS", "QUAY", "WOMAN"]
	}
},
{
	id: "a2942686-9312-4ae1-b768-b80ec29caa47",
	dateId: "20260303",
	puzzle: {
		letters: "HVGUBCLIQAOWRXTPKJEMSDYFN",
		words: ["COPS", "QUIRKS", "BATMEN", "LOCH", "DYER", "FEN", "GIRL", "COWL", "JERKS", "VIXEN"]
	}
},
{
	id: "6fd6ea28-94a2-417c-a157-020eaf9a8d48",
	dateId: "20260304",
	puzzle: {
		letters: "UWTAMQOKCYDSRBGPEVNJFHXIL",
		words: ["WORSE", "DERBY", "SERVING", "JINXED", "ACTORS", "QUOTA", "LIVERS", "PERKS", "HEROD", "MACRO", "FEDS"]
	}
},
{
	id: "3629a823-3c2c-4fca-9d70-27310528edf6",
	dateId: "20260305",
	puzzle: {
		letters: "WRMFEDYOKXTLIJAPNBVUSGCHQ",
		words: ["FOIL", "QUAKING", "JOINTLY", "BLOKE", "DRYING", "SPLINT", "WRY", "AXE", "INCH", "VIOL", "MOLDY"]
	}
},
{
	id: "0ba34291-e1ba-4d4c-a19a-bf53a52ba142",
	dateId: "20260306",
	puzzle: {
		letters: "LMXVYESGAPWDTHIFRBKUJOCQN",
		words: ["FORTH", "ELMS", "QUIP", "TAX", "STAY", "HAGS", "DEWS", "CORDS", "VATS", "HUNK", "FJORDS", "COB"]
	}
},
{
	id: "46603e4e-ee02-4f8e-9004-6ba580dd9e2c",
	dateId: "20260307",
	puzzle: {
		letters: "KCMWSGVETNAPBYRIULJOQDXFH",
		words: ["METRO", "FLUID", "FLUX", "VAPID", "GAPE", "BECK", "JOY", "HORNS", "QUID", "MEWS"]
	}
},
{
	id: "4bfeb17d-e5b2-42dd-9a98-0a78a7df0686",
	dateId: "20260308",
	puzzle: {
		letters: "XIWFHMYCTAGNKSVPOUERLDJQB",
		words: ["ONYX", "JUNKER", "HAFTS", "BEST", "WICKER", "SAVER", "DOUSE", "LOUSE", "DONG", "QUEST", "POKERS", "GYM"]
	}
},
{
	id: "63378da2-1e29-460a-b377-f964ea4e2128",
	dateId: "20260309",
	puzzle: {
		letters: "KRNBQFEJUILWVCDGSYMHXOPAT",
		words: ["LEVY", "CHAT", "DUNE", "FERN", "CHAMPS", "BID", "POX", "JUICY", "GLEN", "QUID", "JERK", "NEWSY"]
	}
},
{
	id: "63114ffc-2d8c-4979-adec-52c53c42b53c",
	dateId: "20260310",
	puzzle: {
		letters: "YDBCFLPUOHSQREXGINAMJKTWV",
		words: ["PRANK", "ANTIQUE", "FORAMEN", "MANTIS", "JIGS", "CHOREA", "VANE", "PROUDLY", "BORAX", "TINWARE"]
	}
},
{
	id: "ffc84a90-c3f9-4816-9bcb-24a4cc11568b",
	dateId: "20260311",
	puzzle: {
		letters: "THGOWICKBMXPEVRFUJAYDLQNS",
		words: ["WOMB", "QUEASY", "THICK", "JEANS", "FLUE", "DUPE", "FLUX", "BRAVE", "BOG"]
	}
},
{
	id: "e597f473-deba-4b51-b227-4d047831aa8e",
	dateId: "20260312",
	puzzle: {
		letters: "FAHKCYNWGEORQJDLMIUTSVPBX",
		words: ["NORWAY", "DUX", "OLMS", "HAWKED", "BUT", "QUIP", "JUDGE", "FAWN", "DECK", "VIMS"]
	}
},
{
	id: "23494142-f14c-4374-8054-e0afcd7363f0",
	dateId: "20260313",
	puzzle: {
		letters: "WFVKLTESYOGNPBMCUHXAQIDJR",
		words: ["SYMBOL", "CUPS", "ABSENT", "JAMBS", "MARX", "NEWT", "VENT", "PESKY", "QUID", "FENS", "HUGE"]
	}
},
{
	id: "5ab1b9c3-0572-4948-a78e-3d33fa2c3a5f",
	dateId: "20260314",
	puzzle: {
		letters: "QPWSRUXNOLTIJVYEFGAHBMDKC",
		words: ["INPUT", "BEFIT", "JACK", "SLOVAK", "JINX", "SLOW", "GIFT", "QUIET", "ACHY", "ITEM", "ROWS", "CHAD"]
	}
},
{
	id: "c765e782-b345-4a9c-86be-11c2371b862b",
	dateId: "20260315",
	puzzle: {
		letters: "DOPRVHQUETWFLNSBICAJKYMGX",
		words: ["CLIMAX", "FLUENCY", "PUNSTER", "OPULENT", "BILES", "QUEST", "HOPES", "WILES", "GALES", "VENAL", "DOPES", "KILNS", "UNJAM"]
	}
},
{
	id: "19939f54-77ac-4c1b-a30d-b891bfbee7b5",
	dateId: "20260316",
	puzzle: {
		letters: "WYARBHMQNGLSIUKFODJXCVPET",
		words: ["ANGUISH", "MARQUIS", "JUDO", "DISMAY", "VOIDS", "DEPOSING", "EXUDING", "SLOPED", "TEDS", "WHY", "GUNK", "CODING", "BRAN", "FLOP"]
	}
},
{
	id: "9df44a14-c54b-42ed-b746-7b502e274b6a",
	dateId: "20260317",
	puzzle: {
		letters: "XHFBQJELUWCTYADVNPGKIMSRO",
		words: ["FLAGS", "VINYL", "ADULT", "FLAW", "DAUB", "JET", "ORGY", "MINCE", "FLAK", "FLEX", "HEX", "QUAY", "IMPALE"]
	}
},
{
	id: "185f96c2-24e1-4eda-ad2b-14a0083b3b46",
	dateId: "20260318",
	puzzle: {
		letters: "YNOWEGCIRVHUQKTJMSFDXBALP",
		words: ["LAMBSKIN", "SQUIRT", "COWERING", "FLABS", "REV", "BALD", "CHUMS", "IRONY", "XMAS", "JUICY", "PLASM"]
	}
},
{
	id: "18c96fc5-8b9f-4f2d-8471-eba97a688f91",
	dateId: "20260319",
	puzzle: {
		letters: "YRCVHEKGAJFWMLTOPUINXDSQB",
		words: ["LACKEY", "GLINT", "JACK", "CAMPUS", "HACKER", "SQUINT", "TALMUD", "POWER", "FOPS", "SQUIB", "VAMPS", "FOX"]
	}
},
{
	id: "bcbf54c8-8aaa-49c5-992a-f66093eb87b8",
	dateId: "20260320",
	puzzle: {
		letters: "SGAYKTCWRDMLEJFQUHVOPINBX",
		words: ["LUPIN", "BOX", "OVERACTS", "VELUM", "DRAWL", "DRAGS", "CLERK", "JERKY", "PIQUE", "SCARF", "HELM"]
	}
},
{
	id: "6d903de5-2ad5-4568-992e-0c52aa27fe99",
	dateId: "20260321",
	puzzle: {
		letters: "CJWDKPHOLYVASIXNRUMFEQBGT",
		words: ["FIX", "BRASIL", "MILKY", "OWLISH", "VANQUISH", "JOWLS", "MISHAP", "CHAOS", "GUILD", "LIFT", "LOANER"]
	}
},
{
	id: "b13dd3a6-acac-40c7-8579-e3a9078e50e3",
	dateId: "20260322",
	puzzle: {
		letters: "NHTXBKAMEYRGQVDWUFLSJIPOC",
		words: ["GRATED", "EXT", "WRATH", "EQUIP", "BEVY", "SOLVED", "FOLDS", "GAMED", "THANK", "COLDS", "JUG"]
	}
},
{
	id: "2508a465-0c9e-4621-87eb-d53ffe5d6ae5",
	dateId: "20260323",
	puzzle: {
		letters: "HIQRSTUNEYLCJVFKAPWOMBGXD",
		words: ["DOVER", "LAMB", "WOVEN", "ENVY", "SEQUIN", "FOX", "BAG", "TUNERS", "CLAP", "UNJAM", "THINE", "BACK"]
	}
},
{
	id: "4b79873b-81ed-4f87-a626-bd9ab3ddc3c8",
	dateId: "20260324",
	puzzle: {
		letters: "MVSNDWEOYXRCHQBKAUTLFGPIJ",
		words: ["GAUCHE", "BLITHE", "QUACK", "HAREM", "SECOND", "WRACK", "PARCHES", "PITHY", "FARCES", "JILT", "COVER", "ONYX"]
	}
},
{
	id: "454f4980-a4f0-48ad-9817-6bf04e7b0d5f",
	dateId: "20260325",
	puzzle: {
		letters: "BAPMJDLTOFKHWNSYIEUQGVXCR",
		words: ["CENT", "TALKIE", "VIXENS", "MOSQUE", "GIVEN", "CRUX", "JOWL", "ATHENS", "FONT", "PLATO", "BALD", "IVY"]
	}
},
{
	id: "6d035880-73d4-4048-816f-1e8f24aacf16",
	dateId: "20260326",
	puzzle: {
		letters: "HSDLWGVCXOIFJRYPNTUAKBEMQ",
		words: ["MARTEN", "SCRAM", "VINE", "BETRAY", "FIGS", "INJURY", "QUART", "WOLDS", "NIGH", "MARX", "PIGS", "PINK"]
	}
},
{
	id: "1f0f20db-10bf-4bb8-8e64-747aeaced214",
	dateId: "20260327",
	puzzle: {
		letters: "FLKODEHPSBQUXWYGINVRCJTAM",
		words: ["ANTIQUE", "ELF", "GUITAR", "HELPS", "JINX", "MANIC", "BOPS", "ELKS", "UNITARY", "PODS", "NAVY", "WRY"]
	}
},
{
	id: "0fc70cc5-6d96-4364-8494-7bb0e9306a67",
	dateId: "20260328",
	puzzle: {
		letters: "PIFUNTXKAQBSLVDREMJOHCGYW",
		words: ["FITS", "FALSER", "CHEST", "QUALMS", "WODAN", "GYMS", "HERBS", "JOY", "FIX", "PITS", "OVALS", "AUKS"]
	}
},
{
	id: "02f885f6-8af9-403a-9fd2-b8b8cbafbf0f",
	dateId: "20260329",
	puzzle: {
		letters: "QWPSBUIFETGKRHMCOJAVDXNLY",
		words: ["FIREMAN", "HEROD", "COX", "QUIPS", "WIPER", "MANLY", "FROCK", "THAMES", "EPIGON", "JAMES", "NAVY", "BERK"]
	}
},
{
	id: "7de9432f-dddf-45d9-930e-ec74264dd857",
	dateId: "20260330",
	puzzle: {
		letters: "FQKGTDUESLHARVIXYNPWCMBOJ",
		words: ["LIPREAD", "ONYX", "SILVERY", "JONAH", "QUERN", "DUKES", "WILTS", "FURS", "HYMN", "BONY", "GEARS", "CYAN"]
	}
},
{
	id: "1fd4d63f-105a-4138-91f4-0abcb6d6202f",
	dateId: "20260331",
	puzzle: {
		letters: "MNGOPIVCTXJBKEQLYARUDSWHF",
		words: ["POCKET", "MINCER", "DYKE", "JINGO", "QUEASY", "VIM", "WHARF", "ABLY", "EXPO"]
	}
},
{
	id: "2c0fd2a6-193e-4ed6-a780-262f46474dd0",
	dateId: "20260401",
	puzzle: {
		letters: "OXGJFCHALYNVPBDUESRKQWTIM",
		words: ["FLAX", "QUENCH", "MITES", "HAVEN", "SPRITE", "JAPES", "BALDY", "KITES", "GAPES", "WENCH", "COX"]
	}
},
{
	id: "bfc223ae-d0c0-45f4-a076-4d8e05ec7c1a",
	dateId: "20260402",
	puzzle: {
		letters: "WSVCYEXBIKTNMUGPAQLHJFRDO",
		words: ["QUICK", "DOLMAN", "HUMANE", "JAMBS", "RATES", "PANES", "FATES", "NEXT", "ICY", "ANEW", "VIM", "GLUM"]
	}
},
{
	id: "e4154ded-a5c4-4f94-9751-c0aa780f7f5c",
	dateId: "20260403",
	puzzle: {
		letters: "MVRXNWEDFOISTJLCKUAYHPGQB",
		words: ["TALON", "GUTSIER", "PUTSCH", "FLATUS", "LOFTED", "WICKS", "FLAY", "VESTAL", "METAL", "BATED", "FOX", "JUST", "QUAY"]
	}
},
{
	id: "a0fd3363-61a2-4828-9477-459a00e8d5bb",
	dateId: "20260404",
	puzzle: {
		letters: "GPSTQBRIUVMACXENWKFDLHOJY",
		words: ["SPRAWL", "FOWL", "BRAWN", "VEX", "JOHN", "GRIPS", "RACIST", "DEFY", "QUICK", "PRAM"]
	}
},
{
	id: "dc6f5b1d-fd5f-4763-b160-ac428b866362",
	dateId: "20260405",
	puzzle: {
		letters: "OXPTYBAKGHCWRFNDMQEVSLUIJ",
		words: ["BARE", "THY", "BARK", "QUIVER", "DWARF", "GRAB", "BOAR", "WREN", "BOX", "CARE", "SLUM", "PARE", "JERK"]
	}
},
{
	id: "da8e08f7-f742-4e32-b1c9-608c3702ca75",
	dateId: "20260406",
	puzzle: {
		letters: "HTEJMCSULOXPQRGKAFYVNBWDI",
		words: ["PUTSCH", "QUEST", "SPANK", "IVY", "JEST", "EULOGY", "BAWDY", "FAX", "MOLEST", "GLORY"]
	}
},
{
	id: "185033a8-4c83-4963-8d00-a19bc3a07822",
	dateId: "20260407",
	puzzle: {
		letters: "BQXVKCUEIJRFMSOPYLTDHGNWA",
		words: ["TAWNY", "GLYPH", "FEMUR", "CRUXES", "KIEV", "JOIST", "QUEST", "BUMS", "DAWN"]
	}
},
{
	id: "94029daa-31e7-4c63-aaa2-a9b57617709d",
	dateId: "20260408",
	puzzle: {
		letters: "KHNEWAUQSBLTJGMDORCIVPYFX",
		words: ["FIGS", "SQUALOR", "AUK", "HALO", "FIX", "TUNES", "DOLT", "PORTAL", "MICRO", "NEWS", "JOLT", "WEBS", "DOPY", "VOLT"]
	}
},
{
	id: "2b5ecc68-a590-468a-a664-a12f3165dcb8",
	dateId: "20260409",
	puzzle: {
		letters: "MBYFSAPXTRCDVOJGUINHQWELK",
		words: ["GUILE", "CAMP", "ROTS", "DIVOTS", "JOHN", "STYX", "ABY", "FRO", "WINKLE", "QUID"]
	}
},
{
	id: "82e64b56-3ac4-42d8-9d79-634e8652ee83",
	dateId: "20260410",
	puzzle: {
		letters: "GDLVNXOCKAMJBUQREFPIHWSYT",
		words: ["REFS", "QUIPS", "VAN", "HERM", "MOCKUPS", "TIPSY", "CLOG", "JOCK", "MEWS", "BOX", "DOMES"]
	}
},
{
	id: "b0fc6160-1872-4ad7-87a3-2e2454619083",
	dateId: "20260411",
	puzzle: {
		letters: "EXATGDNBLHWICMSPUVOKQRJFY",
		words: ["COMBINED", "COMBAT", "RUINED", "QUID", "VINE", "UPWIND", "FOCI", "BALMS", "JOY", "GLAND", "BATHS", "EXALT", "SMOKY"]
	}
},
{
	id: "39d1bd04-9361-4689-a0d8-06a0c77a4476",
	dateId: "20260412",
	puzzle: {
		letters: "JBEOXVACRWFLUDYSNQIMTHGPK",
		words: ["FLAUNTS", "CROWD", "MIGHTS", "COX", "QUIP", "JAUNTS", "ROWDY", "BAUD", "UNLACE", "KID", "SLAV"]
	}
},
{
	id: "9656e17c-800b-48e5-8354-a4e8aa3e5bdc",
	dateId: "20260413",
	puzzle: {
		letters: "GQYSPKNUCXJMIHEALDROFTBWV",
		words: ["PSYCHE", "EXHUMING", "WORDING", "TAMING", "FLAMING", "VOW", "UNJAM", "BLAMING", "BLINK", "QUICHE"]
	}
},
{
	id: "071f13fa-9d4a-47f3-9b05-d2065a6ce5af",
	dateId: "20260414",
	puzzle: {
		letters: "GYRDKLIUCTPVBQJONXAFWHMES",
		words: ["SEABIRD", "DRILY", "FAXES", "DRIP", "GIRD", "WHOP", "VOW", "BUCK", "DUCT", "JAMES", "QUIP", "NOW"]
	}
},
{
	id: "106d3d4e-cbbf-4a70-a9d9-61c832d0aa3e",
	dateId: "20260415",
	puzzle: {
		letters: "EWNGPMBOIFYDJXLCHVRQTSAUK",
		words: ["QUARK", "DOWN", "EMBODY", "VAST", "QUASH", "FLING", "CHAR", "JINGO", "FLIP", "BOXING"]
	}
},
{
	id: "48fa9342-f1fc-4356-bd19-145e3270ca51",
	dateId: "20260416",
	puzzle: {
		letters: "BLXFDROJIMEKVUCHWSNQTAPYG",
		words: ["GYPSUM", "JOKER", "BREWS", "FICUS", "GNUS", "BOX", "QUID", "HAWKER", "OVUM", "SWATHE", "BLOKE"]
	}
},
{
	id: "95c182d0-2e9e-4544-b2ab-3d560683a1d8",
	dateId: "20260417",
	puzzle: {
		letters: "FDNXJKRPEAVSUIHOQLMTYWGCB",
		words: ["FRUIT", "HAILS", "QUIPS", "CLIMB", "SPEND", "JAILS", "YOWL", "GLIA", "LURKS", "VOW", "AXE"]
	}
},
{
	id: "27540847-8c26-444c-bb83-b28e3584f8fd",
	dateId: "20260418",
	puzzle: {
		letters: "DRGEWYUCTPHQISKVOLMAFJXBN",
		words: ["DRUG", "JOIST", "QUITE", "OILMAN", "ASPECT", "SPEW", "VOICE", "HOLISM", "XMAS", "BASIC", "FOILS", "CRY", "BASK"]
	}
},
{
	id: "5d9aa940-4f94-4f8a-9bd1-52a0e3f058e1",
	dateId: "20260419",
	puzzle: {
		letters: "QDXGFPUJRYCAEWHBOKTVMSNIL",
		words: ["ACONITE", "VINO", "DUX", "JACOB", "SMOKER", "GREW", "MONTH", "TEACUP", "BAKERY", "FREAKS", "QUAKER", "KILTER"]
	}
},
{
	id: "f6fa7051-1b2e-4c07-94b3-4fb112361254",
	dateId: "20260420",
	puzzle: {
		letters: "SWMDIHKRUXGEYJQLVCANTOBFP",
		words: ["QUID", "REVOLT", "MURKY", "HERD", "RECAP", "FACER", "JACOB", "DUX", "CYAN", "SHE", "GLOVE", "WHEY"]
	}
},
{
	id: "824d5be4-0954-4f74-96f5-aa405ea69b8b",
	dateId: "20260421",
	puzzle: {
		letters: "FKCIJVENXMTHWYSOBDALPUQGR",
		words: ["ETHNIC", "BOTH", "KENYA", "FEN", "MINCE", "GALS", "DYNE", "JINX", "RAYS", "QUOTE", "WHOP", "VETO"]
	}
},
{
	id: "5de6339d-6c84-4780-a9b0-2baa7839d83b",
	dateId: "20260422",
	puzzle: {
		letters: "MPNADYUIWTCQJSXBLKFEGROVH",
		words: ["QUIP", "CLOVES", "DAIS", "UNWISE", "JUMPY", "HEX", "STAIN", "GLOVES", "FOLKS", "ORB"]
	}
},
{
	id: "b2b0f20a-2fe1-45e8-b700-59b862d961cb",
	dateId: "20260423",
	puzzle: {
		letters: "WHFTBCEXPLYSGIQJNROUKAVMD",
		words: ["VANS", "ORANGES", "DOGES", "RANK", "MORNS", "JARS", "CHEF", "BLIP", "LIQUORS", "CHEW", "EXT", "WHEY"]
	}
},
{
	id: "7866ec01-db4e-449e-9e9c-18e642c8ade2",
	dateId: "20260424",
	puzzle: {
		letters: "FDJWLYIOQMVTHCUKXSABREGPN",
		words: ["BASER", "QUASH", "RESHOW", "SCOWL", "CHAPS", "HASTY", "CAGES", "RESCAN", "MUCH", "CODIFY", "KEGS", "IVY", "JOTS", "EXT"]
	}
},
{
	id: "a9df0d44-7e50-4b11-a00e-c022d99def32",
	dateId: "20260425",
	puzzle: {
		letters: "GBWNFDYOUSLMQTRPIKEVCHXAJ",
		words: ["CHIMP", "MONSTER", "HIKERS", "GYM", "BONUS", "MIXERS", "AVERTS", "FUTON", "SNOWY", "CHILD", "JETS", "QUOTER"]
	}
},
{
	id: "4aaf90db-bcd4-4d90-9c19-1fd686ece71e",
	dateId: "20260426",
	puzzle: {
		letters: "SIMXTPHNUQWJOAGVBLRKDECFY",
		words: ["GAOLED", "BELFRY", "PINHOLE", "QUARK", "SHOUT", "JOHN", "ARCED", "WHORLED", "SPHINX", "MINOR", "VELAR"]
	}
},
{
	id: "8fa3812a-d36e-4ac6-a7bd-7807564d5820",
	dateId: "20260427",
	puzzle: {
		letters: "FNDQKMLAURPSXOTGIYECBJVHW",
		words: ["ISLAND", "CORK", "HECTOR", "QUALMS", "GIPSY", "CORTEX", "CHEW", "BIG", "JIGS", "FLAN", "VECTOR"]
	}
},
{
	id: "954afaaf-4aa7-416c-b861-20935a9ff815",
	dateId: "20260428",
	puzzle: {
		letters: "LVFXINUAMGQPSRHTEDCKWYJOB",
		words: ["MARCH", "QUARK", "FAUN", "UPSET", "JOCK", "MAXI", "DEWY", "VASE", "BODES", "ARMFUL", "GRASPED"]
	}
},
{
	id: "8fc82783-1307-4be7-839c-3dc7014cd5f9",
	dateId: "20260429",
	puzzle: {
		letters: "SYXMKDROECNGBTJPIFVAQUHWL",
		words: ["BECK", "HIND", "METAL", "INGOT", "LATEX", "FINDS", "ROBIN", "WHIP", "BOXY", "QUIP", "VAT", "JAW"]
	}
},
{
	id: "a39b3820-0628-4d99-a5d3-d2c92adcdf75",
	dateId: "20260430",
	puzzle: {
		letters: "XMCYTJOVKHWRGFADLQENIBUSP",
		words: ["GROWL", "SQUEAKY", "BILGES", "PEAKY", "SNEAKY", "COX", "MOCK", "VOW", "FANS", "THANE", "WORLD", "JOCK"]
	}
},
{
	id: "919208e2-38e4-4f2a-89dd-e539dec00fb0",
	dateId: "20260501",
	puzzle: {
		letters: "JMYANLOGHVDXSFWPUIECQBRTK",
		words: ["DOGFISH", "BUSHFIRE", "BRUSHY", "PUSHY", "NAGS", "BUXOM", "BISECT", "QUIET", "JOGS", "RESOLD", "KERB", "VAN", "BREW"]
	}
},
{
	id: "74ff99dc-2d2c-4dd2-900c-8db6972cc47a",
	dateId: "20260502",
	puzzle: {
		letters: "SLFQMNAEUWPBVIDJOXGCTRHYK",
		words: ["QUICK", "TOXIC", "FLANS", "SLEIGH", "DIVANS", "WICK", "JOB", "ABORT", "OVUM", "BOXY", "OPALS"]
	}
},
{
	id: "52d0e1f1-0a51-4ecb-b619-ddc68a2bddec",
	dateId: "20260503",
	puzzle: {
		letters: "YFWXHNAETGKJPVOIURLCSDQMB",
		words: ["JAPE", "QUIDS", "COVET", "NAPE", "CLOTH", "PURL", "BLOC", "TWEAK", "OLM", "CLOG", "YANK", "EXTOL", "FAN"]
	}
},
{
	id: "4857e58b-135e-4d88-8d70-e86bc10cd071",
	dateId: "20260504",
	puzzle: {
		letters: "ENPMJLQROBUDTXFKIVSYHGAWC",
		words: ["STOMP", "FORTS", "BORNE", "JOTS", "DIVAS", "GAITS", "QUITS", "PROXY", "IDLE", "HITS", "KITS", "CYST", "WAITS"]
	}
},
{
	id: "c98e877a-1c9c-47f5-9c13-44c974a05608",
	dateId: "20260505",
	puzzle: {
		letters: "QUGEBAXYIFCNHWTDKOLMSJVRP",
		words: ["AND", "QUACKS", "GUANO", "ANYHOW", "ONYX", "BEFIT", "JOHN", "NORM", "PROWL", "VOLT"]
	}
},
{
	id: "1b5e4223-c216-4666-911f-2a8f93666683",
	dateId: "20260506",
	puzzle: {
		letters: "PYKCUBIXQASLVMWREDOJNHGTF",
		words: ["GOVERN", "FOG", "DEVILS", "MODELS", "PILED", "WACKY", "QUACK", "HELIX", "JOG", "BILES", "PIVOT"]
	}
},
{
	id: "1bc6121a-66ae-43b1-a731-954583878af7",
	dateId: "20260507",
	puzzle: {
		letters: "YDHWMTVRALIOJFXUBGESPQKCN",
		words: ["IVY", "FLAXEN", "PUB", "FJORD", "WHARFS", "QUIT", "FROG", "MAJOR", "NECK"]
	}
},
{
	id: "895a7f18-2baa-47d0-ab31-4fb57285fd41",
	dateId: "20260508",
	puzzle: {
		letters: "DKNOCYRHTFAJGSLWVMIBEXUQP",
		words: ["PISTON", "BLIGHTS", "CONK", "GRAVE", "JAR", "FLIGHTS", "MIGHTS", "QUILTS", "VEX", "DRAW", "DRAY"]
	}
},
{
	id: "f1754765-1e35-4fb4-9047-c79c7be048c9",
	dateId: "20260509",
	puzzle: {
		letters: "MXTKVOHNGYCSAIWBUDEFJPQRL",
		words: ["SHADING", "JUDAS", "HANSOM", "XHOSA", "DEFIANT", "READING", "LEADING", "FEDUP", "DINGY", "WEANS", "VYING", "FIASCO", "KNIFED", "BUDS", "QUAINT"]
	}
},
{
	id: "66fe3e1e-3370-4a76-b468-cba2c3080ba4",
	dateId: "20260510",
	puzzle: {
		letters: "QUALTSYJDGVHBNMKEPFIOWXRC",
		words: ["QUAYS", "ADMIN", "BEVY", "HEX", "WOKE", "FIND", "JAYS", "CRIM", "GLAD", "ALT", "PHEW"]
	}
},
{
	id: "c7b9846b-6e8e-4684-a3c2-312b16ecbb66",
	dateId: "20260511",
	puzzle: {
		letters: "BVQHXCIURGMJTADKEWYPFLSNO",
		words: ["ELK", "FLEW", "DAYTIME", "XRAYS", "JUTE", "ONWARD", "VIM", "PARTY", "QUARTIC", "BITES", "HURT", "GRATES"]
	}
},
{
	id: "038f3832-1728-44e3-b950-094a77b3972c",
	dateId: "20260512",
	puzzle: {
		letters: "TOJFVRXPEMAKIGSUDCHLBQNYW",
		words: ["QUARTO", "TROPIC", "RADIX", "WHIP", "TROPES", "DIGS", "LYNCH", "KIEV", "DAUB", "GEMS", "JOT", "CHIEF"]
	}
},
{
	id: "d10a859b-e9b6-4d73-aa5f-926546ec3dd6",
	dateId: "20260513",
	puzzle: {
		letters: "CWTBXRDJOSPEKFGVMAQYHILUN",
		words: ["ALIVE", "HIVED", "LIMPED", "TOGS", "QUAKED", "WREAK", "BOGS", "BOX", "CREAK", "FAUN", "BOGY", "JOKED"]
	}
},
{
	id: "105f5f85-6636-4733-b307-e0b001c55f14",
	dateId: "20260514",
	puzzle: {
		letters: "IVQKSPEWUYGXNAJFORMCBDLHT",
		words: ["XRAYS", "QUAYS", "PEG", "VIEW", "JANUS", "WARMTH", "FORAYS", "DRACHM", "DOLMAN", "BONUS", "AUKS"]
	}
},
{
	id: "2f7d60fb-7e27-4c0b-95ab-11d18103a233",
	dateId: "20260515",
	puzzle: {
		letters: "XYNLIVAJGBFRSOPHCUTWKDQEM",
		words: ["SCURVY", "STEM", "POUCH", "BIGOTS", "FANGS", "QUOTE", "STEW", "DUETS", "FAX", "STUCK", "JOUST", "GLIB"]
	}
},
{
	id: "2606f2b3-04c4-4e91-b796-a2fedb798b63",
	dateId: "20260516",
	puzzle: {
		letters: "HTGSOFEKIMPXLJWNRUAYCDQBV",
		words: ["HEFT", "CRUX", "DUALISM", "JIGS", "BURN", "QUAY", "WALKS", "JULEP", "LIMO", "VALET"]
	}
},
{
	id: "8717c110-46a6-493e-bd26-0e2c8279f8b1",
	dateId: "20260517",
	puzzle: {
		letters: "CRTONKAJFWVSLHGBMIXEQUDPY",
		words: ["HEX", "CARTON", "TRACKS", "TALMUD", "FLACK", "JACKS", "VALID", "QUID", "LIMBS", "FLIP", "WHIMS", "PEG", "WHEY"]
	}
},
{
	id: "2e9d48c1-bfa1-4578-9fa4-6de6817d32b5",
	dateId: "20260518",
	puzzle: {
		letters: "JFUNDKOPQLYXTVASGERCIBWHM",
		words: ["HERALD", "EXPOUND", "POKY", "BEGS", "GERM", "IBEX", "CARVE", "QUOTER", "JOYS", "FOUND", "CHEW"]
	}
},
{
	id: "6f54733b-ed42-417f-a405-b5f41e3178d0",
	dateId: "20260519",
	puzzle: {
		letters: "QJWRCEUPOVNADGFLXBSHMYTIK",
		words: ["BALMY", "HITS", "PRODS", "WODAN", "EQUAL", "STYX", "VOW", "LAPDOGS", "FOGS", "CODA", "JUDO", "KITS"]
	}
},
{
	id: "0295b969-a8ff-4134-a437-6ece575a735a",
	dateId: "20260520",
	puzzle: {
		letters: "GAVWRNSXYDIOPKCHBUQLTJMFE",
		words: ["CLEF", "AXONS", "DRY", "JUMBO", "THINGS", "WRY", "SOUK", "NAVY", "POSING", "QUOINS"]
	}
},
{
	id: "b9938149-f9cd-4278-a03e-8a8e60f3c0b3",
	dateId: "20260521",
	puzzle: {
		letters: "KJGQSOBRUMLWEAVICPYNXFDHT",
		words: ["FIX", "GRANT", "HYPERBOLIC", "BLOWER", "MARQUE", "DYER", "SQUARE", "JOWL", "WOK", "GRAVY"]
	}
},
{
	id: "ba42274e-04a1-4a95-a824-e3e303efa67a",
	dateId: "20260522",
	puzzle: {
		letters: "NSWLVDOXGIFYAJETMRUCHKPQB",
		words: ["FOAMY", "MARQUE", "BURMA", "BURP", "GAMY", "CUB", "AXONS", "DONS", "FOWL", "SOFTY", "QUARK", "VIE", "JURY", "MYTH"]
	}
},
{
	id: "e0e0f988-61ea-443f-a052-16f64452ca67",
	dateId: "20260523",
	puzzle: {
		letters: "SPMNTEVHRBDLIUKCXFQGYOWAJ",
		words: ["QUIRK", "HIVES", "FOXY", "JAG", "SPED", "BUILD", "BURNT", "COW", "FIRM"]
	}
},
{
	id: "8186fe62-c735-4e02-a785-8136797365d5",
	dateId: "20260524",
	puzzle: {
		letters: "KUSTGLIQYADVWBJEFNPCHRMXO",
		words: ["COP", "LUSTY", "FERN", "GAYS", "HERM", "WILDER", "JAYS", "QUIVER", "BATS", "SILK", "COX"]
	}
},
{
	id: "36643468-158c-4d4b-8cf4-3ffce4108092",
	dateId: "20260525",
	puzzle: {
		letters: "HCIWQSYKUNPRGJTVEAMFOXDLB",
		words: ["QUICK", "PEDLARS", "LAXER", "LAGERS", "OVERS", "MARSHY", "GUT", "WICK", "JUICY", "UNJAM", "FLARED", "BLARED"]
	}
},
{
	id: "0c351bcf-9608-4155-a161-97f2a5543d13",
	dateId: "20260526",
	puzzle: {
		letters: "PVTJBWAOUQYLDMSHEXNKGCIRF",
		words: ["RICHLY", "ATOMS", "GEL", "QUOTA", "FRIED", "PALED", "WADE", "OVAL", "RINKS", "BUMS", "JUDO", "INDEX"]
	}
},
{
	id: "702c2327-82db-46f1-bf6d-12054fcfc8db",
	dateId: "20260527",
	puzzle: {
		letters: "FDVXTYREBSLIKCWPOUJANMHQG",
		words: ["UMPIRED", "VERILY", "EXT", "DEBTS", "WACKIER", "JUMPIER", "QUIRE", "FRIED", "HOLIER", "SWAG", "BECKON"]
	}
},
{
	id: "9af4dbec-e0ab-4d13-9b9f-234c40419066",
	dateId: "20260528",
	puzzle: {
		letters: "CMKPQGLAUBHNVRDFOXYTWISEJ",
		words: ["PARTY", "DRAM", "QUALM", "NOISE", "JET", "AVOW", "FIXES", "BRAVO", "AUK", "CLANG", "HOSE"]
	}
},
{
	id: "4eb595a9-3d0e-4188-9e2c-f98b4f99bc72",
	dateId: "20260529",
	puzzle: {
		letters: "VQUBPCAKMDHNYOXLTWGIRESFJ",
		words: ["CHANTER", "THANK", "VAN", "DOWSER", "JIGS", "MOWER", "QUAY", "FIGS", "BUMP", "FIX", "ANTLER"]
	}
},
{
	id: "53c7f55f-8bf2-4c83-9d1f-fead080b22d1",
	dateId: "20260530",
	puzzle: {
		letters: "WACRIGKVFMYNOBPLUTEDHQJSX",
		words: ["FOUNTS", "VOTED", "CRIMPED", "GAWKY", "HUNTED", "JEST", "IMBEDS", "LUTES", "QUOTED", "SEX"]
	}
},
{
	id: "f8ec03df-3f35-42c3-a14b-fa60d3112443",
	dateId: "20260531",
	puzzle: {
		letters: "QVMPKIULHRFDJGEOXYNBWSTAC",
		words: ["DIVULGE", "SODIUM", "JUDO", "ACNE", "DUMP", "SOW", "HEN", "FOXY", "BANGER", "GENTS", "QUID", "BERK"]
	}
},
{
	id: "51d05d43-c753-4506-a06f-b647234eae55",
	dateId: "20260601",
	puzzle: {
		letters: "XDTHGVEJOSKUPFYAQRINLWBCM",
		words: ["PURIFY", "GOTHS", "QUAKED", "VETO", "AURIC", "BRIM", "VEX", "LAKE", "BRINY", "WAKED", "JOGS"]
	}
},
{
	id: "a0fd73a1-7c24-4291-aef5-d5fb595b69bd",
	dateId: "20260602",
	puzzle: {
		letters: "NMHCWRLBKEYOSTFXJGDUVAPIQ",
		words: ["VAPID", "JOGS", "BORN", "QUIDS", "SKEW", "TECH", "FEW", "BOXY", "LOBS", "OLM"]
	}
},
{
	id: "75073547-f295-4696-b11e-cad8a2636858",
	dateId: "20260603",
	puzzle: {
		letters: "QARILGUTKNYHCWXPOMVESDJBF",
		words: ["TURIN", "FEW", "TRUCK", "CHOPS", "VEX", "KILN", "COMB", "QUARK", "JOCK", "CODS", "ITCHY", "CHUG"]
	}
},
{
	id: "fa39e3e5-3203-4603-b2c7-4162b91b0b69",
	dateId: "20260604",
	puzzle: {
		letters: "GTCSXIWVELUJFKHQAMOYDRBPN",
		words: ["YOKELS", "TWIG", "DRAB", "FARM", "SECT", "QUIT", "VEX", "POKES", "NOMAD", "HEX", "JAMB"]
	}
},
{
	id: "e8e4feec-9977-40cb-9bf2-ed63fe4e04d3",
	dateId: "20260605",
	puzzle: {
		letters: "XJBFIKOVDLYEAQMHSPUGRTWNC",
		words: ["HEAPS", "JOKES", "YEAST", "FILM", "PAVES", "SWUNG", "BOAST", "RHEA", "QUASH", "DASH", "BOX", "CUPS"]
	}
},
{
	id: "e30aefe8-af0f-4de0-b0ce-882afdf25d08",
	dateId: "20260606",
	puzzle: {
		letters: "TWNBFSPOCRJKQULXEHAGMIVYD",
		words: ["SPOKE", "BOPS", "FRUGAL", "OPTS", "HIVE", "BOWS", "GLUON", "CLAD", "CLAY", "EQUAL", "JEHAD", "HEX", "AHEM"]
	}
},
{
	id: "6d123edf-a3ca-43b9-a7fe-ae8f4f3c2c40",
	dateId: "20260607",
	puzzle: {
		letters: "HTRJUNGDAQWIPSMCLXOFKVEBY",
		words: ["LEOPARDS", "FOXING", "PLIGHT", "BOY", "JAMS", "QUART", "VEXING", "PICKLE", "WIDTH"]
	}
},
{
	id: "da43aec1-7340-44ea-8969-23f180d818be",
	dateId: "20260608",
	puzzle: {
		letters: "SGYBKDRJUQLVACEPITONFHMXW",
		words: ["GRAVITON", "AUK", "BUY", "NECTARS", "MOWN", "OXTAIL", "QUAIL", "JAIL", "MOTIF", "DRACONE", "PITON", "MOTH"]
	}
},
{
	id: "52ab169b-3fbd-48e0-91fb-b0688754e27d",
	dateId: "20260609",
	puzzle: {
		letters: "DNJPHTVAUGXRFCQKEMIOSLWYB",
		words: ["EXTRA", "JACOB", "HUG", "CAFES", "ACME", "QUARKS", "SKEW", "SERVANT", "RAND", "PARES", "ARMY", "ELKS", "MICA"]
	}
},
{
	id: "a424da14-448c-4620-a81d-fd26dbdda45e",
	dateId: "20260610",
	puzzle: {
		letters: "MWYJGISDHOVRUKPAQCXEBNFLT",
		words: ["CURDS", "VIRUS", "SWIM", "CRAN", "FLEX", "HYDRA", "IRAQ", "HOG", "JOKE", "KELT", "EXPO", "BARDS"]
	}
},
{
	id: "a98373ba-7d9d-407d-a39c-e6c0e3c93190",
	dateId: "20260611",
	puzzle: {
		letters: "DFKTIAQLPMJUEYXHRNOSWCBVG",
		words: ["FAD", "WRENCH", "BOGS", "CREPT", "ENVOYS", "JULEP", "HULK", "IMPEL", "BOXY", "QUENCH"]
	}
},
{
	id: "e6a101b0-73a5-4227-8cf9-aa783c9491eb",
	dateId: "20260612",
	puzzle: {
		letters: "MDLEBQIASVJUGFXHRKOTCNYWP",
		words: ["TOGAS", "JURY", "POKY", "MIDAS", "DALES", "CHUGS", "FAILS", "TOW", "FOX", "BEAD", "VEAL", "QUAILS", "CHURN"]
	}
},
{
	id: "8add95ff-6570-4ba0-bd54-7b4998bfad8d",
	dateId: "20260613",
	puzzle: {
		letters: "MRJFWAEXIGVTLBUOYDNQKSPCH",
		words: ["BUILDS", "BUNCH", "FIXER", "SKY", "GUILDS", "QUILT", "TAMELY", "VELDT", "OVATE", "JILT", "WILDS", "SPY"]
	}
},
{
	id: "7166a76c-b1c3-40e0-abcf-fde329213905",
	dateId: "20260614",
	puzzle: {
		letters: "BFLVYSREAPHOCJMNWKIUDTXQG",
		words: ["IMPALER", "CAVERS", "RECKON", "BREAM", "JUICE", "FRONT", "QUICK", "JUMPY", "GUM", "MIX", "SHOCK", "SHOWN", "CROWD"]
	}
},
{
	id: "8f2fae77-2c59-4a84-84dc-140da38fb0a1",
	dateId: "20260615",
	puzzle: {
		letters: "KBGSNRAECYPTFWXJOLIQDHVUM",
		words: ["DOTAGE", "HOD", "SYNC", "QUILT", "FATES", "JOLT", "FIX", "PATES", "BATES", "VOLTAGES", "WEAK", "BRAGS", "MILT"]
	}
},
{
	id: "493120cf-be4f-4380-ae0c-15fdf1a197ac",
	dateId: "20260616",
	puzzle: {
		letters: "BPXCVWLKIQYOHMUGJFTRASEDN",
		words: ["QUICKLY", "MUTES", "VIM", "HOGS", "BLOW", "LOFTED", "JOGS", "DRUM", "MIX", "TURN", "SAGO", "PLOY"]
	}
},
{
	id: "b042a8d3-1df2-41b5-8cee-14ddd92f6cd7",
	dateId: "20260617",
	puzzle: {
		letters: "KAVSJLTMOGNCYDWBERFPXHQUI",
		words: ["RENTAL", "BENT", "RECTAL", "AVOW", "HERD", "TALK", "EQUIP", "MALTY", "CLAMS", "JOGS", "FURY", "HEX"]
	}
},
{
	id: "31586533-787e-48b9-bfc6-ad6a85747a80",
	dateId: "20260618",
	puzzle: {
		letters: "LNWAJXITYHPUFGRMSQEDBKCOV",
		words: ["TAHR", "EQUIPS", "LIFE", "CODER", "EQUITY", "JAW", "COVER", "SQUINT", "DECKS", "MUFTI", "FIX", "EDGY", "BMUS"]
	}
},
{
	id: "e3046277-2e65-4c4a-96a2-6481261c4181",
	dateId: "20260619",
	puzzle: {
		letters: "SMHTOPILJYQDCFBUAWEXGNKRV",
		words: ["QUAKER", "SPICER", "VEX", "JOT", "NUDISM", "BERK", "GNAWER", "PILFER", "HILT", "SILTY"]
	}
},
{
	id: "a52eb0f7-c3c1-4066-9d47-f4e0d4a12b95",
	dateId: "20260620",
	puzzle: {
		letters: "TJCFSQUMOGKEANIHLBRVPDWYX",
		words: ["HEARINGS", "JUT", "BALD", "BLEARY", "SOARING", "FOAL", "HELP", "KELP", "VIRAL", "EQUAL", "MARBLE", "MARX", "WRINGS", "COAL"]
	}
},
{
	id: "e7efcda1-33b5-4e6d-a12f-030d8dbce3e1",
	dateId: "20260621",
	puzzle: {
		letters: "TFEQJYSNUBKDMCWIXAGOHPLRV",
		words: ["APHIDS", "BUMS", "AMNESTY", "JUNE", "GROW", "LARGO", "VOCAL", "FENDS", "KIDS", "RADIX", "QUEST"]
	}
},
{
	id: "b66d0b62-123f-43ae-8f36-348d08f8cd71",
	dateId: "20260622",
	puzzle: {
		letters: "XVKCQEWTIUASRNGHLBMYPFDOJ",
		words: ["MOD", "QUICK", "VESTING", "STRINGY", "WASTING", "FLASH", "JOBS", "PLASTIC", "SEX"]
	}
},
{
	id: "8e11c98e-517c-4af6-bb83-e2716b5fd84e",
	dateId: "20260623",
	puzzle: {
		letters: "LKHVFQURADJGISBWYTOCPEMXN",
		words: ["VARSITY", "COMETS", "BASTION", "JURIST", "BOX", "DABS", "GRABS", "HULK", "FAIRS", "QUIRK", "PETS", "STEW"]
	}
},
{
	id: "608ebcd3-b2a9-4142-8263-ecbcfc06a07a",
	dateId: "20260624",
	puzzle: {
		letters: "OKMGTWFQULBRIXYCADNPJSHEV",
		words: ["WOK", "SARDINE", "GLUT", "QUIDS", "BRAINY", "RADIX", "FINDS", "VENDS", "JADE", "CRASHED", "BARIUM", "PEN"]
	}
},
{
	id: "fa8ff2a3-1e05-416e-9f10-c6289ac53f22",
	dateId: "20260625",
	puzzle: {
		letters: "NXMPHIFQAJWEKUGVDYLBSTROC",
		words: ["CORDS", "FEDS", "GLORY", "VEIN", "TROY", "MAKE", "QUAKED", "FIX", "PAUL", "BULKY", "JULY", "WEDS", "HAKE"]
	}
},
{
	id: "adb81b50-2445-4727-bb2b-a26abd96afbc",
	dateId: "20260626",
	puzzle: {
		letters: "XEQSADURYPCJBVTNIGMWLHKOF",
		words: ["INJURY", "INCURS", "TYRE", "LIBYA", "WOMB", "QUERY", "KILN", "INJURED", "PAYS", "DUX", "NIGH", "CURVY", "FOG"]
	}
},
{
	id: "a5033a37-8097-4f20-8c09-95c151654b19",
	dateId: "20260627",
	puzzle: {
		letters: "JUNOBQAFWGMYLRHDVCEPTIXKS",
		words: ["PELVIC", "WRECKS", "MALES", "FLECKS", "BOWLER", "JUNO", "HECK", "EXIT", "RELAY", "DICES", "OGRES", "QUAY"]
	}
},
{
	id: "09c7c1b2-0a58-46d2-ab89-0a99626e547f",
	dateId: "20260628",
	puzzle: {
		letters: "OLQKDFHIUMVEPYXBRTASCNGWJ",
		words: ["KIEV", "HOLIER", "MUD", "REPAYS", "BERN", "WAXY", "QUIET", "CREPT", "PILFER", "GAPE", "JAPE"]
	}
},
{
	id: "e0957a8f-7d0c-4e27-a817-b354f50f3790",
	dateId: "20260629",
	puzzle: {
		letters: "NVHFRWOGAEQIBKJUPSYCMLTDX",
		words: ["HOIST", "GOWN", "CYST", "STYX", "FREAKY", "GIPSY", "DYKE", "LUMPS", "QUIPS", "JABS", "VOW"]
	}
},
{
	id: "e034fc90-6264-45a7-ace9-22f16a351856",
	dateId: "20260630",
	puzzle: {
		letters: "DPSLMRWQUBHEFAVCOKXTJYNIG",
		words: ["GIN", "PREFAB", "QUAKER", "CONKER", "CHEWS", "CONY", "JOKER", "DREW", "BMUS", "TAXI", "SLUM", "VAT"]
	}
},
{
	id: "edbf2e8b-eda3-4e10-af96-3c53825d5d0c",
	dateId: "20260701",
	puzzle: {
		letters: "STHFAOGDIVWJERPMUCXYBQKNL",
		words: ["EXPIRY", "QUERY", "DREGS", "BUCK", "JOGS", "STOW", "AFIRE", "MUCK", "LYNX", "HIDER", "AVID"]
	}
},
{
	id: "f61224cb-88ef-4b29-8a10-d5642fbaca30",
	dateId: "20260702",
	puzzle: {
		letters: "VDJKMEHNATBRCXYSOGIUFPWLQ",
		words: ["QUICHE", "ACORN", "YANK", "JACOB", "ACHED", "GORED", "GROWL", "VERBS", "CROPS", "MAXI", "FOBS", "TANK"]
	}
},
{
	id: "8227fb17-5963-47ae-bb41-b6513aa1a909",
	dateId: "20260703",
	puzzle: {
		letters: "QKIHSMURCNPFAOYVEXLBWJTDG",
		words: ["CHIRAL", "LYNCH", "GLOB", "CRUMPET", "QUARK", "WETLY", "LYONS", "VEAL", "SCALD", "SCARF", "JET", "AXONS"]
	}
},
{
	id: "d805d3d8-9d46-4d95-a7ae-8d0994640f0f",
	dateId: "20260704",
	puzzle: {
		letters: "NIDEPJXHUQSYBGAFOVRCLWMTK",
		words: ["QUART", "BOWL", "ARGUED", "ARM", "JINX", "BOYS", "VOW", "DUPE", "FLOW", "HIDE", "QUACK"]
	}
},
{
	id: "58415abc-cd3a-4ee9-86f1-a951a4a9acdf",
	dateId: "20260705",
	puzzle: {
		letters: "VBXCSGEQUWPDIKMTHLNJRFAYO",
		words: ["HANKIE", "RHINO", "FLANK", "KIEV", "SCUM", "THINLY", "QUID", "VEX", "JONAH", "DEPTH", "BEG", "SWUM"]
	}
},
{
	id: "d5da37bd-83b9-4798-9c3f-60c3b4f1234f",
	dateId: "20260706",
	puzzle: {
		letters: "XCDVYONIBQJWTUFMEGSRAHPLK",
		words: ["FURLS", "RUBICON", "AHEM", "RUSTIC", "GUTS", "COX", "PEGS", "SPEW", "JETS", "TURKS", "VINO", "QUITE", "DINTS", "RUBY"]
	}
},
{
	id: "733f745a-90c4-4d3c-aead-1b762ef9c3f3",
	dateId: "20260707",
	puzzle: {
		letters: "PVJOTAMSYDHLKGBFCRIWENQUX",
		words: ["CLAMP", "QUIRKS", "CHALKS", "TOYS", "WIGS", "SLAV", "JOYS", "DOT", "NECKS", "BIRCH", "CRUX", "FLAP"]
	}
},
{
	id: "bb105b48-5a49-4c3d-b36e-d1df096056d8",
	dateId: "20260708",
	puzzle: {
		letters: "GYCPMFRDHLQAVEJKUWTXINOBS",
		words: ["STEWARD", "INWARD", "UNWARY", "EXT", "QUOTED", "JETS", "ARCHED", "CRAVED", "HELM", "GRAVEL", "BOWED", "FADE", "HELP", "KNOBS"]
	}
},
{
	id: "e2b850f8-cba1-406c-b2ad-aa40c4932655",
	dateId: "20260709",
	puzzle: {
		letters: "KAJDMWLNPIBXYSGHURVTFQECO",
		words: ["FURS", "BLAND", "JAW", "GIPSY", "QUERY", "COVERS", "HUB", "IMPS", "BURST", "WALK", "CRUX"]
	}
},
{
	id: "8ff7a2bc-7fbe-41ea-a9e5-f0264b823b78",
	dateId: "20260710",
	puzzle: {
		letters: "PUQBRMIHTOLKXWFYDCSNGEVAJ",
		words: ["WORTHILY", "MILKY", "FORTH", "BROWNS", "JACK", "CAVED", "EDGY", "QUIP", "MIX"]
	}
},
{
	id: "44de75d9-fd7c-4a65-87cd-b38d12359e20",
	dateId: "20260711",
	puzzle: {
		letters: "HTQBNFEDUISRVMYLOPAGXWCKJ",
		words: ["UNIMPROVED", "CAVERS", "CORSET", "OVERPAY", "HEFT", "SLOVAK", "PROWLS", "BUMP", "SEQUIN", "CAGY", "JACK", "COX"]
	}
},
{
	id: "f5cab238-10b5-4b0f-8b22-57f1de0b8baf",
	dateId: "20260712",
	puzzle: {
		letters: "DKGSJQLFECUOTHRWAPYMVIXBN",
		words: ["VAULT", "REFLOAT", "GERM", "BYPATH", "LOATHES", "RETOLD", "QUOTER", "FOLK", "HYMN", "WATERY", "JET", "OPIATES", "TAXI", "CHEFS"]
	}
},
{
	id: "e86540b5-f260-4422-8417-0ab4a86f6590",
	dateId: "20260713",
	puzzle: {
		letters: "YBDSFXOKAWTNVJRELGICHUQPM",
		words: ["CRAWS", "BONE", "KNELT", "TONGUE", "PIGLET", "JAWS", "HEN", "PIQUE", "BOXY", "RADON", "FADS", "ENVOY", "CRIMP"]
	}
},
{
	id: "6cd447da-801c-4525-8191-dc05610977a5",
	dateId: "20260714",
	puzzle: {
		letters: "NOVEWRSYIMHTQJKBUDLCXGAPF",
		words: ["GUTSY", "BUTS", "CLAP", "JIVE", "STROVE", "SQUAD", "DUX", "VIEW", "MEW", "FLAG", "KIEV", "NORTH"]
	}
},
{
	id: "79273d32-5e4a-4b23-9dd5-9a6c0b5b43e9",
	dateId: "20260715",
	puzzle: {
		letters: "HFQUGMIAXBJLVDOKSCEPYNRTW",
		words: ["RECLAIM", "QUAVERS", "SCREW", "BUG", "MILKS", "TERNS", "ADOPTER", "HIVED", "FIVERS", "JIVED", "REDOX", "MILKY"]
	}
},
{
	id: "a83f75bb-44a2-4cf2-b44d-bc8e8508f1a9",
	dateId: "20260716",
	puzzle: {
		letters: "JWMRACOHFGIKXDSTUVPEQBYNL",
		words: ["FARM", "DENY", "DHOW", "JOCK", "LED", "RAGS", "BUXOM", "ESPY", "QUICK", "QUIT", "ENVY"]
	}
},
{
	id: "730670b0-17ca-4cd2-99d5-8a15b3576b38",
	dateId: "20260717",
	puzzle: {
		letters: "APSIRXMCUWLHOFQYEJNTBKVDG",
		words: ["QUICHE", "CHOMPS", "AXLE", "CONVEY", "FOND", "AMONG", "JOEY", "RICHLY", "KEY", "FONT", "WISP", "BEL"]
	}
},
{
	id: "f84d12b5-199f-414d-817e-cecb457e5b0e",
	dateId: "20260718",
	puzzle: {
		letters: "BCFPMOSJRQHGYAUKTWDIXELNV",
		words: ["DWELT", "WARM", "COBS", "EXT", "JAYS", "QUAYS", "PRAWN", "KELT", "VIA", "ETHOS", "DWARFS", "BOGS"]
	}
},
{
	id: "f3ce568e-3fe7-4b0a-970a-a0bc47921bc0",
	dateId: "20260719",
	puzzle: {
		letters: "DOKFMHJLNIVAPGUWTCEQYRXSB",
		words: ["SEQUIN", "PLOD", "AWRY", "JAPES", "APEX", "BEGIN", "HALF", "PLACES", "MINK", "VAT"]
	}
},
{
	id: "15d404d1-59f8-4ed3-aee0-7a646a581f64",
	dateId: "20260720",
	puzzle: {
		letters: "YCLOFKXAWDSTRNPBEUIMGJVQH",
		words: ["JEST", "TRACKS", "PIRATES", "MINARETS", "GESTURAL", "VIRTUES", "BERN", "CLOWN", "PIRACY", "WAXY", "HIRES", "QUIVER", "FOAL", "GERUND"]
	}
},
{
	id: "9d0769e7-f643-4fd2-b78a-65e333f9fb1c",
	dateId: "20260721",
	puzzle: {
		letters: "YRKNWDTOHEGSLUFBAVXQCJMPI",
		words: ["XMAS", "CALORY", "HEWN", "DRONE", "CASTOR", "PIQUE", "VALUE", "FEN", "JABS", "LAGS", "KNOTS"]
	}
},
{
	id: "471302ea-413a-4357-b388-9f326bcf0d40",
	dateId: "20260722",
	puzzle: {
		letters: "KCRVOAGIPWMDJLNQUEFHYXBST",
		words: ["FLICK", "OWL", "AGILE", "PRIDES", "VILEST", "QUEST", "FLESH", "ILEUM", "FLEX", "PLEBS", "OWN", "SEXY", "JEST"]
	}
},
{
	id: "823d4a2b-8a44-4267-8a1e-5658241d065f",
	dateId: "20260723",
	puzzle: {
		letters: "PFIGSRMNBCYHVOXQAJTWUKEDL",
		words: ["QUAKED", "RHYMING", "HAVOC", "SCOWL", "DETOX", "IMP", "JOBS", "FIBS"]
	}
},
{
	id: "05a0fd7b-5810-4b73-a6d2-cce357947480",
	dateId: "20260724",
	puzzle: {
		letters: "NWTXVDAGSIYUHMRQLBPEKJOCF",
		words: ["QUAGMIRE", "BLOC", "VISTA", "JOB", "PERISH", "SHANDY", "DAWN", "REMIX", "BULK", "REF"]
	}
},
{
	id: "0aebfa4b-bb09-4277-a078-8db3b7479068",
	dateId: "20260725",
	puzzle: {
		letters: "MAXYVRGIUQKPNDFHJOTBSCLWE",
		words: ["CODING", "FUNGI", "SCOWL", "QUID", "MARGIN", "AXING", "DOTE", "COPING", "MARK", "VYING", "JOLT", "LOCHS", "BET"]
	}
},
{
	id: "60f2b382-9fa4-4ac5-a0fa-d7b5889138e1",
	dateId: "20260726",
	puzzle: {
		letters: "TBMKSCJROVFAHIWUQNXEPGYLD",
		words: ["JAR", "FACT", "LYNX", "ROVING", "BRING", "MOVING", "HANGUP", "MOWED", "QUARKS"]
	}
},
{
	id: "e2640404-81d5-451f-8136-61792bc52dd0",
	dateId: "20260727",
	puzzle: {
		letters: "MXQYDBUIERHFPNKTASWCGJLVO",
		words: ["JAPE", "THUMB", "GASPER", "FINERY", "NEPAL", "PINKED", "COWL", "EQUIPS", "FIX", "SALVO"]
	}
},
{
	id: "6c1a2365-005c-4b3a-b32c-a48fe25cd279",
	dateId: "20260728",
	puzzle: {
		letters: "CBMSOKEDTFQNPGHUIYAXLJRWV",
		words: ["BENDS", "WAX", "MENDS", "BECK", "GAPED", "ENQUIRY", "VARY", "SOFT", "LINKED", "JINKED", "INDEPTH"]
	}
},
{
	id: "f517cc7e-b512-4560-be0e-956106b00af6",
	dateId: "20260729",
	puzzle: {
		letters: "QFWREPUXKCTSALBNOJIVDYHGM",
		words: ["RECLAIM", "CLASP", "DONS", "GHOST", "QUAKER", "STONY", "BLAST", "JAIL", "VIAL", "FUTON", "HOAX", "WRECK"]
	}
},
{
	id: "0a105124-e8a8-415f-8e7c-59f8d533d2dd",
	dateId: "20260730",
	puzzle: {
		letters: "YMKGPSUBNRQIFOVHCWDJXETLA",
		words: ["KNOB", "JOWL", "ADORN", "QUICHE", "MUSIC", "FICHE", "HEX", "TWICE", "BUSY", "VOW", "GROWL", "PRONG"]
	}
},
{
	id: "9e4edc61-9e4b-433a-8719-041de03ebcd9",
	dateId: "20260731",
	puzzle: {
		letters: "HCDJWXMROFEQYPTSUKLBVAING",
		words: ["KINGLY", "CROFT", "WORMY", "VAINLY", "FJORD", "SEX", "PORCH", "BLINK", "QUAKING"]
	}
},
{
	id: "451cfc7f-defb-406f-b56f-7140d9f90ae4",
	dateId: "20260801",
	puzzle: {
		letters: "NQUWPBRJACFOKYVLSEIHTXGMD",
		words: ["WAVIEST", "QUAKES", "BORN", "JOKES", "CAP", "DIGEST", "DIMES", "BOLTS", "EXT", "FORKS", "JOKEY", "HIKES"]
	}
},
{
	id: "6a72eb9e-58ed-463c-aff5-c9891079b677",
	dateId: "20260802",
	puzzle: {
		letters: "MTRGKIPALQHYCUNWBVODSEJFX",
		words: ["PRAY", "GRAPH", "NODULAR", "IMPART", "COX", "QUART", "FOCAL", "ALCOVES", "WEBS", "TALK", "JOCULAR"]
	}
},
{
	id: "7df030f4-a192-45cb-b7d0-003e8300527e",
	dateId: "20260803",
	puzzle: {
		letters: "NICGAUQPDJRKSOHLMTWBVEFYX",
		words: ["HOSTEL", "LEFTY", "ELMS", "ELKS", "RUIN", "SODA", "BOPS", "JOTS", "QUIPS", "TOPIC", "STYX", "GAD", "VETO", "TOWS"]
	}
},
{
	id: "2cbf78c8-5d2d-4296-bda9-0c7669e7d317",
	dateId: "20260804",
	puzzle: {
		letters: "XCGYLATBOFVEQNDRHIUSKPWJM",
		words: ["LYONS", "CATER", "EQUIP", "TAX", "BEHINDS", "JUDO", "WHEAT", "BERK", "CAVEIN", "FLOG", "MUDS"]
	}
},
{
	id: "66843de7-ef30-446f-bce7-351a57aa744a",
	dateId: "20260805",
	puzzle: {
		letters: "SOFMGXBHYWITKRLDPACNQUJVE",
		words: ["GYM", "CRAVENLY", "AUDIT", "BOX", "JACK", "WRACK", "PATHOS", "QUACK", "FOBS"]
	}
},
{
	id: "f4e603a4-5ef4-4f04-98df-964469f4f35c",
	dateId: "20260806",
	puzzle: {
		letters: "JBQECYOUDLTRWIFXKANHSPMVG",
		words: ["BOWING", "TRAILED", "JOB", "MARX", "WORKMAN", "QUID", "ELFIN", "DIARY", "TRAMPS", "VAMPS", "CEDING", "HIDE"]
	}
},
{
	id: "f1e3e175-0a38-4e03-83c4-45619cd623db",
	dateId: "20260807",
	puzzle: {
		letters: "HFYWDLSCNIPATEKJUXOMQGRVB",
		words: ["LATENCY", "FLAXEN", "ENTOMB", "GUTSY", "QUASH", "JUTE", "SPUTNIK", "ASCEND", "WINCE", "VOTE", "CENTAUR"]
	}
},
{
	id: "40e442d3-8733-4d1b-aed7-450936b8d130",
	dateId: "20260808",
	puzzle: {
		letters: "SYWLBNCOEVPDIHGQURAXMJKTF",
		words: ["RHODIUM", "FAX", "BLOCS", "SYNC", "TRIAGE", "VEG", "QUIRK", "HARDUP", "WEIRDO", "JUICY"]
	}
},
{
	id: "6a066d9e-4acf-4f82-b106-d25f0a59d8b4",
	dateId: "20260809",
	puzzle: {
		letters: "YGRJXCTSEFDALMPQUOIBWHVKN",
		words: ["CALIPERS", "CALMEST", "ADULTS", "GREMLIN", "FESTAL", "BIVOUAC", "QUALMS", "SEX", "HOLMES", "JEST", "SALTY", "WHOLES", "RELINK"]
	}
},
{
	id: "c7e385e3-ef36-491d-8f2b-4a865e4611a2",
	dateId: "20260810",
	puzzle: {
		letters: "DQGMVUAXITYNCSWBRJELKOPFH",
		words: ["ROPES", "MICRO", "DANCES", "AXIS", "HEW", "ITSELF", "QUAY", "JEST", "VICES", "PORK", "GAUD", "BORN"]
	}
},
{
	id: "692886fe-67bd-4a59-a040-c6747eba1396",
	dateId: "20260811",
	puzzle: {
		letters: "XUQTSCIPFLMVEBYRAHNODGKWJ",
		words: ["SLY", "GRAVEN", "MIXUP", "KNEAD", "EPIC", "EBONY", "FEAR", "KNOW", "QUIP", "HEARD", "ENJOY", "HEFT"]
	}
},
{
	id: "85385ddb-3518-4a55-a55e-8a85ae40162d",
	dateId: "20260812",
	puzzle: {
		letters: "HYRKBTGCOSDXJPVWELMAFIUQN",
		words: ["EDGY", "POCKS", "EXT", "FILED", "CROPS", "THY", "LEWD", "VAMPS", "JOBS", "OPAQUE", "NAPS"]
	}
},
{
	id: "77f23b3d-c850-4867-8ed9-42c3e3f25af5",
	dateId: "20260813",
	puzzle: {
		letters: "SFXCJPLHUDIVAQROWTYBNKMEG",
		words: ["CHAT", "DUX", "METALS", "CURB", "SLAY", "FLIPS", "OVALS", "LAWN", "QUAY", "JURY", "HAWK", "BEG"]
	}
},
{
	id: "811dcaef-4530-42c8-9af7-a57583f37a57",
	dateId: "20260814",
	puzzle: {
		letters: "ESDONXVICYFLHMPGRAWKBTJUQ",
		words: ["HALVES", "QUART", "BRAT", "WHARF", "CHIVES", "GLIM", "CHAMP", "HAWK", "JARL", "SEX", "NOISE", "DIVES", "CONY"]
	}
},
{
	id: "5961c7ae-710b-4ef6-9d40-35e532b80275",
	dateId: "20260815",
	puzzle: {
		letters: "LTCKNWAYEQMVFUPSOJIGBXDRH",
		words: ["MALTY", "MODIFY", "EQUIP", "BOX", "LACKEY", "GRIPE", "SMACK", "JOBS", "HID", "OVAL", "RIPEN", "WACKY"]
	}
},
{
	id: "5288339d-5a55-4e73-bcf2-289e966f6f0d",
	dateId: "20260816",
	puzzle: {
		letters: "DMSHGXNEBOVJYTKWILUFPCRAQ",
		words: ["BOG", "CRAFTY", "TEND", "LYNX", "FAULTY", "HOTLY", "JILT", "WILT", "IRAQ", "LUTES", "HEMS", "AUK", "VIRAL", "TULIP"]
	}
},
{
	id: "d4d35c10-45f3-4d69-a5ae-83fe8c1a53dc",
	dateId: "20260817",
	puzzle: {
		letters: "SOYAWHBLDPRCIGFJUXENQMTKV",
		words: ["OBLIGE", "HOLIDAY", "QUIET", "CURBS", "VEIL", "KEG", "CRUX", "BYLAW", "JUTE", "CLAP", "FEIGN", "MUCH"]
	}
},
{
	id: "a00ba203-25e3-4f20-8aff-d9985df638c9",
	dateId: "20260818",
	puzzle: {
		letters: "FLHPBREKDOXCMVYIWSUAGTQJN",
		words: ["TWIG", "BOP", "JUSTICE", "NAVY", "EXITS", "QUAY", "STICKLER", "HECK", "REMUS", "BODY", "FLECK"]
	}
},
{
	id: "7a38a78c-1c1a-4441-bd55-b7b97cd5ee14",
	dateId: "20260819",
	puzzle: {
		letters: "SYXRQDELUJBWVHAMOGINFKPCT",
		words: ["HAULED", "NAIVELY", "PINT", "GIANT", "OBEYS", "JULY", "FOWL", "QUAINT", "ANTIC", "SEXY", "HURLED", "MOVED", "WOK"]
	}
},
{
	id: "f1fef61a-299d-4de4-8ba6-66bdbe95b5ab",
	dateId: "20260820",
	puzzle: {
		letters: "MJPXKNOERDYBWGVLAUIHSCTQF",
		words: ["LAUGH", "MOWER", "BOWER", "VITALS", "DREW", "SCALY", "POWER", "JERK", "WIGEON", "EXPO", "FIG", "QUAY"]
	}
},
{
	id: "840f4a56-9b25-40b6-90eb-a4138d6d9dc8",
	dateId: "20260821",
	puzzle: {
		letters: "PCFTJEYLOWRKDBMQUIASNXVGH",
		words: ["SHADOW", "QUID", "TOMBS", "GAMBOL", "AVIDLY", "DUIKER", "CLOD", "PERKY", "FLYER", "JOBS", "DUX", "NUKE"]
	}
},
{
	id: "8e826e6f-a4ab-4608-90c6-e20ab6325f8b",
	dateId: "20260822",
	puzzle: {
		letters: "KLTOCGRFHIBDAMXNUJESQPYWV",
		words: ["CHIMES", "HARDUP", "JAMES", "BRAHMS", "MEXICO", "YEAH", "FAUN", "EARL", "GRAFT", "SWEAR", "VEX", "KRAFT", "QUARTO"]
	}
},
{
	id: "51514ac7-d4c4-46bc-93f3-17e08a2c6daf",
	dateId: "20260823",
	puzzle: {
		letters: "TBHLQIXSCUEMYOFPANRWJVDGK",
		words: ["FOULS", "GROUCH", "QUONDAM", "NAPE", "EMIT", "BIT", "CORK", "WRONG", "ANGRY", "JAMS", "VAMP", "APEX"]
	}
},
{
	id: "8a996a5f-acd7-48e6-9be8-73e3332517ba",
	dateId: "20260824",
	puzzle: {
		letters: "GTXKDREHLOVYCSBJIWMQPNFAU",
		words: ["FIVER", "BOLD", "FICHE", "JIVE", "NIP", "SQUAW", "GREY", "KOSHER", "SWAM", "EXT"]
	}
},
{
	id: "92955dc5-276b-4fbc-8cad-a844470dee48",
	dateId: "20260825",
	puzzle: {
		letters: "CHWMPYDIJAFVSRBLXTNOKEUQG",
		words: ["AMIDST", "JARS", "BAROQUE", "IVY", "CHIMP", "BARONS", "STRONG", "ELK", "FLEX", "WHIST"]
	}
},
{
	id: "922dc685-5acb-4fdc-a0c7-110e5c75835e",
	dateId: "20260826",
	puzzle: {
		letters: "LBXGFJWOMIEHNDUTCYQVKSPRA",
		words: ["DOWNY", "OBJECTS", "ODIUM", "GOWN", "SPRY", "VARY", "BOX", "FIG", "QUID", "PSYCHO", "BOWL", "HECK"]
	}
},
{
	id: "62bdb6f9-15be-4a97-8a85-c8bbb1488d43",
	dateId: "20260827",
	puzzle: {
		letters: "LYHDXSPGINBCKWRQUAOMEFTJV",
		words: ["ATOM", "SPHINX", "EQUATOR", "QUACK", "SYLPH", "BUCK", "CAFE", "GIRO", "HIND", "JACK", "VOW"]
	}
},
{
	id: "08b29f5f-5974-47b5-8780-ca6bb8db5ca6",
	dateId: "20260828",
	puzzle: {
		letters: "MFBHYJURSDQIGEPLNWATKXCVO",
		words: ["TAPERING", "VOTERS", "LINGERS", "JINX", "FRIGATES", "WATERING", "QUIRE", "CAPERING", "SERUM", "FRINGED", "SHRINK", "BREWING", "SHY"]
	}
},
{
	id: "39620bc9-aaa2-403e-83f7-2f047595bdaa",
	dateId: "20260829",
	puzzle: {
		letters: "GRVTHBKEDSXLJUMYOQNCPIFAW",
		words: ["FOLK", "DUSTER", "PIQUED", "BLED", "MUSTER", "ANUS", "JERK", "CUDS", "ERG", "FAWN", "FOXY", "VERB", "MUSH"]
	}
},
{
	id: "f0aa4b0f-da4f-4eaa-a9ec-ac334c1dfeb3",
	dateId: "20260830",
	puzzle: {
		letters: "NYQHCBURISKAPWTDEVOJLFGMX",
		words: ["CHIRPED", "MOPED", "STIPEL", "BURPED", "QUAKED", "SWIPED", "JOTS", "PAVED", "FEAR", "DEARY", "UNBAR", "POX", "GEAR"]
	}
},
{
	id: "8bd2e848-e91f-4530-9523-ff14ef69a42b",
	dateId: "20260831",
	puzzle: {
		letters: "YMVUCJOKIQXHTFNSAERWDBLPG",
		words: ["WREATHS", "PLEADS", "MOTHER", "LATIN", "VITAL", "CITE", "GREAT", "QUITE", "BATIK", "AHOY", "JOT", "RELAX", "BEFIT"]
	}
},
{
	id: "ed58cab8-e840-4f2f-9e74-b40336d40edd",
	dateId: "20260901",
	puzzle: {
		letters: "DPRQJVOKUGLNMSAEXWFYBHTIC",
		words: ["ICY", "PRONE", "JUGS", "DOLE", "NEXT", "QUAYS", "SWIFT", "THEN", "MONKS", "BEL", "VOLE"]
	}
},
{
	id: "d8b39c11-9948-4072-8df9-54a53d33e803",
	dateId: "20260902",
	puzzle: {
		letters: "YKCDNIGBAHMFQUTLOSREJWXVP",
		words: ["QUACK", "FOX", "FLOWS", "NATURE", "SQUAD", "HATERS", "MOSQUE", "FIG", "BURP", "REVS", "TACKY", "JOWL"]
	}
},
{
	id: "10ba2cc0-aa49-480b-a90b-654a86977c38",
	dateId: "20260903",
	puzzle: {
		letters: "GQBIRUASJDVFETCPKHLMOXWYN",
		words: ["SEABIRD", "SAFELY", "POX", "HYMN", "KELTS", "WHET", "VASTLY", "QUASI", "CLEF", "JEST", "BAG"]
	}
},
{
	id: "8d34554c-ed97-49d0-a0a6-d163b69a563c",
	dateId: "20260904",
	puzzle: {
		letters: "NWXDMFOJELRGTPVKIUSBYCQHA",
		words: ["SUITOR", "VELD", "LEPTON", "BASTED", "FOXED", "JETS", "HASTED", "UPTOWN", "ITEM", "EXOTIC", "QUIRKY", "GUSTED"]
	}
},
{
	id: "bfe4ceff-84be-4ee8-9e36-e7b8d9c8fa60",
	dateId: "20260905",
	puzzle: {
		letters: "QUEVPWKCRFOMYLTHJGBADSINX",
		words: ["TANGIBLY", "JOKER", "BANISH", "FLAB", "HOMY", "FLAX", "QUERY", "DHOW", "PRE", "CLANG", "VERY"]
	}
},
{
	id: "237f1633-e4e9-485b-83b2-31736b3a65ec",
	dateId: "20260906",
	puzzle: {
		letters: "YGQNJRWUDECVOTHLFKPXBAMSI",
		words: ["CLAMPS", "FLAK", "POUND", "JET", "DOWRY", "SIXTH", "DUG", "VOTED", "FLAB", "QUOTED"]
	}
},
{
	id: "06fb584c-30a3-4ca1-a28f-f627a41552ae",
	dateId: "20260907",
	puzzle: {
		letters: "PXCKLTHENIGSWUVRABMQDFJOY",
		words: ["INWARD", "NEWSBOY", "UNLIKE", "JABS", "PHEW", "MUNCHES", "INCEST", "FAST", "NEXT", "QUINCES", "VINES", "DRAGS"]
	}
},
{
	id: "0aca0002-461e-4de8-9a54-ed93360dd083",
	dateId: "20260908",
	puzzle: {
		letters: "YHPMAXODFVCKJRTIGQELWUNSB",
		words: ["COX", "UNSET", "AFTER", "HOCK", "VAMP", "BELT", "QUICK", "JOCK", "GUNS", "DOCK", "WICK", "COY"]
	}
},
{
	id: "e9c8171a-893a-4ed0-a835-c0de406f93b1",
	dateId: "20260909",
	puzzle: {
		letters: "RHBXGEJSUYNWALQDIKVMCFPOT",
		words: ["GUSHER", "BUY", "LUSHER", "JAWS", "QUALM", "SHREWD", "VAINER", "TOPIC", "FINER", "AKIN", "LUX"]
	}
},
{
	id: "f9f1b1ac-4008-4c5d-b100-70f93591f0a6",
	dateId: "20260910",
	puzzle: {
		letters: "VINBFTDPGOQXEYLSURWCKMHAJ",
		words: ["QUERY", "TINGLY", "JAWED", "INDEX", "BOGEY", "FOGEY", "PERMS", "HARED", "VIPER", "HUSK", "CARED"]
	}
},
{
	id: "78d82aeb-64a1-4167-86e6-3c13e5da17c9",
	dateId: "20260911",
	puzzle: {
		letters: "PNTEWORDKQCVXIUMAHLGFJBSY",
		words: ["DEW", "HIKED", "PROVABLY", "MACRON", "CAVORTED", "MAXI", "FAB", "QUID", "SLIDE", "GLIDE", "JABS"]
	}
},
{
	id: "f373f70d-042a-4c7f-95f9-0c7f6a7b2299",
	dateId: "20260912",
	puzzle: {
		letters: "YLPIFOMUQRKVBSTCEGWAHNDXJ",
		words: ["PLUMBED", "ATRIUM", "JAWS", "CHEKOV", "FIRST", "OLYMPUS", "SQUIRT", "TAX", "BENCH", "GECKO"]
	}
},
{
	id: "932f67f0-c60a-4941-8a7b-0089eac271e1",
	dateId: "20260913",
	puzzle: {
		letters: "HCWKATIDRUNFXVQSGMOBYPELJ",
		words: ["DINGY", "BOXING", "MOLE", "QUARK", "JOB", "CHINS", "PEGS", "WINGS", "VOLE", "THINGS", "FINS"]
	}
},
{
	id: "d3e5458a-60d6-45c8-965b-e77bb352ac71",
	dateId: "20260914",
	puzzle: {
		letters: "PHQVMDIUJECLGRKONXSFWYTBA",
		words: ["CLOWN", "FAST", "BASK", "PIGSTY", "JERKS", "LURKS", "HUGS", "QUID", "REM", "ONYX", "REV"]
	}
},
{
	id: "a3155c06-fb7f-4f70-bb5d-2e0fda13b5e7",
	dateId: "20260915",
	puzzle: {
		letters: "KFOGBSMJIDACRLVHNYEXWTQUP",
		words: ["SCANTY", "FOIL", "BIRCH", "GIVER", "QUERN", "CASK", "JIVE", "WHAM", "PERCH", "VEX", "DIRELY"]
	}
},
{
	id: "20532b27-0378-4834-bfa4-88546972398e",
	dateId: "20260916",
	puzzle: {
		letters: "BXMDHAVLCKUTOJSQERIFYWNPG",
		words: ["TAX", "RETOLD", "FINER", "CORNET", "SINEWY", "EQUATOR", "PINE", "OLM", "BATE", "OVATE", "GIRO", "LOCKS", "LOCH", "JOINER"]
	}
},
{
	id: "f5530cdd-6577-4417-92ec-7a13b497d978",
	dateId: "20260917",
	puzzle: {
		letters: "ELGWSYMXOPRNHCTVADKIJFBQU",
		words: ["POTCH", "BAND", "OGLE", "VARY", "QUICK", "CHOW", "CHOPS", "FARM", "LYNX", "JAB"]
	}
},
{
	id: "9a891472-d9d9-4b35-9fa3-3a64458259a7",
	dateId: "20260918",
	puzzle: {
		letters: "YNATXQUJILBPWFKMSECOHRGVD",
		words: ["LITANY", "COVERS", "QUAIL", "PUBS", "SHREW", "GECKO", "DOVER", "JAIL", "FIX", "GERMS"]
	}
},
{
	id: "b01c4f08-3130-4857-b45d-6c0a976234b1",
	dateId: "20260919",
	puzzle: {
		letters: "TNKRLPCEWOAXBVJHUQSMFYGDI",
		words: ["EXACT", "HUBCAP", "LOVER", "QUACK", "DIMS", "JOWL", "WOVEN", "BUY", "FUG"]
	}
},
{
	id: "6f567142-496b-40d0-b5d3-21263792b17e",
	dateId: "20260920",
	puzzle: {
		letters: "YPCLDNVISBQUJFXWTGKRHEMAO",
		words: ["FRAME", "NUTMEG", "BLIP", "WHET", "MARX", "ROAM", "IVY", "JUTE", "MARK", "GUILDS", "CLIP", "QUIP"]
	}
},
{
	id: "178e73e3-d941-43e9-9076-1e1241ca31c7",
	dateId: "20260921",
	puzzle: {
		letters: "DXFYSLBECRVATOKIHPUJWMQNG",
		words: ["LATEX", "IMPUGN", "UTAH", "BEATUP", "OUTCRY", "SCOUT", "QUOTA", "FETAL", "BALD", "JOCK", "VIAL", "WHAP"]
	}
},
{
	id: "dae04344-f357-4f74-b6fe-04b015ec70a6",
	dateId: "20260922",
	puzzle: {
		letters: "VNJWOXERHKTBAIFSMCGUPLYDQ",
		words: ["STEAMY", "FIRE", "HAIRNET", "WHAM", "AMPLY", "JETS", "QUIRE", "VERBS", "NEXT", "WOK", "DUG", "CIGARET"]
	}
},
{
	id: "da58f4be-b896-4a96-8c98-ddd867758db5",
	dateId: "20260923",
	puzzle: {
		letters: "TOICRKNJEPXDHUWMYABQGFVLS",
		words: ["REJOIN", "GYM", "PUBS", "BLAH", "CREW", "FAB", "SQUAD", "HADNT", "SLAV", "KNOT", "JINX"]
	}
},
{
	id: "53bd8bd6-872e-421f-8f9c-f63117780d76",
	dateId: "20260924",
	puzzle: {
		letters: "NWORBDGLFKQUCYTXPAESIJMHV",
		words: ["JAMES", "HAYLOFT", "TEMPI", "VEST", "TEACUP", "DULCET", "FLOWN", "GULF", "FORK", "FLUX", "BROWN", "QUAYS"]
	}
},
{
	id: "4edcd193-152a-49c1-80f9-7db58e642722",
	dateId: "20260925",
	puzzle: {
		letters: "EGJDBLVQIFCWUXNRTOPSYMHAK",
		words: ["HASP", "OUTCRY", "VEG", "FINS", "JINX", "BINS", "QUID", "CLEG", "OAKS", "MOUTH", "HOWL"]
	}
},
{
	id: "c7441c49-180b-42b5-86b0-f938e5e202cb",
	dateId: "20260926",
	puzzle: {
		letters: "EHODSFWPKLVJCYXIUARTMQBNG",
		words: ["DOPY", "TRACKS", "MUCKS", "VIM", "PHEW", "JACKS", "BUCKS", "XRAY", "ANGRY", "LYRA", "QUACKS", "FEW"]
	}
},
{
	id: "38c943bc-d9de-4d0f-92de-1a4911a7cd1a",
	dateId: "20260927",
	puzzle: {
		letters: "EMKXSPQUCINTDAGVOLFHWBJYR",
		words: ["TOLD", "JOLT", "EQUAL", "FRY", "BLACK", "DAIS", "DUMP", "HALON", "VOLT", "DUX", "MUDFLOW", "GADFLY"]
	}
},
{
	id: "994f2b2a-e02f-4cbf-b83d-133968dcb018",
	dateId: "20260928",
	puzzle: {
		letters: "YDSVKMLEAGJFNHBQUXCRPIOWT",
		words: ["LEAK", "DEFUNCT", "BASELY", "GAVEL", "RHEA", "COUP", "QUIP", "COW", "COX", "JUNE", "HELM"]
	}
},
{
	id: "a5f3078c-6b79-4b4d-b50e-3b4915338944",
	dateId: "20260929",
	puzzle: {
		letters: "POHYJCRTGAVXSUDMELBQWKNFI",
		words: ["BUSTY", "MEN", "AUTHORS", "SLUDGY", "CORSE", "FIBS", "BULK", "VEST", "QUAY", "JAG", "PORTS", "BLEW", "FLEX"]
	}
},
{
	id: "062c69e7-4c6e-48b3-ad95-74839f98d203",
	dateId: "20260930",
	puzzle: {
		letters: "TUCGPDIQAJKMSRBXONYEFVHWL",
		words: ["VOMIT", "FOX", "KID", "PARSIMONY", "WHOM", "BARELY", "ACQUIT", "JARS", "BRAG"]
	}
},
{
	id: "e6b16ac0-b303-4028-acee-effc5db78b17",
	dateId: "20261001",
	puzzle: {
		letters: "DEGYVUTSRAQWPBKMILFOJNXHC",
		words: ["OBLIQUED", "BARGED", "GRAVY", "HOBS", "DUETS", "MINX", "SWIM", "KARST", "FLIPS", "COBRA", "JINX"]
	}
},
{
	id: "f6e5e0ae-852c-417c-9bb2-d4fb26960ca4",
	dateId: "20261002",
	puzzle: {
		letters: "HQUIPSJGTDRFOXNVAWLYMECKB",
		words: ["JOWL", "CARVE", "FOXY", "SQUID", "QUIP", "MARSH", "CLOG", "BLOT", "WACKY", "LYNX"]
	}
},
{
	id: "670a54e4-05d6-45af-b07d-82f0c69757f3",
	dateId: "20261003",
	puzzle: {
		letters: "YDBGQOREUNKJWVHPMSTAFILCX",
		words: ["FILMS", "HUNGER", "BREWS", "BERK", "STAVED", "REDO", "TAX", "CLIP", "QUERY", "JERK"]
	}
},
{
	id: "791e0876-2028-47ad-8892-a74099c97075",
	dateId: "20261004",
	puzzle: {
		letters: "BYAPFVMCEHQIGXDNULORSJWTK",
		words: ["APEX", "LIMB", "GLOW", "MILORD", "INSULT", "JUICE", "DECAY", "WORK", "QUILT", "VICE", "FED", "HEAP"]
	}
},
{
	id: "ebfb4fd7-cb59-4493-a8f4-3baf9c8f71c1",
	dateId: "20261005",
	puzzle: {
		letters: "WGUQJXIDLAHBSPVKCOETFRYNM",
		words: ["BONES", "WISE", "ORCHIDS", "QUIDS", "CROPS", "FROCK", "SPENT", "JAPES", "GUISE", "NOSEY", "COEVAL", "SIX", "MESON"]
	}
},
{
	id: "bf0bba61-cd3c-4ce8-b8d0-501dd165dde8",
	dateId: "20261006",
	puzzle: {
		letters: "MSHOTYCPKFVNABIDWEJRGLXUQ",
		words: ["SPAWN", "ENVY", "RIFT", "QUENCH", "CANDLE", "IBEX", "BEAK", "MYNA", "JAB", "PSYCHO", "GLEAN"]
	}
},
{
	id: "925d10d4-5570-42f1-83f3-069dc00a9682",
	dateId: "20261007",
	puzzle: {
		letters: "INGFLTVOPYQCWJMUASHEDXBRK",
		words: ["DUCTING", "COPY", "HERBS", "WASHER", "DUX", "QUASH", "VINO", "HEMP", "FLY", "JERK"]
	}
},
{
	id: "efbb120d-cf52-4b97-8a58-711a9d682701",
	dateId: "20261008",
	puzzle: {
		letters: "DHXQMOSJUKFYAGNVITWRPBLCE",
		words: ["XHOSA", "GAYS", "GUM", "BLIP", "GUNK", "JAIL", "QUAIL", "RECTIFY", "SHOD", "IVY", "WAIFS"]
	}
},
{
	id: "f7244559-8da5-4f24-84a5-124a116059d6",
	dateId: "20261009",
	puzzle: {
		letters: "KPTVBEDMWOXIYSHGLJFQCRAUN",
		words: ["SHOWY", "BOWS", "KEPT", "JARL", "ARC", "LIMPED", "FAUN", "GLIDE", "SQUALID", "VOWS", "MIXED"]
	}
},
{
	id: "9b625019-fb6f-4b63-80cc-c9db28849bf2",
	dateId: "20261010",
	puzzle: {
		letters: "KRQAVFGUHSPMDTYIXEOCNJWLB",
		words: ["GUTSY", "QUASH", "VAST", "JINXED", "CLOTHS", "BLOWED", "TURF", "MURK", "PIXEL"]
	}
},
{
	id: "4d481fd8-5046-40d1-8b32-478588f864eb",
	dateId: "20261011",
	puzzle: {
		letters: "GTMCQKASUXROJEPLWYBVNDHFI",
		words: ["WORLD", "SOWN", "FIVES", "LOAMS", "PUMAS", "WHY", "STARK", "GAOL", "VIBES", "QUEST", "IBEX", "MAJOR", "CUES"]
	}
},
{
	id: "30584e00-4d19-4ac3-aa5c-9c6e572475ef",
	dateId: "20261012",
	puzzle: {
		letters: "EBMWOGSPHCFQAVXTURNYJKDLI",
		words: ["COWHAND", "HARDLY", "CHAPS", "JUT", "NAVY", "FUR", "QUARK", "LYNX", "BEGS", "ANIL", "CHASM"]
	}
},
{
	id: "7788b7c4-1b2a-40ac-b49f-0797a8d49e25",
	dateId: "20261013",
	puzzle: {
		letters: "XFVOPDATKGWRLNHBIEUJMYSQC",
		words: ["BYELAW", "OVARIES", "DRAFT", "HUES", "CUES", "RELAX", "RISQUE", "GNUS", "ATOP", "JUNTA", "MILER", "KNELT"]
	}
},
{
	id: "cf3d8bc5-6e2d-46b0-b03c-871551fd30e3",
	dateId: "20261014",
	puzzle: {
		letters: "XDWTSHOPEKNMRUYVIFCQGLBAJ",
		words: ["HOPES", "ACRES", "MOWER", "BLIMP", "ERUPTS", "CROWD", "POX", "DOPEY", "JAB", "PESKY", "VINO", "GIRO", "QUEST", "SERIF"]
	}
},
{
	id: "f1472453-97a4-43b7-8b7a-b23622be4602",
	dateId: "20261015",
	puzzle: {
		letters: "FKMHCJLAGEQUPBSRDVOWYTIXN",
		words: ["BAULK", "BEHALF", "FLAGS", "GABON", "QUALM", "PAGES", "JURY", "AUDIT", "BOWS", "VOID", "CHALK", "BOX"]
	}
},
{
	id: "d0ca9438-77db-4cbb-9529-11fc7f5b06c8",
	dateId: "20261016",
	puzzle: {
		letters: "JQNWDXEUABKVSHCLMTGIOPRYF",
		words: ["BACH", "JEST", "DANES", "FIGHTS", "KEN", "OPTS", "VESTRY", "SEX", "CAUSE", "OLMS", "QUASH", "WANES"]
	}
},
{
	id: "8bcc8cbb-9580-470f-8392-ec58e30d5056",
	dateId: "20261017",
	puzzle: {
		letters: "MPQAGVUBKFSIDEWRXCLHYNOJT",
		words: ["RICE", "FELONY", "FEDUP", "MUSIC", "VICE", "BAKED", "WELD", "HELD", "QUID", "BELT", "BAG", "JOLT", "OXIDE"]
	}
},
{
	id: "f336da50-3519-49b4-b668-253b14a6795f",
	dateId: "20261018",
	puzzle: {
		letters: "VDNCYFEKHLXSJAWIRUPGMQBOT",
		words: ["TOGA", "JAG", "MIXED", "WAKED", "CLAUSE", "FEND", "QUAKED", "BRISK", "CHAP", "WHY", "VEND"]
	}
},
{
	id: "f559835b-9f6e-410e-b79c-a3d34162b72d",
	dateId: "20261019",
	puzzle: {
		letters: "TJWVGOYPEXNHBAFIULSDRMQCK",
		words: ["BEG", "PHONY", "ALBUMIN", "TONY", "BASK", "JOHN", "APEX", "BEADS", "SQUIRM", "FADS", "WEAL", "CLUBS", "VEAL"]
	}
},
{
	id: "d29c89c0-af04-4083-8eb9-b3e5e36016e7",
	dateId: "20261020",
	puzzle: {
		letters: "FATBVJKRELNWGUXYOQHICPMDS",
		words: ["CONK", "COPY", "QUIDS", "BLURT", "JARGON", "VERB", "LUREX", "GOWN", "BLUISH", "FARE", "MOGUL"]
	}
},
{
	id: "2dce24bd-65e9-4325-b884-9a8eb234b7a5",
	dateId: "20261021",
	puzzle: {
		letters: "NPMUIGAJRQVKEHYFWXLDCOSTB",
		words: ["OSTLER", "QUIRE", "FOX", "VAMP", "HELD", "JUMP", "SOWER", "COSTLY", "BLEAK", "LEAN", "PANG"]
	}
},
{
	id: "4b0aa763-3cd1-4452-b886-811392d7679d",
	dateId: "20261022",
	puzzle: {
		letters: "GPBVFKNIRDLYAEWTQSXCMUJHO",
		words: ["FRANKLY", "COXED", "MUSED", "BRAYING", "JUT", "BRASH", "WEARING", "IRAQ", "SERVING", "PINKY"]
	}
},
{
	id: "1176f61a-06d3-4ca8-acb9-1dbe69005881",
	dateId: "20261023",
	puzzle: {
		letters: "JRTFDWESAYQUNHXMVIOCPGBLK",
		words: ["FASHION", "EQUINOX", "SUMP", "CHOLINE", "COINERS", "MUSHY", "ANVIL", "BLOCK", "JEST", "STREW", "GINS", "DAFTER"]
	}
},
{
	id: "d64d8cc6-f508-439d-9d9a-87f493626ee9",
	dateId: "20261024",
	puzzle: {
		letters: "CSXYAHOJDKVLUNMWEQIFRBPGT",
		words: ["ADMIT", "SOLVER", "JUNIPER", "COVER", "BREW", "EQUIP", "SHOVEL", "PINKY", "UNFIT", "GIFT", "COX"]
	}
},
{
	id: "92d5d6cb-1313-494c-b8e6-5f92317d4abc",
	dateId: "20261025",
	puzzle: {
		letters: "EUQHOTSJWGMXACNYRVBLFPKID",
		words: ["DIVAS", "BASQUE", "WAXY", "PRAWN", "WARMS", "JUST", "CASTE", "FRY", "GOWN", "BARK", "KILN", "HOG"]
	}
},
{
	id: "e11019bc-4f92-4a67-8394-cb24fc9fb46f",
	dateId: "20261026",
	puzzle: {
		letters: "KSPUTEBIQHNMVROWAJGLYXCFD",
		words: ["VANES", "CANES", "QUIPS", "IBSEN", "LOGJAM", "THOR", "GOLD", "FLOG", "WAXY", "RISK"]
	}
},
{
	id: "10799bc9-778f-4894-a18a-60b1c861989c",
	dateId: "20261027",
	puzzle: {
		letters: "QJESWGUMTALKRFVBODIXPNYHC",
		words: ["FIRMEST", "WAFTS", "HYDRO", "METRIC", "PORTS", "QUEST", "GLUES", "BLURTS", "LURK", "FIX", "NORDIC", "JEST", "DIVAS"]
	}
},
{
	id: "b3d789f0-d235-470e-aedf-a3e4710501ef",
	dateId: "20261028",
	puzzle: {
		letters: "BOCXNSQLAKUHJTMDERYWVGPIF",
		words: ["GRIPED", "SHRED", "MALTY", "LACQUER", "CLANK", "WIPED", "VERIFY", "JACOB", "LAX"]
	}
},
{
	id: "29894f84-1670-4c3c-8a33-b4220485c2fe",
	dateId: "20261029",
	puzzle: {
		letters: "JKSRDOGCETNLHBQFYIAUPMVWX",
		words: ["WAVILY", "DECKS", "QUAIL", "CHIMP", "ABET", "WAX", "FLOGS", "BECKON", "JOGS", "RECKON"]
	}
},
{
	id: "f4faed06-d720-420a-8e24-dbc5cce119ad",
	dateId: "20261030",
	puzzle: {
		letters: "PBQUEWIKRHTNJFDMVLOGXASYC",
		words: ["JOYS", "TWIN", "FLOG", "SLAM", "PIQUE", "SLAV", "COLAS", "HERD", "BIN", "KNIT", "FLAX"]
	}
},
{
	id: "cf158474-c31e-4d60-a0ea-76c5b6f65344",
	dateId: "20261031",
	puzzle: {
		letters: "IMQAYLSUWPHDJFGOXERCVTNKB",
		words: ["DENT", "SQUAW", "MILDER", "FEDS", "ERG", "MUSH", "VOTED", "BRED", "CREDO", "QUAY", "JERK", "PAW", "EXODUS"]
	}
},
{
	id: "5000a21e-ad37-4bb3-8029-59d82b53d53a",
	dateId: "20261101",
	puzzle: {
		letters: "MHUQSGRETJWKYODBXVFPNILAC",
		words: ["STYX", "VOYEUR", "DOER", "POETS", "BIN", "TURKEY", "WRY", "CALVIN", "FOYER", "HERM", "GREY", "QUERY", "JOEY"]
	}
},
{
	id: "6b485cc6-052a-452b-ac13-9a8b5d6940bb",
	dateId: "20261102",
	puzzle: {
		letters: "STPCAJFGLHDIVXKRUEMYNBQOW",
		words: ["MEOW", "QUID", "BRIG", "CHALKY", "ALP", "DRIFTS", "BURN", "VEX", "JIVE"]
	}
},
{
	id: "ba38c47c-3281-40d2-af0f-44ed3fb03fb3",
	dateId: "20261103",
	puzzle: {
		letters: "LMVQTDIXUHNRAFSKEYJCWGBPO",
		words: ["VINEYARD", "COPY", "SHUT", "BEAUX", "LINKER", "FAIRY", "JAIL", "TUAREG", "WEARY", "MINER", "QUAIL"]
	}
},
{
	id: "daac6ad6-8f00-49f9-afd3-72a09312b7cb",
	dateId: "20261104",
	puzzle: {
		letters: "SPYVXQTDNIUMCJRLAKEHGBWOF",
		words: ["BLACKER", "GAMUT", "AWOKE", "JINX", "IVY", "HECK", "INJECTS", "QUAKER", "FERNY", "SPY", "RIND"]
	}
},
{
	id: "452f9825-24c9-41b9-a98b-93feb5a448da",
	dateId: "20261105",
	puzzle: {
		letters: "DACKGLJXINYSTBREFWOMPVUQH",
		words: ["STORM", "SLACKING", "QUOTING", "LYE", "BROWSE", "FEST", "AXING", "CAD", "VESTING", "PEST", "HORN", "JACKING"]
	}
},
{
	id: "4dbf61b0-657f-4dd8-be12-6be1f1c49bee",
	dateId: "20261106",
	puzzle: {
		letters: "RHJIMENQODPUVCWGTKLBSYAXF",
		words: ["MOCKUP", "QUERN", "HEN", "VOID", "CLAYS", "FLAX", "JOCK", "COWL", "BLAT", "GUTSY"]
	}
},
{
	id: "ca516a3f-f90f-4dfb-a2fd-ba391d3e5e49",
	dateId: "20261107",
	puzzle: {
		letters: "JCHKTOYDIUNBVRQSEPAXLWMFG",
		words: ["GAMES", "IRAQ", "NEWSBOY", "MARX", "FAME", "JOBS", "QUID", "CHIVES", "DRIVELS", "KID", "DRAPES", "CHIT"]
	}
},
{
	id: "b7c36cd6-2238-4bb5-a084-3735e5afa359",
	dateId: "20261108",
	puzzle: {
		letters: "GUQNPLXJABHYMRITVCFKODEWS",
		words: ["MYTH", "JULY", "IRKS", "FIRM", "LUX", "DEWS", "PARKS", "BARKS", "IRAQ", "DOVE", "UGLY", "BRAN", "ARCED"]
	}
},
{
	id: "8e4209c6-f389-4818-b17c-c71cd96ccde0",
	dateId: "20261109",
	puzzle: {
		letters: "WLVDQGOKEUMFHRPBANJTYCXIS",
		words: ["QUERN", "FANCY", "JINX", "GOVERN", "WOMB", "GLOVED", "HOVER", "ERUPTS", "AMOK"]
	}
},
{
	id: "142a6796-f4fd-48df-a2d0-db60e1096b22",
	dateId: "20261110",
	puzzle: {
		letters: "VRWPIMETGLNDYFHBXACKJOSUQ",
		words: ["QUACK", "BOAS", "PIG", "DAFTER", "JOB", "FLIP", "TRENDY", "ADMEN", "NEWT", "BOXY", "SUCH", "VEND"]
	}
},
{
	id: "b8760861-7d2c-451c-9ffe-85a00e319054",
	dateId: "20261111",
	puzzle: {
		letters: "KSWMPRCOJBYGHDNEAFIQLXVUT",
		words: ["COMB", "CRY", "CHOMP", "DOCKS", "LAGOS", "AXLE", "JOCK", "QUID", "CHOW", "CHIN", "CHIT", "AVID", "FIND"]
	}
},
{
	id: "353936b1-dc5c-4262-bb18-dfe2c8dcf490",
	dateId: "20261112",
	puzzle: {
		letters: "VYBMISAHNJWQUTKPLRDEGOCXF",
		words: ["MINUTED", "BAWL", "SQUAW", "FED", "INTRUDE", "JINKED", "CORTEX", "PORTED", "CLOG", "QUAYS", "HAUNTED", "VAUNTED"]
	}
},
{
	id: "75a075a2-7b9c-4bea-b621-82f41b395293",
	dateId: "20261113",
	puzzle: {
		letters: "KXCVMLEUIDFQGSWYRNOHPATJB",
		words: ["MIGRANT", "PANTRY", "TONGUE", "JOGS", "QUIDS", "KEGS", "ANGUISH", "FLEX", "DICE", "VICE", "SWOT", "BOGUS"]
	}
},
{
	id: "2db46955-30e2-4fa6-ab12-663b6adc87b8",
	dateId: "20261114",
	puzzle: {
		letters: "DPWVIJLMEXRAFOKGBTYUSCHNQ",
		words: ["VIEW", "AMOK", "FLAME", "FLAGS", "AMOUNT", "QUOTA", "BATCH", "BALD", "PLATO", "FOX", "JABS", "GARBS", "TYKE"]
	}
},
{
	id: "6e4b9029-4a93-43e3-89c0-cc1c27088f9d",
	dateId: "20261115",
	puzzle: {
		letters: "TQUNGKSDIELRWCPHABOVYJXMF",
		words: ["DRAWING", "YARDS", "QUIDS", "HARKS", "VOWING", "MOPING", "FOCI", "DUST", "BOWING", "BOX", "JAWING", "WALKS", "GENIUS"]
	}
},
{
	id: "47624c14-ab8c-43f2-bcc5-8ef44bd5feb8",
	dateId: "20261116",
	puzzle: {
		letters: "CTSVXHIPEQYNWAUODLRKBJMGF",
		words: ["QUALM", "BODY", "DWARF", "JOB", "VEAL", "GRAPES", "SEPTIC", "APEX", "QUARK", "INLAW", "WITCH"]
	}
},
{
	id: "73424d63-feab-40ce-9aa1-61bef3d0eddf",
	dateId: "20261117",
	puzzle: {
		letters: "RLKQBSOVCUTFHANGYPEJMWIXD",
		words: ["QUACK", "VANED", "BUNCHED", "APEX", "GYM", "ANCHORS", "JACK", "WIPED", "LOFTS"]
	}
},
{
	id: "6f99468b-c63b-4b76-991a-82a509ddf3e8",
	dateId: "20261118",
	puzzle: {
		letters: "LOHUDMJCQSTNKWAEGIRBPVXFY",
		words: ["BARKING", "LOCKING", "RIVET", "IRAQ", "FINCH", "FIX", "PENT", "MOCKING", "WARING", "AWRY", "SUCKING", "DUCKING", "JOCK"]
	}
},
{
	id: "c4a8fcd2-cb23-425d-bba0-98703cc13d46",
	dateId: "20261119",
	puzzle: {
		letters: "FVNPXMAGSOWJRDHBCELQKYTIU",
		words: ["HOPS", "GNARLED", "DEITY", "BYTE", "DECK", "WARDS", "JARL", "FANGS", "MARSH", "REDOX", "QUILTED", "VANS"]
	}
},
{
	id: "5a042823-2853-4a1c-b53d-4be1ae5141ff",
	dateId: "20261120",
	puzzle: {
		letters: "FBJQPTEUIHSLDXOGWAMKNYVRC",
		words: ["CRADLES", "BULWARK", "VALETS", "OXIDES", "BEDLAM", "PIQUED", "DAWN", "GLADES", "JEST", "BULGY", "HIDES", "FEUDAL"]
	}
},
{
	id: "95aa9759-ff38-4281-b1c4-45445a201663",
	dateId: "20261121",
	puzzle: {
		letters: "MGJNTSUIELQVYFWDCPAHOBRKX",
		words: ["SQUINT", "GUMS", "COD", "HARP", "PRAY", "FAX", "VIEW", "JIGS", "HARK", "BRAWL"]
	}
},
{
	id: "b6a0840f-ad88-4549-b3e5-6761c233d068",
	dateId: "20261122",
	puzzle: {
		letters: "CLVTDOWPEHNBRUJIYSAQXFKMG",
		words: ["HUSKY", "COBRAS", "SUPERB", "FIBRED", "QUERY", "GARBS", "PRAMS", "CLOWN", "VERBS", "ONYX", "DEPTH", "JAMS"]
	}
},
{
	id: "3a9fe255-81b3-49b9-8d04-5e5e41dca27b",
	dateId: "20261123",
	puzzle: {
		letters: "FTGUQEBLISCDNXAHVMJRWOPYK",
		words: ["QUILTED", "HOMY", "CHOMP", "AXIS", "LIAR", "BLIND", "VOW", "JAIL", "DEFT", "ARK", "GUILD"]
	}
},
{
	id: "5accd158-ac0f-4652-a04e-93214fbca198",
	dateId: "20261124",
	puzzle: {
		letters: "WAGPKNUSOYDQJVRCIFTBHMXEL",
		words: ["SORBET", "HIC", "JOGS", "DIM", "POKY", "SAUDI", "SQUAW", "SAWN", "FELT", "VORTEX"]
	}
},
{
	id: "aa03a72d-bd19-428f-83ef-ce135acb5ab1",
	dateId: "20261125",
	puzzle: {
		letters: "YPUOFHCQITKNVDJRESMABLXGW",
		words: ["QUIVER", "BLENCH", "JIVES", "FIVER", "BERK", "CUP", "TOUCHY", "WADI", "MAGS", "SEX"]
	}
},
{
	id: "937187ab-2cf7-4dd4-8b6f-e5d54072fc9c",
	dateId: "20261126",
	puzzle: {
		letters: "KNFVMOJAERGSBYXCIULDPWQHT",
		words: ["BUYER", "QUIP", "JOGS", "THUS", "IBEX", "FEASIBLY", "KNAVERY", "DYER", "MEAN", "WIGS", "BASIC"]
	}
},
{
	id: "1bf898d1-a74a-4229-8d1b-63a00275ff75",
	dateId: "20261127",
	puzzle: {
		letters: "YOBRDJSPKEWMTNXULIFCAQVGH",
		words: ["DENIMS", "LINKER", "QUALMS", "FINED", "JOBS", "GIFTS", "DRENCH", "SWUM", "BOYS", "MINX", "LIMPS", "VIMS"]
	}
},
{
	id: "dc404ac1-4838-4248-ad1c-08ad7770ee77",
	dateId: "20261128",
	puzzle: {
		letters: "NJSBWTIVEMUFCOXLQRDHGYKAP",
		words: ["ADHOC", "PARK", "CORKY", "GLUT", "JIVES", "QUIT", "COXES", "NICE", "WEBS", "DOMES", "FIVES"]
	}
},
{
	id: "2438f0d2-feb3-464f-8fd7-8bc0650b6960",
	dateId: "20261129",
	puzzle: {
		letters: "LAFGNSMXUIRDQJTHOBCEVYWKP",
		words: ["FUNGI", "DORSAL", "XMAS", "OBJECTING", "VOW", "QUITE", "PECK", "BYWORD", "DHOW"]
	}
},
{
	id: "aafde6de-1a8e-4ea7-8ebd-7c6069159b4b",
	dateId: "20261130",
	puzzle: {
		letters: "BRVKJQCELOUNPHTGISAXWYFDM",
		words: ["HELPING", "DASH", "GUNSHOT", "PINCER", "GIPSY", "QUINCE", "FISHER", "TOKENS", "WINCE", "VERB", "JOKER", "MASHER", "XMAS"]
	}
},
{
	id: "41145091-d941-4518-af81-7a7708224eee",
	dateId: "20261201",
	puzzle: {
		letters: "OKBEXHCNPTQIMAFWUVYGRJDLS",
		words: ["RUMINATE", "APEX", "FAMINE", "NAVY", "WINCH", "QUICK", "JUMP", "MAGS", "HOCK", "DUMP", "SLY", "BENCH"]
	}
},
{
	id: "d333c89a-15dd-4ad4-a220-281ce3ba4931",
	dateId: "20261202",
	puzzle: {
		letters: "YKHTMBOCEDFRNVWPIGXASUQLJ",
		words: ["WAVED", "LAW", "BORING", "SIGNED", "PINCHED", "QUINCE", "DECOY", "JAWED", "FORCED", "THEM", "FROCK", "LAX"]
	}
},
{
	id: "5004feac-2e94-459c-be08-283421d35cd0",
	dateId: "20261203",
	puzzle: {
		letters: "FVBNLPASMYWXGEHKOJICRQUDT",
		words: ["DITCHES", "FAX", "GAWK", "HYMNS", "VASE", "QUICHES", "PAGES", "JOGS", "BAGS", "WORK", "LYE"]
	}
},
{
	id: "db3d3c67-71d9-4430-ae46-cfc989920496",
	dateId: "20261204",
	puzzle: {
		letters: "BXDMKATREQVYPNUWOHGILJFCS",
		words: ["UNHOPED", "SIGNED", "CHOP", "FOWL", "KEPT", "AVOW", "BAT", "SIGNER", "QUERN", "MENU", "TAX", "QUERY", "JOHN"]
	}
},
{
	id: "438025da-a6cc-4241-a9a5-65c5641ed351",
	dateId: "20261205",
	puzzle: {
		letters: "SOTYRGUAHFJXQVLCPBIWKEMND",
		words: ["LIMB", "QUOTA", "SOUTH", "AVID", "FRY", "JUGS", "BECK", "BIND", "TAX", "WIMP"]
	}
},
{
	id: "3c3e48ba-5d35-4d3d-88b0-acfeef1a75bf",
	dateId: "20261206",
	puzzle: {
		letters: "HKYGWBTCIXFEUPRNLQAMOSVJD",
		words: ["FLECK", "JAM", "AMPULE", "BECK", "FELONS", "MARX", "SLEUTH", "SQUIRM", "PRIG", "WICK", "VAMP", "LEFTY", "SQUAD"]
	}
},
{
	id: "5ef54a99-a166-460b-b154-bc07cd85bf77",
	dateId: "20261207",
	puzzle: {
		letters: "FQXSYMUREVHICTLNJAPBGKDWO",
		words: ["LEVY", "WATERING", "OBTAIN", "SECURING", "JAW", "MINK", "CRUXES", "PLECTRUM", "DATES", "FUMING", "HURTLES", "QUIRE"]
	}
},
{
	id: "77334b02-5c0d-4d1d-933a-f2b44f91c2c3",
	dateId: "20261208",
	puzzle: {
		letters: "RLAPHGEKUDNVXMQFSICTBOWJY",
		words: ["VIXENS", "FOBS", "SWIVEL", "MIXER", "EVICT", "DUAL", "QUAKER", "GLENS", "ICY", "MIXUP", "HUM", "JIVE"]
	}
},
{
	id: "ac04c7a3-b385-4315-9371-226b94d666f3",
	dateId: "20261209",
	puzzle: {
		letters: "GOLSTCYEWDJMHKQRAIUBFVPNX",
		words: ["MINX", "ARMY", "HAIKU", "LEST", "JAMES", "BUN", "GOES", "QUIP", "LEWD", "COLE", "VAIN", "FRAMES"]
	}
},
{
	id: "e565be94-a9a0-4c13-af91-d014874f284e",
	dateId: "20261210",
	puzzle: {
		letters: "DMCNXIFVOWESPLGRJUTBKQYAH",
		words: ["MISER", "BLOWN", "JERK", "DIES", "BATH", "GLOW", "COPSE", "REFS", "COX", "VOLT", "QUAY"]
	}
},
{
	id: "1fa6ab9b-8397-4c11-92ab-8c109522b8e2",
	dateId: "20261211",
	puzzle: {
		letters: "FGSICBOLPVHTQERADUNWMXYJK",
		words: ["QUERN", "SLEUTH", "DUELS", "DUX", "BOGS", "FOGS", "DYNE", "PLOSIVE", "JUNE", "RELIC", "MATH", "KNEW"]
	}
},
{
	id: "7818d606-dc9a-4eb4-93e9-b8385e2a2ab5",
	dateId: "20261212",
	puzzle: {
		letters: "PAMVWRDXOGYCINFBLQUJTEKSH",
		words: ["VOILE", "FUNGOID", "NOMADIC", "MOW", "RADIUS", "QUILT", "FOXILY", "ELKS", "HUNG", "BELT", "JUICY", "PRAM"]
	}
},
{
	id: "6ff9178e-51d9-434b-b91b-cc07bfdb0a2e",
	dateId: "20261213",
	puzzle: {
		letters: "OPIMGTDQUKBLVJCYHASERWFXN",
		words: ["MUCK", "BLASE", "AWRY", "EXALT", "BLAH", "QUID", "FAXES", "VASE", "PODIUM", "WAXEN", "JAW", "GUM"]
	}
},
{
	id: "0067fcbb-1463-40dc-bc85-3d9ea12568f0",
	dateId: "20261214",
	puzzle: {
		letters: "PKRYVCAWJEBTODXHUQNILSGFM",
		words: ["OUTBACK", "FIXED", "WRATHS", "VEXING", "HUBCAP", "MIXED", "LUGS", "NOTARY", "QUOTA", "JOT"]
	}
},
{
	id: "ce68def2-4c71-4008-9f10-30474de129ab",
	dateId: "20261215",
	puzzle: {
		letters: "JKLACVOHTXDIFENUMRWYQGBPS",
		words: ["PREYS", "CATER", "VIOLATE", "SYNTAX", "FOLK", "NEWSY", "QUIRE", "JOLT", "ODIUM", "LATHER", "BREWS", "GREYS"]
	}
},
{
	id: "74c180ea-2b6b-4661-8106-18d9af445171",
	dateId: "20261216",
	puzzle: {
		letters: "NYDOGKACVFRLWBSEHMTUXJPIQ",
		words: ["CLANK", "DARE", "FOCAL", "PITS", "COG", "SUBMIT", "JERKY", "QUITS", "WHELK", "VOCAL", "HEX"]
	}
},
{
	id: "327868dd-4e3a-40d7-a63b-75c8eef7f60a",
	dateId: "20261217",
	puzzle: {
		letters: "BMVTCOWIRQXDGUJHYESALPFNK",
		words: ["TIDES", "CRIM", "GUIDES", "WIDENS", "OXYGEN", "DEFY", "QUID", "HYPE", "DESK", "VIRUS", "HYENAS", "BODES", "LYE", "JUGS"]
	}
},
{
	id: "6d85e59b-db06-4464-bc63-2a2b076e17c5",
	dateId: "20261218",
	puzzle: {
		letters: "CFPUQAMIJBHSRNETOVXLYDWKG",
		words: ["FAMINE", "ELK", "CASTOR", "JINX", "QUIP", "GLEN", "BEL", "WORMS", "FAMISH", "ENVOY", "HOWDY"]
	}
},
{
	id: "ee31d8de-b727-41bc-a785-70b7bb7d7745",
	dateId: "20261219",
	puzzle: {
		letters: "SQMKYBUVEXRIJGAOHWLNCDTPF",
		words: ["CHORUS", "COD", "FLANGE", "KEY", "THRIVE", "SQUIB", "JIVE", "WHIR", "EXALT", "PLAN", "THORIUM"]
	}
},
{
	id: "7dd26b8d-390f-4b55-b70e-571c0f278357",
	dateId: "20261220",
	puzzle: {
		letters: "IMPRBNXDLOQEHWYFUAVKTGJCS",
		words: ["QUACKS", "MIXED", "GAWKY", "DEFT", "IMPLY", "DENIM", "WORLD", "WHACKS", "HEAVY", "BLOW", "JACKS"]
	}
},
{
	id: "274df12c-95d8-4c51-bd1a-829c3fcbadc7",
	dateId: "20261221",
	puzzle: {
		letters: "JGCDKWABRFOLTINYSHUVEXQMP",
		words: ["VITALS", "SEXY", "JAB", "CABIN", "ATRIUM", "STUMP", "UNFITS", "GAOLS", "BIRTHS", "SQUIRT", "BAWLS", "THIRD", "QUIRK"]
	}
},
{
	id: "ed0b4f30-34f0-453c-a14e-0ebaa27e1b22",
	dateId: "20261222",
	puzzle: {
		letters: "PIHDRFCTEOMBSKWXLUNGVAQJY",
		words: ["DOWNY", "FICHES", "QUALM", "PITCHER", "JUNKER", "BLUSTER", "SLUNG", "LAX", "SLAV"]
	}
},
{
	id: "446c77a2-f3c0-4a76-a64f-64d1e0d881d9",
	dateId: "20261223",
	puzzle: {
		letters: "YHPOWMIDBXRUGFKJEQNLTCSAV",
		words: ["BOX", "FLANGES", "LANGUID", "DIRECT", "YIP", "SQUIRM", "WODGE", "VANS", "FLANK", "HIRES", "JUDGES"]
	}
},
{
	id: "6d912345-4778-4642-9b27-5c05d01489c6",
	dateId: "20261224",
	puzzle: {
		letters: "BLSNGTECUIDRKQWFYVPHOXJAM",
		words: ["VAMP", "DECRY", "RESCUING", "WINCED", "SUCKER", "QUINCES", "JAM", "FOXY", "BECK", "WHAM", "INSERT", "UNCLES"]
	}
},
{
	id: "d63b6bbd-130f-4797-9ab5-873fa4834b6b",
	dateId: "20261225",
	puzzle: {
		letters: "KLYTCQSDNXHUGWIOAJEPBVRFM",
		words: ["PINGS", "DUSK", "REWINDS", "FRAUDS", "GAUDY", "SQUARE", "LYNX", "BOAR", "OVA", "JUDGE", "SYNC", "HAREM", "FEINT"]
	}
},
{
	id: "f098ce83-8bea-4976-956d-8ef0e5fca414",
	dateId: "20261226",
	puzzle: {
		letters: "PXTFWNLOAHRUJSGQEBVMYCKID",
		words: ["SHAW", "QUOTAS", "JOLT", "DIMS", "GAOL", "QUERN", "BECK", "PLOT", "SHAFT", "KEY", "VIMS", "FOX"]
	}
},
{
	id: "952a9ba7-8fed-431a-803e-daa443957295",
	dateId: "20261227",
	puzzle: {
		letters: "RYPOSXTMEKJNALHDIBUFWVGCQ",
		words: ["FLAMES", "BAULKS", "MANDIBLES", "CUBAN", "JINX", "WINTRY", "MOPES", "GIANT", "QUAINT", "HEMAN", "VIABLE"]
	}
},
{
	id: "9dc68e1a-c6ba-4924-914d-ed8328753cc5",
	dateId: "20261228",
	puzzle: {
		letters: "GLYKSBAFQOMHUCWXITRDJNPEV",
		words: ["FLAG", "SQUINTED", "CRETIN", "JINX", "DEPTH", "WOKS", "CURVED", "NIMBLY"]
	}
},
{
	id: "0f872e4b-c361-4a7f-8ba4-1838f8baaa23",
	dateId: "20261229",
	puzzle: {
		letters: "YOFVIRGSBMHWKLDTCEJQAXNUP",
		words: ["ELM", "TACKLE", "EXACT", "QUENCH", "PUNCH", "BLENCH", "FOGS", "WENCH", "VIM", "WELD", "JUNE", "GORY"]
	}
},
{
	id: "357ace5a-df7e-402e-8bc1-4bfb596b3f21",
	dateId: "20261230",
	puzzle: {
		letters: "PQNLDJUASKGYCBHVOWEMXIRTF",
		words: ["SCALD", "HEFT", "UNLACE", "COX", "SABER", "JUG", "VOCALS", "BASK", "CASHEW", "QUASH", "TRIO", "METRO", "ROYALS", "PUNS"]
	}
},
{
	id: "745a1f5d-202e-4aa3-ba9d-7d7d0547b1b3",
	dateId: "20261231",
	puzzle: {
		letters: "CHYAQBKIUVPMRLGSEFTOXNJWD",
		words: ["AIRMEN", "GLIMPSE", "LIMB", "JERKY", "QUIRKY", "AIRFLOW", "DOLT", "CHIMES", "VAULT", "LUREX"]
	}
},
{
	id: "4adbeb75-669c-42fa-96c3-11ceceeb40be",
	dateId: "20270101",
	puzzle: {
		letters: "LJQDTWUNEKVASMIBOHRFXYPGC",
		words: ["PHASED", "PRIMED", "FRIEND", "QUASH", "BASED", "JUNE", "WASHY", "SHAWL", "BOXY", "SHRIEK", "GRIME", "UNMET", "CRIMES", "VANED"]
	}
},
{
	id: "a6543a40-27f6-467d-9c5a-6664d35344d9",
	dateId: "20270102",
	puzzle: {
		letters: "MQYVPULSAXDIJWKBROTHFGNCE",
		words: ["NOISY", "BRIOCHE", "WAVY", "DROWSILY", "FRONT", "JAWS", "PAWS", "GRISLY", "SQUIB", "ASYLUM", "YAK", "WAX"]
	}
},
{
	id: "eec682a9-8532-45e5-881f-5d1b5f14e19c",
	dateId: "20270103",
	puzzle: {
		letters: "CXGOBTEKHJNRFSQMAIUDWYLVP",
		words: ["WARILY", "CENTRAL", "QUIRKS", "DULY", "GERMAN", "VIRAL", "JOKER", "EXTRA", "BOG", "FISH", "PUSH"]
	}
},
{
	id: "8459ec90-1fed-4d05-9e3e-7ff235373253",
	dateId: "20270104",
	puzzle: {
		letters: "JTWGCSOHYVDKANBRUEPLQXMIF",
		words: ["ANYHOW", "OAKUM", "BLIMP", "GHOST", "RUMEN", "QUAKE", "JOHN", "ENVY", "APEX", "FLIP", "DOTS", "CYAN"]
	}
},
{
	id: "c97171ca-7313-4a38-88a0-3cbc44adcb6a",
	dateId: "20270105",
	puzzle: {
		letters: "DIHCGXLWNKREAJTBUVSPQYMOF",
		words: ["FOPS", "JAW", "CHILEAN", "QUAVER", "VEX", "GNAWER", "BREAST", "BEVY", "ILEUM", "CHILD", "KNAVE"]
	}
},
{
	id: "cbd7b2a1-7eaa-4b36-b6b2-03690f4dba4b",
	dateId: "20270106",
	puzzle: {
		letters: "JTDGBCAIUHVWQRXOEKNLFPMYS",
		words: ["CAIRNS", "FEW", "JAW", "HURLS", "ADIT", "AVOW", "QUIRKY", "POEM", "LYNX", "GIRLS", "BURLY"]
	}
},
{
	id: "fcb29c01-08fa-4876-9e97-b8b6aa14d1eb",
	dateId: "20270107",
	puzzle: {
		letters: "MBHPNASJIXFRQYLCETUWKVGOD",
		words: ["CRABS", "JINX", "QUOTER", "SAFETY", "TULIP", "TREK", "MARSH", "VETO", "OWL", "GOUT", "DOGE"]
	}
},
{
	id: "8b45467b-be9a-4133-aa81-ecbd07312233",
	dateId: "20270108",
	puzzle: {
		letters: "TCGPKIMOEHXDJSBNYWUQFLVAR",
		words: ["WAVY", "OMIT", "LYNX", "BUSH", "JOSEPH", "FLY", "KEG", "RUBS", "DOGES", "SQUAW", "COPES"]
	}
},
{
	id: "d2ac9f1c-76aa-4eda-9597-ca8e099bc50c",
	dateId: "20270109",
	puzzle: {
		letters: "NLHYWEGJARVBQTXSUFKCMIPDO",
		words: ["DOCK", "GLEN", "QUIP", "AWRY", "HART", "BUMS", "VEG", "XRAY", "SIFT", "JAR"]
	}
},
{
	id: "0c0c9ece-38bb-43e4-822a-9108d6070bd8",
	dateId: "20270110",
	puzzle: {
		letters: "BMDVROGYITESNJUWAXCQFLPKH",
		words: ["CUING", "JINGO", "GNAWS", "FLANGES", "PANGS", "RIDGES", "FLAX", "INCH", "TUCK", "BOGS", "PANSY", "VYING", "MYNA", "QUID"]
	}
},
{
	id: "30995e68-6e7d-4308-a7de-9d2fe7052175",
	dateId: "20270111",
	puzzle: {
		letters: "WTYHLGEOUJXSFNQBVICDPRAMK",
		words: ["BRAISE", "FEW", "PRISON", "AMINO", "QUOTES", "UNISEX", "HOUND", "JUNO", "BRICK", "GET", "SINFUL", "NOSEY", "VICAR"]
	}
},
{
	id: "faa255c8-281e-4429-ba94-57e30ae02098",
	dateId: "20270112",
	puzzle: {
		letters: "MAKJHRVIUGBLYXQCTNWPFOSDE",
		words: ["DEWS", "SOFTLY", "PEWS", "IVY", "QUILTS", "BRAIL", "FONTS", "COSTLY", "LYNX", "MAIL", "JILTS", "GUILTS", "HUG", "KILNS"]
	}
},
{
	id: "1c93644b-dbe8-4794-b05d-71c08d8f9fb5",
	dateId: "20270113",
	puzzle: {
		letters: "KSPMWTQUIFBLNYEDOCRXHJAVG",
		words: ["CLUMPS", "BONIER", "JACOB", "GREY", "MUSK", "BOLTS", "VARY", "CONIFER", "WIFE", "QUIPS", "HOARY", "ONYX", "BOLD"]
	}
},
{
	id: "2ceebb42-7e69-4e7a-9e6c-c2d97d473be5",
	dateId: "20270114",
	puzzle: {
		letters: "YSKUQCDANIWLGRFPOTXHBVMEJ",
		words: ["FRANKS", "DARING", "SALOME", "JET", "MOLDY", "PLANKS", "HEM", "AGLOW", "VOLGA", "QUARTO", "CLANG", "BOLA", "EXTRAS"]
	}
},
{
	id: "d7dd76e0-73b4-446f-875a-82f8855fd6b6",
	dateId: "20270115",
	puzzle: {
		letters: "EVQKXNBAULHJOPDWISRCGTMYF",
		words: ["GIST", "WHIMSY", "BAULK", "PAVE", "DROPSY", "CROAK", "JOIST", "FROST", "DUX", "BEN", "QUOITS"]
	}
},
{
	id: "065e100b-47a6-431d-b2fc-07b77a5d2acc",
	dateId: "20270116",
	puzzle: {
		letters: "BTRMSYEVWHXACKIFUGNJLDQOP",
		words: ["WRECKING", "BEAUX", "QUACKING", "FLUX", "JINGO", "TERMS", "BYTE", "PONCE", "QUAVER", "DUCKING", "SHIN"]
	}
},
{
	id: "ab5bc1f7-309d-42d6-802a-0e5273a9e333",
	dateId: "20270117",
	puzzle: {
		letters: "HUQIDPERFMVWGOTCANYJKSBLX",
		words: ["TORQUE", "GNAWER", "AGRIMONY", "PURGE", "JOG", "DIRGE", "ORGANS", "LYONS", "BANGER", "CAVER", "ONYX", "FORGAVE", "BACKS", "HERONS"]
	}
},
{
	id: "870aa577-9a88-40b9-b6c3-6060ad7898c2",
	dateId: "20270118",
	puzzle: {
		letters: "AFKYPXBCOWEHMVSQUILTGNRJD",
		words: ["MOVING", "COPY", "EXHUMING", "RUMBA", "QUILTS", "MOCK", "FAB", "COWS", "CHILD", "JILTS"]
	}
},
{
	id: "6beb5f0d-eef6-4210-8e62-b843c15642ac",
	dateId: "20270119",
	puzzle: {
		letters: "XDVHQBAJUFLNWSITEKPYRCOMG",
		words: ["BLANKER", "BLANKET", "SPOKEN", "MOCKER", "IFS", "JAWS", "HUSK", "QUIPS", "DANTE", "RELAX", "VALET", "RECOPY", "GYM"]
	}
},
{
	id: "2cf4eabc-eb98-4443-ad17-d93db7b05aa5",
	dateId: "20270120",
	puzzle: {
		letters: "MGWHBAVLOSDTIRQXENUYKFCPJ",
		words: ["SQUINTED", "NEXT", "VIED", "AGLOW", "HORNED", "PURLOINED", "INCURS", "JUNIORS", "PYRITE", "FEINT", "KENT", "BOLTED", "MATED"]
	}
},
{
	id: "fab7a623-2617-4444-bc84-b0f659e73d9e",
	dateId: "20270121",
	puzzle: {
		letters: "DQUTWMOXFEKRIPHVAGNLBJSYC",
		words: ["JAB", "VAINLY", "SYLPH", "GRAINY", "FIRM", "QUOINS", "SYNC", "PHEW", "DOINGS", "FIX", "BARK", "GROUT"]
	}
},
{
	id: "da7453a4-5575-4112-9ccd-55ad6a27d26d",
	dateId: "20270122",
	puzzle: {
		letters: "DHPGKMAEQCBVSUJRFTYNWOXIL",
		words: ["BASQUE", "STUCK", "FORBAD", "PEG", "HAVES", "JUST", "FOXILY", "MASQUE", "SUNLIT", "BROW"]
	}
},
{
	id: "f25180c2-6211-4048-8a0f-99795c8deece",
	dateId: "20270123",
	puzzle: {
		letters: "HTOPGQKMECJUNDLBAVFRYWSIX",
		words: ["BUNDLE", "MOTH", "RIFLED", "CLEG", "JUMPED", "QUASI", "QUAY", "BANK", "UNFIX", "WANED", "VANED"]
	}
},
{
	id: "31f9549f-1b88-4e88-bd7d-029c2182aaba",
	dateId: "20270124",
	puzzle: {
		letters: "LFTQUNOMHAWYJSDVEBIPKRGXC",
		words: ["KERBS", "BIDS", "ASPIC", "JERK", "SIX", "GREW", "FLOWER", "MOTHS", "QUASH", "FOYER", "VERBS", "FLOWN"]
	}
},
{
	id: "4dba6a86-abeb-4107-b1db-2664c985f9f8",
	dateId: "20270125",
	puzzle: {
		letters: "TGCJYHNOBKFARQSLEVUXPMDIW",
		words: ["DIURNAL", "DUX", "CONFER", "HAREM", "QUIVER", "DERBY", "REPLANT", "DUSKY", "WIDER", "JONAH", "GORED"]
	}
},
{
	id: "c96025c1-07e2-46d5-9f6c-ff6b306fd1b5",
	dateId: "20270126",
	puzzle: {
		letters: "POVLFNCEDTKXSIYMRAUQBJHWG",
		words: ["WAXED", "COVES", "GUIDES", "DISARM", "FLECK", "NOVELTY", "HARK", "PONCE", "BRAISED", "JARS", "QUARK"]
	}
},
{
	id: "dcdbe377-5d9a-4fcc-9bff-fbbea26fe907",
	dateId: "20270127",
	puzzle: {
		letters: "NBYHSKIDFLCUWEXPAQOVRGMJT",
		words: ["QUACK", "VOWELS", "TOWELS", "GAUDY", "NICK", "FLEX", "PAWED", "JOT", "BIDE", "WELSH", "PRAM"]
	}
},
{
	id: "7d6cea4c-c8aa-4c15-9d61-cae2d6fc8bb3",
	dateId: "20270128",
	puzzle: {
		letters: "KOQTNAUCSWGLPEVMIXJBHDFRY",
		words: ["COUPES", "GULPS", "MIXES", "PEWS", "VEST", "SQUALID", "JEST", "SEWN", "HIPS", "BEST", "FRY", "KALIF"]
	}
},
{
	id: "983e9490-da83-46c6-b62f-2520056e5af8",
	dateId: "20270129",
	puzzle: {
		letters: "QXYPDVUTRGILMECSOWBHFKJNA",
		words: ["SLUMBER", "DREW", "ISOMETRY", "AHEM", "FOILS", "BANJO", "VIOL", "CRYPT", "WOKS", "GERM", "QUILT", "LUX"]
	}
},
{
	id: "97adf4c5-2205-46b5-b549-bb630109f1a2",
	dateId: "20270130",
	puzzle: {
		letters: "YFJHPAMRONQUKSVTECLIXBDWG",
		words: ["WILD", "TURFY", "BECKONS", "FAUCET", "QUAY", "JOHN", "VISOR", "POKED", "WIG", "MUCKED", "EXT"]
	}
},
{
	id: "1d1ae411-eba3-4dab-8663-58bd8d98f620",
	dateId: "20270131",
	puzzle: {
		letters: "YLTDWAHGENCSQUFRIPJMVKBOX",
		words: ["RICHLY", "UNFED", "PIQUED", "SALTED", "BOX", "UNWED", "MOPS", "VISA", "JUGS", "IRK"]
	}
},
{
	id: "409474df-c8ad-471a-adc1-746be9718b7b",
	dateId: "20270201",
	puzzle: {
		letters: "TKVLGSAXNEFBMQDWOUYHCJRIP",
		words: ["WOMBATS", "ENQUIRY", "LEND", "HYMN", "JUMBO", "VAST", "COMBATS", "GLEN", "EQUIP", "FORUM", "BASK", "AXLE"]
	}
},
{
	id: "1865dfe5-6084-4716-afdd-48774a1dfa20",
	dateId: "20270202",
	puzzle: {
		letters: "LHTCFRNSUKDIOVQXGJBWEMYPA",
		words: ["QUOINS", "BOGY", "JOINTS", "GEM", "GIRL", "EXIST", "PAW", "STUCK", "FUSION", "DINTS", "SOUTH", "VOID"]
	}
},
{
	id: "14619f52-5fd3-4b67-8580-18d0edc17b19",
	dateId: "20270203",
	puzzle: {
		letters: "FWVIKNELDBXMSHYJUAORQCGPT",
		words: ["BILES", "KIDS", "CAPTOR", "JUG", "FEN", "XMAS", "SHORT", "DIVES", "QUASH", "MUSHY", "WELDS"]
	}
},
{
	id: "52cf6de1-2f49-48a5-b21f-57808b949b5c",
	dateId: "20270204",
	puzzle: {
		letters: "JIPTXKCLOGSBQHNDUVRWAYMEF",
		words: ["LICKS", "BUDS", "TOPICS", "REV", "QUAY", "WHOP", "FERN", "REMUS", "JILT", "POX", "CLOG"]
	}
},
{
	id: "dbd3a0d4-d2c0-4530-8a70-fc91cb872e0e",
	dateId: "20270205",
	puzzle: {
		letters: "JSCGQLODUKHXYIMEWBVTFNPAR",
		words: ["SODIUM", "PART", "IDOLS", "AVID", "FEN", "GUITAR", "QUIDS", "HEWN", "BATIK", "JOY", "OXEN", "CODS"]
	}
},
{
	id: "e62c5e4f-2280-4810-8af6-38f399e16e5e",
	dateId: "20270206",
	puzzle: {
		letters: "VBYLCOXDFEPWNGTKMASJHIRQU",
		words: ["MIRAGE", "SAGELY", "RAMP", "JUST", "RANDY", "IRAQ", "HIM", "CLEFTS", "VOW", "BOWMAN", "BOXY", "GAWK"]
	}
},
{
	id: "f136363c-c373-4bfa-81f9-755c137b7270",
	dateId: "20270207",
	puzzle: {
		letters: "XORFBHJCEKQNSAGLUVWYDIMTP",
		words: ["MILD", "JOHN", "WAKES", "FRESCO", "EGYPT", "QUID", "DIVAS", "COX", "BEAK"]
	}
},
{
	id: "7eb4799f-320b-4578-87ad-46476510eaa7",
	dateId: "20270208",
	puzzle: {
		letters: "YHOEGXNJVRSTMUQFILACDBWPK",
		words: ["CALUMNY", "PALMIST", "HOVER", "AMUCK", "ONYX", "WILTS", "CALIF", "BITMAP", "URGE", "AMID", "QUACK", "JOHN"]
	}
},
{
	id: "326e0724-9176-410d-b1e5-b820f9d502e8",
	dateId: "20270209",
	puzzle: {
		letters: "VXJIRMANGLYOTFPQUWHSCKBED",
		words: ["QUOTA", "WOMAN", "PLINTHS", "MOUTHED", "AMONG", "JINX", "BUOYANT", "GIRL", "FLING", "VAN", "BUCK"]
	}
},
{
	id: "edc1f0a5-5109-4f28-ad45-96b53c46ad12",
	dateId: "20270210",
	puzzle: {
		letters: "CPFWBXHEROJATDSUNIMYQKVGL",
		words: ["ORDINATE", "BREATH", "CHANTED", "JAUNTED", "WORDSMITH", "FETID", "DIMLY", "THANK", "VIMS", "PERTAIN", "QUAINTER", "TAX", "GIANT"]
	}
},
{
	id: "f8443bcc-5d57-498c-beb2-534e432f0ce6",
	dateId: "20270211",
	puzzle: {
		letters: "MYGRXPLJAKTHVEFIQDNWUCSBO",
		words: ["QUIT", "FAKED", "SNOWED", "JAG", "FAX", "GLYPH", "BONDS", "TICS", "GRAVEN", "LYMPH"]
	}
},
{
	id: "dca8c886-174e-40ac-b957-680cfa5b9c6c",
	dateId: "20270212",
	puzzle: {
		letters: "TCXJSPYRUQKVAMDNLBOEIGWHF",
		words: ["JUMBO", "VARY", "CRYPT", "CRUMBLING", "HOWLING", "BMUS", "FOALING", "BLAMED", "QUAY", "BLINK", "CRUX"]
	}
},
{
	id: "6435545a-c6f7-4a21-97b2-f4bc6c04e1e5",
	dateId: "20270213",
	puzzle: {
		letters: "MLTAJVUSXCQIDFKHPBOWYGRNE",
		words: ["JACK", "FORBIDS", "HIPBONE", "ORGY", "ODIUM", "STACK", "QUIDS", "VISTA", "LUDO", "TAX", "BROWN"]
	}
},
{
	id: "8808c78c-da8c-4093-a5c7-481328968ea2",
	dateId: "20270214",
	puzzle: {
		letters: "PDOCSGIUNYMVQXWLHREFABJTK",
		words: ["KERB", "EQUIP", "SYNOD", "TREK", "FERVID", "DIG", "ONYX", "JET", "CONS", "BALM", "BLAH", "BREW"]
	}
},
{
	id: "53d5d04e-a609-487e-a904-2135709d69a6",
	dateId: "20270215",
	puzzle: {
		letters: "NHGLYVOTMKWARSCUFJIBQDEPX",
		words: ["SICKLY", "JARS", "STRAFED", "QUARTO", "BISTRO", "PISTON", "WARTHOG", "SIX", "VARIED", "STORMY"]
	}
},
{
	id: "de0fc4e0-318c-48d7-bd3b-b95686ed9642",
	dateId: "20270216",
	puzzle: {
		letters: "GQMKSHAUNDWJRVLOCYIEPBXTF",
		words: ["IRAQ", "WARNS", "MARVEL", "JUNKS", "LEVITY", "BOP", "CRAG", "FIX", "WHAM", "FIELDS"]
	}
},
{
	id: "4227b705-7fe3-4821-881e-54eb7ab20783",
	dateId: "20270217",
	puzzle: {
		letters: "CQBOTSLUDYVPIMKJAXWEFHNGR",
		words: ["PLUMY", "HANGER", "JAILS", "GREW", "DIMER", "ODIUM", "FAILS", "DYKE", "VAPID", "REMIX", "TYKE", "BLIPS", "QUIPS", "CLIPS"]
	}
},
{
	id: "1c6e4c1d-53a9-417b-bf18-11b11aebf305",
	dateId: "20270218",
	puzzle: {
		letters: "DUHOBQALMGWCPJYRIFEXKSNVT",
		words: ["RIPENS", "CLAD", "APEX", "BOGY", "CLAW", "HALO", "NEXT", "IRKS", "FENS", "QUALM", "VET", "JET"]
	}
},
{
	id: "c45b5d11-1669-4923-9d6c-37ee45967096",
	dateId: "20270219",
	puzzle: {
		letters: "VIFAWDREGXCHTNKYSOBPLMJUQ",
		words: ["MONTHS", "JOTS", "SMOTHER", "KNOTS", "SOUP", "FAX", "BOTHY", "FERVID", "MONGER", "ETHYL", "QUOTER", "CHEF", "WAFER"]
	}
},
{
	id: "828488c9-69d5-4962-a86a-27feb6df1793",
	dateId: "20270220",
	puzzle: {
		letters: "SFKHTGCAVPNMJOXDIWEYQUBLR",
		words: ["AVOWING", "OAFS", "HACK", "REBIND", "BERYL", "OPT", "AMID", "JACK", "EXPO", "QUID"]
	}
},
{
	id: "c440563b-ff20-4b12-b8a8-67a4dd118e06",
	dateId: "20270221",
	puzzle: {
		letters: "NPGOFESVDCLKIXYJUMBATQHRW",
		words: ["BRAY", "LUMBAR", "QUID", "FOGS", "JULEPS", "HULKS", "BRAW", "LENS", "COGS", "AXIS", "SLUT", "VISE"]
	}
},
{
	id: "0b17dc31-44df-4783-800a-5766b8f458bd",
	dateId: "20270222",
	puzzle: {
		letters: "KRCFTOPSGAQWHMJYUIEXBVDNL",
		words: ["SPHINX", "DENIMS", "VIED", "BUD", "CROPS", "GAMED", "BUY", "FAMINE", "WHINED", "LEND", "QUID", "TAMED", "JAMS", "PORK"]
	}
},
{
	id: "5b535abf-7843-498b-934b-06fcf6c0718b",
	dateId: "20270223",
	puzzle: {
		letters: "KSBOFNWTXGEHPUQVIYAMRCDLJ",
		words: ["QUALM", "STUPIDLY", "FOBS", "JAM", "NEWTS", "RIVEN", "BOX", "GOTHIC", "KNEW"]
	}
},
{
	id: "af4b4f9a-bd03-4e1c-89bc-ef950ced7340",
	dateId: "20270224",
	puzzle: {
		letters: "NFUQKXOBCGSRTYHPDALMIWJEV",
		words: ["LEADS", "TOUCHY", "JARS", "WARDS", "TORPID", "GYM", "ADSORB", "VELAR", "FORAY", "BUCK", "QUOTA", "XRAY", "ARSON"]
	}
},
{
	id: "f3b0c007-b479-4268-9563-55a495be9dba",
	dateId: "20270225",
	puzzle: {
		letters: "LOYNIKMFVWGTADHXUJECQSRPB",
		words: ["INVADERS", "CHEAT", "FOLK", "SQUAD", "ADJURE", "GUT", "BEAUX", "PEAT", "INFAMY", "WHEAT"]
	}
},
{
	id: "4eac8e29-b745-40e3-bd92-8396eb7493c3",
	dateId: "20270226",
	puzzle: {
		letters: "QMPVLBUTIOJXAFHRDSCWEGKYN",
		words: ["FOIL", "TACKY", "FAX", "VIOL", "CADGER", "QUACKS", "BUMP", "SYNC", "WHIP", "JUMP"]
	}
},
{
	id: "f1aca5da-1c95-4a4a-9f70-870d9d2c4d38",
	dateId: "20270227",
	puzzle: {
		letters: "VYDJBMIPOEXFLWGQUACNTRKHS",
		words: ["DIPOLAR", "KHALIF", "CLOWNS", "QUACK", "FLUX", "CHART", "JOWL", "DIM", "BODY", "IVY", "ALOE", "GOWNS"]
	}
},
{
	id: "0cadd516-d21a-4de7-a767-2a9830cd6f4d",
	dateId: "20270228",
	puzzle: {
		letters: "QFDWYEUARCNBJIVGHLOXPMSKT",
		words: ["PHLOX", "BUNG", "QUAILS", "OLMS", "UNBAR", "VIOL", "JUDAIC", "WAILS", "ILK", "DAIRY", "FAILS", "DUNE", "TOILS"]
	}
},
{
	id: "1d2b5744-c13c-42b4-9811-c29e20a5181e",
	dateId: "20270301",
	puzzle: {
		letters: "FKHUQWRADJTICEYNPBVLSGOXM",
		words: ["BEARINGS", "BEVY", "OPTING", "TRACINGS", "DARWIN", "QUARTIC", "FRAUD", "NICELY", "ELM", "QUARK", "HAIR", "ICEBOX", "JUDAIC"]
	}
},
{
	id: "c184ac46-66ce-4eb4-854b-ca8a334a1b20",
	dateId: "20270302",
	puzzle: {
		letters: "LNFTBYJASEPRQUVKOHXICDWGM",
		words: ["ORATES", "QUARK", "GIVES", "COPRA", "MIX", "FATES", "DHOW", "KORAN", "JAR", "LYRA", "BEST"]
	}
},
{
	id: "bbe4d628-27fe-44ef-906e-a893ed7d47e2",
	dateId: "20270303",
	puzzle: {
		letters: "YALDTUBWCPQXOEVNISHRKGJMF",
		words: ["PERMS", "RESHOW", "SECT", "SHREWD", "BOXING", "REV", "FRESH", "KINGS", "CLAW", "CLAY", "JIGS", "QUAY"]
	}
},
{
	id: "38363575-71a3-4c54-aacc-7d0e4dbd0658",
	dateId: "20270304",
	puzzle: {
		letters: "PWYUQGRSAFXOJTLKIBEVDNHCM",
		words: ["PROBE", "BELAYS", "BEHIND", "BOX", "SALVE", "CHINK", "FAUST", "JOSTLE", "WRY", "GROIN", "MELTS", "QUAYS"]
	}
},
{
	id: "74a762fc-cdbd-47a0-a7af-e69d0537fca1",
	dateId: "20270305",
	puzzle: {
		letters: "KDRFPCNAVSMLTIGJOQWXHYBUE",
		words: ["ANTIQUE", "FRANK", "TOBY", "EXIT", "JOLT", "WISP", "GIANT", "VITAL", "DRANK", "HOB", "MOLAR", "CLANK"]
	}
},
{
	id: "4169f399-6312-417a-83e9-5a5d319e850b",
	dateId: "20270306",
	puzzle: {
		letters: "HESWYMNVPRBUDAJIQXLCFTGKO",
		words: ["RAVENS", "PADLOCK", "GLAD", "QUIT", "DUMB", "ESPY", "DUX", "JACK", "WRACK", "FIB", "HENS"]
	}
},
{
	id: "a975d793-b39c-4d92-81a4-48520213d103",
	dateId: "20270307",
	puzzle: {
		letters: "EPMAVTWFXBICJOLGUKDRHQSYN",
		words: ["BODY", "QUICK", "QUITE", "FJORDS", "VAMP", "FOLDS", "HUSKY", "BORN", "TWIG", "BOX"]
	}
},
{
	id: "99ff8fd0-c150-48b0-8510-306bc069fbcd",
	dateId: "20270308",
	puzzle: {
		letters: "SFNOGQIVEKWUTXBJACHYDMRLP",
		words: ["MARCH", "INVOKE", "PLY", "SQUAD", "WITCH", "JARL", "NEXT", "BETA", "FINE", "GONE"]
	}
},
{
	id: "665e7147-8325-4816-9bac-6d00b7b7e393",
	dateId: "20270309",
	puzzle: {
		letters: "QBILJMUTPOSFKVRNAYEGHDWCX",
		words: ["BUILT", "JOLT", "CYAN", "MUFTI", "SAWYER", "SNAKE", "HANDY", "VEX", "PLOVER", "GROVE", "QUILT"]
	}
},
{
	id: "bf68a8e5-2654-4336-ad9e-4a1b7a3587a5",
	dateId: "20270310",
	puzzle: {
		letters: "BOXTFMEJGLDVNWYQIAHSUKPRC",
		words: ["SCRAPING", "RAVINGLY", "BOXED", "JOB", "SHAKING", "MEDIAN", "WARPING", "QUID", "FLY", "NEXT"]
	}
},
{
	id: "ee773cfb-ba26-48b1-b813-cc255b7724b4",
	dateId: "20270311",
	puzzle: {
		letters: "HEFPNYLVAXQMCSRIUGOBDTWKJ",
		words: ["MUCOSA", "DIMLY", "HELM", "BRAVELY", "BORAX", "BROW", "SAFELY", "KORAN", "PAVE", "QUIT", "JOGS"]
	}
},
{
	id: "afeaaa4c-b1b9-4bd4-ac27-2ac1a38701a1",
	dateId: "20270312",
	puzzle: {
		letters: "COVEJYXWUKPBQLNGISFMHDRAT",
		words: ["RISQUE", "JUNK", "MASQUE", "COVE", "COX", "DRAFT", "YOWL", "SIGH", "BIRDS", "PIQUE"]
	}
},
{
	id: "20a32b46-d937-42db-a58a-1646645d2521",
	dateId: "20270313",
	puzzle: {
		letters: "HGQJOPIUWVFKXABYENMRDCTLS",
		words: ["RANKED", "PIQUANCY", "FIG", "BANKED", "MANED", "MARLS", "JUG", "EXAMS", "WANTED", "HIKED", "BRAVO"]
	}
},
{
	id: "eab38c80-c322-4895-bb8e-6de6905245ce",
	dateId: "20270314",
	puzzle: {
		letters: "CHKQTWSAUREDPVFGYIOXLNJBM",
		words: ["BOX", "CHASED", "MOVINGLY", "DEWS", "QUASH", "FOPS", "JOIN", "AUKS", "SPURT"]
	}
},
{
	id: "e1c1fc25-bc09-478e-91d9-cd095624cdb8",
	dateId: "20270315",
	puzzle: {
		letters: "GOWTHCLRSKFXVAMBYJUQDENIP",
		words: ["BED", "MARSH", "QUARTS", "FLORAS", "CLOG", "FLOWS", "VAST", "KARST", "MARX", "PINED", "DENY", "UNJAM"]
	}
},
{
	id: "12b389d4-d62d-4130-bb3f-be804399c2af",
	dateId: "20270316",
	puzzle: {
		letters: "HLWYTJOPVIXBRDQNKFUSECAGM",
		words: ["SURFACE", "AUDIT", "LORDS", "IVY", "DRUMS", "PROWL", "HOWL", "JOWL", "BOWL", "QUACK", "DRUGS", "ACNE", "BOX"]
	}
},
{
	id: "075febfb-1b19-4c2b-abca-8ef7523c1769",
	dateId: "20270317",
	puzzle: {
		letters: "RWBIJAMCVKTDSHEGNYLFXPOUQ",
		words: ["CHEF", "JIVE", "QUONDAM", "LONG", "PYLONS", "WARMS", "BIKE", "LYNX", "MAT"]
	}
},
{
	id: "60eb76db-9c84-4971-abc3-c760eb7c97cc",
	dateId: "20270318",
	puzzle: {
		letters: "WLGOFQICNXYUKJHBASPERVDTM",
		words: ["BASTE", "QUICK", "DAUB", "HEMP", "LICKS", "WICKS", "FOCUS", "VAST", "COG", "COX", "BRAS", "JETS", "CONK", "BRAY"]
	}
},
{
	id: "81157a0f-4cc3-4d6d-a277-b2a21555964a",
	dateId: "20270319",
	puzzle: {
		letters: "TFHQDJOPUWRGKANCYSVIXEBML",
		words: ["HOGS", "ORYXES", "FORCES", "ANVIL", "QUAIL", "PAIN", "LIMBS", "PAWN", "JOGS", "CROFT", "AUKS", "DUN"]
	}
},
{
	id: "4764666b-7ecd-42a1-b377-df6236d1b61d",
	dateId: "20270320",
	puzzle: {
		letters: "WOKUDVNQIRFHGTMXECSABLYJP",
		words: ["MATCH", "BELCH", "KNOW", "KITSCH", "PSYCHE", "TRIGS", "QUITS", "JAMS", "HEX", "CHEF", "DIRTS", "VOW"]
	}
},
{
	id: "4b959684-ab53-4fd3-87a4-58946c17b443",
	dateId: "20270321",
	puzzle: {
		letters: "YDGFKPEWACJTSRNHUOLVQMXIB",
		words: ["STORAGE", "ANVILS", "FAROUT", "DETOX", "BLOUSE", "MOUSEY", "DEPTH", "JEST", "KARST", "CAROUSE", "RAWEST", "QUOTED"]
	}
},
{
	id: "0641d5ac-ece4-42ae-8641-550fc68bea1f",
	dateId: "20270322",
	puzzle: {
		letters: "JVGRYKOBSDETFLMWHPUAINXQC",
		words: ["HEWN", "FLUX", "THIN", "DRY", "BOGS", "QUALMS", "VOTE", "CALMS", "JOBS", "JOKE", "PLUMS"]
	}
},
{
	id: "aaff7864-b865-45ce-bb47-8f570cc513ba",
	dateId: "20270323",
	puzzle: {
		letters: "JCHKMPOWATYXNVIDUBRFQSELG",
		words: ["CHAIR", "RIFLES", "TIRES", "CHOP", "AHOY", "QUERN", "COX", "JONAH", "VAN", "WHAM", "HAWK", "FREUD", "AIRBUS", "GRIT"]
	}
},
{
	id: "7f18c9c6-66fa-4acf-948d-9457b538e529",
	dateId: "20270324",
	puzzle: {
		letters: "YXNGTLUPHEQDAOSVMRJCIWKBF",
		words: ["BROADLY", "LUNGES", "VIM", "WRAP", "DUX", "HARDLY", "QUARK", "ETHOS", "FJORD", "CORD"]
	}
},
{
	id: "90f46705-5f8a-4db7-98a0-3c1c9617f02f",
	dateId: "20270325",
	puzzle: {
		letters: "FGSJXTRINYPUHCEMQWLDBAVKO",
		words: ["VAMP", "TURF", "BAWLED", "WHINED", "ELK", "GRINS", "QUINCE", "JINX", "OLDEN", "PRICEY"]
	}
},
{
	id: "3cb1c9ff-a305-466a-959d-13e28e8b6387",
	dateId: "20270326",
	puzzle: {
		letters: "MGXFRBOKIHPQSWLYUEACNDJTV",
		words: ["MOSQUE", "VALISE", "BOSUN", "JAWED", "BOG", "SATED", "CLAWED", "PUNY", "RISQUE", "BOX", "WHISK", "CALIF"]
	}
},
{
	id: "3b1e0b4a-bbdb-49c9-8fa0-e67e5707be88",
	dateId: "20270327",
	puzzle: {
		letters: "DMQJGPOCUATVNKXRIWELYSFBH",
		words: ["WINKLE", "MOTIFS", "QUAKE", "POCK", "NEWSY", "VINE", "DOCK", "BEFIT", "GUNK", "HEWN", "JUNE", "AXLE", "FIRS"]
	}
},
{
	id: "b088a304-7c94-4458-ac22-181063fb86b0",
	dateId: "20270328",
	puzzle: {
		letters: "RFJNMDYHEBIPVTGWAULSXCKQO",
		words: ["FRY", "GLUTEN", "STUPID", "QUACK", "SQUAW", "THEM", "WAX", "SOLUTE", "VAULTS", "BEGS", "JETS"]
	}
},
{
	id: "bed2934a-9067-4a6f-8a36-1c54c9e613cf",
	dateId: "20270329",
	puzzle: {
		letters: "CKWEVIJMPNQUFDOBSGXHTAYLR",
		words: ["HONE", "JUGS", "QUICK", "FUME", "UGLY", "PODGY", "WEND", "BUMP", "VEND", "RHO", "EPOXY", "STAY"]
	}
},
{
	id: "b86f3283-257b-469e-ab51-f27975192b14",
	dateId: "20270330",
	puzzle: {
		letters: "NTDECBISXVUMRKHQAOYWFLJPG",
		words: ["QUARKS", "BIDES", "FLORIN", "POLARISED", "GYRO", "VEST", "PYRAMIDS", "SEC", "WHY", "MARX", "JOYRIDE"]
	}
},
{
	id: "d0a3d060-2153-4c3d-a858-625f095cbd11",
	dateId: "20270331",
	puzzle: {
		letters: "PQLFJIUSAKNWVRTCEDGMHXYBO",
		words: ["LARGO", "PINCHED", "GRAVEN", "TARDY", "BOGY", "WINCHED", "JARS", "FARM", "HEX", "QUINCE", "FLAK"]
	}
},
{
	id: "bf47a4b5-0ee6-43b0-9be1-5baff9f805d0",
	dateId: "20270401",
	puzzle: {
		letters: "SWDYKEQUNILVATGMOJRFXPHCB",
		words: ["FRANK", "CHOMP", "JAUNT", "EQUATING", "KNAVES", "BRANDY", "SWUNG", "POX", "GRAVEL"]
	}
},
{
	id: "f45e1629-fb35-4d7e-b9d6-82c2d4ac389e",
	dateId: "20270402",
	puzzle: {
		letters: "GNMALTESWVBPIDHYRUKOFJQCX",
		words: ["KISMET", "LAWMEN", "CURIES", "GEMS", "VASE", "FRIES", "QUIDS", "COX", "BRUISE", "JURIES", "UPRISE", "HOCK", "WISPY"]
	}
},
{
	id: "5181126f-ab0d-4d7c-9c75-ba557133f372",
	dateId: "20270403",
	puzzle: {
		letters: "WAGCHVSREFYPDNMJOUXLBQKIT",
		words: ["QUILT", "DUX", "WARNED", "BOUNDERS", "GRAVY", "KILN", "POUNDS", "ARCHED", "MENDS", "FEDUP", "JOYS"]
	}
},
{
	id: "7954b7d6-83cf-47c5-b3ab-5330febbf92a",
	dateId: "20270404",
	puzzle: {
		letters: "XTCSBEANFRGLYIPJOUKHVDMQW",
		words: ["VOYAGE", "QUIP", "MODULATE", "KINA", "TEXANS", "JOULE", "FINALE", "WHIP", "CAGOULE", "BRINY"]
	}
},
{
	id: "85d3d2d5-8b91-442f-98c0-8587d7ed3c61",
	dateId: "20270405",
	puzzle: {
		letters: "CHVQXPOSUFMBTLARKJINWEYDG",
		words: ["FAULTING", "FLUX", "COSTING", "VOTING", "JERKY", "POSTING", "HOSTING", "SQUALID", "SOMBRE", "BREW"]
	}
},
{
	id: "05fdac38-30c6-4134-956d-59525ba2586b",
	dateId: "20270406",
	puzzle: {
		letters: "GHENBRVLJIWAKUDXOQMTFSCYP",
		words: ["COAL", "RHENIUM", "INLAW", "GRAVEL", "OAKUM", "DUMPY", "FOAL", "SQUIB", "JUMPY", "COAX", "DUTY"]
	}
},
{
	id: "13ab4852-afcb-48c3-8d91-82e11b3633dd",
	dateId: "20270407",
	puzzle: {
		letters: "MANOPHWESFXDTGCBUIJRQLVKY",
		words: ["MANED", "DIGEST", "WHAM", "VIDEOS", "QUITE", "CRY", "DUX", "DILUTES", "FOETID", "KITES", "POSTED", "JIGS", "BUTS"]
	}
},
{
	id: "f45dcae6-5106-4543-9aad-aa7c124f43d8",
	dateId: "20270408",
	puzzle: {
		letters: "FTGIMXABRDVLUQKCWONEYJHSP",
		words: ["CLONES", "DRUNK", "GRID", "FAUNS", "BRIM", "JOHN", "EQUAL", "VALOUR", "TALONS", "PENS", "SHOWY", "FAX"]
	}
},
{
	id: "059bc713-ccc0-4fba-915d-3cb3f0f6c66b",
	dateId: "20270409",
	puzzle: {
		letters: "BQXVDHAUOIJNTRWSGCEFLYMPK",
		words: ["CRETANS", "BANTER", "CRUX", "JANGLY", "DIVORCE", "MERCY", "PERIOD", "FRET", "QUOTER", "TOWER", "HANGS", "TREK"]
	}
},
{
	id: "b91745c6-4fae-4ed1-a95d-ae23fb7cce45",
	dateId: "20270410",
	puzzle: {
		letters: "GFNCQLXOUMASTRJVDEWIYKPBH",
		words: ["FOREST", "WIRED", "NOSTRUM", "DYKES", "QUOTED", "VASTER", "JUNO", "HIRED", "COURTED", "GLADES", "TRIBES", "PEDALS", "DETOX"]
	}
},
{
	id: "2211c537-23db-4943-a093-4c4a783b06ff",
	dateId: "20270411",
	puzzle: {
		letters: "YVWDEQSOJGMUCKHNLIAXBTPRF",
		words: ["FAX", "CULPRIT", "JOCK", "QUICK", "VOWS", "BLUNT", "CLUMSY", "WODGE", "HACK"]
	}
},
{
	id: "13fe3b32-78f7-4b27-b12b-1e84329179b3",
	dateId: "20270412",
	puzzle: {
		letters: "FJAYVLRHODPECMBKUITGQWSNX",
		words: ["PECTIN", "COMING", "QUICHE", "BOAR", "FRAY", "KELP", "BODY", "SWITCHER", "JARL", "VOMITS", "MINX"]
	}
},
{
	id: "0c49eda7-6164-4e92-9509-e99a0b6cfb22",
	dateId: "20270413",
	puzzle: {
		letters: "JETWFVUROMHQXYKADLSNBPCIG",
		words: ["FORTE", "JURY", "SLINKY", "BADLY", "WROTE", "VERY", "TORQUE", "CLINGS", "HURT", "BAP", "FOXY", "MORE"]
	}
},
{
	id: "06c1ca0c-58e1-46c0-b0bf-0cb3218ad800",
	dateId: "20270414",
	puzzle: {
		letters: "QUJYDLFAPINSGKVOTWEMHCRBX",
		words: ["FAKE", "QUAY", "CREWS", "PAGER", "NOTCH", "BERTH", "MEGA", "VEX", "DIVERTS", "GAULS", "JAG"]
	}
},
{
	id: "be979580-f176-4e41-82cd-6ca1aa0e566c",
	dateId: "20270415",
	puzzle: {
		letters: "DSQJCXIUFHRPMYEGBNATWOKLV",
		words: ["PRIMATE", "JUMBO", "GRIDS", "FEALTY", "KNOB", "HYMNAL", "VAMP", "MIX", "QUIDS", "CHEAT", "KNOW"]
	}
},
{
	id: "9a855ae2-de16-4346-bae5-981fb034b537",
	dateId: "20270416",
	puzzle: {
		letters: "KCQUDHNOWITYGBXLSAREPFJMV",
		words: ["COBRAS", "XRAYS", "CONK", "RABID", "FAME", "JARGON", "QUID", "LYNCH", "KNOW", "FAST", "GRASP", "VERB"]
	}
},
{
	id: "3c665a32-6594-48c6-aab9-dcfe08f134cf",
	dateId: "20270417",
	puzzle: {
		letters: "MYXQIJAWTUFCDOVGREKNPLBSH",
		words: ["FADEOUT", "QUIT", "DECAY", "KERBS", "PLEBS", "AFRESH", "JADES", "WAXY", "VOW", "FREONS", "ERG", "MACES"]
	}
},
{
	id: "98ec0ee7-026a-49d7-8f02-92a65a7b52f5",
	dateId: "20270418",
	puzzle: {
		letters: "HQKEVSUCLXIRPGNMOYADBFJTW",
		words: ["DANGLE", "SQUIRM", "FORCE", "TANGLE", "TANGY", "SUCKLE", "VEX", "TWANG", "CRUSH", "OPUS", "BOP", "JANGLE"]
	}
},
{
	id: "cf33b7df-b206-4368-b290-bbd05ec7a7ad",
	dateId: "20270419",
	puzzle: {
		letters: "HRKCGONSIMQUVWFADLEPJYBTX",
		words: ["QUAY", "HONKS", "PELVIC", "BELT", "EXT", "GIVE", "HORNS", "JAY", "ADULT", "SWIVEL", "SKIM", "WIFELY"]
	}
},
{
	id: "77f85e86-7466-4ef7-8301-5be6fe7fb983",
	dateId: "20270420",
	puzzle: {
		letters: "QSBKYLUEFDAXNVGMRTCIJOWPH",
		words: ["VENTRAL", "NEBULAR", "CHIP", "DYKES", "GIVEN", "FEN", "JOT", "WORM", "QUARTO", "SEXUAL"]
	}
},
{
	id: "146bf767-7617-45e8-a966-e8d57c907035",
	dateId: "20270421",
	puzzle: {
		letters: "EWNRMVSAHBYTIPKQUGOCLFXDJ",
		words: ["KHANS", "VEST", "RAWEST", "GUITAR", "SWARM", "JOIST", "PHRASE", "GUTSY", "BRAISE", "DOCK", "FLUX", "QUITS"]
	}
},
{
	id: "7f977446-48d9-4cad-a5c7-9d67a237fdea",
	dateId: "20270422",
	puzzle: {
		letters: "QUNCBXAVERLFPHTJSKIGOYDWM",
		words: ["LANCER", "FLAX", "APHIDS", "QUAVER", "BERTH", "GIPSY", "WITHER", "SPIKY", "ALSO", "JOYS", "MIGHT"]
	}
},
{
	id: "1435373c-d829-4c6d-be08-ebf890a207e7",
	dateId: "20270423",
	puzzle: {
		letters: "PNDYOMUIWRQBXGKVSTCJLEHFA",
		words: ["ROWDY", "SQUIB", "JACK", "NUMBS", "FACTS", "VEST", "BUMP", "GROW", "ACHES", "DUX", "LEST"]
	}
},
{
	id: "78f6d0f4-c45e-4357-9f67-65076c739dc5",
	dateId: "20270424",
	puzzle: {
		letters: "YWJNLFOVAXDMREKSCIHPQUGBT",
		words: ["SQUIRE", "THROW", "FORMIC", "SQUIB", "JAR", "YORE", "ARIGHT", "LAXER", "CREPT", "CRAVE", "PEKAN", "DOVER"]
	}
},
{
	id: "18922ec5-1ad0-4449-84a8-c6129aa7c1a2",
	dateId: "20270425",
	puzzle: {
		letters: "HECLPTVRUDBYQAKJNGSWFOMIX",
		words: ["DULCET", "SMOG", "PURE", "BYTE", "MIX", "SQUAWK", "AGONY", "JOGS", "HER", "CURVE", "FOGS"]
	}
},
{
	id: "6053755a-10b2-44e5-8d3f-607c9a1ec1b8",
	dateId: "20270426",
	puzzle: {
		letters: "FSHOCLGPJBTIMEWVYAKDQUXRN",
		words: ["LIMPED", "COPED", "MARKED", "AMITY", "QUAILS", "JOB", "HOPED", "GILT", "IVY", "FLIPS", "BEAUX", "EARN", "SPEW"]
	}
},
{
	id: "765aa48b-70ac-4992-9f1a-27eb6f93623c",
	dateId: "20270427",
	puzzle: {
		letters: "YGPNJIXHOFDERMWLSVCQBKTAU",
		words: ["SERMON", "QUAVERS", "PORED", "YIELDS", "SLEIGH", "DESK", "WORSE", "EXPO", "FOREST", "JOHN", "BLED", "CAVERS"]
	}
},
{
	id: "692119ab-c5cd-4ab5-9258-845053dc0d05",
	dateId: "20270428",
	puzzle: {
		letters: "DKRMCPWYUALEHIQBVNFJOGXTS",
		words: ["OBEYING", "VENTS", "LEWD", "JINGO", "JINX", "WHELP", "MURKY", "FINE", "QUAINT", "CUING"]
	}
},
{
	id: "e8b7a5e1-7cd1-447f-960d-e50667c42830",
	dateId: "20270429",
	puzzle: {
		letters: "SCWHKBGONDVEJPYIQFLXTUMAR",
		words: ["FLAX", "QUIT", "DHOW", "BEGS", "CONY", "IVE", "CONK", "MARL", "JOGS", "COPY"]
	}
},
{
	id: "4493c32c-ac63-4c8b-a3ac-7a913e7b4c26",
	dateId: "20270430",
	puzzle: {
		letters: "BRHCSYNTGWEQFAOMLUJVDXKIP",
		words: ["ENTRY", "JAWS", "MELD", "FLUX", "EQUIP", "AUK", "AVOW", "BYE", "WATCH", "GAUL"]
	}
},
{
	id: "5baad730-6fa8-4af5-8d5c-494b1f9636da",
	dateId: "20270501",
	puzzle: {
		letters: "BALKPWYCFROTXNEJMIUHSVQGD",
		words: ["UNITY", "MINX", "FLACK", "BYLAW", "FREUD", "QUERN", "NIGH", "PRE", "VIMS", "OMIT", "JOT"]
	}
},
{
	id: "699c05c5-7280-4a85-9507-f2d5cc997d85",
	dateId: "20270502",
	puzzle: {
		letters: "SHFRGQEVCATULDBPONKYXJMIW",
		words: ["WINKLES", "MINUTES", "QUOTES", "MOULDY", "WINDBAG", "JOULES", "FELON", "CARVES", "POX", "HELD"]
	}
},
{
	id: "0e80216d-dce5-42d1-a426-8f035666ff9d",
	dateId: "20270503",
	puzzle: {
		letters: "GQLFSPUBDHAMXRTYVKIEOWCJN",
		words: ["GULFS", "QUAY", "BUMP", "AVOW", "JERKIN", "NERDS", "BRICK", "INERT", "FLUX", "SHRINE"]
	}
},
{
	id: "e14a9cfc-a1e5-4732-b451-c9b7e895af45",
	dateId: "20270504",
	puzzle: {
		letters: "EFCHQXTGUIBLVYDWOASRKMNJP",
		words: ["FETCH", "EXT", "BOWMAN", "QUIDS", "JAYS", "SALVO", "SPRY", "GLANS", "AMOK"]
	}
},
{
	id: "3b68defa-743b-4292-8c28-5fd4e7ddfbb3",
	dateId: "20270505",
	puzzle: {
		letters: "DROJGIVWEXFSQTNYKAUHLPCBM",
		words: ["SAUTE", "QUACKS", "VISA", "HUBCAP", "MUCKS", "NEWSY", "PLY", "BASIFY", "GENT", "DROWSY", "NEXT", "JET"]
	}
},
{
	id: "d6a015ef-4e69-489f-b3b9-f64c4a3499b7",
	dateId: "20270506",
	puzzle: {
		letters: "YRHEDNTPVGOXLFBSMWIJKACUQ",
		words: ["MASONRY", "WILT", "CASK", "FILMS", "FIB", "DEPTH", "QUILT", "JILT", "VEG", "XMAS"]
	}
},
{
	id: "85602ec5-f1ac-4ddf-a1bd-daae4fd2ffcb",
	dateId: "20270507",
	puzzle: {
		letters: "XYBKMGALEHCSWUQPOIDRFJVTN",
		words: ["EQUIVOCAL", "WAXY", "POSIT", "DISABLE", "GABLE", "JOWLS", "HULK", "URN", "SALEM", "FOCAL"]
	}
},
{
	id: "5c499a92-c48b-491f-b0c2-913a2b977c5d",
	dateId: "20270508",
	puzzle: {
		letters: "DEGRJCVWUXHKTIQYMPSBONLAF",
		words: ["URGED", "SALMON", "WISP", "VEG", "JUTS", "DECK", "QUIPS", "FAST", "BALMY", "SIX", "HYMN"]
	}
},
{
	id: "2dfdfcc8-daa1-47fc-8a7d-bb98ba9cd5b8",
	dateId: "20270509",
	puzzle: {
		letters: "SDKWQLEHRUNMTCIOVBAFGJYPX",
		words: ["FICHES", "QUICHES", "GONE", "METRIC", "JOG", "BYPATH", "WHEN", "FAX", "LEMON", "ENVY", "IRKED"]
	}
},
{
	id: "551d94f3-b471-4e95-851c-75b650ce9f26",
	dateId: "20270510",
	puzzle: {
		letters: "XHNCDFELITQAVJKURWOGMBYPS",
		words: ["UMBRAE", "INLAW", "RAVINE", "HEX", "EVICT", "CLEF", "JIVE", "VALID", "KILN", "JOGS", "EQUAL", "NEARBY", "SOP"]
	}
},
{
	id: "50cc05c1-2a90-4cf6-b20e-64ff69b10509",
	dateId: "20270511",
	puzzle: {
		letters: "VFBIDJOWHATSGCKEXQYLNURMP",
		words: ["WHACK", "PLY", "RUNES", "BOGS", "VOTES", "FOGS", "JOGS", "CHAD", "GOBI", "GYM", "QUEST", "NEXT"]
	}
},
{
	id: "0a6e8c49-f58d-4ac6-bc22-acfa221c041c",
	dateId: "20270512",
	puzzle: {
		letters: "DGLPNOFMAYKIXQWVTEUBSRJHC",
		words: ["TEXAN", "PLAQUE", "MIXERS", "FLAW", "KITE", "VIER", "JETS", "DOGMA", "FLAY", "HERS", "CUB"]
	}
},
{
	id: "0184813e-6e5e-4814-ad71-5fc8a1cf7d52",
	dateId: "20270513",
	puzzle: {
		letters: "GVJATIDNSBLKQWRFUEYOXPHCM",
		words: ["TANKFUL", "STAND", "BASQUE", "ANVIL", "MOWN", "BROWNS", "FLUX", "CHEWS", "JABS", "PEWS", "DIG", "FLUKEY"]
	}
},
{
	id: "33b1e392-e298-438d-afd1-e178bee45312",
	dateId: "20270514",
	puzzle: {
		letters: "HNRILCEKWFMGTXODVAJBYUQSP",
		words: ["JOBS", "VAT", "GAUDY", "MEGA", "FIRE", "WRENCH", "GASP", "LIKEN", "SQUAT", "BOX"]
	}
},
{
	id: "e92c5c76-4580-41bb-bae1-2e36a1283f14",
	dateId: "20270515",
	puzzle: {
		letters: "JVWSRYAHDOPTKCGLEIUNFMBXQ",
		words: ["SOCIETY", "SOCKET", "THAWS", "FELT", "WAVY", "EMIT", "MIX", "BUNCH", "ROCKET", "DOCKET", "CHAPEL", "QUICK", "BUNG", "JAPE"]
	}
},
{
	id: "62cab5a7-b235-45dd-ab0d-17f39d1d720e",
	dateId: "20270516",
	puzzle: {
		letters: "MBRLJXODACKSPWFQENTYUGIVH",
		words: ["BROKEN", "VINES", "DRAFTING", "MOSQUE", "LAPSE", "THY", "WAFTING", "JAPES", "CAPES", "BOX"]
	}
},
{
	id: "d59d4ebc-2b13-46bf-8812-646ed2e8f3c6",
	dateId: "20270517",
	puzzle: {
		letters: "VYTREIMJWDLBAGPXUNSCFKQOH",
		words: ["IVY", "GNAWED", "CONGA", "BANGS", "JAWED", "MASON", "LUX", "GNAWER", "TWANGS", "FUNK", "QUASH", "GASP"]
	}
},
{
	id: "81d4d88f-cc6d-4e38-a3cc-7e015f51b18d",
	dateId: "20270518",
	puzzle: {
		letters: "OSXDLCMRETBFPJNGAYIHKQUWV",
		words: ["JET", "COMB", "HINTED", "VIPERS", "COMPEL", "COMFY", "QUAY", "WINTERS", "APEX", "GAPED", "YAK"]
	}
},
{
	id: "883bca62-796f-4b92-833f-044194145da6",
	dateId: "20270519",
	puzzle: {
		letters: "IVNADMEXPULKFQGYTOWSHJCRB",
		words: ["LEFTY", "BROKEN", "PANEL", "CROFT", "BROTH", "LEVI", "AXE", "SQUAD", "BROWS", "PUGS", "MELT", "JOKE"]
	}
},
{
	id: "6434539d-e5fb-4ebd-9304-4707f042a4b8",
	dateId: "20270520",
	puzzle: {
		letters: "CSMDYQRIXHUVLGAEFPWTNJOBK",
		words: ["WAXY", "JOWL", "FOWL", "RISQUE", "BOP", "CRIM", "GIVEN", "GAWK", "TAXIS", "HAWK", "DIMS"]
	}
},
{
	id: "fbfa21f5-bdcd-4956-8e4c-ac6f45c18643",
	dateId: "20270521",
	puzzle: {
		letters: "JSUQRIKGOPMVTCNFEXWDLBAHY",
		words: ["FLEX", "BAH", "JIVE", "BAWDY", "PROTEA", "QUOTE", "SKIM", "NOTE", "COGS"]
	}
},
{
	id: "e4f6d175-2fff-4dda-8805-508ccb73ce27",
	dateId: "20270522",
	puzzle: {
		letters: "KRPQUELGIJVBSNCOYXATFWHDM",
		words: ["MANCIPLE", "CATNIP", "ELBOW", "HANGS", "JINGLE", "BEVY", "QUIP", "FOBS", "DANGLE", "JINX", "BERK"]
	}
},
{
	id: "32180431-ca00-4d68-9741-547347eae9de",
	dateId: "20270523",
	puzzle: {
		letters: "SRQUJDVYHIFAPBCLOWEKXGMNT",
		words: ["QUICKEN", "LAWMEN", "FOMENT", "DRY", "HYPE", "GOADS", "FOX", "BECK", "JUICE", "WAVY"]
	}
},
{
	id: "0f2c9520-8105-4489-9bb7-61415e26765c",
	dateId: "20270524",
	puzzle: {
		letters: "KFGPQCALWUTHJIMVNRSBXEYDO",
		words: ["RENTAL", "VEX", "LIMBO", "FLACK", "ALP", "QUIRE", "BIRDS", "JACK", "WIRE", "LATCH", "FLAG", "FLIMSY"]
	}
},
{
	id: "7d59ec5b-3221-4696-8a47-c91087e6cda2",
	dateId: "20270525",
	puzzle: {
		letters: "YPJBQKSAEUXCNFDVIRTGMWHLO",
		words: ["CAFE", "GOTHIC", "WHIRL", "QUEASY", "WHINED", "MIX", "BEANS", "VINE", "PANICKY", "JACKS"]
	}
},
{
	id: "75c55bcc-5a4a-4c8c-bc5d-b258e46aaa76",
	dateId: "20270526",
	puzzle: {
		letters: "BOWGKVJQUETLASDXPYRIHNMFC",
		words: ["JARS", "SALVO", "LARYNX", "QUAYSIDE", "GUARDS", "BOW", "DUKES", "DISARM", "DESALT", "LYMPH", "FRAUDS", "CRYPT"]
	}
},
{
	id: "701e6d64-62e3-45cf-b695-c0dab980ffc4",
	dateId: "20270527",
	puzzle: {
		letters: "XGHSNMERTOILWPFDUKAYCQBJV",
		words: ["OTHERS", "DIMERS", "JAB", "IDLERS", "FONTS", "BULK", "WAVY", "HEX", "QUID", "CUBA", "POST", "GREW"]
	}
},
{
	id: "52442d29-a2d9-4383-ac3d-1e480b440c20",
	dateId: "20270528",
	puzzle: {
		letters: "ODERPFMVJKGACNSXYIUQHWBLT",
		words: ["DOMAINS", "CAVED", "FAMED", "BLINKS", "QUILT", "JERKS", "PREVAIL", "LIBYA", "GAINS", "WINKS", "FAX", "WHY"]
	}
},
{
	id: "981f0546-9913-429a-ac00-8fa6fa71d2aa",
	dateId: "20270529",
	puzzle: {
		letters: "HJNYLGOMSIDCFBXWKRAVEPTUQ",
		words: ["TAXIS", "COMBAT", "VAT", "KEPT", "WEPT", "TURFS", "HOCK", "SMOG", "SYNOD", "QUARK", "JOCK", "SLY"]
	}
},
{
	id: "2571058d-f4e1-43a7-92ca-a07138ef7ab4",
	dateId: "20270530",
	puzzle: {
		letters: "WFNEBLORGSQUDAKHIJMVCTXPY",
		words: ["QUID", "FORAGES", "GRAVY", "DRONES", "WORDAGE", "RADIX", "BERGS", "CHURN", "MASK", "LONGER", "ADJURE", "DAMP", "DITCH"]
	}
},
{
	id: "b183810f-8a5e-41df-8d6d-c29af7cd3a70",
	dateId: "20270531",
	puzzle: {
		letters: "VJXQSMETOUPBLFDANGRWCYIHK",
		words: ["RINGLET", "IRK", "MELT", "EXODUS", "PAYING", "JET", "QUOTE", "WHIRL", "VETO", "FRINGY", "BAYING", "CABLE"]
	}
},
{
	id: "556447f0-0e00-44a8-9727-2b0354777980",
	dateId: "20270601",
	puzzle: {
		letters: "SKXWBMRFNEYAVCDTULHPJGQIO",
		words: ["VARY", "WENCH", "QUARKS", "TULIP", "MARX", "BEND", "CHOP", "GLUT", "FARMS", "JUG"]
	}
},
{
	id: "c74d49ba-7693-4fd0-a7e8-24795fb07f2b",
	dateId: "20270602",
	puzzle: {
		letters: "BXGUQCIOSHLPTWRAJFEVMNKYD",
		words: ["SHRED", "DETOX", "CLANKED", "BIGOTED", "POWERS", "VETO", "JAM", "QUOITS", "DEFT", "DYERS"]
	}
},
{
	id: "18bab40a-22f7-4a44-9c5e-0f49e563c95c",
	dateId: "20270603",
	puzzle: {
		letters: "THCJBFYREWSLKVXDUIMPGAQON",
		words: ["EXPO", "BERYL", "THREW", "GUILDS", "LIVERY", "QUAILS", "CREW", "JERKILY", "LION", "MILKER", "FLUKE"]
	}
},
{
	id: "49d98719-eee2-4595-be08-ad5ec1873ea6",
	dateId: "20270604",
	puzzle: {
		letters: "TAWMYFNHDGXLRPJOEVISUQKCB",
		words: ["GYM", "DRIVEL", "SICKER", "FAWN", "BICKER", "HAFT", "JIVE", "QUERN", "PHLOX"]
	}
},
{
	id: "b61cdfc0-f31c-4b80-ab5d-dd09000421da",
	dateId: "20270605",
	puzzle: {
		letters: "RVNLDTEJOWXPMIFQUAYCSKBGH",
		words: ["HYMEN", "ICY", "DOME", "BUMPER", "AUKS", "VENOM", "GAME", "QUAY", "NEXT", "LONER", "WOMEN", "FOLD", "JOWL"]
	}
},
{
	id: "49515f90-3bba-4af3-90cb-52d20fef7243",
	dateId: "20270606",
	puzzle: {
		letters: "WNADQRICUTJFVKGLHEXYMOBSP",
		words: ["CAIRN", "DUG", "JIVES", "SEXY", "TUCK", "LOBES", "ESPY", "WIVES", "HOBS", "FIVES", "MOBS", "QUACK"]
	}
},
{
	id: "be10f9b6-80b4-4424-bef0-baa268321004",
	dateId: "20270607",
	puzzle: {
		letters: "RNBOWLITMVYCXPGHKEUJSDAFQ",
		words: ["BITCHY", "SKEPTIC", "JUG", "BOTCH", "RICKS", "QUAKED", "LICKED", "FAKED", "VOW", "EXIT", "TOMB", "NICKED"]
	}
},
{
	id: "d690282e-765d-4bf2-a581-8e655ae98386",
	dateId: "20270608",
	puzzle: {
		letters: "STPVDYMNRIFKALBEOUHWJXGQC",
		words: ["VIBRANT", "BRAKE", "CHANTS", "WHAM", "QUAKE", "FOAMY", "GUARD", "FOX", "CHAMP", "LANKY", "JOKE"]
	}
},
{
	id: "d9920960-3417-46f9-949c-797482bcb7d7",
	dateId: "20270609",
	puzzle: {
		letters: "HCQBEDUNPYALFMTGISJWKXVOR",
		words: ["JOVIAL", "DUALISM", "QUAILS", "TYPE", "KILN", "BYE", "UNFIX", "ROW", "LAUNCH", "GAULS"]
	}
},
{
	id: "0fd2c57a-bd85-4178-b44d-37327337d50a",
	dateId: "20270610",
	puzzle: {
		letters: "LYKHGERFDAQUCNMBOVPSTJWIX",
		words: ["QUERY", "SIX", "DAMPS", "KHANS", "PIVOT", "JOB", "SNAG", "FUEL", "CRUEL", "WISP"]
	}
},
{
	id: "03462dfd-380b-4b7a-874e-b4532ac6ff48",
	dateId: "20270611",
	puzzle: {
		letters: "CQRFYLPUIMOJVTGNAWEBKHXDS",
		words: ["KNAVES", "LOAVES", "FRUITED", "PRIVET", "QUITE", "BEDS", "HAVES", "GIVES", "MITES", "TEXAN", "CLOAK", "PURIFY", "JAWED"]
	}
},
{
	id: "e9cbc2f5-1520-49d4-8ef2-431ff69948a5",
	dateId: "20270612",
	puzzle: {
		letters: "MIVCGDKENHTBWUQJSXRLFAYPO",
		words: ["EURO", "DIVE", "KIEV", "MIEN", "BENCH", "FAST", "SWUNG", "PRUNE", "FAX", "NEWSY", "JAYS", "QUENCH", "LUNCH"]
	}
},
{
	id: "6cba716f-3e09-42f3-a4c5-1307a1c0d519",
	dateId: "20270613",
	puzzle: {
		letters: "LCHVWDISAXUPJMNRQOTGEKBFY",
		words: ["FOPS", "SMOKER", "GNASH", "SHANTY", "PRUDISH", "TOPICS", "EQUIPS", "BOPS", "JOKER", "GNAW", "CHILD", "VAN", "XMAS"]
	}
},
{
	id: "54b00963-9458-451b-9eca-486f89b527f5",
	dateId: "20270614",
	puzzle: {
		letters: "QVEGMYUPRNFLSKTOBACIXDJWH",
		words: ["GERM", "VERTICALS", "QUERN", "PERKS", "REPLY", "WITCH", "BLACKS", "JACKS", "BOLA", "DABS", "FLABS", "BOX"]
	}
},
{
	id: "6e526501-d01b-44d5-bd0c-4e9ff1fbd195",
	dateId: "20270615",
	puzzle: {
		letters: "KQUXHYAGELPNJDCWIOMBSVTRF",
		words: ["JANITOR", "MOVING", "HEX", "APING", "SINGED", "PINY", "YAK", "TONGUE", "QUAY", "WINGED", "FROM", "ANGEL", "CLEG", "TOMB"]
	}
},
{
	id: "0d4860ed-85c0-4866-b5a1-ee0510bf8a66",
	dateId: "20270616",
	puzzle: {
		letters: "BQKFLJUTOGWISMECANPVXDRHY",
		words: ["DRASTIC", "EGOTISM", "RASPY", "LOFTS", "QUITS", "BUST", "JUST", "HYPE", "WINSOME", "WAX", "VEG", "KUWAIT"]
	}
},
{
	id: "25fb9022-55f8-4072-ba71-75aabf9d922c",
	dateId: "20270617",
	puzzle: {
		letters: "NDGEVIFPTSBYROWCAULXHQJMK",
		words: ["VESTRY", "CABIN", "HARLOTS", "QUARTO", "STRUM", "POX", "BAULK", "FIDGETS", "JARL", "PROWL"]
	}
},
{
	id: "e74cb485-ce03-4696-9b3b-9a9ef24fe29c",
	dateId: "20270618",
	puzzle: {
		letters: "SBHXQTREUGYVJINPWDFCMOALK",
		words: ["MODAL", "ADVERBS", "WADING", "UNCLAD", "JUG", "ADVERTS", "QUERY", "DOPY", "QUICK", "FADING", "ADIEUX", "HERBS"]
	}
},
{
	id: "48b259d9-7aab-494e-9b4c-3344365b705a",
	dateId: "20270619",
	puzzle: {
		letters: "XSFDTBOCNMYHQGEWUAIVKRJLP",
		words: ["COBS", "MEND", "LIVEN", "BOX", "PIGMENT", "FOBS", "AHOY", "QUAIL", "QUARK", "JAIL", "WHO"]
	}
},
{
	id: "90889b45-e0e3-4b77-89e4-08677b8e2bf9",
	dateId: "20270620",
	puzzle: {
		letters: "RYFWHDOPXAQLNJCUIMEKBVTSG",
		words: ["JACKETS", "DRONES", "MILORD", "VINES", "WHACKS", "BUILD", "POLITE", "MINX", "GEMS", "FOLD", "DOPY", "QUITE"]
	}
},
{
	id: "954d2302-5f1d-4d28-8add-37df0d13d3cc",
	dateId: "20270621",
	puzzle: {
		letters: "WYVFIMODKSHTXABPLJNUCEGRQ",
		words: ["IFS", "WODAN", "DANGLE", "HOMY", "QUASI", "JANGLE", "BURGLE", "PELT", "AXLE", "CLEG", "VODKA"]
	}
},
{
	id: "1b3e5705-a213-430a-8d5d-fc71ababa61b",
	dateId: "20270622",
	puzzle: {
		letters: "WBMGASUQLHCNOKPXIDFRTJYEV",
		words: ["FOUNDER", "FOLK", "PLOD", "NUMBS", "CINDER", "HALONS", "JINX", "REV", "TINDER", "SWUM", "GAL", "QUOINS", "DEFY"]
	}
},
{
	id: "e8191438-9b76-4aa3-bb6b-e83a7d523bfb",
	dateId: "20270623",
	puzzle: {
		letters: "SQNHACKUJRDIXMPOFGTBWVELY",
		words: ["HUNKS", "HUMBLY", "QUICK", "FELT", "WOVE", "JUMBLE", "FIX", "DIG", "HARP"]
	}
},
{
	id: "7afc800c-5a1d-40d9-ad3e-8769c33a4bfb",
	dateId: "20270624",
	puzzle: {
		letters: "MXRYDBEQNKIWUCPGHAOFSLVTJ",
		words: ["VOCALS", "QUOTA", "BERN", "WEIGHS", "FOALS", "QUACK", "JOCK", "POUND", "IBEX", "QUERY", "MEW"]
	}
},
{
	id: "f1af94f3-09fe-497e-846d-bd68f97c4095",
	dateId: "20270625",
	puzzle: {
		letters: "IQDWNTUPHXSRGOJBYKVFMLACE",
		words: ["BLACK", "OKAYS", "HOVE", "SYRUP", "QUITS", "JOHN", "DUST", "FOX", "GUTSY", "CALM", "WHOP"]
	}
},
{
	id: "e97c29d5-5207-4e1d-9623-6ecf21c44710",
	dateId: "20270626",
	puzzle: {
		letters: "EBLYCVFXKSWODTQGMPUHNAIJR",
		words: ["IMAGO", "SKY", "WOMAN", "BEFOG", "PUTS", "DOGMA", "QUIP", "JUDO", "FOXY", "RUTH", "CYST", "FLY", "DOVE"]
	}
},
{
	id: "2c66e822-101d-4573-89b8-d7323645c296",
	dateId: "20270627",
	puzzle: {
		letters: "EYUGKTQDICVXRPFHALSBNMWOJ",
		words: ["DRAWLS", "HARDY", "MARX", "EQUIPS", "PRICK", "JOWLS", "BOWMAN", "YET", "GIRLS", "SLAV", "FIRS"]
	}
},
{
	id: "08c3f020-846b-4527-8a59-a58bfaf9e069",
	dateId: "20270628",
	puzzle: {
		letters: "BVXLCNYEOKIQGSRMUWHTFJDPA",
		words: ["COXES", "SWUM", "PATHS", "JUGS", "BYES", "INVEST", "DUG", "PATROL", "FUG", "CORKS", "SEQUIN"]
	}
},
{
	id: "db5c08bd-bc8b-43f1-81e6-90f64ed05082",
	dateId: "20270629",
	puzzle: {
		letters: "SKDAXTNLHFBRCIJPEMGYQUWOV",
		words: ["HADNT", "VOW", "JIHAD", "QUERN", "CHALKS", "YOGI", "FAX", "BERN", "PUMICE"]
	}
},
{
	id: "6a3db3c8-2ab7-4801-ba8b-4f36aeea7252",
	dateId: "20270630",
	puzzle: {
		letters: "XAJBVFIUOGMDQLWPCERKTNYHS",
		words: ["AIDERS", "CENT", "BOWLERS", "VOLE", "BULKS", "IMP", "OGLED", "SHRED", "FAX", "JOULE", "BOLEYN", "QUID"]
	}
},
{
	id: "6a31b4d5-4b4e-4e1e-94dc-06745c57bd2b",
	dateId: "20270701",
	puzzle: {
		letters: "BQSPKRLUMCTIYAHNJXFVGDEWO",
		words: ["FAXING", "MAULING", "DEFAULTING", "SQUIRT", "QUACK", "DEFYING", "VAULTING", "BLIND", "HAULING", "AVOWED", "JILT", "AMPULS"]
	}
},
{
	id: "aea419d7-b471-42e7-a034-f8eb9f6f9696",
	dateId: "20270702",
	puzzle: {
		letters: "RJLQUOCKEWNYMSTFIBAXHDGVP",
		words: ["QUEST", "BIGAMY", "ROCKETS", "ASKEW", "DIMES", "HID", "TAX", "PASTEL", "FIBS", "VASE", "AMINO", "JOCK"]
	}
},
{
	id: "2aef64f7-b1c2-4dc8-b36a-e7f570800214",
	dateId: "20270703",
	puzzle: {
		letters: "GTDXSOVILMWFJYRNKHAUPECQB",
		words: ["ACHE", "BURLY", "FIX", "GOWN", "CHARMS", "JACK", "DIVOT", "PECK", "QUACK"]
	}
},
{
	id: "f017b41a-c993-4ada-b5f9-b0146bcb1e9c",
	dateId: "20270704",
	puzzle: {
		letters: "DLGSNYTEWAKHVJPFRBIQOXMCU",
		words: ["PAWNS", "ORB", "JIVES", "ETHYL", "FOX", "FORMIC", "FORK", "QUIP", "VELDT", "LEGS"]
	}
},
{
	id: "9b10b34a-b65f-4ff4-a395-c89788ddb1f1",
	dateId: "20270705",
	puzzle: {
		letters: "OKBHSGANPYWFVMDLITERCXQUJ",
		words: ["HYMN", "BANK", "CLIQUE", "WAFTURE", "AGO", "LIFTED", "FIXTURE", "SPY", "JUTE", "KNAVE"]
	}
},
{
	id: "623966bf-c889-4729-b344-de28d89e058b",
	dateId: "20270706",
	puzzle: {
		letters: "PDYVWFSAHMIKXEBTOGULCJRNQ",
		words: ["AHEM", "BEGOT", "JOG", "BLEAK", "WHYS", "HEADS", "HASP", "LUXOR", "HEAVY", "FIT", "CORN", "QUEASY"]
	}
},
{
	id: "5a5c935a-94e6-4a41-a37c-3b04ef1a7d9d",
	dateId: "20270707",
	puzzle: {
		letters: "PINBJUQXOFDMTGKYESARWCHLV",
		words: ["BOGS", "DETOX", "METALS", "FOGS", "QUIP", "CHEWY", "GRATED", "ARGON", "JOGS", "SLAV", "SHARK"]
	}
},
{
	id: "98073903-5f78-4950-a4e3-6739e5f37c7e",
	dateId: "20270708",
	puzzle: {
		letters: "KRJFLUQOYTVISXBWMDCEPGNAH",
		words: ["QUIDS", "FOXY", "JOYS", "SOFTLY", "WIMP", "VISOR", "FORK", "SOYBEAN", "HANG", "BEACH"]
	}
},
{
	id: "5033a6b5-da4f-4a95-b233-de4011a72246",
	dateId: "20270709",
	puzzle: {
		letters: "QYAKGNUTOJLMRVHIWDEFPCSBX",
		words: ["BEDS", "LURED", "DERMIC", "JOG", "OKAY", "NUT", "LUREX", "FEDS", "SWIM", "HORDES", "DROVES", "TULIP", "QUAY"]
	}
},
{
	id: "b4f27301-f43f-4999-b995-efcda9c504ac",
	dateId: "20270710",
	puzzle: {
		letters: "XKCVJPETOYFSRALIDHUGWBQNM",
		words: ["FESTAL", "SPECTRUM", "DISTAL", "COLUMN", "BISECT", "GUARDS", "TAYLOR", "QUARTO", "RESTOCK", "CORTEX", "JOCK", "HATERS", "VORTEX", "WISER"]
	}
},
{
	id: "6bc61316-7ca9-4420-99d4-3006e0692b82",
	dateId: "20270711",
	puzzle: {
		letters: "NWDRBHEIKPCSXVTUAFLJQMYOG",
		words: ["NEWISH", "FLOG", "QUASHED", "JOLT", "AMUSED", "FAXED", "DECAY", "BRIDES", "PRIDES", "VIXEN", "SHEIK"]
	}
},
{
	id: "03d464e2-f645-400a-b193-7762874d8785",
	dateId: "20270712",
	puzzle: {
		letters: "GFJQWEVUATLBRCKXYSHINMPDO",
		words: ["NYMPHS", "CARVE", "JACK", "FURS", "LYMPHOID", "WARBLE", "QUACK", "LYNX", "WATCH", "BEG"]
	}
},
{
	id: "558afa35-43c7-4104-97e7-bd1a7df8161c",
	dateId: "20270713",
	puzzle: {
		letters: "XLBVDTNYMIEFJASOWURCPQGHK",
		words: ["MARCH", "OFTEN", "JAMB", "WETLY", "QUACK", "POET", "DISMAY", "GRAMS", "LYNX", "VIMS"]
	}
},
{
	id: "cd735d95-0a94-483c-8b99-08893f1f02d8",
	dateId: "20270714",
	puzzle: {
		letters: "VLGXTNAOSHRMJFBEKWQUYDCIP",
		words: ["DERMAL", "QUICKER", "SOARED", "JOGS", "GOSH", "FOAMED", "WICKED", "PUBS", "NAMED", "FOX", "DYER", "LOST", "VAN"]
	}
},
{
	id: "79161e53-dfbb-4e20-a6a1-cb1522f469f7",
	dateId: "20270715",
	puzzle: {
		letters: "BTSIROGKHDACYWLPUVEXQMJFN",
		words: ["WHISKY", "MUCKS", "STOCKY", "RISKY", "BOGS", "PACKS", "VEX", "JUMP", "QUACKISH", "FEN", "SIDLE"]
	}
},
{
	id: "a531fd74-095d-4721-abbc-546b6a293487",
	dateId: "20270716",
	puzzle: {
		letters: "MDRKHBEFCYUWNTVQGAOLIPXSJ",
		words: ["DRENCH", "LOANED", "PIQUED", "ATONED", "SAXON", "BENCH", "PATCHY", "GNAWED", "VOLT", "MERCY", "BERK", "FRENCH", "JOLT"]
	}
},
{
	id: "6a077a37-f1c4-4f10-95ca-e0f26cfd1e2f",
	dateId: "20270717",
	puzzle: {
		letters: "GEUPTXVQRBFWAMCDOJKINHLYS",
		words: ["FOLKART", "PRAM", "MARQUE", "WARM", "DHOW", "SICKLY", "JAMB", "FOND", "BRAVE", "VEG", "VEX"]
	}
},
{
	id: "f99fc60f-823b-4a5f-a4ad-7d0fa2a8c249",
	dateId: "20270718",
	puzzle: {
		letters: "DVSMBPAYWLKXRNOJFIUHETQGC",
		words: ["UNWRAP", "GUNITE", "VARY", "BLOWN", "QUITE", "OLMS", "YAK", "FRAYS", "JET", "XRAYS", "DARN", "CHURN"]
	}
},
{
	id: "ece7b472-7d63-4629-9e6b-3771bdbe83e0",
	dateId: "20270719",
	puzzle: {
		letters: "LJPRHAKSVETYFMGOXIUNWDCBQ",
		words: ["TALKS", "DIMERS", "FUME", "BUNG", "REMIX", "JAYS", "PRE", "TOW", "HEMS", "TOXIC", "QUID", "REVS"]
	}
},
{
	id: "b7e4b25f-0771-46aa-9c38-b41d31073ca6",
	dateId: "20270720",
	puzzle: {
		letters: "YOIUGTRQLBJPNVHXADESFMKCW",
		words: ["RIOT", "FAKED", "FAX", "PANES", "JADES", "ENQUIRY", "BUG", "VEND", "DECK", "ANEW", "APRIL", "MAKES", "HENRY"]
	}
},
{
	id: "cc70386f-4adf-418e-88af-45ad8581a7d2",
	dateId: "20270721",
	puzzle: {
		letters: "CUQKFETYLDMSBXIWAHROJPNGV",
		words: ["ANGRILY", "QUEST", "VOID", "FLY", "JAMES", "PASTE", "WASTE", "PHASE", "BASTE", "CUES", "STYX", "ILK"]
	}
},
{
	id: "89034bff-b9be-4834-9e12-d585d9ca8516",
	dateId: "20270722",
	puzzle: {
		letters: "VSPGMFAYBOENCHDRXKIJWTQUL",
		words: ["PSYCHO", "WRENCH", "TRENCH", "BOGY", "JUICY", "VANE", "FANCY", "QUICK", "ACID", "MOB", "NEXT", "LICK"]
	}
},
{
	id: "c6f7e3cd-ebc7-4ef0-99aa-6f200326ff63",
	dateId: "20270723",
	puzzle: {
		letters: "BTOPYWEUQKDHVNJFMGIXARSLC",
		words: ["INKPOT", "WHET", "CLINGS", "SLINKY", "MARGIN", "DEVILS", "FARMS", "QUOTED", "JIVED", "JINX", "DEBT"]
	}
},
{
	id: "f0ad2b03-5bc0-48c3-8f47-3f7ef4c4397c",
	dateId: "20270724",
	puzzle: {
		letters: "QFPEVNULKGYSIDRCOMATJHBXW",
		words: ["MARK", "VELDT", "ISOBAR", "BOSUN", "GRAILS", "FLIMSY", "WADIS", "COMBAT", "OHMS", "TAX", "JOYS", "KELP", "QUID"]
	}
},
{
	id: "c1f7ee68-7524-42dc-83f9-9614b9efb750",
	dateId: "20270725",
	puzzle: {
		letters: "GIHVWNXOYESFJBCMDAURPLKTQ",
		words: ["ADJOINS", "QUALMS", "TRUCE", "BEVY", "TALK", "FOXING", "WEB", "HOVE", "ALP"]
	}
},
{
	id: "9dd276e4-6ce8-44fc-8e64-d43b6868fa90",
	dateId: "20270726",
	puzzle: {
		letters: "EWCMHPSVIDGNXLTOBAJYFUQRK",
		words: ["BARKY", "ANVIL", "FOGS", "QUALITY", "PEWS", "BALTIC", "MILAN", "JAB", "HILT", "BALD", "LAXITY"]
	}
},
{
	id: "7c29a330-6334-482e-a12c-3f3f937024a5",
	dateId: "20270727",
	puzzle: {
		letters: "JMIFAQUNKRHVXCSOTYELDWBGP",
		words: ["QUINCES", "HUNKS", "UNCLES", "MINXES", "BECKS", "PECKS", "CLEG", "HOW", "FARCES", "DOT", "BYES", "OVUM", "JUNKS"]
	}
},
{
	id: "ba1455bb-7659-4022-b44d-8db6407dd1c2",
	dateId: "20270728",
	puzzle: {
		letters: "AXQWKDUBNOPJEYLGRFSTHCIVM",
		words: ["DAUBER", "VISE", "PRISM", "DUX", "SERIF", "CHRIST", "JEST", "QUEST", "GRISLY", "LONER", "OWNER", "KNOW"]
	}
},
{
	id: "fa754991-a7ec-48e1-ad28-a438bc3d9406",
	dateId: "20270729",
	puzzle: {
		letters: "JETPLHDWAXIOVNFBURCSQKGYM",
		words: ["AVOWED", "GYMS", "JET", "DEHORN", "PLATED", "CROWED", "DIURNAL", "BOWED", "QUID", "FAVOUR", "WORK", "FAX"]
	}
},
{
	id: "78f0f2aa-bdab-4d33-a9b0-b5e741303337",
	dateId: "20270730",
	puzzle: {
		letters: "WBSPIANCQLKFUJTVERHMDOXGY",
		words: ["FUNKED", "BANKER", "PIQUED", "FAWNS", "CURED", "DOVER", "SPILT", "GYM", "REDOX", "HUNK", "JUNKER"]
	}
},
{
	id: "d1243f0a-a68e-4615-ac34-dc9d524b6c51",
	dateId: "20270731",
	puzzle: {
		letters: "MJBQKGOUXSDYVIFCEALRPHWNT",
		words: ["MOVED", "HALVED", "BUOYANT", "SQUIRT", "CHAIR", "JOVIAL", "BOGY", "FLAWED", "PEAL", "FIX", "FRISK"]
	}
},
{
	id: "2e1f0cec-a631-41df-8f2e-925cb0322a91",
	dateId: "20270801",
	puzzle: {
		letters: "CBMKJPHWAQIXYDUTEGOLFNVRS",
		words: ["EXIT", "JAMB", "WHITEN", "CHIP", "SLUDGY", "QUAY", "CHIEF", "YAK", "MAYORS", "ENVOY"]
	}
},
{
	id: "f6131e6c-1e1b-417d-a51c-1eb14c111324",
	dateId: "20270802",
	puzzle: {
		letters: "PKTLWBRQIJDUHOEMFAVXGNSYC",
		words: ["HILT", "HAVE", "QUAYS", "DRUM", "BURP", "MURK", "HOVE", "VEX", "WILT", "CYAN", "JILT", "FANG"]
	}
},
{
	id: "fa93580b-608b-43c7-87e5-fa6575a7cc7c",
	dateId: "20270803",
	puzzle: {
		letters: "SBKCDHRQFLWTUEAOVINGJMYPX",
		words: ["FLANGE", "VYING", "JOT", "WRUNG", "MOTHS", "TURK", "EQUIP", "YIELD", "BRUNEI", "MINX", "CLANG"]
	}
},
{
	id: "160f2181-ae7b-4f95-8b89-4b073156d968",
	dateId: "20270804",
	puzzle: {
		letters: "QUGRMLXEYHJPFTAOCKWISBDNV",
		words: ["GERM", "REPLUG", "WATERY", "VIA", "COBS", "HATER", "QUERY", "EXPO", "JOBS", "HAWK", "RETAIN", "WIND", "REF"]
	}
},
{
	id: "5ce15a3c-dae2-4b76-809e-8b336ff3fe0d",
	dateId: "20270805",
	puzzle: {
		letters: "ICKMYHRFENXDLAVOGBUWPJTQS",
		words: ["RICH", "FLAWS", "POX", "GLEAN", "JOG", "NAVEL", "SQUAW", "ABUT", "MEANY", "BALD", "RICK"]
	}
},
{
	id: "0b7d7204-67c7-49e0-99f4-7cd478c8bb59",
	dateId: "20270806",
	puzzle: {
		letters: "FCSKWJETVOPDMBLHGQAINUYRX",
		words: ["AIRY", "BLAMED", "MARX", "EDGY", "PEST", "VOW", "HUNG", "DESK", "JEST", "FEST", "SECT", "IRAQ"]
	}
},
{
	id: "5b90706d-5297-4041-976f-c2a63e75e9a7",
	dateId: "20270807",
	puzzle: {
		letters: "EBTLVRSXIQWPMHUJYKFDACGNO",
		words: ["LIMPS", "WREST", "VIMS", "DONG", "MIX", "QUILTS", "JACK", "BEST", "ESPY", "FOND", "HILTS"]
	}
},
{
	id: "41f01929-9df3-4dcd-b792-4b64fce0d653",
	dateId: "20270808",
	puzzle: {
		letters: "GDPCJINHOFUVYBXQRASELMWKT",
		words: ["CHOP", "MAYBE", "BOXES", "WAVING", "DIVAS", "BASKET", "QUID", "RAVING", "FOXES", "MARL", "JOBS"]
	}
},
{
	id: "4e28a946-3736-4ac3-9cd7-85869bf7c3b7",
	dateId: "20270809",
	puzzle: {
		letters: "YMBIGVNSKAREQDLHWUOXTJCPF",
		words: ["THREW", "KAISER", "NERVY", "CUPOLA", "IBSEN", "JUDAISM", "FOLDS", "COX", "GALOP", "QUERN"]
	}
},
{
	id: "305d761b-dca8-419f-9922-04d2b8d04716",
	dateId: "20270810",
	puzzle: {
		letters: "QMPDYVUIJKWGLCEBOSAXFTRNH",
		words: ["VULCAN", "SOLACE", "PUMICE", "JEANS", "QUICK", "STOLID", "WORST", "BORAX", "DYKE", "HARTS", "LOGICS", "ALOFT"]
	}
},
{
	id: "f2f8dcba-8d1c-4670-88e6-f153feab844c",
	dateId: "20270811",
	puzzle: {
		letters: "BIMCHNXUVYPQTRKSOFDAEGJLW",
		words: ["DRAWL", "FLAKY", "MINX", "SQUIB", "MUCH", "SPOT", "CURVY", "FOES", "FOGS", "JOGS"]
	}
},
{
	id: "23b2deb7-a6cc-464b-b759-1083db5feaa4",
	dateId: "20270812",
	puzzle: {
		letters: "THBNJWXOARDLSYCIFPEKQUMVG",
		words: ["CRAYON", "VEG", "XHOSA", "EMPLOYS", "FUMES", "THOSE", "CRAB", "WHOSE", "SOLID", "QUID", "JACK"]
	}
},
{
	id: "2cc9b073-e2fb-494e-9201-b218427ee062",
	dateId: "20270813",
	puzzle: {
		letters: "LWBAKGESYDOXNTMFRUIVPCJQH",
		words: ["ADMITS", "ABSENT", "HINTS", "NEWSY", "QUITS", "TINSEL", "CRUXES", "PROGENY", "VINES", "JINXES", "YAK", "FRUITS"]
	}
},
{
	id: "5be19c27-3dc1-4e08-8fca-49b26db1a3d5",
	dateId: "20270814",
	puzzle: {
		letters: "PIXTWRJLOBHGAKNESCUFVDMYQ",
		words: ["QUASHED", "PILOT", "JACK", "FUNK", "BOX", "SAUCY", "GASHED", "OAKUM", "GRIP", "VEG", "AGLOW"]
	}
},
{
	id: "67250b75-8841-41c8-a06e-a9012ca81f04",
	dateId: "20270815",
	puzzle: {
		letters: "CTFBXWILAGHMRQOYKEUJSVPND",
		words: ["TWIRL", "HYMEN", "JUNE", "FLAREUP", "GARLIC", "BALTIC", "FLAX", "DUNE", "BARKS", "GOAL", "IRAQ", "REVS"]
	}
},
{
	id: "896170f3-4567-4399-90b3-abc7f4efb58b",
	dateId: "20270816",
	puzzle: {
		letters: "GBPCTMOXAHJDYLQNVSURIWKFE",
		words: ["OPAQUE", "WINDSURF", "HAYDN", "GODS", "LATCH", "BODY", "IVY", "BOXY", "RUSK", "MOB", "JOYS"]
	}
},
{
	id: "7b28c41b-9176-4e2c-ad1c-a92b690c5189",
	dateId: "20270817",
	puzzle: {
		letters: "NYEDKFIXWLRGJAMHQPBTSCUOV",
		words: ["FRIED", "TALK", "SCUBA", "VOUCH", "WEIGHS", "QUOTA", "BALM", "GRIN", "DEIFY", "JAWED", "POUCH", "TAXIED"]
	}
},
{
	id: "62c5c0d5-3b72-4da2-94ad-79d6ec6b4ed1",
	dateId: "20270818",
	puzzle: {
		letters: "EWADQBXCUSPRGLMOHYFKTJNVI",
		words: ["SQUAD", "BROTH", "PHYLUM", "EXPO", "JOHN", "CAUGHT", "SQUAW", "GULF", "IVY", "SULK"]
	}
},
{
	id: "5cbff00a-b2e1-4469-adfd-0dc3f4d7927f",
	dateId: "20270819",
	puzzle: {
		letters: "COARYFXLJWHPKVTDGESMINBUQ",
		words: ["JARL", "WRY", "NIGH", "FOLKS", "BUMS", "DIGEST", "COAX", "QUEST", "PEST", "VEND"]
	}
},
{
	id: "cab96a12-8af1-46b1-9ca8-818aedea7807",
	dateId: "20270820",
	puzzle: {
		letters: "OYEFXHRDUCMVBNQIWAJGKLTSP",
		words: ["HORDE", "REFUND", "TWANGS", "BANGS", "JAB", "WASP", "LANDER", "DUX", "HYDRO", "VAST", "KILTS", "CUBAN", "QUERY", "MILAN"]
	}
},
{
	id: "d0c32f01-937f-43cb-ae2a-3ab00949ceec",
	dateId: "20270821",
	puzzle: {
		letters: "LDPKFWOXUEMYGSQACTINRJHVB",
		words: ["RACHIS", "YACHTS", "DOGS", "WOLD", "JAM", "BITCH", "INQUEST", "STYX", "PUKE", "VISE", "FUSTY"]
	}
},
{
	id: "dc88efde-1521-4e95-a80e-a77124f573ae",
	dateId: "20270822",
	puzzle: {
		letters: "TFGXBUERSOMQWNVILPACHDJYK",
		words: ["QUERN", "FERNS", "SNOB", "VANS", "LIME", "ANSWER", "HID", "YAWNS", "JACK", "PAWNS", "TERNS", "ERGS", "BOX"]
	}
},
{
	id: "2ebfbb18-f720-4b71-8f2e-f14591424567",
	dateId: "20270823",
	puzzle: {
		letters: "XDSMLFITYWNBQVOJACUPGHREK",
		words: ["MYSTIQUE", "HABITS", "CABIN", "YOWL", "DINAR", "CRAG", "VOUCH", "JAB", "MYOPE", "FIST", "PUKE", "FIX"]
	}
},
{
	id: "cc9bc27d-4cdc-4b4e-830b-fb8bb1e6186c",
	dateId: "20270824",
	puzzle: {
		letters: "WIRDCJVENLKAQHOMUFPXBGSYT",
		words: ["SYPHONED", "JIVED", "BMUS", "QUAVER", "PHENOL", "OPT", "CLONED", "BUGS", "PHLOX", "DEAF", "WIRED", "AUK"]
	}
},
{
	id: "2cdac2e3-6fa1-48b0-9583-98fce86d391d",
	dateId: "20270825",
	puzzle: {
		letters: "HOBLVWPYIKTFRAXNSGUDMEJCQ",
		words: ["URGENT", "FRAIL", "PHOBIA", "DAILY", "JEST", "QUAIL", "WHOP", "CURIA", "VIA", "GEMS", "KARST", "DUX"]
	}
},
{
	id: "ca82415f-8a38-4325-8c8d-0e32070940de",
	dateId: "20270826",
	puzzle: {
		letters: "JBLCDGUMFNPQIRAOXEYTHWKVS",
		words: ["POWER", "ATRIUM", "JUG", "FIERY", "CLUB", "QUIRE", "KEYS", "REVS", "WHOP", "FIXER", "STRAND"]
	}
},
{
	id: "90dd2bf6-33fe-4bd6-9a6c-b76bf539ee5b",
	dateId: "20270827",
	puzzle: {
		letters: "KOGELRFNWYVIMTDJCUASHQPXB",
		words: ["FINELY", "FRONTS", "QUIRK", "VINE", "TAMING", "MUCH", "BATS", "JINGO", "PASTY", "TAX", "DATUM", "NEWLY"]
	}
},
{
	id: "a7e20bd4-9b0b-41d1-83de-6948033061a8",
	dateId: "20270828",
	puzzle: {
		letters: "FYPJTLWSOIDXHGNREKQCVBUAM",
		words: ["HEX", "QUAKED", "INGOT", "FLY", "VERB", "WHOP", "TONGS", "MAKER", "JINGO", "CAKED"]
	}
},
{
	id: "e4708092-e54c-4f74-8fc3-452fa159162e",
	dateId: "20270829",
	puzzle: {
		letters: "QVFLDAUGCOYRBSXWHMKJTEPIN",
		words: ["TEMPI", "QUAY", "SCOLD", "GRUBS", "FURY", "JINKS", "COX", "VARY", "PHEW"]
	}
},
{
	id: "6eb60435-13ca-4f32-bd54-392d7de9cbe7",
	dateId: "20270830",
	puzzle: {
		letters: "MOKVYWRANHTLQJCISEUPXBFDG",
		words: ["VALISE", "QUEST", "MORALISED", "DUCHY", "FEDUP", "KORAN", "JARL", "BISTRO", "GUEST", "SIX", "OWLS"]
	}
},
{
	id: "23a3737d-53f6-48d5-9ccb-ab473bd6f488",
	dateId: "20270831",
	puzzle: {
		letters: "TFRMYPABNVISQEHXULWKGDCOJ",
		words: ["HELD", "RAPT", "LOCUS", "SLUG", "WOKEN", "BELOW", "ARMY", "JOWLS", "FARM", "EQUIPS", "BEVY", "DUX"]
	}
},
{
	id: "ec2ac667-2173-4e66-9b87-59581c3ae156",
	dateId: "20270901",
	puzzle: {
		letters: "QJNCGUOVIWMALEDXTFRPSHYBK",
		words: ["LATHS", "REVOLTS", "REFLOAT", "JOLTS", "QUAVER", "RELAX", "DEVILRY", "PELVIC", "MATHS", "NOVELTY", "GILTS", "DERBY", "WELTS", "PERK"]
	}
},
{
	id: "fb661f05-c817-4a1d-9e40-e31646dee5b7",
	dateId: "20270902",
	puzzle: {
		letters: "OPDWYCRGEXHIQSNTUMAJKLFVB",
		words: ["HUMANS", "SEXY", "BASED", "JAMS", "FANS", "ANEW", "CORGI", "QUIT", "CHIRP", "VANED", "HULK"]
	}
},
{
	id: "accd2f64-4b23-401e-a057-944b343f3f48",
	dateId: "20270903",
	puzzle: {
		letters: "WTBDFHVKOCIYSLXRUMANEPQGJ",
		words: ["CLOSURE", "PERUSAL", "DOLMAN", "PRIVY", "CLANG", "JAMS", "THYMUS", "FOLKS", "BOLA", "WHIR", "BOX", "QUERY"]
	}
},
{
	id: "25f426dc-82d2-4dd5-bdd1-adeeb36d9047",
	dateId: "20270904",
	puzzle: {
		letters: "LYXVWBMDITQUFEPGASOKCNRHJ",
		words: ["FOETID", "HOPED", "JOKED", "VIDEOS", "DUMBLY", "PORNS", "CAUSED", "QUASH", "WIDES", "FIX", "GAUDY"]
	}
},
{
	id: "6d98837b-fb43-4079-95bd-efbbb8837bde",
	dateId: "20270905",
	puzzle: {
		letters: "JKMDTNUPECOLQAGBFRXSYVIWH",
		words: ["FOUL", "SWIRL", "JUNK", "ACTED", "GAPED", "CASH", "FLUMPED", "IRAQ", "FIX", "IVY", "KNOB"]
	}
},
{
	id: "4d4c90eb-6572-46e6-b0f0-3e3b1f671d65",
	dateId: "20270906",
	puzzle: {
		letters: "QYIGLHURDWFBVAPOCXNSJMEKT",
		words: ["COBRAS", "BRAWL", "GDANSK", "FOMENT", "WAXEN", "QUID", "JOB", "VANE", "BURY", "SPANK", "HUB"]
	}
},
{
	id: "0ebb21a7-d330-49ca-930e-a2d5338517ab",
	dateId: "20270907",
	puzzle: {
		letters: "YPWJSLUOHRQVMNFIEDAKGXTCB",
		words: ["QUONDAM", "MOVIE", "CANOPY", "JOHN", "TANDEM", "RHO", "BACK", "EXT", "GIVE", "FAMED", "PLUMED", "WOMAN", "SHOVED"]
	}
},
{
	id: "aafd3da5-d3ef-4d5c-9cbb-519e5d14140e",
	dateId: "20270908",
	puzzle: {
		letters: "QDVJPOUNAMWESTXFRLHKCYBIG",
		words: ["RELIGHT", "KILTS", "FRESHLY", "REWOUND", "VASTLY", "CREST", "JANUS", "DUSTMAN", "BLIGHTS", "XMAS", "PANELS", "QUERY"]
	}
},
{
	id: "d78bb55c-9837-4902-bff6-5b0dad6f6bd5",
	dateId: "20270909",
	puzzle: {
		letters: "GYBIWSRCPHNDALFOMXTKVUQEJ",
		words: ["GYRATE", "OVUM", "GRAPHIC", "EXALT", "WHIP", "TALK", "QUONDAM", "PARDONS", "JET", "BRAT", "CALF"]
	}
},
{
	id: "7ce1f06c-c1cd-4c9f-9223-33dac35e1109",
	dateId: "20270910",
	puzzle: {
		letters: "YVXITKEDSLGAMOCNURHFBJQPW",
		words: ["EDITS", "CHROMED", "VEGAN", "FORAGED", "PROLIX", "YEAR", "QUAKED", "BURMA", "JUG", "WHOM"]
	}
},
{
	id: "5a4bba91-4a04-4075-a9bc-ac1b4f9fe9da",
	dateId: "20270911",
	puzzle: {
		letters: "SFPBURKVIQEYNWGCTOALMHXJD",
		words: ["SKETCH", "WINKERS", "FRET", "WINTERY", "LANKY", "DANTE", "QUIP", "VINO", "OHM", "AXON", "JOWL", "BIG"]
	}
},
{
	id: "2b51ef46-56d6-471e-8d0d-89f5b8a6a26e",
	dateId: "20270912",
	puzzle: {
		letters: "KRXANBEQWCFOUTHGIJSPMVDLY",
		words: ["MIDST", "BERK", "SYLPH", "EXACTS", "VIM", "BEFOG", "AQUIFER", "JOUST", "AWN"]
	}
},
{
	id: "f943a7f9-726a-452e-ac3b-5371e48712fe",
	dateId: "20270913",
	puzzle: {
		letters: "YTSDWXPFOGRECJBKVULNMIQAH",
		words: ["QUIVER", "MIKE", "SOFTY", "BLUER", "KEPT", "BLAH", "GOFER", "ULCER", "CODS", "CLAN", "BOW", "JOB", "STYX"]
	}
},
{
	id: "ed3c1614-7aee-4c86-afcd-92b4e83c6513",
	dateId: "20270914",
	puzzle: {
		letters: "SWAGOBRYUDCFQHNPMEIXTLJKV",
		words: ["FELT", "HELP", "JINX", "GARBS", "CRAWS", "FRAUD", "SWAY", "VIE", "HELM", "HIKE", "UNDO", "QUAY"]
	}
},
{
	id: "a6fa241d-0bcf-4c94-90ab-573f224938e1",
	dateId: "20270915",
	puzzle: {
		letters: "BCXPYONDIFKEJGVHUQRLWTSAM",
		words: ["VIDEO", "HUTS", "BONED", "JUST", "GRAM", "EDIFY", "LAST", "MARQUE", "COKE", "FIX", "DIP", "WHEN"]
	}
},
{
	id: "608bc327-e10b-4880-96ec-63ad01b42de3",
	dateId: "20270916",
	puzzle: {
		letters: "GONRJDMLAYBWCSPHUIETQKFXV",
		words: ["RACIEST", "KIEV", "CLOD", "JAPES", "PALSY", "FISCAL", "CUB", "WISPY", "HUB", "QUIETS", "EXIST", "SALMON", "CLOG"]
	}
},
{
	id: "b35f4269-4511-4fa9-b0a3-5ceaea560816",
	dateId: "20270917",
	puzzle: {
		letters: "QWCNKEUPRBHIALFDOTVGJSXYM",
		words: ["HEW", "JOTS", "EQUITY", "STYX", "BRAIDS", "TARN", "RAPIDS", "QUARK", "VAPID", "FLATS", "GYM", "CUPID"]
	}
},
{
	id: "acbc5d9e-c3e1-4be4-8130-f8908f3c40da",
	dateId: "20270918",
	puzzle: {
		letters: "COKPTHRYFWXVDISJANUQLBMEG",
		words: ["ORDINAL", "ENVY", "SWIFT", "CHORDAL", "JANUS", "BLAME", "LAX", "CRYPT", "SQUID", "CORKY", "GENIUS"]
	}
},
{
	id: "66ce6a15-6716-41ce-af1a-6253eb87645c",
	dateId: "20270919",
	puzzle: {
		letters: "JDMANILXFSEVGPYQUOTCKRBWH",
		words: ["POTCH", "DIVOT", "BROGUE", "BOPS", "AXLE", "XMAS", "PORK", "BROW", "FANS", "JIVE", "SPY", "TORQUE"]
	}
},
{
	id: "b1852df8-55f8-43bb-a03d-97a4008ce6f6",
	dateId: "20270920",
	puzzle: {
		letters: "WDSNTVOEXPMHBIFYURAGCKQLJ",
		words: ["JARL", "CURIAL", "BURIED", "FIXED", "PIED", "DOESNT", "MURKY", "GARBED", "WOES", "HOSED", "IRAQ", "VOW"]
	}
},
{
	id: "ef306672-9dff-4184-ac0c-6c9986a710b0",
	dateId: "20270921",
	puzzle: {
		letters: "FHXOGACEYRSVQNWMUIDTPKJLB",
		words: ["KIDNEY", "QUILT", "HAVENT", "JUMP", "FACE", "WRY", "GORY", "OXEN", "BLIND", "ASCEND"]
	}
},
{
	id: "d16ad0e8-4e74-42e5-b22c-1235459c4e8e",
	dateId: "20270922",
	puzzle: {
		letters: "YHMSWGLAUBKETJQFIVOPCDRXN",
		words: ["HAMLET", "POX", "NORDIC", "DRIVEL", "TALKIE", "QUALMS", "FETAL", "BUMS", "GLEAMS", "MUTELY", "MAJOR", "SWUM"]
	}
},
{
	id: "c1b5bca5-c239-4a06-91df-325e707fa4a7",
	dateId: "20270923",
	puzzle: {
		letters: "GIFCKOBVUTXRQASNEJMHPLDWY",
		words: ["FIBRED", "STUCK", "BOXED", "ASHY", "LED", "PEN", "QUASH", "WHAM", "JAMS", "GORED", "VAST"]
	}
},
{
	id: "7401b8c2-d49e-4aed-bcdb-23015fc7141c",
	dateId: "20270924",
	puzzle: {
		letters: "NOXMRQEWIPUTFHYJAVLGDBCKS",
		words: ["OXEN", "GLYPH", "QUACKS", "BACKS", "FIRM", "VAT", "DAFT", "WIMPY", "JACKS"]
	}
},
{
	id: "2d8c1237-61ec-4eaf-8ea1-7a8dd0e69c89",
	dateId: "20270925",
	puzzle: {
		letters: "DVKCQETBUAMLFGNHYRXIOPSWJ",
		words: ["FUNGI", "MELT", "ANGRY", "JINX", "QUACK", "HOPS", "VET", "SWING", "BLED"]
	}
},
{
	id: "fdd41c37-da6c-40e6-bc13-6c27407f54b6",
	dateId: "20270926",
	puzzle: {
		letters: "DFBARHLEVWOXSJPNYIUMCKTGQ",
		words: ["RAVELS", "WAVES", "JESUIT", "FELONY", "QUIT", "JUMP", "ABEL", "HOLES", "HONK", "SYNC", "ONYXES", "GUISE", "HOLD"]
	}
},
{
	id: "19a2996e-bffb-4e9f-902a-a1d10ca9fc67",
	dateId: "20270927",
	puzzle: {
		letters: "BLRVTNIKAJWGCQDHOMUEYPXSF",
		words: ["COX", "TACKLING", "COWGIRL", "FUSED", "JACKING", "IRAQ", "DUMPY", "BINGO", "HOCUS", "VAT"]
	}
},
{
	id: "711acc88-9239-4008-a9fd-4463752ce974",
	dateId: "20270928",
	puzzle: {
		letters: "YTHSDJAMOERUWCKLXQIFPBNGV",
		words: ["BLUR", "SHOCKING", "MARX", "THAWING", "VICES", "FIG", "QUAY", "PLUMS", "DECKING", "JAWING"]
	}
},
{
	id: "9e559639-6d82-430e-9dc8-5d47f10c9676",
	dateId: "20270929",
	puzzle: {
		letters: "KQGWYCURPHJSEFOMATNVDBXIL",
		words: ["PHONES", "GREAT", "JAMB", "WREST", "RUCK", "LINERS", "DATES", "MAXI", "HYPE", "INFEST", "VINES", "QUEST"]
	}
},
{
	id: "f4fd4b40-fe3c-4330-92bb-ef5e26b55b63",
	dateId: "20270930",
	puzzle: {
		letters: "XOLIMWCQSBTGUFNPEKAVDRYHJ",
		words: ["FAKERY", "QUAKED", "CLIQUEY", "KEPT", "SLOW", "CLIMBS", "KHANS", "VANS", "COX", "AUGER", "JAY"]
	}
},
{
	id: "a638d64d-0e61-43f5-a0f1-9d880487b803",
	dateId: "20271001",
	puzzle: {
		letters: "BTJMNSEQIGLPHUYFAKVODWXRC",
		words: ["DALES", "SEQUIN", "VYING", "JEHAD", "CORK", "BEHALF", "PALEST", "WALES", "HIM", "FLAX"]
	}
},
{
	id: "4553b756-a95b-4a77-9430-4a2701e7dcd5",
	dateId: "20271002",
	puzzle: {
		letters: "VLPKMCIEUSHXWJQDROABTFGNY",
		words: ["SQUELCH", "PELVIC", "TROWEL", "PIXEL", "BANG", "FORD", "JAB", "NORWAY", "ILEUM", "KELP"]
	}
},
{
	id: "80d6c04c-8bec-4eed-a1b6-76ab77429a92",
	dateId: "20271003",
	puzzle: {
		letters: "HEJLSFVARCDGWBTPUYOMQIKNX",
		words: ["DUG", "YUKON", "FEARS", "HEALS", "QUIP", "CRAVE", "BOX", "MONK", "HEART", "JARL", "WARS"]
	}
},
{
	id: "4d3def45-9699-405b-b728-6730129b5a54",
	dateId: "20271004",
	puzzle: {
		letters: "MVWPDOBENFSLUAKGIJQYXRCHT",
		words: ["THY", "BLEAK", "QUAY", "SIX", "BLEND", "RICH", "FAUN", "JULEP", "MOBS", "ANEW", "GLEAN", "GLOVE"]
	}
},
{
	id: "f209d4d1-f645-41ea-ae21-40ffc2ed0003",
	dateId: "20271005",
	puzzle: {
		letters: "VUPRKQICEBYTMFJSAXWOGLNHD",
		words: ["JERK", "VIPER", "BERK", "ICEMAN", "AMITY", "REF", "MAGS", "DHOW", "XMAS", "QUITS", "RECITALS"]
	}
},
{
	id: "1df3bef0-21ff-4aa4-aad7-dec7984715fa",
	dateId: "20271006",
	puzzle: {
		letters: "HALWXKVMICJUPGFDEQYSNRBTO",
		words: ["DUMPER", "PIGSTY", "IMPEND", "JUMPED", "EPIC", "KHALIF", "FIX", "TOYS", "DEBTS", "QUERN", "VAMPED", "WIMPY"]
	}
},
{
	id: "d34a36a6-6032-4ebe-b2cb-c4edc9b84236",
	dateId: "20271007",
	puzzle: {
		letters: "HEXYDLWNBFPASQRCOMIUKJTVG",
		words: ["DYNAMO", "HEX", "QUIT", "SMOCK", "LAWNS", "BRIG", "PANEL", "JOCK", "FRUIT", "VIMS"]
	}
},
{
	id: "97b1bed2-a646-4fbe-a42b-eef80c67c415",
	dateId: "20271008",
	puzzle: {
		letters: "RDGNLJEKISMOVWXBCFAUHYTPQ",
		words: ["REMOVING", "LINGER", "JOKING", "QUAVER", "PATCHY", "FAXING", "LINKED", "SWINGER", "BOER"]
	}
},
{
	id: "84008b28-4883-4acc-be3f-d93cce1bc805",
	dateId: "20271009",
	puzzle: {
		letters: "AGSIKWHMTQJBVEUCODYRXPNLF",
		words: ["OVERFLY", "HAGS", "KISMET", "PONDER", "QUERY", "SHAW", "EMBODY", "COVETS", "JOB", "REDOX"]
	}
},
{
	id: "d27b61cc-cfb9-497d-8d96-7c7c2da30efa",
	dateId: "20271010",
	puzzle: {
		letters: "OCKRVXJGIPNEFUMWLATQSYBDH",
		words: ["NEWLY", "MUTABLE", "JOCK", "TUGELA", "VIM", "FLEX", "NEWSY", "DATUM", "GRIP", "QUAYS", "BATH"]
	}
},
{
	id: "5e7638ee-b576-453c-b4ac-7e219383b275",
	dateId: "20271011",
	puzzle: {
		letters: "EWBKGLTXRIHODQMPFUVYSCNAJ",
		words: ["GRIMY", "QUOTE", "PHLOX", "NAVY", "IRK", "FOPS", "DOLE", "SCUD", "JAY", "WELT", "BRIG"]
	}
},
{
	id: "4c7ea452-25e4-43a6-8e3c-905de7a84e60",
	dateId: "20271012",
	puzzle: {
		letters: "OBSAFGTPVJHENDWYCUIKLMXQR",
		words: ["DUX", "BOGEY", "QUENCH", "QUIRK", "FASTEN", "VAST", "SPENT", "ETHYL", "WINCE", "MUNCH", "JAPE"]
	}
},
{
	id: "cafbeca2-e7ca-4cd7-a908-bd407a6ce7dd",
	dateId: "20271013",
	puzzle: {
		letters: "VQXHNUITESBRDWFJGLMOYACKP",
		words: ["BURDENS", "VIXENS", "MOWED", "BIRTHS", "CAGY", "CALM", "SWOP", "JACK", "QUITE", "FETID"]
	}
},
{
	id: "9fa4d3a3-69fc-4707-ba2e-51bc15e69260",
	dateId: "20271014",
	puzzle: {
		letters: "NWOEVGYTJBQIRHAPUDSMCLFKX",
		words: ["TOWN", "JAMS", "GIRTHS", "PURITY", "FLUIDS", "QUITE", "XMAS", "BASK", "CUPID", "VETO"]
	}
},
{
	id: "f9682692-8fb8-432c-ae3e-793a1447c501",
	dateId: "20271015",
	puzzle: {
		letters: "DTYSFEQUBLVGNAHKIPXJMRWOC",
		words: ["COPING", "FLANGED", "PALSY", "MINUTED", "HANGED", "PRIVET", "FLAX", "KINA", "JANUS", "EQUALS", "LAPWING", "BANGED"]
	}
},
{
	id: "71a51654-2e12-4fe0-a120-07562e101e97",
	dateId: "20271016",
	puzzle: {
		letters: "QBVJPOUTEFWSARHDLKXYMCGIN",
		words: ["FREAKS", "SUBVERT", "CLARETS", "JERKIN", "OUSTER", "LARYNX", "HERALDS", "QUARKS", "QUALM", "BOWLS", "PETALS", "GLARE"]
	}
},
{
	id: "871e919a-e5fe-4c1b-a690-8fbe3463a7c5",
	dateId: "20271017",
	puzzle: {
		letters: "GUWJFQLIDAYMHSBVECPKTXORN",
		words: ["DIMLY", "PORCH", "GLIM", "WILY", "JABS", "QUIDS", "FADS", "SCORN", "CORKS", "VET", "COX"]
	}
},
{
	id: "a57406f8-7248-4405-9e21-e9c4057197f5",
	dateId: "20271018",
	puzzle: {
		letters: "VXQYJLIAUPGBNWSDKRFMEHCOT",
		words: ["BLINKED", "QUAY", "TORCHED", "WAX", "FORKED", "PUNK", "SMOCK", "VIA", "JUNK", "GLIA"]
	}
},
{
	id: "8e547f21-54c7-4400-88c6-376a1477327c",
	dateId: "20271019",
	puzzle: {
		letters: "GCFSRPOVETMIBYWQUDAHKNLXJ",
		words: ["COVERTS", "BEFOG", "BUNK", "POVERTY", "DIVERTS", "LAX", "QUIVERS", "HAYDN", "LABIUM", "JAB", "LAWYERS"]
	}
},
{
	id: "01909a0a-1cb9-467b-8f04-358aba52a8ad",
	dateId: "20271020",
	puzzle: {
		letters: "BKSPMCEUYLVGQINWOFRXJATHD",
		words: ["UPLIFT", "FIRTH", "SEQUIN", "BEGOT", "WAFT", "LYNX", "FILMY", "BECKS", "JAW", "DRIFT", "VOGUE"]
	}
},
{
	id: "73fe3e36-838c-45a2-a8c1-32d29cacbba7",
	dateId: "20271021",
	puzzle: {
		letters: "MSYNQLJGUFKETIXWAVRPDHBOC",
		words: ["PROBATIVE", "COVET", "HAWK", "UNFIX", "TRIGS", "GUYS", "ELMS", "JET", "QUITE", "DATIVE"]
	}
},
{
	id: "0a45e1c5-731b-422a-8cb7-1cee54f55df5",
	dateId: "20271022",
	puzzle: {
		letters: "QURYHIDXPTLNMVCWEFAGBKSJO",
		words: ["EMPTY", "QUID", "JAMES", "GAMES", "THY", "CAFES", "ASKEW", "DINES", "RUIN", "OAFS", "CAMEL", "BEND", "VAMP", "XMAS"]
	}
},
{
	id: "76c64ece-a087-4d22-8b44-4842f5c01891",
	dateId: "20271023",
	puzzle: {
		letters: "QIFYBWUDEPJKNRVOALHMGTXCS",
		words: ["LANDER", "ALTO", "QUID", "BEND", "CLANK", "REFUND", "PENAL", "EDIFY", "PERMS", "LAX", "JUNE", "VERNAL", "SHRED", "GANDER", "WIDEN"]
	}
},
{
	id: "06a2de77-b885-44b0-a597-c7c7cadeb1c8",
	dateId: "20271024",
	puzzle: {
		letters: "JFMCBPASNOXWKRTIVGUQYHELD",
		words: ["SWIVEL", "PAWS", "MASCOT", "BORN", "MAXI", "CORKS", "GRUEL", "JAMS", "DUEL", "LEVY", "HELD", "TORQUE", "FAX"]
	}
},
{
	id: "f7e31e37-8ae9-4df5-8f89-ffd5ee598282",
	dateId: "20271025",
	puzzle: {
		letters: "PYCADSLXHMQUEOWKIJRTBVNGF",
		words: ["SQUELCH", "TOEING", "KING", "SYCAMORE", "PLEXUS", "WHELP", "FROM", "JEHAD", "SQUIB", "VIER"]
	}
},
{
	id: "86b32a4b-bec0-4e1b-899d-33f82789a7a9",
	dateId: "20271026",
	puzzle: {
		letters: "NFGJWMREOYQLXVCDUSBAPITKH",
		words: ["GOVERN", "GERM", "CABS", "AVOW", "JOG", "HAVOC", "IDLER", "COX", "DUSK", "QUITS", "STUPID", "LEVY", "FERN"]
	}
},
{
	id: "6479b20d-4a63-41b4-a7a1-49d8407db314",
	dateId: "20271027",
	puzzle: {
		letters: "YDTKFNOBIWJMGXCLSHERQUAVP",
		words: ["KIT", "QUAVER", "LUSHER", "FIXER", "EXCITON", "PEAS", "BODY", "HAULMS", "TIGER", "WIGS", "JOGS"]
	}
},
{
	id: "3070e25d-1271-43ec-8366-4708c2527224",
	dateId: "20271028",
	puzzle: {
		letters: "TIDANWSFLUYGMKQHPRCJVEXOB",
		words: ["BOXER", "HYPE", "JOCK", "REV", "ERGS", "TIDAL", "QUALMS", "FADS", "WITS", "FAUN"]
	}
},
{
	id: "e36b5ac6-ff65-4d43-84d3-4625355b2913",
	dateId: "20271029",
	puzzle: {
		letters: "DNJALQCERXTUBGMHIYVKPFSWO",
		words: ["PITH", "RECTIFY", "BEND", "VOWS", "NEARBY", "LAX", "WOK", "JARL", "GERM", "CUBIT", "QUIP"]
	}
},
{
	id: "278fa365-d168-4bda-a0b7-dd3e08b66b11",
	dateId: "20271030",
	puzzle: {
		letters: "KGEIBSCNMUVWJQATOFLRXHYPD",
		words: ["QUINCE", "VOWS", "LAMBING", "DRAM", "FOX", "ENJOY", "HOT", "PRAM", "NECKS"]
	}
},
{
	id: "031ad7ca-2aa6-4ec1-83f1-131dc12cd3a9",
	dateId: "20271031",
	puzzle: {
		letters: "SPFLVXGERYMNBUQHIOAKJTDCW",
		words: ["DAUBING", "JINX", "WADINGS", "QUOTING", "QUACK", "NERVY", "MINER", "THINGS", "PEGS", "BELFRY"]
	}
},
{
	id: "9d745608-7b89-4b2f-8c8c-11dd256f7280",
	dateId: "20271101",
	puzzle: {
		letters: "FCRSBLHEYGMUXOKQIWJDPTNAV",
		words: ["DOERS", "ANTIQUES", "QUERY", "MULCHES", "WOK", "FLUXES", "PIQUE", "BYES", "VAN", "JOEY", "GOERS"]
	}
},
{
	id: "9e086106-77a6-489d-bc8c-0e3cffd03973",
	dateId: "20271102",
	puzzle: {
		letters: "PGBIHFEYMVTRJALOQUDNWCKXS",
		words: ["FREYA", "WORE", "JURYMAN", "TRUCK", "LANDS", "GYRO", "DUX", "AMBER", "HIM", "VANS", "PERT", "QUALM"]
	}
},
{
	id: "da50eb17-d830-4bb7-aefc-0046a770ed0b",
	dateId: "20271103",
	puzzle: {
		letters: "KGFHSLWRPMEYBOVDTIAXJUQNC",
		words: ["MORPH", "FROM", "DEWY", "VANITY", "QUITE", "BOX", "GROAN", "CABIN", "ELK", "JUTE", "ROMPS"]
	}
},
{
	id: "14cd7d75-47a1-46c1-b26d-08e14f18942b",
	dateId: "20271104",
	puzzle: {
		letters: "GPVBXAEKODTWURSMNJQICYHLF",
		words: ["LIQUORS", "BOUNCY", "DROVE", "PEAT", "PAGE", "BOX", "JUNTA", "FIRS", "HYMN", "TAWNY", "GAWK"]
	}
},
{
	id: "c2479e02-d077-448f-b6ed-169213bea2f1",
	dateId: "20271105",
	puzzle: {
		letters: "SVTBJDAUOGXLQERKIWCMPFHYN",
		words: ["GROUT", "QUOTAS", "FIX", "CHILD", "BOER", "MERCY", "BULK", "PIQUE", "JOB", "VALUER", "WILDS", "HYMN"]
	}
},
{
	id: "e1c81807-2a3f-44fe-ac34-e4979e78e37c",
	dateId: "20271106",
	puzzle: {
		letters: "BQUKSJOCLMPTEFGRWNXHYADIV",
		words: ["FLECKS", "QUOTE", "COPRA", "HIND", "BOP", "ELMS", "VIXEN", "POETRY", "GLEN", "PRAWN", "JOULE"]
	}
},
{
	id: "fbb9a687-28b2-4683-945d-53f8dcd5796a",
	dateId: "20271107",
	puzzle: {
		letters: "QYKFLBUVNIDGEPWCOASMXJHRT",
		words: ["HOARSE", "RAPINE", "FINEST", "PINKY", "SEAGOD", "INVEST", "PSEUDO", "COX", "HARMS", "JAPES", "SWINE", "QUEST", "BUDGE", "LINEAR"]
	}
},
{
	id: "293620fc-4520-4fdc-82b9-6255eab8798f",
	dateId: "20271108",
	puzzle: {
		letters: "BETAMYNULJKVGQRIHXOFDSWPC",
		words: ["GUNK", "FROG", "GLUEY", "LAUGHS", "COWS", "DISH", "QUALM", "COX", "JAUNT", "SWOP", "ENVY", "BENT"]
	}
},
{
	id: "9d556c3a-0baa-4564-9d11-5b4130e128b7",
	dateId: "20271109",
	puzzle: {
		letters: "BVMRCTEODHWXNUJGASIQKLYPF",
		words: ["VENDOR", "SPINET", "KLAXONS", "CHROME", "WAXEN", "GLAND", "JINX", "EXODUS", "BEND", "QUIPS", "LYSINE", "FINALS"]
	}
},
{
	id: "b60ef614-4e2a-4998-9878-ab5dd0f7cd26",
	dateId: "20271110",
	puzzle: {
		letters: "TQLOMHUKPYDAFVEGNSCBXJIRW",
		words: ["BEVY", "POLKAS", "THAN", "SINFUL", "GAUD", "JINX", "WRING", "MYOPE", "QUASI", "NICE"]
	}
},
{
	id: "c64b3ae8-44be-4f47-a9ea-80e116688834",
	dateId: "20271111",
	puzzle: {
		letters: "TKDOVNRLYHQEXFAJUGWMCPIBS",
		words: ["LENT", "AHOY", "QUERN", "FLEX", "VOLE", "GENT", "BIG", "DOLE", "JERK", "HAMS", "CUE", "SWAM", "EQUIP"]
	}
},
{
	id: "fc390ed0-9a7e-498b-be9f-f06af0fa7659",
	dateId: "20271112",
	puzzle: {
		letters: "DAWQFRXJUNLHCGIKYMESPOBVT",
		words: ["RHYMES", "INGEST", "JARL", "BEINGS", "WAX", "POKY", "FUNGI", "CUING", "DRAW", "QUIETS", "VEIN"]
	}
},
{
	id: "6555aa59-b1ec-4ff9-ae10-6f0679868c5e",
	dateId: "20271113",
	puzzle: {
		letters: "CHQTGBXUERFAYPVWNDOMLSKIJ",
		words: ["IMPUTE", "YAWNS", "CHUTE", "DOVER", "FAWNS", "BAWLS", "JOY", "SKIMPY", "QUAY", "GREY", "WAXY"]
	}
},
{
	id: "d8ab2320-2fb4-445c-8de5-46dd82a8ce11",
	dateId: "20271114",
	puzzle: {
		letters: "CSEGBIPRYJLFDVAKOTUNXMWHQ",
		words: ["SERFDOM", "NAVY", "FOLK", "PILOT", "GREY", "FLOW", "FOX", "AUTO", "LOTH", "BYES", "QUAY", "EPICS", "JAY"]
	}
},
{
	id: "34c7edcd-b05c-4564-86f3-9ca43afb0e6f",
	dateId: "20271115",
	puzzle: {
		letters: "EDBQXOTHLUJWVIFCMAPGNRKYS",
		words: ["VIA", "JOT", "WARN", "DOTE", "QUIPS", "FLIPS", "FLUX", "GIPSY", "SPARK", "BLIPS", "WHIPS", "CRAM"]
	}
},
{
	id: "3c1de47b-d73f-4a8d-b02d-b0ede0623131",
	dateId: "20271116",
	puzzle: {
		letters: "HWUQMLIFEJRBTYVOSKAGPNDCX",
		words: ["ADSORB", "JETS", "TAX", "STACK", "ITEM", "EQUITY", "FIRST", "CAGY", "WHIRL", "PONDS", "STAVE"]
	}
},
{
	id: "c43c0567-7d16-48ec-94d8-1a153354bec1",
	dateId: "20271117",
	puzzle: {
		letters: "NXWBAVIHFKJGOEPMLRUQCYTSD",
		words: ["CLOUDS", "PURLOIN", "VIGOUR", "BAKERY", "OLM", "JINX", "WHORE", "CLOUTS", "FAKERS", "QUERY"]
	}
},
{
	id: "3c744e3d-1d97-4ecf-8b34-4cb6c7a3345b",
	dateId: "20271118",
	puzzle: {
		letters: "MXTQBALNURVKGHIWOJSDCFYPE",
		words: ["AVOW", "ESPY", "FOGS", "COGS", "BRUISED", "LAX", "SHRUNK", "QUIDS", "JOGS", "SHUNT", "MALT"]
	}
},
{
	id: "c2bfca33-03e1-4cbf-80f1-512e422f7e14",
	dateId: "20271119",
	puzzle: {
		letters: "THXCFQUANLERMPYKIWDGVSBOJ",
		words: ["QUARKS", "MARQUE", "BOWMAN", "HUMANLY", "LYNX", "VIER", "BOGY", "FLY", "CAMP", "THUMP", "BODY", "JOBS"]
	}
},
{
	id: "b918a1b1-12f9-464c-b033-4d342e6d704b",
	dateId: "20271120",
	puzzle: {
		letters: "FIDQMKGLUBCRAJTPHXSVWNOYE",
		words: ["QUARK", "SAXON", "GAUL", "CHASE", "SAUDI", "PHRASE", "BUTS", "VEST", "NOSEY", "WHOSE", "ALUM", "FIG", "JARL"]
	}
},
{
	id: "b6b42950-aaff-46af-b9de-0b6046ee5263",
	dateId: "20271121",
	puzzle: {
		letters: "PVTMWCSARIOQYDXBUJELKNFHG",
		words: ["GEL", "BUNK", "MATRIX", "COSTAR", "UNFED", "VARY", "IRAQ", "RASP", "JUNK", "WIDE", "HELD"]
	}
},
{
	id: "38c861ba-ee0b-424b-9ae7-1d685225733f",
	dateId: "20271122",
	puzzle: {
		letters: "GXVJINWETSFOYLHRCKQBPDAUM",
		words: ["STYLE", "PRONG", "DROWN", "VETS", "CROWN", "FROCK", "QUACK", "ISLET", "BLEW", "JETS", "WELSH", "BUM", "VEX"]
	}
},
{
	id: "0cc6eddf-b955-466b-b739-ec41f3b53a23",
	dateId: "20271123",
	puzzle: {
		letters: "ECKHQTPMUJYBDIFNOGAWLSVRX",
		words: ["AGONY", "DUMPY", "HUMID", "BYTE", "RADIUM", "FIGS", "PECK", "WAGONS", "OVA", "QUID", "JUMBO", "IDOLS", "FAX"]
	}
},
{
	id: "23d33afb-9f08-4551-85c1-dc4441522825",
	dateId: "20271124",
	puzzle: {
		letters: "XJVGPYRAMEWTIHFBSLUCDOQKN",
		words: ["MARX", "SOLITARY", "JAILS", "QUILTS", "BOLTS", "VAMP", "WRIST", "MIRAGE", "CHEMISTRY", "CHUNK", "CHEF", "DOLT"]
	}
},
{
	id: "cc9ce779-9dc0-438b-9b78-39045131372e",
	dateId: "20271125",
	puzzle: {
		letters: "YLABMPNGVOCFJSRDHETIQUKXW",
		words: ["MORTISE", "VORTEX", "LYNCHES", "ABORTS", "DUKES", "ANGST", "WISE", "PLAN", "QUEST", "JEST", "CHEF"]
	}
},
{
	id: "c9bdd4fc-e841-4138-a080-e43fb829bbd6",
	dateId: "20271126",
	puzzle: {
		letters: "FQKELUATJCPGBORNXHWYVIMSD",
		words: ["MINX", "HOTEL", "FAKE", "PATE", "WHIMSY", "CROWDS", "QUAKE", "VIMS", "JOYS", "ABHOR", "GATE"]
	}
},
{
	id: "f75950e2-2a41-400f-8d67-6d99e3782818",
	dateId: "20271127",
	puzzle: {
		letters: "WLFKYOJSXIHGBPANMETVCRQUD",
		words: ["GERM", "SPIKY", "QUERN", "HOWLS", "CREPT", "BEGS", "VAT", "DUET", "TAXI", "FLOGS", "JOWLS"]
	}
},
{
	id: "99101d6c-7106-4403-ae78-76c4b0500233",
	dateId: "20271128",
	puzzle: {
		letters: "WYDPOFANCHIQUJKBLERSTXGVM",
		words: ["QUAY", "FAILURE", "FILERS", "GERUND", "POCKS", "WAILER", "CURVE", "JERKS", "FAULT", "BILGE", "HOCKS", "LUREX", "GERMS"]
	}
},
{
	id: "698addbb-0ed5-415e-b84b-075f71be3172",
	dateId: "20271129",
	puzzle: {
		letters: "HUPCKFIQAJSDOLVREWYXGMTNB",
		words: ["BYTES", "LOWERS", "QUIDS", "JACK", "IFS", "DOWNY", "LYNX", "VAPID", "GERM", "HIDER"]
	}
},
{
	id: "39e8d028-e6d0-4211-8d21-7bb4243c5879",
	dateId: "20271130",
	puzzle: {
		letters: "PDSYMXEKUFCLQAVBNWGIROJTH",
		words: ["NOBLES", "QUAKES", "VIA", "BOWLED", "FAITH", "GAIT", "MUSKY", "BROWN", "PESKY", "SEX", "JOWL", "ONCE"]
	}
},
{
	id: "4525e708-efc4-43f8-b3b1-543bf727a8e8",
	dateId: "20271201",
	puzzle: {
		letters: "XQLBGUAFMRJTPIODECKYVNSHW",
		words: ["VEND", "SKIMPED", "PATCHY", "JAPES", "FLAX", "ESKIMO", "GRIPES", "QUALM", "BRICKS", "WHY"]
	}
},
{
	id: "2f2e8935-a308-4a33-875f-a24da4d41678",
	dateId: "20271202",
	puzzle: {
		letters: "KXYIMRPNWVUASJFQEHOGDTLBC",
		words: ["QUASHED", "SHARP", "MINX", "FOB", "BOLTED", "JOLTED", "VIM", "COBLE", "GOBLET", "SWIM", "QUARK", "RASPY"]
	}
},
{
	id: "40608ab9-f887-4d8f-aa2c-18c541a284cb",
	dateId: "20271203",
	puzzle: {
		letters: "GIMHYLOUXJNTQAWDESRKFBVPC",
		words: ["QUILTED", "GILTS", "MOLTEN", "BEND", "VENOM", "SQUAWK", "JARS", "FEND", "ARC", "WAXY", "HUTS", "WARPS"]
	}
},
{
	id: "3e16fd5d-7772-4c12-bd3a-d4c1deb62c26",
	dateId: "20271204",
	puzzle: {
		letters: "PBCYHTARXSMNFEGVLIKUWOJQD",
		words: ["DUKES", "INFLOW", "OILMAN", "AFRESH", "KEGS", "MARX", "VOW", "CAFES", "BARES", "JOINT", "FIERY", "QUERN", "PARES"]
	}
},
{
	id: "5608e4f2-0a94-4183-acde-620d1a715bd3",
	dateId: "20271205",
	puzzle: {
		letters: "ITNDHKRSUMPBEJQYWFOLXAVCG",
		words: ["QUERN", "PRE", "OVA", "HUNTS", "BERK", "BEFOG", "BESTIR", "JERK", "CLOG", "MUDS", "WAXY"]
	}
},
{
	id: "f80e8bd6-0b2f-4239-9608-152b6e75d2a8",
	dateId: "20271206",
	puzzle: {
		letters: "DQUYGWNSIXMAEPRCJOBTKFVLH",
		words: ["LOANS", "SQUIRT", "CANES", "JANUS", "SIX", "SNACK", "RIPENS", "UNEASY", "VOLT", "FOAM", "GIRTH", "SPEND", "WANES", "BEANS"]
	}
},
{
	id: "95d55545-598b-48f7-be81-493cc5e78645",
	dateId: "20271207",
	puzzle: {
		letters: "FRXOMTEYLJVSGAWICNPUDHKBQ",
		words: ["SEXY", "CHIVES", "DIVERTS", "PANGS", "JANGLY", "WAGES", "QUALM", "LANK", "FRETS", "PUB", "OYSTER"]
	}
},
{
	id: "a696d9c6-ff2e-4eaa-a3ac-75f8694b6cb1",
	dateId: "20271208",
	puzzle: {
		letters: "GVFTJOSXUQKLERWNIMAYDPCHB",
		words: ["CHARY", "MARQUES", "LOSER", "RELINK", "PILES", "TUES", "BARES", "FUELS", "VOLES", "MARX", "WARES", "REMIND", "LOGS", "JURY"]
	}
},
{
	id: "c42572f3-9b6d-4428-8138-3b6e4e25fbb4",
	dateId: "20271209",
	puzzle: {
		letters: "XIHLFMKEYDNJSOWBATPUCGVQR",
		words: ["QUOTAS", "STOW", "HIKES", "SPUR", "DOES", "BASELY", "SELF", "STANK", "VASE", "GASP", "MIX", "CASE", "JEST"]
	}
},
{
	id: "404506ee-e77b-45ac-af0d-da1403acac87",
	dateId: "20271210",
	puzzle: {
		letters: "HDSEBLOJVNGPXITMAUFRCQYKW",
		words: ["FINES", "GOLDS", "ACQUIT", "HOLDS", "FIVES", "QUIRKY", "BENT", "JIVES", "PLODS", "MAXI", "WRIT"]
	}
},
{
	id: "5dabb43a-4127-41fc-920e-7d57209b5684",
	dateId: "20271211",
	puzzle: {
		letters: "SQUTXRAPEFWDLVKOJMINYHGBC",
		words: ["UPLINK", "LEFT", "PELVIC", "GIMLET", "PARQUET", "ADLIB", "SQUAW", "OHMIC", "JOY", "APEX"]
	}
},
{
	id: "1f8a0fa4-7e62-48ab-b3af-3ee729fe9de9",
	dateId: "20271212",
	puzzle: {
		letters: "SGCXVBNPATFORDJHUIWLQMEKY",
		words: ["HORNS", "PRONGS", "FORUM", "MIKE", "JAR", "WEIRDLY", "BONGS", "TARNS", "QUID", "BORAX", "CAPRI", "VAPOUR"]
	}
},
{
	id: "29e7cfe1-0172-47fd-889f-4f5ea9d9318f",
	dateId: "20271213",
	puzzle: {
		letters: "MXYFCHIKDLVONBAJPEWRQUSTG",
		words: ["FLAWS", "CLAWS", "HONEST", "GRAB", "MIX", "QUEST", "JOIN", "VINES", "DARTS", "HONK", "BALDY", "POETS"]
	}
},
{
	id: "c4dbeb86-9e47-4bce-82a8-286f2a3ed913",
	dateId: "20271214",
	puzzle: {
		letters: "TDNOFGIVHCSLYJQMEPAUXWBKR",
		words: ["SLEW", "QUAY", "FOND", "APEX", "CON", "HYPE", "ABEL", "JAPES", "ELMS", "PELVIS", "DIGS", "TILES", "QUARK"]
	}
},
{
	id: "1074d6dc-4a8b-4bf9-a1f4-725036b0bde8",
	dateId: "20271215",
	puzzle: {
		letters: "HADTWLUVCRQEBYFSXNIKOMGPJ",
		words: ["MOSQUE", "JINXES", "CRYING", "HAVEN", "PINES", "WRY", "DAUBING", "TRYING", "KING", "LEVYING", "FIBULA"]
	}
},
{
	id: "af639c96-6447-48db-b153-7cf613557a92",
	dateId: "20271216",
	puzzle: {
		letters: "WTIPSUEKFBQRMYLCOJADHGNVX",
		words: ["SPIKE", "NORMAL", "CROQUET", "CHORE", "FLAX", "VAN", "MAJOR", "CREW", "GONAD", "COMFY", "BLAME"]
	}
},
{
	id: "1926ea04-fdd1-4e28-ad93-0b83a91475b6",
	dateId: "20271217",
	puzzle: {
		letters: "POXJBQCTEHUSVYLIFGNWKRMDA",
		words: ["BEVY", "SQUIRM", "HEX", "QUIRK", "COTS", "STYLE", "ANGST", "JETS", "POTS", "FUSTY", "DAWN"]
	}
},
{
	id: "acb5ac09-8c09-43f0-9760-8c51906c316f",
	dateId: "20271218",
	puzzle: {
		letters: "YDPVSMJNETOLUHFCAKQGBRXWI",
		words: ["BAULK", "CLOAK", "MOLAR", "CLUES", "WIG", "BALMY", "PEST", "FEND", "QUALM", "COAX", "VEND", "JUNE", "HEFT"]
	}
},
{
	id: "f4a348c3-abf3-4dde-b33e-16861e2149ed",
	dateId: "20271219",
	puzzle: {
		letters: "THGNDYWSIPROKJXFAVCEMBUQL",
		words: ["BUCKING", "PIXEL", "OVARY", "BAKINGS", "DINGHY", "INSOFAR", "NIGHT", "MAKINGS", "JIGS", "QUAKING", "AVOW"]
	}
},
{
	id: "8e67f3e1-3b77-4af8-89fb-e099c3a4166a",
	dateId: "20271220",
	puzzle: {
		letters: "BFVTNSAGKWPYRMOXEUCHJDQIL",
		words: ["VARY", "TWO", "CLIQUEY", "GRASPED", "JERK", "FARED", "APEX", "BARED", "PARCH", "MOWN"]
	}
},
{
	id: "c8be38b9-dbb8-4c1d-8158-2bcf44580a4f",
	dateId: "20271221",
	puzzle: {
		letters: "TCXFLSEHYKVJPONBRMDIWAGQU",
		words: ["RAMP", "ABJECT", "ONYXES", "VEST", "BRAG", "DINKY", "LYON", "FLY", "BRAW", "QUID", "CHEST"]
	}
},
{
	id: "6aaadc74-fe8f-425f-bde5-e82cd5f732a5",
	dateId: "20271222",
	puzzle: {
		letters: "HMEXTIDCVNBURYJKSQAWPFLGO",
		words: ["CURVED", "CUSP", "LARYNX", "SQUIB", "BUSK", "GOALS", "DIME", "HIDE", "EXT", "JARS", "DRAW", "FLAG"]
	}
},
{
	id: "6ea56544-ea95-4ce2-b8f1-798ee7e552e2",
	dateId: "20271223",
	puzzle: {
		letters: "QUEBHKSNOPTCMRYXIGAJVWDFL",
		words: ["PYRAMID", "WICKS", "RADIX", "HONEST", "QUEST", "NORMAL", "VIMS", "JAMS", "FARMS", "STIGMA", "PROBES"]
	}
},
{
	id: "0b2a5f48-7880-45bc-b478-97473f6c5690",
	dateId: "20271224",
	puzzle: {
		letters: "WDQKLREUIHXAVPTJFMNCOGBSY",
		words: ["DREAMS", "FARED", "SYNC", "HIVED", "DEVIL", "FOG", "REVAMP", "KITH", "EXAMS", "JAMBS", "PIQUED", "DREW"]
	}
},
{
	id: "33a0df18-859d-49e9-8644-56a6e57e2bc8",
	dateId: "20271225",
	puzzle: {
		letters: "DRPIBCNULVAQGYJEHXOSKMFWT",
		words: ["GUYS", "FOGY", "KHAN", "EQUIP", "BLIP", "STOW", "DRUG", "FOXY", "AHEM", "IVY", "JOTS", "CAN"]
	}
},
{
	id: "ddb58581-69a2-4a79-9d4d-5712d6854100",
	dateId: "20271226",
	puzzle: {
		letters: "NXWLDSAYEVPTJKRUIHGOQBFCM",
		words: ["NASTY", "CORKED", "QUIPS", "STYLED", "CHIPS", "FITS", "GORED", "BITS", "STYX", "SAWYER", "MORE", "VELD", "JAWED"]
	}
},
{
	id: "b07962a5-4567-47e2-bdf9-2fa522052d16",
	dateId: "20271227",
	puzzle: {
		letters: "CPGYTLOWSIQJRBFUVDAMHENKX",
		words: ["CLOGS", "ORBITS", "BAROQUE", "AMBIT", "FADE", "DROWSY", "VEND", "DROP", "FAX", "HEN", "JOGS", "DRANK"]
	}
},
{
	id: "e5f6c108-c0cc-4522-a4f6-1f5be8a714f2",
	dateId: "20271228",
	puzzle: {
		letters: "YRFBPECKLWMQAIVXUHSGJODTN",
		words: ["BLACKISH", "DUALIST", "WIGS", "FLACK", "QUACKISH", "PLACER", "VIAL", "JUDO", "DUX", "MERCY", "ALIGNS"]
	}
},
{
	id: "f112bf8b-693d-49ce-a1bc-5e1c1ad9bbdb",
	dateId: "20271229",
	puzzle: {
		letters: "NEYSWXVUABKLDQRFCJHITPOGM",
		words: ["BAULK", "BRIG", "OPT", "VEX", "BRAYS", "BRIM", "ADHOC", "JOCK", "QUAYS", "BRAW", "FLUE", "ENVY"]
	}
},
{
	id: "f4e654db-92bf-4f2f-9ff3-f1e2966817b9",
	dateId: "20271230",
	puzzle: {
		letters: "CLVOSYDTEPQANGMJURFXBHKWI",
		words: ["HUNG", "GRANDLY", "TEMPO", "UNFIX", "QUARK", "BURNT", "WRUNG", "GRATES", "ADVENT", "JAUNT", "CYAN"]
	}
},
{
	id: "5087e22c-8c20-4cb9-bb67-6bceebbaef32",
	dateId: "20271231",
	puzzle: {
		letters: "PHGSEYLWJRQUAXMICKOFBTNDV",
		words: ["BIT", "SERMON", "GLYPH", "ACQUIT", "VODKA", "JAWS", "AXON", "FOAL"]
	}
},
{
	id: "8523746b-04c8-49a6-ae49-d2ea806afede",
	dateId: "20280101",
	puzzle: {
		letters: "TDGKWJISEXBMRVCFNAOPQUYLH",
		words: ["POLARISE", "TIGERS", "AMBIT", "JIGS", "KEGS", "QUAVERS", "GERMANY", "SKEW", "FUN", "DISMAL", "COARSE", "HOARSE", "SEX"]
	}
},
{
	id: "7dd4d524-cc39-43e7-bf9d-44a0c6f3e5da",
	dateId: "20280102",
	puzzle: {
		letters: "ORICMKPYLBHFSGADEXUVWJTNQ",
		words: ["QUALM", "JET", "LYRIC", "GLYPH", "FETUS", "VAUNTED", "PORK", "PHEW", "SEXUAL", "BLIPS"]
	}
},
{
	id: "7337d1ac-8242-4f20-aafd-7b39f2c09d8b",
	dateId: "20280103",
	puzzle: {
		letters: "MGNVWRFXAHLOJCBTUEKSQIPDY",
		words: ["BACKED", "WACKY", "FLOUT", "GROUPIE", "PECAN", "JACKED", "WHACKED", "WHACKS", "FOX", "PIQUED", "VAN", "FORM"]
	}
},
{
	id: "59dc51c9-c0eb-497d-b7e1-6d8f3889c045",
	dateId: "20280104",
	puzzle: {
		letters: "XCVBDRIWTAHSMKFQUJYONLEPG",
		words: ["MYOPE", "MUSIC", "SWIM", "JULEP", "DAFT", "BAD", "RISQUE", "VIMS", "SHUN", "MIX", "FOGY", "POKY"]
	}
},
{
	id: "9cd89fe0-9225-4818-a986-6cd2e4c9aca5",
	dateId: "20280105",
	puzzle: {
		letters: "PSVIXLNTFGMAKOBWEUDYHJQCR",
		words: ["VITALS", "BODY", "PLANTS", "FIX", "CRY", "JEANS", "EQUALS", "WHEALS", "GIFTS", "SLAKE", "MEATS"]
	}
},
{
	id: "10d6dc98-9b93-4bfb-b27b-8b5baed4447a",
	dateId: "20280106",
	puzzle: {
		letters: "KPLDXMOYNVRTWCASGIUFEBJHQ",
		words: ["BESTOW", "VACUITY", "GIBES", "LYNX", "CANDY", "HITS", "WOK", "JUICY", "MOLDY", "STORM", "QUITS", "PORTS", "FANCY"]
	}
},
{
	id: "3d083674-f338-4ea5-be07-4c246183ab15",
	dateId: "20280107",
	puzzle: {
		letters: "KTFOBWSVICERXMLDQPAHYGUNJ",
		words: ["WREST", "LIFTS", "VIM", "BOIL", "EDGY", "EQUAL", "CLIMAX", "UNJAM", "DESK", "HAM", "CLAMP"]
	}
},
{
	id: "a3e0077b-2dd4-4c75-98bd-069d9ebdb848",
	dateId: "20280108",
	puzzle: {
		letters: "HQMNSAKUBXJIWCOGVTDRYELFP",
		words: ["COBS", "JIVE", "HAIKU", "PROD", "VELDT", "TWIG", "NUMBS", "QUITE", "ELF", "LEVY", "BOX"]
	}
},
{
	id: "64c6650b-31fa-4ac5-8a7c-6fa86dbeb35f",
	dateId: "20280109",
	puzzle: {
		letters: "WMUFBYEQLOJPSNXITAVDCHGRK",
		words: ["DRASTIC", "GRAPES", "BLUEST", "JEST", "RASPY", "QUEST", "SNATCH", "BOX", "FLUMES", "SPEW", "VANS", "SPARK"]
	}
},
{
	id: "dfdffd9f-f371-4c48-ba2e-16e9190fee72",
	dateId: "20280110",
	puzzle: {
		letters: "HGEMDWIFSUVTRQKBYAJCPLXNO",
		words: ["IRAQ", "ITALY", "BLAT", "TWIG", "FRIES", "JOCK", "VIRAL", "DUSK", "EMUS", "WHIR", "FRANC", "PLAN", "LAX"]
	}
},
{
	id: "4fa97d98-6d36-449e-8778-88639c66a9fe",
	dateId: "20280111",
	puzzle: {
		letters: "VHNFQOYKUBGWLJIXAMTPRSCDE",
		words: ["CALMS", "HOWL", "JULY", "FUNKY", "MARX", "QUITE", "BIPED", "VOW", "GAWKY"]
	}
},
{
	id: "55480cf5-4f6c-4fec-9b31-b0bff34a2d15",
	dateId: "20280112",
	puzzle: {
		letters: "NQUPSCMBIJFAXKVDOWYELHGRT",
		words: ["DOWRY", "LOWKEY", "QUIVER", "FOAM", "DAMN", "AXIS", "JIVE", "BIKER", "DHOW", "TREK", "QUIPS", "CAB", "ERGO"]
	}
},
{
	id: "47073f3b-20fc-4392-b3ad-a2ec2d9509ec",
	dateId: "20280113",
	puzzle: {
		letters: "NKAVBQUOLCSJRPYFGEDITHWXM",
		words: ["SQUALOR", "CYPRUS", "FJORD", "DREW", "ALB", "CLOAK", "MIXED", "HERD", "THE", "VALOUR", "DRUNK", "GROPED"]
	}
},
{
	id: "9fd94acb-d1e4-46df-8efd-c548fb90799c",
	dateId: "20280114",
	puzzle: {
		letters: "VKYQSEGBHULDJIXOTCFNMPWAR",
		words: ["SQUIB", "VELDT", "LODGE", "FACT", "INFRA", "SHIN", "PODGY", "JINX", "KELT", "MODEL", "WARN"]
	}
},
{
	id: "c52d6b5c-6344-44e0-a5fb-2111d3eab86b",
	dateId: "20280115",
	puzzle: {
		letters: "OSMFGBAUIKJLQCXWVPEDYHNRT",
		words: ["WHY", "DECIMAL", "FICUS", "EQUAL", "BOAS", "ENVY", "JABS", "FIXED", "FIG", "SAUCER", "AMUCK", "PERT"]
	}
},
{
	id: "e1bc1be7-2b44-48cc-aff8-b42083566685",
	dateId: "20280116",
	puzzle: {
		letters: "GYQWDMUNEHPOTSBXCJAFRIVLK",
		words: ["COMPUTED", "COUNTED", "GUNS", "FLASHED", "BASHED", "QUOTAS", "JABS", "RIVAL", "STONY", "STALK", "UNWED", "DETOX"]
	}
},
{
	id: "dba9af2e-fe84-457c-8814-61ef1a59a966",
	dateId: "20280117",
	puzzle: {
		letters: "WGVDNSAJOKMQIRTCULEYBFHXP",
		words: ["QUIRK", "AILERON", "BUMS", "WAILER", "VORTEX", "GAIETY", "HELIUM", "CUB", "JAILER", "PERIOD", "FLIER"]
	}
},
{
	id: "0fc967b8-b4e9-4aec-b1b1-5cc4b67e5f68",
	dateId: "20280118",
	puzzle: {
		letters: "VEHIDFNOBKTXYUMPRAWQCGJSL",
		words: ["HEFT", "CRAYON", "SAXONY", "BONE", "CRAG", "VENT", "JAWS", "QUART", "SWUM", "AUK", "PRAY", "CRAWLS", "BID"]
	}
},
{
	id: "0b97e823-19d2-4248-ace5-e6fdbf9e3e00",
	dateId: "20280119",
	puzzle: {
		letters: "LPIMNYXVRJWBOUQEFTADKSGHC",
		words: ["PIVOTS", "BOXY", "CHAD", "STORM", "JUTS", "PLY", "SKEW", "GAUD", "QUOTA", "FEST", "BORN"]
	}
},
{
	id: "92dd5bc7-a409-419a-9660-d58a702147a7",
	dateId: "20280120",
	puzzle: {
		letters: "AWBVTRKJELNOCGXHYUSDMQFIP",
		words: ["VEX", "WARN", "FIDGET", "QUIPS", "BECKON", "OHM", "CORNY", "BELT", "JOCK"]
	}
},
{
	id: "b66ccecc-44d2-441b-b032-a1d1a2060f09",
	dateId: "20280121",
	puzzle: {
		letters: "NWPDJUOTAXQKIHBVEGRCMSLFY",
		words: ["SEQUOIA", "BRIGHTON", "JAB", "SLEIGHT", "DAIRY", "BATIK", "KIEV", "FRIGHT", "CHAIR", "TAX", "TOWN", "PATIO", "GEMS"]
	}
},
{
	id: "153fa55e-5805-4fa3-ba78-549830b426d9",
	dateId: "20280122",
	puzzle: {
		letters: "CIJHWVLAXPTMFUKYEORQBNSGD",
		words: ["BEFOG", "CLAMOURS", "DRONES", "GROUP", "BYTES", "QUAIL", "FLAX", "WHAM", "JAMES", "VIAL", "FORK"]
	}
},
{
	id: "57bac893-992e-4cc3-b77d-0e691a96ac80",
	dateId: "20280123",
	puzzle: {
		letters: "FGXNTQUBALKECSWRYVPJMODIH",
		words: ["BAWLS", "DIPS", "CUBAN", "JIVE", "LAX", "HIPS", "BERK", "FUG", "RECANT", "MOVER", "QUERY"]
	}
},
{
	id: "b6882b6f-6d9b-461d-bed7-eac33d91e489",
	dateId: "20280124",
	puzzle: {
		letters: "LDJVIFOHMCYWKAQXETUNSRGBP",
		words: ["FOYERS", "DHOW", "HATERS", "JOKERS", "FLOWERS", "QUAKERS", "SETUP", "BUG", "CATERS", "VIM", "KHAN", "SEXY"]
	}
},
{
	id: "8992047a-92ff-4f0e-ab76-91f910d534e8",
	dateId: "20280125",
	puzzle: {
		letters: "MQSCRUFBAHPOTLXYENIDKWVJG",
		words: ["TAXI", "PETAL", "DILATE", "CRABS", "GIVEN", "FOETAL", "WENT", "QUOTAS", "BONEY", "HALITE", "MUFTI", "KENT", "JILT"]
	}
},
{
	id: "17495e89-55fb-4e4d-afc9-9cd930be2c4f",
	dateId: "20280126",
	puzzle: {
		letters: "EVMOWNYFSXGRKHCAPLUDBJTQI",
		words: ["GRAB", "MOWS", "SCULPT", "FOX", "QUID", "ENVY", "BARKS", "JARL", "HULKS"]
	}
},
{
	id: "3c67707b-6530-478a-8bb8-3343df6d24b6",
	dateId: "20280127",
	puzzle: {
		letters: "DFSTHGRKXUBWOIQJLPEMCAVYN",
		words: ["EQUIP", "CALVE", "JALOPY", "FRO", "WORKS", "GROPE", "MIX", "NEPAL", "WORST", "BLOW", "HUTS", "DROP"]
	}
},
{
	id: "cd062d46-9577-4a65-9dfa-c0f1ac0f8e0b",
	dateId: "20280128",
	puzzle: {
		letters: "CVBILWOSFRJNPQXYATUDHMGKE",
		words: ["MANY", "LISBON", "RISQUE", "JONAH", "COBS", "DUKE", "GAPS", "VOW", "FIBS", "PANT", "DUX"]
	}
},
{
	id: "11c1a080-72b6-4187-a0e8-7c5de0707957",
	dateId: "20280129",
	puzzle: {
		letters: "DPBNGHOVSAWFKYJCTRXLQUIEM",
		words: ["FRUIT", "NAGS", "MERIT", "HOBS", "DHOW", "VOW", "QUIRKY", "LYRE", "EXIT", "JAYS", "CURIE", "POKY"]
	}
},
{
	id: "e83f4da5-2f6e-4424-8d39-39074b1850c5",
	dateId: "20280130",
	puzzle: {
		letters: "VYMCGWEFABITPRHUXSONLQJKD",
		words: ["CARPETS", "SPEW", "BRAG", "FRAME", "LUTE", "LUX", "ABHORS", "PARSON", "QUIETS", "HONKS", "DOPEY", "JOHN", "VETS"]
	}
},
{
	id: "171a96cd-499c-4d52-8384-49340d6f78a5",
	dateId: "20280131",
	puzzle: {
		letters: "TQKRWUPJEMINGVSALYBFHDCOX",
		words: ["HANGER", "JERK", "CLANG", "BOX", "INPUT", "MEW", "DAILY", "REVS", "FOBS", "QUIP"]
	}
},
{
	id: "88f88453-b6d8-4f4f-9bb9-4436bb1de009",
	dateId: "20280201",
	puzzle: {
		letters: "DJGBQSINUHTXFAMLKCERPYWVO",
		words: ["FITLY", "NUMERACY", "JINX", "STING", "BUNG", "QUACK", "DINAR", "HUMANIST", "CAMEO", "PLY", "CARVE", "WEAN"]
	}
},
{
	id: "7758592a-2cc6-488d-8588-eed61accf227",
	dateId: "20280202",
	puzzle: {
		letters: "PKWXBFORUNHMSAQIVGYELDCJT",
		words: ["FORAYS", "TEARS", "LIMO", "KORAN", "OHMS", "CYAN", "WORMS", "PORK", "BURS", "JET", "VIMS", "GAYS", "XRAYS", "QUARK", "DIMS"]
	}
},
{
	id: "1f9c6f32-7986-48b1-a8ad-50058dfb963a",
	dateId: "20280203",
	puzzle: {
		letters: "KHNMYSGLBCIRAQTOXJEUWPVDF",
		words: ["IRAQ", "CYMBAL", "AGIO", "LARGISH", "POX", "GROW", "SIGN", "VEAL", "DEARS", "RISK", "TEARS", "JARL", "DUET", "FEARS"]
	}
},
{
	id: "3ab41aa1-1155-439c-bc13-4ac5c45a073c",
	dateId: "20280204",
	puzzle: {
		letters: "BWDRMECJUNVSHIQFATLOYKGXP",
		words: ["DRUM", "SHAKY", "HAVES", "LOP", "CHASE", "GASH", "POX", "WEST", "QUILTS", "FAST", "JILTS", "BEST", "CHURN"]
	}
},
{
	id: "786ef25a-d9bf-45ae-b74d-38a7495583a4",
	dateId: "20280205",
	puzzle: {
		letters: "HGIOVQULYMKBSTXNADEJCPFRW",
		words: ["FASTED", "BANK", "GUSTED", "MOLTS", "QUILTED", "JEST", "WETLY", "SEXY", "CADETS", "BLUSTER", "HUBS", "PADRES", "VOLTS"]
	}
},
{
	id: "1671f60b-81ac-4544-8554-b16a769584b1",
	dateId: "20280206",
	puzzle: {
		letters: "EQRACUPMJHFGVSWXODINYLTKB",
		words: ["CHARMS", "OLDISH", "GODLY", "MARQUE", "DIVOT", "KIDS", "ODIN", "FOXY", "WHAM", "BIDS", "JAMS", "CHAMP"]
	}
},
{
	id: "acbe9921-afe2-45e7-9fc5-8c07eda14a16",
	dateId: "20280207",
	puzzle: {
		letters: "BXFGPHRCOKWAUEJNQMILTYSVD",
		words: ["CRAMS", "COG", "FRAME", "COKE", "CANT", "SIDLE", "SQUAW", "MARX", "WHARF", "BRAWNY", "POEMS", "JOKE", "VILE"]
	}
},
{
	id: "7d125063-5798-4efa-a52d-20d8269c59b0",
	dateId: "20280208",
	puzzle: {
		letters: "PDFSXTAKHORQIBWMYUNEGJVLC",
		words: ["SHINE", "GYM", "QUINCE", "FARM", "JUNE", "RAINBOW", "DART", "BOX", "BOWEL", "AKIN", "PAIN", "ENVY"]
	}
},
{
	id: "81b22b9a-bb4f-47f6-87ef-90ee2724a3bb",
	dateId: "20280209",
	puzzle: {
		letters: "FGQAYIHUXRDLSCKTEJONVBPWM",
		words: ["KNOW", "FILED", "JOSHUA", "MOPED", "QUARK", "VELDT", "XRAY", "GILT", "BELT", "COPED"]
	}
},
{
	id: "3c2450c8-8433-496e-aaa2-69468465a11c",
	dateId: "20280210",
	puzzle: {
		letters: "KUINFYRQVEXLTSJACOHGMWPBD",
		words: ["ENQUIRY", "SHOW", "BOLTS", "QUIRKY", "WAXY", "DHOW", "STRIVEN", "GHOSTLY", "SHOP", "MALTS", "JEST", "LACTOSE", "INFEST"]
	}
},
{
	id: "17c4f5a1-ae36-48aa-9e4b-e6213e6d82b9",
	dateId: "20280211",
	puzzle: {
		letters: "XMQCWTIUNOBRVLGDEYAJHSFKP",
		words: ["CULVERT", "LAYER", "HERDS", "DEFY", "YAK", "JAYS", "PAVED", "CONVEYS", "MIX", "QUIVER", "ALONG", "CURBED", "WOLVES"]
	}
},
{
	id: "8322794c-153c-4673-8d79-833346ed5736",
	dateId: "20280212",
	puzzle: {
		letters: "NSXJVQUTELIMKOBHDRCAYGWPF",
		words: ["ROCKETS", "PACKETS", "SQUID", "EXTOL", "WROTE", "HYDRO", "BLOCK", "VETO", "JETS", "NUKE", "ORGY", "STORM", "FABLE"]
	}
},
{
	id: "8e0d1dc9-5cbb-44df-877c-385443826258",
	dateId: "20280213",
	puzzle: {
		letters: "BFPHGAKQERYMVUDOJINLSTWXC",
		words: ["MOTIVE", "JINX", "SOYA", "HERD", "INCLUDE", "GERUND", "WINDER", "YAK", "QUIVER", "FAB", "PERU"]
	}
},
{
	id: "fc3e85a9-eb6b-46bf-b6f6-24c40dc106e1",
	dateId: "20280214",
	puzzle: {
		letters: "DXWSFPRHOYGAIBVCUMETLQNJK",
		words: ["SHRIEK", "QUIET", "AIRGUN", "AHOY", "BOWS", "SHOVE", "LUMEN", "ACUMEN", "PRIME", "GUARD", "JET", "FOB", "MARX"]
	}
},
{
	id: "fee1b555-831a-47bb-9428-522ff4e5dfd0",
	dateId: "20280215",
	puzzle: {
		letters: "CGDRWVOBEHJIKTXMLNPAYSQUF",
		words: ["THREW", "JOINTED", "MILKER", "SQUAT", "VIMS", "BIKER", "FATHER", "JOKILY", "CODER", "GOBI", "UNTAXED", "PUNTED"]
	}
},
{
	id: "84f6ac97-3671-4bbe-a5d7-d6c76c4b0d92",
	dateId: "20280216",
	puzzle: {
		letters: "JRDXFWAHOMCUKLBNQEIVYTGPS",
		words: ["RACQUET", "OBLIGE", "FOXHUNT", "PELVIS", "JAUNTY", "MOBILE", "DRAKE", "DRAW"]
	}
},
{
	id: "3da57b3f-56d9-4b2f-abab-11ef35a73445",
	dateId: "20280217",
	puzzle: {
		letters: "FTNVYQRIJGXUWDACOEMLHKBPS",
		words: ["FRUIT", "BEDLAM", "CHOKED", "VIDEO", "MEDALS", "PEDALS", "EDGY", "QUID", "JADE", "DINT", "BOX", "COWED"]
	}
},
{
	id: "b7771ac6-2d22-4c62-877b-9c3bafe7cb4c",
	dateId: "20280218",
	puzzle: {
		letters: "TMVJCQUAHDWSLNFBOREGXIKYP",
		words: ["BIKER", "MAULERS", "CHANGERS", "SWORE", "JAM", "PERKY", "SLAV", "SQUALOR", "FEND", "BOX", "SLUT"]
	}
},
{
	id: "e917b43f-514a-4298-9f83-2fbde2a856ea",
	dateId: "20280219",
	puzzle: {
		letters: "FRPHWCKELDVYMQBNAUXOITSGJ",
		words: ["WHELP", "JOGS", "REMAIN", "NAVY", "QUAINT", "HELD", "PERKY", "FREYA", "BOGUS", "XMAS", "MERCY"]
	}
},
{
	id: "8112b1e2-36b1-4e57-a4d5-2ec975467cfc",
	dateId: "20280220",
	puzzle: {
		letters: "FNCKRMALHWETSOPDVJIUYGXBQ",
		words: ["JOLTED", "BIJOU", "RHO", "KHOISAN", "EDGY", "DETACH", "TEASHOP", "CHOW", "QUIP", "VEAL", "POSTMAN", "SIX", "FASTED"]
	}
},
{
	id: "36dfac85-5fc9-4fae-b001-97db29d25547",
	dateId: "20280221",
	puzzle: {
		letters: "MCYGIFOJRSKNTVHEWUALPQDBX",
		words: ["ATOM", "KNEW", "EQUAL", "PENT", "HAUNT", "TRIGS", "BATON", "DAUNT", "COKE", "FONT", "LAX", "ENJOY", "VAT"]
	}
},
{
	id: "34860c90-880c-40c3-8267-09dfd9336349",
	dateId: "20280222",
	puzzle: {
		letters: "KQMCYUINBERPLVXHOSATDFGWJ",
		words: ["GALOP", "BYE", "KILN", "JAWS", "HOGS", "PRINCE", "FOGS", "MINCE", "QUINCE", "SPLAT", "DOGS", "AXE", "SALVE"]
	}
},
{
	id: "3dc5e91c-5017-483c-a9f1-5c06871fdae3",
	dateId: "20280223",
	puzzle: {
		letters: "PHXSMREIYVQWDOJCUAFBTGNLK",
		words: ["NUDISM", "BLADE", "EQUAL", "HEX", "UNFLAWED", "JOYS", "VOID", "GNAWER", "SIDEWALK", "DUCT", "PEDAL"]
	}
},
{
	id: "62def0c7-58fc-4059-8126-ab3638e9dccd",
	dateId: "20280224",
	puzzle: {
		letters: "JBRCHIUPGATQDWXEMONKFLSVY",
		words: ["FELONS", "ITEMS", "QUITE", "WAX", "DOWNS", "JUDO", "HAWK", "VOLE", "BRUTE", "CAW", "GAWKY", "BURP"]
	}
},
{
	id: "fac3e82a-42d4-4b12-9733-24d10ba7d364",
	dateId: "20280225",
	puzzle: {
		letters: "FIYAXSGWUJOMQPTLRNEKHCVDB",
		words: ["FIGS", "MORN", "KEPT", "WAX", "CLOGS", "VEND", "JUTE", "QUAY", "BENCH"]
	}
},
{
	id: "691a9a90-62c1-406e-80bd-db28c26de866",
	dateId: "20280226",
	puzzle: {
		letters: "QUNYSRIXWEMKCJVTDPOHLAFGB",
		words: ["ADMIN", "COVES", "QUICK", "QUIRK", "HOCK", "BOG", "ADMIX", "OPAL", "ALT", "YEWS", "FOCI", "JOCK"]
	}
},
{
	id: "8bfae3a8-2449-4a22-b788-8d64b6aa829c",
	dateId: "20280227",
	puzzle: {
		letters: "VYJPQIEKUGDXTOBMCLRWNASHF",
		words: ["BOLTED", "BROKE", "IVY", "GOUT", "EXTOLS", "CLOUTED", "CLAN", "JUTE", "MALTED", "PUKE", "CLASH", "WROTE", "FROG", "QUOTED"]
	}
},
{
	id: "29971513-9981-44a1-a1a5-94c967340e5d",
	dateId: "20280228",
	puzzle: {
		letters: "QUJCKFDAERIXWOBNLPVHGTMYS",
		words: ["QUACK", "BOWLING", "FILMY", "JACK", "SHOWER", "GLINT", "BEADWORK", "HOAXING", "VOW", "POWER"]
	}
},
{
	id: "d889c561-4239-49c5-abc6-29ecc4ffd6ff",
	dateId: "20280229",
	puzzle: {
		letters: "CJSDYOMFNKXBHUQPVRAGEIWLT",
		words: ["VIRAL", "RIPE", "FUGAL", "IRAQ", "BRAWL", "COBRA", "JOB", "BOX", "BRAHMS", "FUNKY", "BRAT", "FUNDS"]
	}
},
{
	id: "71f37df2-8582-4aa9-a71b-ea477310c1f7",
	dateId: "20280301",
	puzzle: {
		letters: "TGBOFMRJULWAQHEKSPXNDICYV",
		words: ["RAPIDS", "RASPY", "MARQUE", "ENVY", "JOULE", "ASPIC", "GRAPH", "FLEX", "SWARM", "KIDS", "TRAPS", "BOLE"]
	}
},
{
	id: "1c166a64-90bc-41fb-b68a-9abc861ddcf8",
	dateId: "20280302",
	puzzle: {
		letters: "XFPGASEBMVWLDIQYJRKUOHNCT",
		words: ["AVIDLY", "BLEW", "JOHN", "GAMBLED", "CRIMPED", "FED", "TUCK", "QUIRK", "IBEX", "GAMBLES"]
	}
},
{
	id: "29c25f07-4a3f-4fb8-9472-3135cfaae5cc",
	dateId: "20280303",
	puzzle: {
		letters: "SWNGRVEDOHBYKFPLCIUQMATXJ",
		words: ["PHONED", "DONG", "VENDOR", "QUICKEN", "FIX", "LACKEY", "TICKED", "CALM", "PHONES", "BLACKEN", "JUICY", "DEWS"]
	}
},
{
	id: "322b5941-7d9c-48e2-b640-088e157d4be3",
	dateId: "20280304",
	puzzle: {
		letters: "BEYWPXSTOGNKDRJVACLMHQUIF",
		words: ["QUACKS", "WORLDS", "FLICKS", "BESTOW", "PORTS", "MICRO", "VANS", "SEX", "JOTS", "GODS", "JOYS", "HACKS"]
	}
},
{
	id: "a099a6f6-a428-4ef8-a52c-c8c96f805832",
	dateId: "20280305",
	puzzle: {
		letters: "YOBCLFVHKEWAJXNUSTIGDQPMR",
		words: ["PIXEL", "EXHAUSTING", "SQUAT", "VAST", "FASTING", "TINKLE", "AHOY", "MINKE", "JAWS", "CHATS", "DUSTING", "BOY", "ASTIR"]
	}
},
{
	id: "0701b677-0709-48f0-aa60-8bff2d172231",
	dateId: "20280306",
	puzzle: {
		letters: "JONSFQUTAVLXKMPGEBIRDCHWY",
		words: ["BIKE", "IBEX", "CHIRP", "CHIMP", "FAKED", "QUOTAS", "VAMP", "WIRY", "GLUON", "JUNTAS"]
	}
},
{
	id: "e7e59aca-1b13-4af8-a644-7b89cd7feab8",
	dateId: "20280307",
	puzzle: {
		letters: "NXSQHYLRIUVGMBETAKOCWFJDP",
		words: ["HUBRIS", "RISQUE", "GRIMLY", "COMA", "LYNX", "AMOK", "WAFT", "COD", "JAMB", "WAVY", "BOP"]
	}
},
{
	id: "34f52c72-057a-4d2a-9b03-5b6254d7b26e",
	dateId: "20280308",
	puzzle: {
		letters: "VKJBWREUIPMQTHSXYDAFCONGL",
		words: ["REQUITAL", "WISH", "FLASH", "CONGA", "JIHAD", "JERK", "MYNAHS", "REV", "ONYX", "BITER", "EQUIPS"]
	}
},
{
	id: "58265f03-b97e-4ef3-a71c-19d59975e5ad",
	dateId: "20280309",
	puzzle: {
		letters: "XGNSLIPVEOMJBFTKCUYDHQRAW",
		words: ["CUBES", "PIG", "SOFTEN", "LEFTY", "VETO", "FURY", "JURY", "QUAY", "BUCK", "WARY", "MIX", "DAUB", "ARCH"]
	}
},
{
	id: "01fa676f-aa0e-45bb-9f3a-306b8dffa569",
	dateId: "20280310",
	puzzle: {
		letters: "QJCXSRUTAFWNOYBGEKIHMPDLV",
		words: ["ABIDE", "LIKED", "HIDEOUT", "JUNTAS", "GENOA", "IDEM", "UNWED", "FACT", "SATURN", "PENT", "QUOTAS", "VIDEO", "LIBYA", "FAX"]
	}
},
{
	id: "ad792f4c-79c4-4330-9111-1ce49e3be223",
	dateId: "20280311",
	puzzle: {
		letters: "PEUKHBILQCRFNOGWATJVMSDYX",
		words: ["BELFAST", "FLOTSAM", "WAFTS", "QUIP", "FLOCK", "DANIEL", "LOCH", "GONADS", "VOLE", "FLINTY", "INFRA", "STYX", "JOCK"]
	}
},
{
	id: "8f0be7ed-55dc-40bb-9480-4eba6a17f216",
	dateId: "20280312",
	puzzle: {
		letters: "FVQBJNODUIYWXTLMSARCKPHEG",
		words: ["QUILT", "WASHER", "NYMPHS", "SAXONY", "BUILT", "GRAPHS", "FOX", "CRASH", "VOWS", "JILT", "DOWNY", "TASK"]
	}
},
{
	id: "cbaca08f-dd47-4a91-92eb-969b5e49a4b5",
	dateId: "20280313",
	puzzle: {
		letters: "HLYIBCOXNSTUMPGWEQAVFDKJR",
		words: ["QUOTED", "BING", "DEW", "CHOMPS", "JAG", "VAMPS", "KETCH", "FETCH", "CLOYING", "RAKED", "COXING"]
	}
},
{
	id: "89acd884-ac25-4fcc-a772-42e0c8d5c43c",
	dateId: "20280314",
	puzzle: {
		letters: "GPDFSKNICMVHUQRAJXOBTEWYL",
		words: ["CUING", "HATE", "JUNK", "BOXY", "WORMS", "BOUND", "PING", "QUID", "VAT", "FIND", "BLOW"]
	}
},
{
	id: "323d07d2-6bd7-45e1-8fc9-4b30c2e2ff64",
	dateId: "20280315",
	puzzle: {
		letters: "PYCGVQILWEFUMNXRADOBTSJKH",
		words: ["JARS", "CLIP", "BONDS", "FAMILY", "MODULI", "OXEN", "QUARTS", "NEWLY", "AMOK", "HOMILY", "VENDS", "GENOMIC"]
	}
},
{
	id: "1d6a8501-5a07-4603-804b-58511a508232",
	dateId: "20280316",
	puzzle: {
		letters: "GEWLHVUROPQFNBJIDYMAKCXST",
		words: ["GERUND", "BATS", "SYMBOL", "KID", "QUERN", "ONYX", "PHONY", "VERB", "MAJOR", "CYST", "FROND", "POWER"]
	}
},
{
	id: "d240cb4d-b38a-43fd-82d8-7f55dae34c95",
	dateId: "20280317",
	puzzle: {
		letters: "NRIMTGOHYKBXPUQFJAEDSLWCV",
		words: ["EQUALS", "WEAPON", "GRIMY", "BONG", "FLAWED", "JAWED", "TYPED", "CAPED", "EPHOR", "AUK", "AXON", "VEAL"]
	}
},
{
	id: "32b91eb3-90e1-4961-9766-e155165726a8",
	dateId: "20280318",
	puzzle: {
		letters: "XJSQLROGUCMPAFBNHKWTIEVYD",
		words: ["SQUAWK", "MORPHINE", "VEIN", "HAFT", "POX", "GAWKY", "BUGS", "DYKE", "CLUB", "JOGS"]
	}
},
{
	id: "1526d4b3-76e9-480b-accb-e9685be85a4a",
	dateId: "20280319",
	puzzle: {
		letters: "JGTHXORPIFWDVYCNKAMEQUSLB",
		words: ["WORTH", "ADVICE", "AMBLE", "QUALMS", "GROWN", "SUNDAY", "JOG", "PITH", "AUKS", "FIX"]
	}
},
{
	id: "59674e4d-8bae-4379-a038-f318cc6d3c64",
	dateId: "20280320",
	puzzle: {
		letters: "YPSHJITXEBQUDWNKCGFRVALOM",
		words: ["FROG", "ACQUITS", "NEXT", "JEST", "FLACK", "VACUITY", "BEST", "QUIPS", "FORM", "HEWN", "DUCK"]
	}
},
{
	id: "e92b5e7c-07bc-414f-a384-cffd5f89fb32",
	dateId: "20280321",
	puzzle: {
		letters: "GPBXHQITDEFUWLNVRJMKACYOS",
		words: ["FRUIT", "HELMS", "KNELT", "HELD", "RACY", "QUIP", "JOY", "BIG", "VARY", "NEXT", "TWIG"]
	}
},
{
	id: "2d71b67c-76ab-42ba-ab4e-825f139f79b5",
	dateId: "20280322",
	puzzle: {
		letters: "MOGCJXYBPASQUVWNRIEFKLTHD",
		words: ["THIEF", "BOGY", "QUIRK", "JAWED", "CAVED", "SQUIRTED", "QUILTED", "PAVED", "BOXY", "BURNS", "GYM"]
	}
},
{
	id: "9f142025-4613-4262-92b0-bf4b63965369",
	dateId: "20280323",
	puzzle: {
		letters: "MVXDOBEWFRJTNGHQUASYILKCP",
		words: ["SALUTE", "CYGNET", "QUACKS", "ORGANS", "LATEX", "ETUI", "BENGAL", "ANEW", "VENAL", "JUNTAS", "GNASH", "FORD", "GASP", "MENTAL"]
	}
},
{
	id: "535f41ed-1ef6-436c-88cc-c4682c589585",
	dateId: "20280324",
	puzzle: {
		letters: "MYXOPLCFNHBAGJUREKIQVWTSD",
		words: ["VERBAL", "BALMY", "QUIDS", "HUNGER", "CLARETS", "JUNO", "FOP", "WREAKS", "FOXY"]
	}
},
{
	id: "53d0ca28-f0de-4752-ae6e-c983435a953b",
	dateId: "20280325",
	puzzle: {
		letters: "OBGRDJHSNYVIUQPTMWKEXAFLC",
		words: ["HUNGRY", "JOBS", "FAMISH", "QUIT", "FLECK", "VIM", "SUNDRY", "WISH", "PECK", "FAX"]
	}
},
{
	id: "28730bfc-a0e0-46cb-8590-95c3460db5be",
	dateId: "20280326",
	puzzle: {
		letters: "CAKIVLXMBUETSQRDOGWPFNJHY",
		words: ["JOSTLED", "VIMS", "WHY", "BURP", "TONGS", "KALE", "SQUIB", "CLAMS", "FOGS", "EXALTS"]
	}
},
{
	id: "74053b72-fe61-48be-bd94-c97ecbbed7ff",
	dateId: "20280327",
	puzzle: {
		letters: "DGOTHJUREBQVNCWPASIMXYLKF",
		words: ["LANCET", "ERGOT", "PANICS", "MINCER", "MILKS", "BERTH", "JUNE", "LAX", "QUOTER", "SLAV", "DUNCE", "FINALS", "UNSCREW", "LYSINE"]
	}
},
{
	id: "6340a72d-fac6-4849-91fe-ce1f7a5b7c88",
	dateId: "20280328",
	puzzle: {
		letters: "XNGLODVYCKWITPHFRJSUMABQE",
		words: ["FARM", "JABS", "TYPHUS", "WITCH", "IVY", "LOCHS", "LYNX", "QUEST", "LOCK", "DIRTS", "GLYPHS"]
	}
},
{
	id: "3923138c-2572-48ce-95fc-6333a58825ed",
	dateId: "20280329",
	puzzle: {
		letters: "MKJBCNIWLXGDAUPSVFTQOYREH",
		words: ["CLAWING", "WADINGS", "MINDFUL", "PUTREFY", "BLAT", "OVATE", "KINDS", "JIGS", "LUX", "FATHER", "EQUAL"]
	}
},
{
	id: "061a310b-8706-41b7-b056-ba843b9fb8e5",
	dateId: "20280330",
	puzzle: {
		letters: "QXCHOUSNVJFAWIKPGTRMBEYDL",
		words: ["JINX", "SQUAT", "SWIRL", "BEGAT", "MINX", "JOHN", "FAWNS", "PAWNS", "WINCH", "VIM", "KINA", "SANITY", "DRY"]
	}
},
{
	id: "449a64b3-347c-41f4-88d2-5f9a7460e9d4",
	dateId: "20280331",
	puzzle: {
		letters: "GNFMXIYCAPWVEKDQUSJRHLBTO",
		words: ["FACES", "BLUEST", "KEYING", "GIVES", "HUBS", "FAX", "PACES", "WINCES", "JEST", "DACE", "MAESTRO", "QUEST"]
	}
},
{
	id: "d596b82c-9dc0-42ae-bb1a-2d2185bf233c",
	dateId: "20280401",
	puzzle: {
		letters: "KTCOWNABPSMEVDHXURLGQYJFI",
		words: ["JURY", "BOPS", "FREAK", "VEX", "OCTAVE", "KNAVERY", "DREAM", "GILDS", "QUERY", "BOWS", "POSH"]
	}
},
{
	id: "1199ea72-1fb2-428c-bee6-edd5fbdc6eb6",
	dateId: "20280402",
	puzzle: {
		letters: "TMENCSWRUHYXJVQKLODFGBIPA",
		words: ["BODILY", "NEWTS", "ADJURE", "GLIB", "BLIP", "ILK", "FAD", "MENU", "VOID", "QUENCH", "BOXY"]
	}
},
{
	id: "a0a25181-808f-4eff-88ca-5bf0e762b2a9",
	dateId: "20280403",
	puzzle: {
		letters: "KWHAFVEXIDCNLSQTBMUPGYJOR",
		words: ["OPULENT", "LIQUOR", "GYMS", "JUMBLE", "WHILE", "FAILS", "CENT", "VELUM", "AIDS", "KENT", "HELIX"]
	}
},
{
	id: "8f261a8a-81ec-43c9-b361-f1a34e938471",
	dateId: "20280404",
	puzzle: {
		letters: "GMIKLCYHEVDORQUFSPAXTNWJB",
		words: ["COST", "OPAQUE", "MIKE", "FOPS", "JARS", "BARE", "PARODY", "ELK", "KIEV", "HIKERS", "PRAWNS", "GYRO", "WAX"]
	}
},
{
	id: "4acf51f6-2423-4951-a07c-6546ad213da3",
	dateId: "20280405",
	puzzle: {
		letters: "WFUQYGACRBHKJMSOXEVNPDLIT",
		words: ["QUACKED", "KELVIN", "CURBS", "JACKED", "ACME", "POKED", "FAKED", "FURY", "TILDE", "EXPO", "HACKED", "WAKED", "HAG"]
	}
},
{
	id: "b86ed6ca-26ab-4371-ba69-a62482fe7ac4",
	dateId: "20280406",
	puzzle: {
		letters: "DCRMNWAHIKSJQTLEUPBOGXYVF",
		words: ["SEXY", "CHAD", "THAWS", "FOLK", "OBLIQUE", "JAWS", "CHARM", "GUY", "VOLT", "CHINK", "PUG"]
	}
},
{
	id: "d9b8aefd-dea6-42a6-8dcc-768f4551b164",
	dateId: "20280407",
	puzzle: {
		letters: "SGDWXCFLEQPIKURVBNOYHAMJT",
		words: ["MOULDER", "YOKED", "MANURED", "LUREX", "HANKER", "BANKED", "PINKED", "RELICS", "TORQUE", "VILER", "GLUED", "FLEW", "INJOKE"]
	}
},
{
	id: "d12029d2-8c00-4163-8bb6-9d9d649fb800",
	dateId: "20280408",
	puzzle: {
		letters: "GFNIXMRQUDKYETLAJHVBWPSCO",
		words: ["LUTHER", "COVER", "GREY", "DUX", "JERKY", "PAYER", "ETUI", "BLUER", "HERM", "QUERN", "SHYER", "FREUD", "JAW"]
	}
},
{
	id: "a00f0bae-5ccd-4c09-a662-5c19b11e3330",
	dateId: "20280409",
	puzzle: {
		letters: "XLVFGPOEIWJYMANDBRTUSKHCQ",
		words: ["EMBRYO", "JOVIAN", "PLEAT", "GIANT", "WARMTH", "QUAINT", "MARCH", "POX", "DYE", "QUARKS", "FEINT"]
	}
},
{
	id: "f87ca4db-0bda-4008-8e21-42d283aa0299",
	dateId: "20280410",
	puzzle: {
		letters: "GNJFTEVAOPQUBRHDLKXMSYCIW",
		words: ["EQUABLY", "FORMIC", "KRAFT", "BAUD", "MIX", "BRAVE", "WICK", "BUDS", "PROFANE", "ORANGE", "OHMIC", "BANJO"]
	}
},
{
	id: "cfe83d00-ca5b-43ae-ab4a-e5a1e89548b4",
	dateId: "20280411",
	puzzle: {
		letters: "GKDTLHNAVEWUJPBQORFCMSXIY",
		words: ["NAVEL", "AURIC", "ROUND", "MOUND", "SQUAT", "PRICY", "KNAVE", "JAPE", "HUNG", "FROWN", "BELT", "FIX"]
	}
},
{
	id: "a58039a1-c371-4c27-a180-3b52ad902800",
	dateId: "20280412",
	puzzle: {
		letters: "QUIENAMVTFRXJKHCBLOYSGPWD",
		words: ["SCRAM", "QUIET", "JOWL", "MAUVE", "BLOW", "MIEN", "POKY", "HOWDY", "GLOW", "MARX", "FEN"]
	}
},
{
	id: "89bd6b4d-771e-43a2-bc4c-f99306c91d33",
	dateId: "20280413",
	puzzle: {
		letters: "JLIPWQAKOBGUTXDFMREHSNCYV",
		words: ["QUAIL", "TERMS", "BOXED", "HERM", "TERNS", "GATED", "CREDO", "VERY", "FUGAL", "JAIL", "OPIATE", "BOW", "TALK"]
	}
},
{
	id: "b237c15b-4b9a-4c5f-9760-89421568e3c5",
	dateId: "20280414",
	puzzle: {
		letters: "BHQYJOXNUCVIGAFDWREPTKMSL",
		words: ["TWINGES", "BOXING", "DINARS", "HOB", "QUARK", "JUG", "FEARING", "CAPERING", "SMEARING", "ANGELS", "LEGACY", "VOID"]
	}
},
{
	id: "dbbd2488-2fff-45bc-94c1-34d8cb6cf438",
	dateId: "20280415",
	puzzle: {
		letters: "RBGDWSAVEMQUIXNJHTOFPYLCK",
		words: ["BRAVED", "TYPHUS", "MEGA", "CLONED", "JUT", "QUIT", "FOXED", "VIEW", "LOCK"]
	}
},
{
	id: "1f26f56e-6cd3-4460-bec3-259042da5bb2",
	dateId: "20280416",
	puzzle: {
		letters: "JWNEKCALDVXMFORBIHSGUQTYP",
		words: ["SPYHOLE", "VENDORS", "QUITS", "FAWNED", "KEN", "AMBIT", "LAXITY", "GOLDEN", "JAMB", "CANDLE"]
	}
},
{
	id: "278b8dd5-5731-489b-9e7c-f55ecbd2a746",
	dateId: "20280417",
	puzzle: {
		letters: "CAWMBRHJLEXPDOVIUNGSFQTKY",
		words: ["FUNKY", "CRAWL", "MELON", "DONUT", "ARCH", "DUX", "CAJOLE", "BELONGS", "NOVEL", "QUIP"]
	}
},
{
	id: "613cdc3a-5d71-4b0e-b3c1-512e47222cc2",
	dateId: "20280418",
	puzzle: {
		letters: "XPFHUKOVQIMLSYDERBAWGNCJT",
		words: ["SABRE", "CABLE", "FOX", "VOLE", "FOLK", "ACNE", "TABLE", "GERM", "POLE", "SQUID", "HID", "JABS", "BAWDY"]
	}
},
{
	id: "7e59cbc3-8fc4-4e5f-a2be-e1023a3e935a",
	dateId: "20280419",
	puzzle: {
		letters: "XHQPONUSRGDETIWLVMYBFJACK",
		words: ["SPORTED", "FLEMISH", "JAMES", "DUSTMEN", "PRIMACY", "OGRISH", "JACK", "BISTRO", "CAVED", "RISQUE", "WRITES", "DUX"]
	}
},
{
	id: "23ed6725-13e9-4354-8fd2-c3026b50dbe5",
	dateId: "20280420",
	puzzle: {
		letters: "OGVMKSAJIHQPRWLXUFNBDYTEC",
		words: ["SPURN", "ENWRAP", "JAG", "TURFY", "DUX", "CENT", "VIRAGO", "KILN", "PRIM", "IRAQ", "WHIM", "BENT"]
	}
},
{
	id: "48c1489d-606f-4423-babc-a9418855af57",
	dateId: "20280421",
	puzzle: {
		letters: "INXYQRWTOUGAVKCMJELDPBHFS",
		words: ["LEARNT", "HEAR", "YOKELS", "GRAVELS", "TWIN", "BEAM", "RAMP", "CLEAR", "JAMB", "QUOTA", "COX", "HELD", "CLEF"]
	}
},
{
	id: "206df6d6-6717-4eb0-98c4-258317c9cfe2",
	dateId: "20280422",
	puzzle: {
		letters: "POJDNFMKEAVIBQUTLSWXGCRYH",
		words: ["BLIMP", "BEAUX", "SQUAD", "WHYS", "LIKEN", "JOKED", "DEBIT", "FIBS", "CLIMBED", "VIM", "GLIB", "CRY"]
	}
},
{
	id: "19e5c726-3177-4f3c-a6ea-dc1a4aeebd02",
	dateId: "20280423",
	puzzle: {
		letters: "XFTMDVIQUHPLAWRCBKJEOGSNY",
		words: ["FIX", "CLAW", "QUAIL", "COBS", "BAUD", "HUM", "YENS", "WRENS", "VIAL", "PLAIT", "BOGS", "KALIF", "JABS"]
	}
},
{
	id: "f9cc129e-8ac9-434e-9766-957106d06c8a",
	dateId: "20280424",
	puzzle: {
		letters: "SPBLFDKOVIHERNXWUCJAQYGMT",
		words: ["INVOKER", "CERVIX", "DEWY", "FLOPS", "CURED", "QUERN", "ANVIL", "GUY", "MANOR", "JAM", "BLOKE", "TAXI", "HERON"]
	}
},
{
	id: "cf4acb30-3c02-4285-b8b1-03ee7412f340",
	dateId: "20280425",
	puzzle: {
		letters: "RWBTASOJYKFVQDPHUIECXNGML",
		words: ["ROVING", "CEDING", "FUNGI", "YAK", "TYPED", "CLEG", "BOWS", "HUGE", "MINX", "JOB", "QUID"]
	}
},
{
	id: "5e49faba-53a4-4718-b550-f0bd321b6128",
	dateId: "20280426",
	puzzle: {
		letters: "RDKWQMIAUHJLSBVGCTEXNOYFP",
		words: ["CLAUSE", "MISTY", "SEX", "HUBS", "NOTES", "PEST", "GLAD", "FEST", "QUAILS", "JILTS", "WADIS", "KILTS", "RIALTO", "VEST"]
	}
},
{
	id: "316f9438-0b36-4bff-baed-daf1f7bca1d4",
	dateId: "20280427",
	puzzle: {
		letters: "MKXBFISHOWJLVCRNEAYPTDGUQ",
		words: ["WOVEN", "BOX", "MISLEAD", "SHOVEL", "KILN", "SILAGE", "MISLAY", "QUAY", "PROVEN", "COVALENT", "FOCAL", "JET"]
	}
},
{
	id: "b4f7b59c-972f-43ac-8cdc-835c83b063d4",
	dateId: "20280428",
	puzzle: {
		letters: "RKAVLFEHYSNGDWXIUQOJPCTMB",
		words: ["REDUCING", "QUIP", "REDOX", "HEAVY", "TUNIC", "WODGE", "BODE", "FREAK", "BOWS", "SLY", "JOB", "MODE"]
	}
},
{
	id: "f66d6a98-bd4e-42a9-91f8-475b54cd0977",
	dateId: "20280429",
	puzzle: {
		letters: "XIJGYNFADLHRTVPUSKMOQEBWC",
		words: ["AVOW", "STRAIN", "COMBS", "COMPLY", "JARS", "INRUSH", "DARKEST", "JINX", "INFRA", "GAIN", "QUEST"]
	}
},
{
	id: "ae532894-5ffe-4d40-8078-b43b5c308f3a",
	dateId: "20280430",
	puzzle: {
		letters: "YBXCSRVEKAMDFPGWOQNTLJHUI",
		words: ["GAPED", "QUIT", "BECKS", "JOWL", "UNFED", "MODE", "APEX", "BEVY", "DRY", "HOWL"]
	}
},
{
	id: "64b0458f-b68e-4ae8-9530-ac9681494da1",
	dateId: "20280501",
	puzzle: {
		letters: "BMHRFNUOVEQDCSPJILGAKYTWX",
		words: ["MOVER", "SOUNDLY", "GASPER", "JILT", "KILT", "HOUND", "FEROCITY", "COMB", "AWLS", "LIQUOR", "WAX"]
	}
},
{
	id: "5dacaa41-38c1-4dd2-87c9-6b48ff659e40",
	dateId: "20280502",
	puzzle: {
		letters: "QHIKDWUMPECBNTGFYLAJVORXS",
		words: ["HIKED", "FORAGED", "HUMBLY", "VOLTAGE", "WHIM", "JARL", "SALTED", "HUMPED", "LAX", "CUB", "QUIP", "HUNTED"]
	}
},
{
	id: "f91454a0-cbde-456c-b691-4232e7d2725b",
	dateId: "20280503",
	puzzle: {
		letters: "XGQFBSUAERTNVHJDCOKLIPWYM",
		words: ["QUAVER", "JEANS", "MYOPIC", "FAUNS", "BEAUX", "BEAUTS", "LYONS", "OVERHAND", "KHANS", "GUANO", "SNOWY"]
	}
},
{
	id: "1d2ce19d-7782-4fbf-a8ac-31de20df434b",
	dateId: "20280504",
	puzzle: {
		letters: "KFXRPCOGMAWBSHLQEDTVUJNIY",
		words: ["GRAMS", "JEST", "QUEST", "DINTS", "VINES", "FOBS", "PALMS", "SOWED", "SOCK", "MALTY", "MARX", "HALTS"]
	}
},
{
	id: "71680096-d9a1-4ac4-ac64-e05c6d416eba",
	dateId: "20280505",
	puzzle: {
		letters: "VALERJCQUYPOGWBDFSIKTHNXM",
		words: ["POSH", "MINX", "LACQUER", "JOGS", "BUYER", "DOGS", "KIN", "SOFT", "VALUER", "SWIM"]
	}
},
{
	id: "2baedde2-1db8-402e-b539-8c53129e96bb",
	dateId: "20280506",
	puzzle: {
		letters: "BVRUHFEQYAGTLKPNDWIMOSJXC",
		words: ["DONG", "MILKY", "WILDS", "WIMPY", "FELT", "VELDT", "QUAY", "HAY", "BERYL", "JILT", "RELIC", "MIX"]
	}
},
{
	id: "7ec80f7d-9ace-4b1e-bc0b-374612731e97",
	dateId: "20280507",
	puzzle: {
		letters: "GHCKMALREVYUJNXTQBDFPIWOS",
		words: ["GLUT", "FOB", "MENDS", "JERK", "BURLY", "PITY", "CLAY", "LURCH", "LUREX", "ENDOW", "QUAY", "VENDS"]
	}
},
{
	id: "74ac45d6-5e9e-40de-857f-d47047cd6812",
	dateId: "20280508",
	puzzle: {
		letters: "HVQTLSYMUBEIXAJWNRODGCKPF",
		words: ["ROAMING", "PROXIES", "ADORING", "MAJOR", "SHYING", "VYING", "LUXOR", "QUARK", "BARING", "CRIES", "FOAMING", "ABUT", "SEWING"]
	}
},
{
	id: "8148b80c-a0db-4c1f-ba39-e3eddc388d67",
	dateId: "20280509",
	puzzle: {
		letters: "PLGJOEXNBMKCSIRDUWYFQHATV",
		words: ["EXCUSING", "SWAYING", "KELP", "VYING", "QUAYS", "BRING", "MINGLE", "JOBS", "FRYING", "DUCE", "NIFTY", "WHAT"]
	}
},
{
	id: "41188685-5e4e-41c9-bd07-6ac4b61c57fb",
	dateId: "20280510",
	puzzle: {
		letters: "OVIETSYQULWHFXJBRAMPKGCDN",
		words: ["SOVIET", "JUTE", "BRAG", "CRAMP", "WHARF", "WHYS", "SHARK", "AXLE", "DAMN", "QUIET"]
	}
},
{
	id: "5354b124-f92f-43d1-988b-e2069c701c53",
	dateId: "20280511",
	puzzle: {
		letters: "CODQLNHUWKSJGAIVXYRMTEBFP",
		words: ["COUGHS", "DOUGHS", "BRAWL", "VET", "MAYBE", "PRAM", "DWARF", "AIRY", "GAWK", "EXT", "CONS", "JUDO", "QUAY"]
	}
},
{
	id: "87b51da7-1887-4773-922e-27d275bfe1ea",
	dateId: "20280512",
	puzzle: {
		letters: "KUQSPBNAJCXYMRVITHELFOWGD",
		words: ["UNARMED", "BUNK", "THEMAS", "GERMANY", "JARL", "FIT", "ANYHOW", "SQUARED", "MARVEL", "CRANK", "FIX", "RASP"]
	}
},
{
	id: "3c7cee43-9111-40ab-9068-3642332394da",
	dateId: "20280513",
	puzzle: {
		letters: "QKGTHMUCVAJEDLPBROIWSNYFX",
		words: ["HALOED", "RECTAL", "TALCUM", "WILDER", "BECK", "FIX", "VALID", "HALONS", "DUG", "EDIFY", "PIONS", "QUERN", "JUDO"]
	}
},
{
	id: "f79232dd-2ba9-446b-a0da-22db7a2ce034",
	dateId: "20280514",
	puzzle: {
		letters: "QUAJOXWLSGCYVDHKITEFBNMRP",
		words: ["QUASHED", "INKY", "PERMIT", "GOSH", "JOGS", "BITER", "SALVED", "DERMIC", "FEDS", "WASHED", "LUX"]
	}
},
{
	id: "77667ed0-3f78-4e7c-a580-060bb6881ee4",
	dateId: "20280515",
	puzzle: {
		letters: "VWHTSOBINLKMRCUPXDAQFEJYG",
		words: ["WITH", "WOK", "GAULS", "VOMITS", "CRIMPED", "JAUNTS", "BRAY", "XRAY", "FED", "IRAQ"]
	}
},
{
	id: "e3386565-3108-4ed1-b7e5-9960bfaeba24",
	dateId: "20280516",
	puzzle: {
		letters: "MIPLQHVSCUXOGREJANKFDWBYT",
		words: ["BANKERS", "ULCERS", "HIPS", "VIM", "JOGS", "WAGON", "QUERN", "AGONY", "AXON", "FERNY", "TYKE", "GONAD"]
	}
},
{
	id: "d300f4ec-2d64-4d9d-99b4-947dfc4f7242",
	dateId: "20280517",
	puzzle: {
		letters: "HYJPRNEXOGWTCBSDMAFLQUVIK",
		words: ["MAILBOX", "BOGS", "PROJECT", "BAUD", "QUAILS", "FACET", "HEWN", "VAT", "PROXY", "ILK"]
	}
},
{
	id: "dc3004b1-fc45-4bd2-afad-c7095ade9401",
	dateId: "20280518",
	puzzle: {
		letters: "TNGQSKIUHCYXJRMBVFPEOWALD",
		words: ["SHRUNK", "SHRUG", "INURED", "AVOW", "CRUX", "FRUIT", "PALER", "MELD", "SQUINT", "JUNK", "CHUNKY", "BOW"]
	}
},
{
	id: "2946aef1-8cbe-48b5-86d0-2e82769f8f08",
	dateId: "20280519",
	puzzle: {
		letters: "NUDERQIFBTLKCMXAVSOGWPJHY",
		words: ["HOMBRE", "DEBT", "KALIF", "QUICK", "JOCK", "SOMBRE", "WALKS", "COY", "GOSH", "VALID", "NICKS", "COX", "LAPS"]
	}
},
{
	id: "e7b22324-f08f-4fee-9207-c2ab5c458046",
	dateId: "20280520",
	puzzle: {
		letters: "XBUQFGEDIJVLKNSCTRAMYWOHP",
		words: ["RANKLED", "VELD", "SNARLED", "WORKED", "CLEG", "PARTY", "DUEL", "JINKED", "QUID", "BELT", "HANDEL", "FIND", "INDEX", "MARKED"]
	}
},
{
	id: "2278dc39-fd2e-4c76-9f5d-6ae6f0b07ab5",
	dateId: "20280521",
	puzzle: {
		letters: "OWNUFDKQVACRPMYHEJBITSGXL",
		words: ["VAMPER", "DREGS", "DOWN", "LIBYA", "JERK", "FAUN", "CHEST", "MIX", "QUAY"]
	}
},
{
	id: "d3f0b8c7-8ef5-49f9-90a6-163b821ebcf4",
	dateId: "20280522",
	puzzle: {
		letters: "XRNGBKFAMEPSWOJYTUVHDIQLC",
		words: ["LUSTY", "QUID", "FRAME", "VOWS", "HOMAGE", "BEMOAN", "RASPY", "JOUST", "CHOW", "MARX", "MARKS"]
	}
},
{
	id: "20f7fec5-0504-4d7b-b9cf-0058e96eb714",
	dateId: "20280523",
	puzzle: {
		letters: "PFCJVXEWONHTGLIDUAYMQKSRB",
		words: ["SALON", "GYRATE", "COLAS", "SUGARY", "QUALM", "SKATE", "DUAL", "AGLOW", "LATHE", "PETAL", "FETAL", "BRAYS", "VOLGA", "JOIN", "LATEX"]
	}
},
{
	id: "5cc1b8f5-30c9-408d-b0b9-d7cbe0017439",
	dateId: "20280524",
	puzzle: {
		letters: "MWGIPVALQUREJKTCYSFXDNHOB",
		words: ["CRAVES", "SHYER", "HOSE", "WALES", "JAG", "SOFT", "BOX", "WALKS", "AGILER", "PILES", "QUIP", "DYER", "SYNC", "MARVEL"]
	}
},
{
	id: "ee4c6a28-a15d-4b28-8dcc-3886828ecb34",
	dateId: "20280525",
	puzzle: {
		letters: "TLAOFVMJBHPEUQNYRGDSCKXIW",
		words: ["JOHN", "DUMPER", "LAMPREY", "BUDS", "MALT", "JERKY", "WIG", "SIX", "FOAL", "QUERY", "VERY", "MERCY"]
	}
},
{
	id: "cb681a5a-a479-43ce-b19a-44ae949c86c7",
	dateId: "20280526",
	puzzle: {
		letters: "YSJVXQPIAFGUMKDNRLEBTOWCH",
		words: ["FAKED", "QUIPS", "TRUMPS", "VAMPS", "GROWLED", "BELONG", "BELCH", "CLUMPY", "FAX", "JADE"]
	}
},
{
	id: "fa172ede-25df-4156-9af5-e53c787d813f",
	dateId: "20280527",
	puzzle: {
		letters: "VDOLCKIPWSMRNHTFUEJAQXGBY",
		words: ["BEGUN", "OPINE", "QUERN", "BATHER", "FUG", "HEX", "CLOWN", "DINER", "JERKIN", "VINE", "MINER", "BATHS", "RUGBY"]
	}
},
{
	id: "81587e5d-52ad-43ca-a3ad-8214c1326f5c",
	dateId: "20280528",
	puzzle: {
		letters: "FTQWXLUSVARJEDNPOBMIYGCKH",
		words: ["IMBEDS", "FUSED", "BOGY", "INVADES", "FLUES", "WADES", "JEST", "COPY", "PROBED", "QUEST", "WAX", "KINDEST", "HIDES"]
	}
},
{
	id: "c926e8f8-ed69-46eb-865f-f0641e1a297e",
	dateId: "20280529",
	puzzle: {
		letters: "FXHQKREMUCPTLAJYOWINDGSVB",
		words: ["SOLER", "CAMELOT", "FELT", "BILE", "PODGY", "WAILER", "HEMAN", "QUACK", "HEX", "ANVIL", "JAILER"]
	}
},
{
	id: "df92dc1a-990b-4250-8e4f-d57344b9300c",
	dateId: "20280530",
	puzzle: {
		letters: "VKLGMJEBOQWRTUHIXPYCFDANS",
		words: ["PUBERTY", "PUTRID", "RETOUCH", "MOTEL", "PANSY", "QUOTER", "KERB", "BLEW", "GOBLET", "FIRE", "FIX", "JET", "VERB"]
	}
},
{
	id: "9b191fb7-1c09-40d9-852d-1b1d241a08ea",
	dateId: "20280531",
	puzzle: {
		letters: "CSYLTAKVMFOUQEWJBXHNRIGPD",
		words: ["QUACKS", "BIJOUX", "FLY", "BRIG", "HEWN", "PHEW", "VEND", "MEND", "HEFT"]
	}
},
{
	id: "1aeb5996-3bc9-4142-8f5a-fe70b54be4fc",
	dateId: "20280601",
	puzzle: {
		letters: "HYSODBPEJTQUMRGFIXANWLKVC",
		words: ["CAMPER", "QUERN", "VAMPER", "JOSEPH", "LIMEYS", "GAMES", "MIXUPS", "MILK", "WIMPY", "DOER", "BUMPER", "FUMES", "TRAMPS"]
	}
},
{
	id: "a1210d09-edaa-48de-b2a6-39f18d0d6a9b",
	dateId: "20280602",
	puzzle: {
		letters: "PIMQKHYUSANXVBGCOREFDWTLJ",
		words: ["SUBVERT", "QUIP", "BASK", "ONYX", "DOVER", "COVERT", "FELT", "USAGE", "BUMS", "WROTE", "JET", "HIM"]
	}
},
{
	id: "e145e82a-281d-4d5e-b9a8-6e7e406bd68a",
	dateId: "20280603",
	puzzle: {
		letters: "MJOHRILWDCNASBYFUXEVQPKGT",
		words: ["SEXUAL", "INLAWS", "HOWDY", "BEVY", "BEG", "RHO", "INFUSE", "PUKE", "MILAN", "JOWLS", "CHOW", "QUAILS", "TEXAN"]
	}
},
{
	id: "68996de1-dc5a-4249-bbc7-7d4fa5a7d4ca",
	dateId: "20280604",
	puzzle: {
		letters: "NBMOGUEWSLQRIFKTYVACHPJXD",
		words: ["GLOWER", "FAX", "ISOMER", "JACKS", "BERTH", "PYRE", "DAIRY", "NERVY", "QUERY"]
	}
},
{
	id: "fac8cf98-3103-43ee-93ea-5325f284fad7",
	dateId: "20280605",
	puzzle: {
		letters: "SCMVKUITOYQGLWRBAHEFDXPNJ",
		words: ["JEHAD", "QUILT", "AGILER", "VOLGA", "APERY", "FROLICS", "MOTILE", "WOK", "NEPAL", "RELAX", "BALTIC"]
	}
},
{
	id: "82935662-fffe-4c26-b5b9-7aababbe9fd4",
	dateId: "20280606",
	puzzle: {
		letters: "YNPQWXOKUILJGCRHBSEDAFTVM",
		words: ["PUREST", "QUICK", "REVS", "WIRED", "ONYX", "STEM", "JOGS", "LOGS", "AFTER", "HAFTS", "BAH"]
	}
},
{
	id: "f517bedc-5285-4de6-8802-49aa468f1d76",
	dateId: "20280607",
	puzzle: {
		letters: "HITOPNUJRCXQGYKFBSEWADLMV",
		words: ["JOCKEYS", "JINX", "JUGS", "HUGE", "FABLES", "PORT", "VELD", "ELMS", "WELDS", "QUIT"]
	}
},
{
	id: "e89ec74f-55e5-488a-970f-57d4fb42800b",
	dateId: "20280608",
	puzzle: {
		letters: "TKOFGHSMNWLUQADYVBRJEXICP",
		words: ["DRIVE", "BUST", "AMONG", "JAMS", "FOND", "VEX", "CRAMS", "HUMAN", "PRAMS", "AMOK", "PRIVY", "ONWARD", "IRAQ", "LUSH"]
	}
},
{
	id: "2d97f5c9-6ea0-44e8-a0ff-5f5f5599efb9",
	dateId: "20280609",
	puzzle: {
		letters: "VIJMQLSXUDCREWTGONYABKHPF",
		words: ["HORSEY", "SCREWY", "PAYERS", "CONK", "QUERN", "DUES", "FAWN", "TAWNY", "VIXEN", "MUESLI", "BONEY", "JUT", "GOERS"]
	}
},
{
	id: "e0542fe6-2d3e-4838-9588-857a722e5d09",
	dateId: "20280610",
	puzzle: {
		letters: "HNPIVCOMWKUQGERBAJXLTSYDF",
		words: ["FLEW", "VIM", "STAGER", "POUCH", "LEMON", "JERK", "QUAYS", "CUBS", "MELD", "FLEX"]
	}
},
{
	id: "15da5a13-11f8-4abb-b1b3-6908dcf757c4",
	dateId: "20280611",
	puzzle: {
		letters: "BLQYJODMUARSVPTNECGIWHXKF",
		words: ["JUMP", "HECK", "FIG", "RESOLD", "QUAY", "CHEW", "CENSOR", "REVS", "HEX", "BORES", "SMUT"]
	}
},
{
	id: "cff0557d-8fc4-4793-bd37-5251048675ae",
	dateId: "20280612",
	puzzle: {
		letters: "GYMPXHKVIUTDSQRNOBLJFECWA",
		words: ["JAWBONE", "BOTHY", "MIXUP", "CENT", "IVY", "BONDS", "FENDS", "PURLS", "RISKY", "QUIP", "GYM"]
	}
},
{
	id: "7933e90e-6474-4135-a20b-34bbfedc7ddb",
	dateId: "20280613",
	puzzle: {
		letters: "GWKMEXORDNJYBQSFCVUIHATPL",
		words: ["CHAT", "WORKMEN", "BOXY", "FJORDS", "TULIP", "VAT", "QUIP", "GORY"]
	}
},
{
	id: "5c26468a-1d7a-4017-97fb-f7526b22c737",
	dateId: "20280614",
	puzzle: {
		letters: "TSIRWBKXHFCAYDMPJULGNOQEV",
		words: ["FRISKY", "GLUON", "JOULE", "BACKS", "QUACKS", "PACKS", "ELM", "AXIS", "WHISKY", "JUDGE", "VELD", "WHIST"]
	}
},
{
	id: "406eeda7-c03b-46e5-bf1b-f11699e89a00",
	dateId: "20280615",
	puzzle: {
		letters: "IGQKBTLXUCMDAVFHRNOSEWYPJ",
		words: ["ANDREW", "QUALM", "OVARY", "BUCK", "GILT", "JOY", "HERALD", "FOPS", "LAX"]
	}
},
{
	id: "8d848460-26ab-4e56-9353-3c01a9ab4cbf",
	dateId: "20280616",
	puzzle: {
		letters: "DNKVWPEXTOQSFAMGUYJRBIHCL",
		words: ["CRAFT", "SQUIB", "JARL", "KEN", "CHUGS", "VOW", "SPEND", "BUSY", "MARCH", "FAXED"]
	}
},
{
	id: "88e73210-4c61-46a6-b18e-ed2d2169f82e",
	dateId: "20280617",
	puzzle: {
		letters: "MJUITOWQSHKBGVDFANYLRCXEP",
		words: ["HITS", "LYNX", "ENVY", "YELP", "CRAGS", "MOB", "JUST", "DYNE", "WOK", "FANGS", "QUITS"]
	}
},
{
	id: "b47f5261-9079-47b5-8315-eb1346feaea2",
	dateId: "20280618",
	puzzle: {
		letters: "KWLOCFADNMYJTGPVUSEHQIRBX",
		words: ["CONTUSE", "LATEX", "HERBS", "ADJUSTER", "MONGERS", "VIRUS", "PETAL", "QUIRE", "WATERS", "FATES", "YAK"]
	}
},
{
	id: "dc7aaff4-c209-4dd3-a13d-54af3d3b8498",
	dateId: "20280619",
	puzzle: {
		letters: "MRBLXGPAEVWOQJFHSNUICKTDY",
		words: ["VEX", "STUDY", "HONKS", "CHOP", "JARGONS", "SQUID", "FEAR", "ARM", "LARGO", "KNOWS", "BEAR"]
	}
},
{
	id: "27c0741d-1e05-492d-a180-96c4b47d2e65",
	dateId: "20280620",
	puzzle: {
		letters: "QVWCXUITSOPGMLHYBDEFKRAJN",
		words: ["EMBARK", "HOLED", "ADMITS", "QUITS", "PITS", "JADE", "EDGY", "COLTS", "COX", "NEARBY", "SHELF", "VIMS", "SWIM"]
	}
},
{
	id: "40d5c298-08a3-4a38-9f21-1cfa04b5c7f6",
	dateId: "20280621",
	puzzle: {
		letters: "XOPDBNYREHGJCVWKAMUQSFTIL",
		words: ["GAMUT", "PRONG", "JAG", "SACRED", "CASK", "VERY", "QUIT", "CREW", "LUCRE", "BED", "HERON", "DECAF", "EPOXY"]
	}
},
{
	id: "c1b90a11-e251-4ddd-ab09-7e9496ee71ce",
	dateId: "20280622",
	puzzle: {
		letters: "WDPQJKHEXUMLVTOACFIYBGRNS",
		words: ["CALVIN", "DETOX", "SIFTED", "WHELK", "BALM", "QUOINS", "LEVITY", "RIFLED", "GRINS", "PELVIS", "JUTE"]
	}
},
{
	id: "62d480c7-6c58-4ca0-9067-6174d690b35f",
	dateId: "20280623",
	puzzle: {
		letters: "HUQOJNSIWLBDYXGVAKRFMCTEP",
		words: ["PERKY", "BACKER", "QUIDS", "LOWISH", "CATER", "SUNDAY", "GLOW", "FRET", "SIX", "JOWL", "VAT", "MAKER"]
	}
},
{
	id: "1d6e5f9f-3047-4805-bc5a-dd177c4b53d1",
	dateId: "20280624",
	puzzle: {
		letters: "YTBJCMESGUKLHRQVPFAINOWXD",
		words: ["RADIX", "JUGS", "SHAW", "NOW", "IRAQ", "KELP", "YELP", "AHEM", "CURIA", "VOW", "BEST", "FAIRS"]
	}
},
{
	id: "e5833a55-d601-4ed8-a8a0-2bbc181f06ab",
	dateId: "20280625",
	puzzle: {
		letters: "WGKEFTOLSRVHDJUPIYAQCXMBN",
		words: ["GOTHIC", "JAMB", "PIVOT", "IDLERS", "WODAN", "TODAY", "REFS", "ELKS", "ADJURE", "QUAY", "MIX"]
	}
},
{
	id: "29e74612-64bf-4dea-8f70-f684bf681348",
	dateId: "20280626",
	puzzle: {
		letters: "YFJRVSOBPAGWTIMEHLUKXCNQD",
		words: ["JOGS", "CHEWS", "BOYS", "MULCH", "DUNCE", "BRAIL", "LITHE", "QUILT", "CLUMP", "FOGS", "KILN", "VAMP", "HEX"]
	}
},
{
	id: "fb0591e6-e8cc-4825-918c-789f13fe7c74",
	dateId: "20280627",
	puzzle: {
		letters: "SYCRPTHKGIWLFBUDONQAVMJEX",
		words: ["ENFOLD", "QUIRKY", "AXE", "VOLTS", "JOLTS", "FLOW", "GRIP", "MOLTS", "BIRCH"]
	}
},
{
	id: "e535cf88-e9f8-4ca3-853b-0720a6b8b0b7",
	dateId: "20280628",
	puzzle: {
		letters: "QUGDBRITSELACJNPYMOWHFKXV",
		words: ["BESTIAL", "EDGILY", "PLAITS", "OWNED", "PHYLA", "AMOK", "COMFY", "QUITS", "VOCAL", "COX", "SCARILY", "JEST"]
	}
},
{
	id: "d4fe5103-bcb9-44bf-8f3c-03a75a914fc6",
	dateId: "20280629",
	puzzle: {
		letters: "RHBQUPIGACTMFKLEYNOWDXVJS",
		words: ["KNOWS", "FOLK", "PRIMED", "NYMPH", "VOWS", "BACK", "JOWL", "QUACK", "EMPTY", "PRIG", "ONYX"]
	}
},
{
	id: "69aa82c3-1a63-47df-9569-70f695f5e475",
	dateId: "20280630",
	puzzle: {
		letters: "XQFGLARUIDWSJBTCOVYPMHKEN",
		words: ["BUILD", "JOKEY", "QUID", "FRUITY", "CHOKE", "COVEN", "SUBTYPE", "GUILD", "AWOKEN", "MOVE", "WAX"]
	}
},
{
	id: "776c3c9c-e602-4e84-986b-545fb3242cd4",
	dateId: "20280701",
	puzzle: {
		letters: "BXLSVGUQMICEDOWJRKHTYFPNA",
		words: ["IOTA", "PHANTOMS", "HANKER", "BUD", "QUERY", "FREUD", "JERK", "CREDO", "LUCRE", "DUX", "SLUG", "DHOW", "VIMS"]
	}
},
{
	id: "dde2c25f-c0be-4b87-88ef-3804df8fc083",
	dateId: "20280702",
	puzzle: {
		letters: "VBGUQELHCIPNDKWAJXFTRMOYS",
		words: ["QUICK", "BLEND", "STYX", "CHUG", "VELD", "ENJOYS", "RAND", "MAPLE", "FOXY", "WICK"]
	}
},
{
	id: "57a2d4fc-8ca8-4137-9b5d-76d871dbf241",
	dateId: "20280703",
	puzzle: {
		letters: "VMBHWYANIFPQDSXLTUOKGECJR",
		words: ["CORKS", "GEL", "NAVY", "BANQUET", "MAPLE", "FINDS", "COX", "JUDO", "WINDSOR", "HINDU"]
	}
},
{
	id: "84eb31c9-5b0f-4559-847b-828239ddb903",
	dateId: "20280704",
	puzzle: {
		letters: "QGBOMUWVTDFIRSHJAPEYCLXKN",
		words: ["SPIRAL", "QUIPS", "FUG", "DOTS", "BOTHERS", "MOTHERS", "CAPERS", "WIPERS", "NEPAL", "KEYS", "FAIRSEX", "PIVOTS", "JAPES"]
	}
},
{
	id: "ede598d0-30ca-4436-8646-e7d38d2e767b",
	dateId: "20280705",
	puzzle: {
		letters: "HVDAMJTOCFENXRYULSIKGQPWB",
		words: ["CRISP", "CORKY", "CORSLET", "SIXTH", "MACRON", "RISQUE", "VOTE", "WIRY", "FRONT", "GLENS", "CRIB", "JET", "DOTE"]
	}
},
{
	id: "247b05fe-12d3-4d98-ad70-32f9cfcab81f",
	dateId: "20280706",
	puzzle: {
		letters: "MNKJYBUAVLQTSPHECRIDXFOGW",
		words: ["CRISPLY", "SPANK", "HIRSUTE", "CORTEX", "APHID", "JANUS", "FETUS", "CORGIS", "WISP", "BMUS", "QUASI", "VAPID"]
	}
},
{
	id: "1a6d85e8-ee0b-46e0-a925-6a619398dc53",
	dateId: "20280707",
	puzzle: {
		letters: "GMSJNLOHAWBTXCUVEDQYRFPIK",
		words: ["KID", "CHASM", "BOLTED", "FRET", "QUASH", "GLOBED", "TEXAS", "TEXAN", "WAXED", "TEPID", "SAUCY", "JAW", "VETO"]
	}
},
{
	id: "c3af5863-88b4-470b-b0e1-6d1da8408920",
	dateId: "20280708",
	puzzle: {
		letters: "WHLCYTXOPDSEBANUFKIJQMGVR",
		words: ["VIBES", "BAND", "BOXES", "WHOA", "COPY", "PAIR", "QUEST", "FEST", "CLOAK", "JAB", "GIBES", "MUSE"]
	}
},
{
	id: "eebcf0f6-27b0-4ca4-a99d-af1c80a8c2b3",
	dateId: "20280709",
	puzzle: {
		letters: "WTQSGNEJUMHVARKODBCFXPYIL",
		words: ["NEARBY", "BRAVO", "POX", "FLICK", "JACK", "ADVENT", "ARMS", "HEADY", "HEWN", "GUMS", "QUACK"]
	}
},
{
	id: "0ca247a2-917d-4b48-a5c2-e1f6136dcb99",
	dateId: "20280710",
	puzzle: {
		letters: "YFHDMJUXAGELQIWRVNOCKBPST",
		words: ["CONQUER", "MAGICS", "WAINSCOT", "JERK", "FUEL", "YULE", "VERB", "AXLE", "COPS", "HAD"]
	}
},
{
	id: "ea8b042b-8436-4de3-9cf9-de32cd1d6cee",
	dateId: "20280711",
	puzzle: {
		letters: "FYWECRXSPDKONLVGUQIMTJHAB",
		words: ["MILDEWS", "MINX", "JUNO", "SPEC", "VINO", "MILDEWY", "MAILS", "SOUK", "FROG", "SNOUT", "LIQUOR", "BAILS", "HAILS"]
	}
},
{
	id: "0a0da162-b6d4-4fb6-a4cf-10ad187dfc4d",
	dateId: "20280712",
	puzzle: {
		letters: "WIFLOXKPRYVENJAMTBQUCHSGD",
		words: ["ENROL", "FLORA", "BENT", "FRAUD", "JARL", "PIKE", "VENTS", "STEM", "FRAY", "KETCH", "FIX", "QUAY", "JUGS", "WIPE"]
	}
},
{
	id: "94afe95d-c69c-41e7-9f50-0e2b3b691b75",
	dateId: "20280713",
	puzzle: {
		letters: "LONIFGKRDXBJVEUPATWQCMSYH",
		words: ["DUETS", "WHYS", "LOGJAM", "CAVERN", "FIXED", "PASTED", "QUERN", "BASTED", "DRINK"]
	}
},
{
	id: "732c77c6-04a7-4dae-a120-fa2d4f147ac5",
	dateId: "20280714",
	puzzle: {
		letters: "MKNDSWEXCQHRIUFOVYGTJBLAP",
		words: ["LYRICS", "IVORY", "WHORE", "APT", "SQUIRE", "FUGAL", "MENDS", "KNEW", "VIXEN", "JOB"]
	}
},
{
	id: "c8d35b92-9ef9-431b-96e7-0ff664d55e41",
	dateId: "20280715",
	puzzle: {
		letters: "CNJUQKDAVHBFRSPGEOXTMYIWL",
		words: ["QUASH", "DRANK", "FOYERS", "WORST", "MEOW", "JARS", "VAST", "FOXIER", "BEG", "FRANC", "FOWL", "RASP"]
	}
},
{
	id: "ea4c8b11-673e-491c-a2d6-04022f110147",
	dateId: "20280716",
	puzzle: {
		letters: "SBFVMQUTAONDIJWYPXLECRGKH",
		words: ["MAID", "PILE", "FUTILE", "DUBS", "CRY", "VOWEL", "ELK", "HELIX", "SQUID", "FUND", "JAIL", "GLIA"]
	}
},
{
	id: "f6451e33-0bc5-4b95-9964-30ccfef3ed09",
	dateId: "20280717",
	puzzle: {
		letters: "KHRTPODBIYJWLUMFECQNVXGAS",
		words: ["JOWL", "BUILD", "VEGANS", "ACQUIT", "VELUM", "CLEF", "DHOW", "BLIP", "WOK", "ACUITY", "VEX", "SQUIRT"]
	}
},
{
	id: "b63dcdfc-7736-4b6c-b315-3685ebdfefb9",
	dateId: "20280718",
	puzzle: {
		letters: "YUQLGREAPTBJNXCOFDISWHMVK",
		words: ["BEAN", "MINER", "DHOW", "PLAQUE", "INFO", "PANICS", "AXIS", "KIDNEY", "JOB", "ALT", "GLAND", "VINE"]
	}
},
{
	id: "61742d6e-5070-4e4d-bce8-745018e89028",
	dateId: "20280719",
	puzzle: {
		letters: "VDCBLINXETQOSGAFUKMHRYJWP",
		words: ["BEAMS", "QUOINS", "BEGAT", "ONCE", "TAMP", "HATES", "JURY", "FOND", "YUKON", "BLEAT", "WHAM", "FOXES", "VINO"]
	}
},
{
	id: "d8983c94-8d58-4cb0-be34-5fdd219b8952",
	dateId: "20280720",
	puzzle: {
		letters: "TLVAQJBIWUDOMNPKCYGXEHFRS",
		words: ["COMBING", "QUAIL", "HYMN", "MINX", "COMINGS", "PUNY", "COKE", "WAVINGS", "JOCK", "MILT", "FRY", "DOINGS"]
	}
},
{
	id: "0ae2e5f9-384b-4c14-b467-82a5b092e7cf",
	dateId: "20280721",
	puzzle: {
		letters: "GONKHJBYCIPQDRVTUALFEMXWS",
		words: ["DRAWLS", "BONY", "BOG", "CHIRAL", "DUET", "VIRAL", "JOB", "KNOB", "FRAMEUP", "FLAX", "IRAQ"]
	}
},
{
	id: "3cf12fe8-42bc-4dfe-9ddf-bf2c92643612",
	dateId: "20280722",
	puzzle: {
		letters: "GHNMDWOXUQRBJAKTILPCYFVES",
		words: ["TRIFLES", "KALIF", "PLACES", "NOBLES", "AXON", "DUALITY", "QUALIFY", "JAPES", "CALVES", "JOHN", "GOBI", "ELBOW", "MUD"]
	}
},
{
	id: "6ee5d13b-7aa3-4929-a8c9-9db8c8888fff",
	dateId: "20280723",
	puzzle: {
		letters: "XGWPYCOMSILJKUQDARENBFVTH",
		words: ["JOKER", "EQUIPS", "DARKEN", "FRUMPY", "WOKEN", "VENTRAL", "CLOG", "HERALD", "BAKER", "COX"]
	}
},
{
	id: "9914df7a-d053-41fd-825c-ff9fcfe9572f",
	dateId: "20280724",
	puzzle: {
		letters: "CAXOUWITQBSHNJFYLDERGMPVK",
		words: ["GYM", "WHINED", "QUOTA", "FEND", "HINDER", "LYSINE", "JERK", "REPLY", "BOTHY", "SIXTH", "CINDER", "VEND"]
	}
},
{
	id: "a52b6089-0351-4da9-8f53-20d0bb12f02f",
	dateId: "20280725",
	puzzle: {
		letters: "XLGQPMIUVHYATFEJNSWKDBORC",
		words: ["JAIL", "GUANO", "MAUVE", "BONSAI", "XMAS", "HEFT", "LITANY", "STAND", "CRONY", "PHEW", "WORK", "QUAIL"]
	}
},
{
	id: "db921e7e-26d7-43df-ae32-06acb270bebb",
	dateId: "20280726",
	puzzle: {
		letters: "FPWDXIALOMQRYVCTUKNEJSHBG",
		words: ["WALRUS", "COVEN", "TRIPLY", "FAIRLY", "HURTS", "BEG", "PARKS", "COX", "JURY", "MOLAR", "IRAQ", "COLDWAR"]
	}
},
{
	id: "7400820d-f212-4142-8110-1df877a4ebc4",
	dateId: "20280727",
	puzzle: {
		letters: "TSYMHBEKUFCNQAPJILOGRDVXW",
		words: ["STENCIL", "KAOLIN", "POX", "GALOP", "FAKES", "WOLD", "QUAKES", "BEST", "JINKS", "VICES", "HUM", "ALDRIN", "DICEY"]
	}
},
{
	id: "c1757d89-6f5a-4336-900b-b10970bee97e",
	dateId: "20280728",
	puzzle: {
		letters: "QNBDKUFETSPILHAJCXRVOWYGM",
		words: ["LETHARGY", "BELTS", "VARY", "TASK", "COW", "HELIX", "GYRATED", "QUILTED", "UNFELT", "HARM", "PIETA", "JILTED"]
	}
},
{
	id: "baa92720-d204-44ad-a6c7-6c12cd907cc9",
	dateId: "20280729",
	puzzle: {
		letters: "KROYLBSMDAGXPWNQIFECUJHTV",
		words: ["HEFT", "QUIPS", "FIX", "LANCET", "VENDORS", "YORK", "SPEW", "FIGS", "MODAL", "JIGS", "ORBS"]
	}
},
{
	id: "bad3a574-6a0c-40fd-b4c6-9b14ef8d0be9",
	dateId: "20280730",
	puzzle: {
		letters: "YBMJHKROSXNWGFEATIQLVDCUP",
		words: ["TWIGS", "BROWN", "FLUID", "FLEX", "CUP", "ANTIC", "QUID", "AWRY", "JOGS", "DANK", "FORMS", "FLESH", "VAN"]
	}
},
{
	id: "bf4c80e3-b8a5-45ae-8a5c-2c3fb9291bdf",
	dateId: "20280731",
	puzzle: {
		letters: "BIXNFTDVUJPMERQASWCYGOKHL",
		words: ["BITMAP", "WRECKS", "DECRY", "QUERY", "CERVIX", "FURY", "JURY", "FUN", "GAMED", "LYRES", "SOWED", "WHY"]
	}
},
{
	id: "cf0587da-d01b-4579-8511-2201017347ea",
	dateId: "20280801",
	puzzle: {
		letters: "QLFAKUINSJPGTDEWYXVBRHCOM",
		words: ["DESK", "QUITS", "WHY", "COMBED", "VESTING", "JESTING", "FASTING", "BOXY", "WRY", "FLINTS", "LUPINS"]
	}
},
{
	id: "dfb0b16f-9867-42b2-b36d-a4761fdf522b",
	dateId: "20280802",
	puzzle: {
		letters: "GFBNVDAJOMXTRHWLEYQIPCUKS",
		words: ["WHISKY", "QUERY", "BARON", "AXLE", "JAB", "CUE", "VORTEX", "MORE", "PELT", "FARE", "GABON", "DARE"]
	}
},
{
	id: "4d4ffb27-74c8-41a7-ad59-4994ad215743",
	dateId: "20280803",
	puzzle: {
		letters: "HOFVMGQYIPRUTCSKANEBWJLDX",
		words: ["QUANTISED", "LATEX", "WALNUT", "LARGO", "BEND", "JAUNTED", "VICES", "QUARK", "LAUGH", "QUANTIFY", "PICTURAL", "MITES"]
	}
},
{
	id: "67cc501a-b5db-49a7-9363-d47eb9d5be2b",
	dateId: "20280804",
	puzzle: {
		letters: "FSJGBAYPOTLXMVHNUIRCQWDEK",
		words: ["GOTH", "CHOMPS", "WIDER", "CERVIX", "IRKED", "NUDE", "JOB", "ASYLUM", "FAX", "QUIRE"]
	}
},
{
	id: "e959f437-0db2-4a66-81dd-04f967c1ebee",
	dateId: "20280805",
	puzzle: {
		letters: "YWMVGHTCABERNIDKFPUJOSLQX",
		words: ["TREKS", "GAIN", "WHET", "BANTER", "ADJUNCT", "MANIC", "PUNTER", "INFLUX", "QUIPS", "INFO", "VAIN", "DAINTY"]
	}
},
{
	id: "31d58884-506f-485d-b16a-e291cdd1e8e2",
	dateId: "20280806",
	puzzle: {
		letters: "KGCPQVEDUXHJSNOWATIFLBYRM",
		words: ["QUOINS", "INDUSTRY", "INDUCES", "KEG", "BASTION", "MINX", "PUNTS", "VESTAL", "FONDEST", "HASNT", "BAWL", "JEST"]
	}
},
{
	id: "0268c1e2-9085-479d-b0a0-69481294618f",
	dateId: "20280807",
	puzzle: {
		letters: "BVLKMITJEQCASUGRDWHXPYNFO",
		words: ["FOX", "PRAWN", "TAWDRY", "DRASTIC", "JAWS", "HUSTLE", "GUEST", "KELTS", "QUEST", "MELTS", "VICAR", "BIAS"]
	}
},
{
	id: "e06abef3-1582-45ef-bdbe-c5524f7d66ed",
	dateId: "20280808",
	puzzle: {
		letters: "FXBAGORCNWEYVDLKSIUHTPMJQ",
		words: ["ACRES", "BANG", "BAWL", "FOREST", "MISERY", "HUMPS", "QUIPS", "KERB", "DUMPS", "FOX", "VIMS", "JUMPS"]
	}
},
{
	id: "b2913a73-3c02-4d06-a13d-cac4835ef7bc",
	dateId: "20280809",
	puzzle: {
		letters: "EJAWYTGCPKLBHNRVOSIQXFDUM",
		words: ["PRIMUS", "APHIDS", "BOLT", "QUIRKY", "BOX", "VOLGA", "GAWKY", "FOBS", "CAGE", "JAG", "DINKY"]
	}
},
{
	id: "cd7b1ec2-3ae8-421e-a12c-6396dee6041a",
	dateId: "20280810",
	puzzle: {
		letters: "TFSNCHLBODGYAKWXRJPMEVIUQ",
		words: ["BARIUM", "NOBLY", "UMPIRE", "QUIVER", "GLARE", "COBALT", "FLABS", "BOND", "OKAPI", "THY", "SNOW", "JABS", "XRAY"]
	}
},
{
	id: "b3299a91-0c03-431e-b961-c31236e25176",
	dateId: "20280811",
	puzzle: {
		letters: "DAXOKWNMQRGFUSLTIVEHBPYJC",
		words: ["JESUIT", "FUNGI", "MORSEL", "LEVY", "DAWN", "SQUIB", "MUSH", "QUIP", "SEC", "WAX", "AMOK"]
	}
},
{
	id: "f5519fcd-5b05-4500-89d3-2260970a6797",
	dateId: "20280812",
	puzzle: {
		letters: "WVPCGIYHMRSTLEDOFAUBXKNQJ",
		words: ["FAULTS", "CHEATS", "OSTLER", "DEATHLY", "PHYLA", "GREATLY", "QUALM", "DEBUNK", "WITHER", "VISTA", "FOX", "JULY"]
	}
},
{
	id: "d9f1a698-3e84-45cf-815b-a25e2f837948",
	dateId: "20280813",
	puzzle: {
		letters: "FLCTSBRUQPYODANKXVHIMEWJG",
		words: ["OUTSPAN", "BROKE", "JIHAD", "DROVE", "OUTCRY", "FLUOR", "WHAP", "BOXY", "MEW", "NIGH", "SQUAD"]
	}
},
{
	id: "686ce5f0-8732-430c-b540-62b579539690",
	dateId: "20280814",
	puzzle: {
		letters: "QIWGVUSBELDPRKXYHJATMONFC",
		words: ["SPUD", "VERBS", "JARS", "CARPS", "FAKERS", "SQUIB", "HOMY", "AXLE", "TAKERS", "BREWS", "BRAN", "BEG"]
	}
},
{
	id: "1c2abd0b-7b66-4229-9151-642793f2aa7e",
	dateId: "20280815",
	puzzle: {
		letters: "WBLKSPONXEJVAQDCYRUIMGTHF",
		words: ["QUART", "FURY", "RANKED", "GRAVY", "BLOW", "MYTH", "HIDES", "BOP", "JOB", "AXED", "CYAN"]
	}
},
{
	id: "3b6e2c6b-8761-427c-aef2-5d8a930d6b01",
	dateId: "20280816",
	puzzle: {
		letters: "AJOVXBTFEYWHKMUDNIQPCLSRG",
		words: ["JOEY", "FOE", "CLIQUEY", "PRIME", "THINK", "WHIM", "BATH", "VEX", "RISQUE", "GRIME", "GRIND"]
	}
},
{
	id: "2cac3f33-b5ce-40d4-a99c-8cee78d6086a",
	dateId: "20280817",
	puzzle: {
		letters: "YPROCKXJINEVBTFGSAUQHWLMD",
		words: ["SLAVE", "FIBULA", "COITAL", "SEXY", "PRINT", "BAWLS", "QUALM", "JOINT", "QUASH", "KEGS", "TALMUD"]
	}
},
{
	id: "9499fa18-b46c-4445-9381-c91eeba98415",
	dateId: "20280818",
	puzzle: {
		letters: "GFQBLAWCUEXVIDYTSRJOPKHMN",
		words: ["AVID", "JOYED", "FAX", "CIST", "WIDE", "BLUISH", "QUIRKS", "NODULE", "WAG", "WISP", "MODISH"]
	}
},
{
	id: "3df97a9c-a9c5-495a-90b3-d8ee474dceba",
	dateId: "20280819",
	puzzle: {
		letters: "OVTMQBLGUFYWEXHPRNADSJIKC",
		words: ["CAIRN", "JINX", "KNEAD", "FUEL", "HUGELY", "BLEAK", "SPREAD", "KNELT", "NEWLY", "GUM", "BOLE", "VOLE", "QUERN"]
	}
},
{
	id: "eb1f29fa-22c3-4e85-a037-d937ba79bdda",
	dateId: "20280820",
	puzzle: {
		letters: "DGMPYRTKUAWOQBJCISFXVNHLE",
		words: ["TWINS", "FLEX", "BUMPY", "GROINS", "CORD", "JABS", "AUK", "SHIN", "QUAY", "VISOR"]
	}
},
{
	id: "81f7442e-7cfa-42d2-abee-7fec26a10385",
	dateId: "20280821",
	puzzle: {
		letters: "WSMKGHYQANVULRTFEDOBCIXJP",
		words: ["GNARLED", "FIXEDLY", "FEDORA", "JOB", "PORTAL", "DRANK", "MARQUE", "VELAR", "SMART", "WHYS", "BODICE"]
	}
},
{
	id: "6a84a38a-028d-48e3-b204-bf1592896fc1",
	dateId: "20280822",
	puzzle: {
		letters: "KGWJHLRTIOABSMVUDFEPQNCXY",
		words: ["WIMPY", "DUNCES", "SEXY", "LAUDS", "GRABS", "QUARTS", "FEST", "HIVES", "QUARK", "VOMITS", "JIVES"]
	}
},
{
	id: "7dd4d322-03e6-4960-b270-07bb61508f22",
	dateId: "20280823",
	puzzle: {
		letters: "NTQVXCUKBOPADJWIYELSHMRGF",
		words: ["ERGS", "DAUNT", "PAYED", "BOWLDER", "AIMED", "REACT", "QUAY", "FLEA", "BOX", "VOWS", "LEAK", "JOWLS", "HIM"]
	}
},
{
	id: "0829cd5c-eab3-4147-ae29-4afb42f88184",
	dateId: "20280824",
	puzzle: {
		letters: "APYEDRUKSHQTVLNCOGXIWBMFJ",
		words: ["DESK", "COMB", "BOG", "QUARTO", "SHED", "JINX", "NILS", "PART", "KEYS", "WOMB", "FINS", "VOW"]
	}
},
{
	id: "09e9ab97-8c41-48fc-9a1f-034067348a1c",
	dateId: "20280825",
	puzzle: {
		letters: "VROWSETJGYHFXICPMANKDLBUQ",
		words: ["FANCY", "WORTH", "PLAIN", "JIGS", "QUALM", "VETO", "JINX", "BLANK", "BALD"]
	}
},
{
	id: "35c189e3-f9fc-47fc-9a6f-5a41651d455c",
	dateId: "20280826",
	puzzle: {
		letters: "VMRLPSAWEYTUQKFCOJIDGBHXN",
		words: ["QUOTAS", "BOUTS", "HIKER", "WARMS", "REPLY", "JINX", "FIND", "GOUT", "VAST", "HOCUS"]
	}
},
{
	id: "0dbefac7-a598-401d-915b-db3a950df510",
	dateId: "20280827",
	puzzle: {
		letters: "NPXUWRYQLATEJKVBCMOSIHDGF",
		words: ["FOGS", "DOGS", "WALKS", "RETCH", "BERN", "EQUAL", "PREY", "JOGS", "REMOVAL", "LUX", "HIC"]
	}
},
{
	id: "88650ebe-9063-4a06-aa2d-58a22496ed45",
	dateId: "20280828",
	puzzle: {
		letters: "VBSLWAIKRYMPUQCDNXOHEGFJT",
		words: ["SKIMP", "CRUX", "HOURLY", "VAMP", "TOURS", "FOUND", "RUNE", "WRUNG", "JOT", "BAP", "QUIP"]
	}
},
{
	id: "7e2547ff-baf7-4016-9b59-2875ff97934f",
	dateId: "20280829",
	puzzle: {
		letters: "PGLMTKREUQWNHABIDVSJCYXOF",
		words: ["JOSHUA", "LUMEN", "DINER", "WINK", "PRE", "TUBAS", "FOXY", "CINE", "QUASH", "HEAVY", "BULGE"]
	}
},
{
	id: "22ca1856-6a62-4709-a297-3b2d87e66f6d",
	dateId: "20280830",
	puzzle: {
		letters: "PMSOJVEHTRWFLQBNDKUAIYGCX",
		words: ["MELTS", "GULF", "JOSTLE", "BAULKY", "DWELT", "BUCKLES", "VELD", "IDLEST", "QUACK", "INFEST", "BROTHEL", "INFLUX", "PELTS"]
	}
},
{
	id: "191bbbe1-1d46-4578-82b4-83994db4a72d",
	dateId: "20280831",
	puzzle: {
		letters: "BDWCLXRAETGHUYNVIQKFSMJOP",
		words: ["JIHAD", "GRUEL", "DWELT", "KNEAD", "FOP", "BRACE", "XRAY", "SIGH", "QUAY", "VIMS"]
	}
},
{
	id: "99dd0681-2bf1-4489-94f7-0d30691fe214",
	dateId: "20280901",
	puzzle: {
		letters: "INDOJVSEXBYUGRFQPALMKWHCT",
		words: ["CHARM", "HALT", "FLAREUP", "VINEGAR", "GAWK", "BOXER", "ENVY", "QUALM", "JOB", "SUGARED"]
	}
},
{
	id: "10092049-f509-4fff-8459-911bafb1f89a",
	dateId: "20280902",
	puzzle: {
		letters: "VCRIBWEHLFPGDAUNOYQSXMJKT",
		words: ["BIRCHED", "AFIRE", "MYOPE", "ADLIB", "MONGER", "FLASK", "BLAST", "CHEW", "REDOX", "REV", "JOG", "FAUST", "SQUAD"]
	}
},
{
	id: "7c52fff0-fc1e-491a-a20e-1c2ed8de3c48",
	dateId: "20280903",
	puzzle: {
		letters: "TJKNGCFUIYWAQHSXLERDPVBOM",
		words: ["BOREAL", "WAFT", "HERM", "HELP", "FUNK", "RELAX", "SHYING", "EQUAL", "CALVE", "JUNK", "DOERS"]
	}
},
{
	id: "8b6d2c6e-9117-4ad3-8ed6-24a7b32f2fc7",
	dateId: "20280904",
	puzzle: {
		letters: "QDKYAPUBNCRTIJGFLHVMXESWO",
		words: ["MOVING", "LINKUP", "PURLING", "HEFTING", "CYAN", "FLESHING", "WHILES", "QUILT", "TUBING", "BUD", "JILT", "FLEX"]
	}
},
{
	id: "24b78d6e-f04b-4412-84ce-e1c5798c4e31",
	dateId: "20280905",
	puzzle: {
		letters: "SKVFEGAPTHBWMIQONDCUXRYLJ",
		words: ["BAWDY", "NORDIC", "QUITE", "ETHIC", "MASK", "FETID", "VAPID", "JUICY", "GABON", "LUCID", "LYNX"]
	}
},
{
	id: "8eb8bfc3-922e-4a7b-98e4-ac0caf8f6d10",
	dateId: "20280906",
	puzzle: {
		letters: "TGHXDSILRKPVAYBOMJUEFWNQC",
		words: ["DRAM", "OVARY", "QUARK", "EQUAL", "AVOW", "UNJAM", "LAMPS", "HIPS", "MARX", "BRAIL", "GIST", "FOPS", "CUBE"]
	}
},
{
	id: "965f00f7-c843-417d-a6b5-369aa0b7bf30",
	dateId: "20280907",
	puzzle: {
		letters: "BSYTDWOHIUKCVQXGRMLJEPFAN",
		words: ["GERMAN", "VOWS", "FLAN", "DUX", "PERCH", "SHOCK", "JAM", "QUID", "BOYS", "CHIT"]
	}
},
{
	id: "75b2159c-9945-44a1-92cd-259dee83a438",
	dateId: "20280908",
	puzzle: {
		letters: "XOBQGSTJUHFRIVCPEMKWLNDAY",
		words: ["PRIMED", "ADMITS", "LEFTS", "BUCK", "BOX", "WADERS", "CHUG", "QUIRE", "DAY", "FRIEND", "JOTS", "VIED"]
	}
},
{
	id: "3a50e7a4-a866-46f9-ab81-d71783c1da3a",
	dateId: "20280909",
	puzzle: {
		letters: "WPGIDQRKVCYUJENLXATHBFMSO",
		words: ["JETSAM", "FLUKE", "ETHOS", "FLUX", "CENTAUR", "BLUR", "GIVEN", "DICE", "JULY", "PRY", "QUASH", "WRY"]
	}
},
{
	id: "4beb4f20-d59d-4ff9-bd03-47bd40c65b94",
	dateId: "20280910",
	puzzle: {
		letters: "HOXCVFBTENQDGSIUAJMRYPWLK",
		words: ["INVEST", "GAUD", "HOB", "QUAY", "WAGES", "INCEST", "BOXES", "PAGES", "JAG", "RINSE", "SMIRK", "YAWL", "FOXES"]
	}
},
{
	id: "f9ab8eba-63f8-437f-83ef-44163ae30d66",
	dateId: "20280911",
	puzzle: {
		letters: "QAKBOLUNETWFVSPCRIMYDHXJG",
		words: ["BESMIRCH", "FLUKES", "WRIST", "QUAKES", "STOEP", "GYMS", "CHRISTEN", "UNFIX", "JIVES", "DRIVEN"]
	}
},
{
	id: "91bb6ac1-4ff6-4b80-a3d6-43731421a71f",
	dateId: "20280912",
	puzzle: {
		letters: "DNCMXKEYORTSHIFVAWUPBJQGL",
		words: ["COX", "GULP", "BASHED", "FIRM", "HASTEN", "DECOYS", "BASKED", "VASE", "JAWS", "QUIP"]
	}
},
{
	id: "81a3bac7-adea-46bf-be62-6dd207cd9156",
	dateId: "20280913",
	puzzle: {
		letters: "XDPBVOCRAGKQSFHEUYINJMLTW",
		words: ["BASIFY", "SCRAP", "VARSITY", "BASQUE", "JULY", "COKE", "COX", "GASIFY", "TWIN", "ASYLUM", "HARD"]
	}
},
{
	id: "c3745cb9-b297-40d1-b6b1-fa3bb155f90f",
	dateId: "20280914",
	puzzle: {
		letters: "VETPKIBNYOQUWHJRFSMCGDALX",
		words: ["QUIET", "WHOP", "BUSHY", "XMAS", "VENUS", "GRUNT", "POKY", "CLAD", "FADS", "JOHN"]
	}
},
{
	id: "52bc9480-db78-444d-a7ef-13b573ad66d3",
	dateId: "20280915",
	puzzle: {
		letters: "FNKERBIPLYXHJQVGATOUSCWDM",
		words: ["SCAT", "THINKER", "THAW", "REPLY", "ATOM", "HAGS", "TAXI", "BIJOU", "QUOTAS", "DOT", "OVUM", "FIB"]
	}
},
{
	id: "5bb70a59-3fe1-4245-a0a1-23018dbeb251",
	dateId: "20280916",
	puzzle: {
		letters: "BJLIVMROXDFNYPKUAGWEQSHCT",
		words: ["KETCH", "NORM", "LID", "GNASH", "QUASH", "FANGS", "VIOL", "EPOXY", "JONAH", "PEW", "BROIL"]
	}
},
{
	id: "f48c7428-15b3-4863-b150-b750089dbe2d",
	dateId: "20280917",
	puzzle: {
		letters: "PXDFQLJOUESIWBYVNARMTHCGK",
		words: ["FOILS", "BRANCH", "FEUD", "GRAILS", "ANVILS", "DOWNS", "BARK", "BOX", "PLIANT", "CHARY", "CHARM", "QUOINS", "JOINS"]
	}
},
{
	id: "7fadd229-8af0-4395-aed0-ec7c791498eb",
	dateId: "20280918",
	puzzle: {
		letters: "MOQKGPDIUJXAYSWCLVHRFTNEB",
		words: ["CLAYS", "CAVERS", "GUSHER", "FLAX", "QUID", "MODISH", "BENT", "WHEN", "KID", "JUG", "PODIA"]
	}
},
{
	id: "163395f3-a368-41dc-9267-532b59c71159",
	dateId: "20280919",
	puzzle: {
		letters: "WHCGSKIUQTLMDRYVAXNFJOPBE",
		words: ["WHIM", "CHUGS", "OXALIC", "FEND", "DRY", "HURTS", "JAM", "BEND", "MILK", "VALID", "OPAL", "SQUID"]
	}
},
{
	id: "b9df71c6-a9e6-45a0-bdbd-e42989834b72",
	dateId: "20280920",
	puzzle: {
		letters: "BFGKQIRLUJSWVODXETYNACHPM",
		words: ["NYMPH", "NOTCHES", "EXACT", "FIRS", "BISECT", "QUOTES", "JUDO", "GLOVES", "YOLK", "CHEWS"]
	}
},
{
	id: "bbfc2935-a4bd-4cfb-9d10-545b1a56873d",
	dateId: "20280921",
	puzzle: {
		letters: "VWYDBMILRJXTHGACONKUPSFEQ",
		words: ["FOXILY", "DRAUGHT", "BRAKE", "WILD", "GLIM", "JARL", "TONGUE", "VIM", "CONGA", "COPS", "QUAKE"]
	}
},
{
	id: "cdac4ed6-e900-43ff-bb61-c42cbc1d57a9",
	dateId: "20280922",
	puzzle: {
		letters: "XPTYCORJFLKGEUNHVQWMDISAB",
		words: ["JERK", "ERGO", "CLUE", "HIVE", "DIVERT", "BASQUE", "TREWS", "MASQUE", "PORE", "POX", "JULY", "NUMB", "FLUE"]
	}
},
{
	id: "d247c152-c9a9-4afd-b2d9-51f0edc4637c",
	dateId: "20280923",
	puzzle: {
		letters: "PFGOWEKVBSRNTXHALIUYDJMCQ",
		words: ["MINERAL", "PENAL", "GOSH", "VOWS", "QUILT", "ICY", "DARKEN", "FERAL", "MIX", "BOWS", "JARL"]
	}
},
{
	id: "dedc4a71-bc7d-49d7-9b50-1eca7629cf04",
	dateId: "20280924",
	puzzle: {
		letters: "CVMJQSOLAUINDEBRTFXPGKYHW",
		words: ["BEDLAM", "WHY", "GRIND", "CODEX", "FELONS", "LEFTY", "JADE", "QUALM", "PEDAL", "IRK", "VOLE"]
	}
},
{
	id: "63a03eba-dd6e-44c1-b86d-25a8efaa70e3",
	dateId: "20280925",
	puzzle: {
		letters: "NWKSTARIEDQLXHBFUVOCYGMPJ",
		words: ["OVULAR", "WARIEST", "GUY", "CHIRAL", "FLUXES", "FLAN", "CHOMP", "LISTED", "BOXED", "WARLIKE", "JOB", "IRAQ"]
	}
},
{
	id: "6b1a75da-19b8-470e-9c9f-fe2302b88989",
	dateId: "20280926",
	puzzle: {
		letters: "HFXENJOSKWTCVDBMUPARQYILG",
		words: ["PADS", "COXES", "BRAVO", "SCOT", "GRAIL", "KNEW", "YIP", "OVUM", "JOT", "QUIP", "HOSE", "FOXES"]
	}
},
{
	id: "003edaf0-24c3-4610-83e3-fed066532efe",
	dateId: "20280927",
	puzzle: {
		letters: "DAPOMTYWFVNGSEKBUIRXQHCJL",
		words: ["CHIEFS", "BUSIER", "POWERS", "JIGS", "DAYS", "QUIRE", "GIRL", "HUNT", "MOVERS", "SEX", "QUIRK"]
	}
},
{
	id: "62842140-eee6-4554-8910-dd36a41a0ed4",
	dateId: "20280928",
	puzzle: {
		letters: "KIWOGNYTMLCURJDQEFAPXVSBH",
		words: ["WINCES", "BASER", "FUNKY", "HARES", "QUERY", "SEX", "JABS", "FARM", "PARES", "GLOW", "DARES", "REVS", "TRUCES"]
	}
},
{
	id: "6fb1aac1-9c8c-4a8c-8388-88599c5b17f4",
	dateId: "20280929",
	puzzle: {
		letters: "TKHOVQLJEXMUAWSDRYGNPBCFI",
		words: ["CRAGS", "MURAL", "HOES", "WEARY", "HOVE", "FIGS", "JAWS", "WALK", "BRAGS", "PRAWNS", "ALT", "HEX", "INWARD", "QUALM"]
	}
},
{
	id: "6e943518-01b2-48b8-b458-3983ce33ee37",
	dateId: "20280930",
	puzzle: {
		letters: "STXYWMEQADHUVPFLOJGIRKCNB",
		words: ["APING", "VOLUMES", "ROVES", "FAXES", "COVETS", "QUEST", "WAVES", "SEXY", "JOCK", "HEMS", "DAY", "BING"]
	}
},
{
	id: "61aeef4d-ac0d-4e81-9931-ae427f858348",
	dateId: "20281001",
	puzzle: {
		letters: "FWAMRXONUHBKJQDVEGSYLICTP",
		words: ["HUMAN", "EVICTS", "AWOKE", "SPY", "ICEBOX", "SQUAW", "JOKE", "FOAM", "MUDS", "EVIL", "RUM", "BEGS"]
	}
},
{
	id: "94270df5-531e-4c26-b6d6-efa47935f874",
	dateId: "20281002",
	puzzle: {
		letters: "VDKMLGIXOJSFTACBEWYUPHNQR",
		words: ["TAWNY", "FIXATES", "PHEW", "VISE", "BEFIT", "KITES", "FETID", "QUAY", "CUR", "LOCATES", "MOTIFS", "DIGS", "JAW"]
	}
},
{
	id: "6b51f6b5-5e8f-47f5-a169-8bf4c23412d7",
	dateId: "20281003",
	puzzle: {
		letters: "KJCSYWAHNEPTOGLQUVXFDBMRI",
		words: ["PATHOGENS", "ACNE", "QUOTA", "HAWK", "MUONS", "FIX", "JAW", "OVUM", "DUMB", "RIFLES", "HONEY"]
	}
},
{
	id: "ee8c74d0-56ba-43b0-b3f0-c1bd1607f9e7",
	dateId: "20281004",
	puzzle: {
		letters: "NKSFGXICAMYPVRHDWUQJBETLO",
		words: ["PINKS", "VICAR", "JOLTED", "DEWY", "HACKS", "MARQUE", "SIX", "FARM", "BED", "CRAG"]
	}
},
{
	id: "13597cd2-db87-4f67-849c-77bc825caf0a",
	dateId: "20281005",
	puzzle: {
		letters: "LNBCDFOGAHRVPKTMIXEYUQWJS",
		words: ["FRIVOL", "BAKES", "JET", "TYKES", "DATES", "WIPES", "GATES", "MIXES", "OPIUM", "GABON", "HATES", "QUIP", "CAKES"]
	}
},
{
	id: "3b9ceb53-134e-4457-a340-be336f33e9cc",
	dateId: "20281006",
	puzzle: {
		letters: "QAYTPNURESDKXVBOGLIHWJMCF",
		words: ["LIBERTY", "VESTRY", "QUARK", "FIXER", "WOK", "GLIB", "CHIVES", "STRAND", "PERK", "MIXER", "JOG"]
	}
},
{
	id: "a2d75121-f65e-46de-bc0e-49f62917168a",
	dateId: "20281007",
	puzzle: {
		letters: "YOBEDJXLPWCARNSHQMIKTUGFV",
		words: ["VIRAL", "BLEW", "CAJOLED", "HARPED", "SIGMA", "AXLE", "DEPLOY", "MINKS", "CHUG", "FINS", "IRAQ", "THUG"]
	}
},
{
	id: "a24ebc9d-29f8-4e58-9e81-5b9cae2e6bb5",
	dateId: "20281008",
	puzzle: {
		letters: "TJAYWMHVRFQULCBGIKXOSNPDE",
		words: ["HULKING", "THUGS", "BOXED", "FRAY", "MUGS", "DOCKING", "WRY", "QUIP", "JARL", "VARY"]
	}
},
{
	id: "eeb85513-21f9-4be6-977d-50e999e0ca35",
	dateId: "20281009",
	puzzle: {
		letters: "XSDYBTILKAJVRUQPOCENGFHWM",
		words: ["BAULKY", "DIVORCE", "OCULIST", "FORCE", "GORE", "WHORLS", "QUAY", "CERVIX", "JOG", "MERITS", "PORCH", "SIREN"]
	}
},
{
	id: "4ae82283-154f-4043-9587-0498a7adaae9",
	dateId: "20281010",
	puzzle: {
		letters: "PFMWCYLKGIBAESTVUQXONRHDJ",
		words: ["PLAQUES", "HUES", "AEGIS", "EXOTIC", "FLAKES", "WISELY", "JOTS", "BURN", "VALES", "DOSE", "QUALM"]
	}
},
{
	id: "83b26aca-2b59-4224-b52d-d6045ce4d035",
	dateId: "20281011",
	puzzle: {
		letters: "CXMBWFAKGOIVEHTJRPUQNYDSL",
		words: ["DREAM", "CAVERN", "MAKEUP", "FAKERY", "LUTHER", "SQUEAK", "BOW", "JIVE", "FAX", "GOTH"]
	}
},
{
	id: "c0a9dae6-9432-481b-b6dd-d578f43a18df",
	dateId: "20281012",
	puzzle: {
		letters: "BHPGXKRCEVYIDJWUNTOSQMALF",
		words: ["JOLT", "SLOWED", "MUNICH", "PRICED", "VEG", "INDEX", "QUIRKY", "FLOWED", "SOLANUM", "BRIDE"]
	}
},
{
	id: "d74a03c5-67a1-40ac-977e-dd31c2ac13f7",
	dateId: "20281013",
	puzzle: {
		letters: "QUASMTPCINFHKDLEWJOGVXYRB",
		words: ["BODKIN", "HEFT", "CHEWY", "QUACK", "SAILOR", "JOB", "VEX", "PAINS", "GLORY", "AIMS"]
	}
},
{
	id: "6cddc689-4fc8-4c00-8694-89b1c9cb846d",
	dateId: "20281014",
	puzzle: {
		letters: "LYFPVGAKEXSIRMDBHUOJCNQTW",
		words: ["PERISH", "BIKER", "JOT", "QUIRKY", "VEX", "CHROMED", "NUMERAL", "GLARED", "WORKED", "FARMED"]
	}
},
{
	id: "cf119231-2364-446d-993a-d12e5e0861c4",
	dateId: "20281015",
	puzzle: {
		letters: "TUCWJVIQPOYMSHBGEDAKRFLNX",
		words: ["MISHANDLE", "RESHOW", "QUIT", "JOB", "BASIC", "RELAX", "GREYISH", "FLANK", "PHASED", "VIMS"]
	}
},
{
	id: "64324a83-af89-4186-b9e4-3872db12cf8c",
	dateId: "20281016",
	puzzle: {
		letters: "BMPNQJOHUEVRGDASIKWLTXCYF",
		words: ["JOHN", "EUPHORIC", "STICKY", "LAUGH", "FLAW", "BOG", "SIX", "MORGUE", "LADEN", "VOGUE", "EQUAL"]
	}
},
{
	id: "3dd06129-073f-4386-a3b3-4a19d079b1d0",
	dateId: "20281017",
	puzzle: {
		letters: "TFJMVCUXIWQNESHDARYKGBLPO",
		words: ["MISERABLY", "MISREAD", "CUES", "WHISKY", "BRAG", "VIXEN", "POKY", "FUNERAL", "PLAQUES", "JUNE", "TUNERS"]
	}
},
{
	id: "2396a296-b396-4e77-8871-9f7e743d3df5",
	dateId: "20281018",
	puzzle: {
		letters: "YFQLGJOBUXCRTEPDHMVSWAKNI",
		words: ["GLUES", "KNIVES", "CROQUET", "THAW", "TROY", "THAMES", "FJORD", "ROBES", "SETUP", "CORTEX"]
	}
},
{
	id: "b672289d-3b22-4a9c-8445-cd5909f6b91e",
	dateId: "20281019",
	puzzle: {
		letters: "MPBJDKIOFEASVRLGUCNYQTWHX",
		words: ["FERNY", "WHY", "BORED", "TUGS", "QUASI", "SKIMP", "SORELY", "JOB", "IVORY", "LYNCH", "LYNX"]
	}
},
{
	id: "216893be-ddce-4b09-ab21-4a252f8f7091",
	dateId: "20281020",
	puzzle: {
		letters: "PJFDIOLSUMTHBKQERNAYVGCWX",
		words: ["ACRE", "BANGER", "QUIDS", "WAXY", "FLOP", "OTHER", "VERBS", "JOHN", "MUSKY"]
	}
},
{
	id: "f1c765db-c19e-44b2-957a-b46694c1756e",
	dateId: "20281021",
	puzzle: {
		letters: "MWBFXGYROJTVPAHEQUNCDILSK",
		words: ["QUIET", "PAUNCH", "CARVED", "FRANCS", "WRACK", "GYM", "LUNAR", "BOX", "JACKS"]
	}
},
{
	id: "3c8ea983-cd0e-4a73-b7bf-e58778befdaa",
	dateId: "20281022",
	puzzle: {
		letters: "FJIUQXEWNKLTBGDPAOHCYMRVS",
		words: ["TWIN", "JINGO", "CHORALE", "CHOMP", "SHOAL", "WINK", "VOTE", "FETAL", "WIND", "QUIET", "LATEX", "BELAY"]
	}
},
{
	id: "d248a479-5c55-4283-9f91-8c0b30ab7f94",
	dateId: "20281023",
	puzzle: {
		letters: "HLWSVDEOIYKPXCTBNUARGMQJF",
		words: ["JUNK", "ARTY", "VICAR", "GNU", "DEPOSIT", "QUARTIC", "COWLED", "NUMB", "HELD", "FAXED"]
	}
},
{
	id: "7c17d223-a49c-4d8a-ac1c-d9d29c153056",
	dateId: "20281024",
	puzzle: {
		letters: "WCHJXRVTBODEGPKIFASLUQMNY",
		words: ["MANLY", "AQUIFER", "BOPS", "WRETCH", "JOB", "MASK", "VEGANS", "DREAMS", "BOX"]
	}
},
{
	id: "e5e1e517-85fb-4508-945d-0ec65e5230d7",
	dateId: "20281025",
	puzzle: {
		letters: "YKDMFLSHEXORNAVCWIUGTPBQJ",
		words: ["GAINED", "CROWNED", "UNSHAVED", "FEDS", "MEANS", "JUNE", "BINS", "QUIP", "ENROLS", "AXED", "KHANS", "TWINED", "COSY"]
	}
},
{
	id: "82f053bf-8c74-44b1-868f-9a26cfd176aa",
	dateId: "20281026",
	puzzle: {
		letters: "ONHMDPJEAGXLBURICFSQWVKTY",
		words: ["BURST", "WICKS", "BAGMEN", "VILE", "MARQUE", "JEHAD", "HELIX", "PLEURA", "ONE", "BUSTY", "FLICKS"]
	}
},
{
	id: "a1fb7ccf-b14d-4acc-a2fb-a7bb744815c0",
	dateId: "20281027",
	puzzle: {
		letters: "BMWYPXOSDLFJRCTHUAEKQGNVI",
		words: ["QUAVERS", "DROWSY", "FJORDS", "DRAGNET", "JACKET", "HUNG", "MORE", "PLY", "BORE", "KIEV", "BOX"]
	}
},
{
	id: "30d5475a-ecaa-4e5b-8017-51c9ee2cbb4e",
	dateId: "20281028",
	puzzle: {
		letters: "HSLAVPOQUWTNBMRJECIGKXDYF",
		words: ["JET", "PHOBIC", "FIBULA", "SQUAW", "POTENCY", "IBEX", "KENT", "SLAV", "PHONED", "ALUM", "GIBED", "AURIC"]
	}
},
{
	id: "d8fef0f1-40e8-4c1e-b457-f0d14e196f68",
	dateId: "20281029",
	puzzle: {
		letters: "VHGNSLEORTUMFBJQIYAKWPDXC",
		words: ["PIQUE", "WIFE", "HOMY", "BACK", "ABORTS", "LEGHORNS", "VELUM", "FAX", "FORBAD", "JACK"]
	}
},
{
	id: "3d91f961-6ad3-4766-8546-903184f823cd",
	dateId: "20281030",
	puzzle: {
		letters: "JLWOCQAHKBUPMXDIGYEVTNSFR",
		words: ["PINGS", "JAMES", "BOWL", "NYMPH", "DEFY", "QUIP", "COWL", "REV", "SEXY", "PINT", "HAWK"]
	}
},
{
	id: "3f9b4c91-fd76-47be-a85c-f4ddfd40a706",
	dateId: "20281031",
	puzzle: {
		letters: "MRVJXDGONIHWFABQELYCUSTPK",
		words: ["VOWELS", "GROWLS", "BYTES", "QUEST", "INFORM", "CAFES", "DWELT", "FLACK", "BANJO", "WHELP", "JINX"]
	}
},
{
	id: "5d837651-4b30-40be-8372-8e537b8ef860",
	dateId: "20281101",
	puzzle: {
		letters: "YKLUQOBSTIJRPFNMAGVDCHXEW",
		words: ["CHARGED", "MAJORS", "CARPS", "INDEX", "DEW", "QUITS", "VEG", "SULKY", "FIND", "BORAX"]
	}
},
{
	id: "268a0c76-91b5-4a1f-86f6-c67c04bbc406",
	dateId: "20281102",
	puzzle: {
		letters: "QJETHUKRMSFIVYBLPDOCXANGW",
		words: ["LAPDOG", "COBS", "KIDNAP", "EMBODY", "FIRTH", "JERK", "IVY", "QUIRE", "WODAN", "FLAX"]
	}
},
{
	id: "8eb2a04d-de5f-4feb-85fa-744e5f23f946",
	dateId: "20281103",
	puzzle: {
		letters: "JXFDOALYWGBHTKNCEQSRPUVIM",
		words: ["RISQUE", "MISTY", "DOWNS", "RIVETS", "TECH", "BEHALF", "PETS", "RISKY", "JAB", "FLAX", "GOWNS"]
	}
},
{
	id: "9be2910e-8e4b-4312-9da8-944779ab33f4",
	dateId: "20281104",
	puzzle: {
		letters: "BFHVTPLINSYDEJGOCRXMWKAUQ",
		words: ["FLINTS", "RECODING", "DELHI", "QUACK", "VILER", "PLIED", "JERK", "BLED", "COW", "FINELY", "CODEX", "ARUM"]
	}
},
{
	id: "17828ee2-21d8-41a1-a49f-fb65bef83c0d",
	dateId: "20281105",
	puzzle: {
		letters: "SUOJYQWTDMNCHAKIFLVRGEBPX",
		words: ["FLATUS", "MARX", "BELCH", "JOT", "DOWN", "BEGIN", "PLATO", "LADY", "DARK", "VALE", "QUOTA"]
	}
},
{
	id: "ede3819a-1fb1-4339-9244-90be9936cafb",
	dateId: "20281106",
	puzzle: {
		letters: "PMYFJEDLIKSWXNAHCOUVBRQGT",
		words: ["BROWSED", "JINX", "GUANO", "CROWED", "MESH", "VAINLY", "KNOWS", "PEWS", "SCOUT", "QUAIL", "FILMED"]
	}
},
{
	id: "dff84794-9984-4c96-867b-eef9953a1c21",
	dateId: "20281107",
	puzzle: {
		letters: "TFQLVPSUWORCIBHYKJMDGEXAN",
		words: ["WISTFUL", "CUBIST", "BIKE", "OHMIC", "DAMN", "VOW", "EXAM", "KEG", "CUSP", "SPRY", "QUICK", "JAMB"]
	}
},
{
	id: "20d9ac79-160c-4b26-9333-fce4d801e3b5",
	dateId: "20281108",
	puzzle: {
		letters: "DPOMCBYQHSKEUGLJXNAWTIRFV",
		words: ["FARING", "CHUGS", "BENGAL", "CHOP", "WARING", "VAGUE", "EXIT", "OHMS", "DYKE", "JINX", "EQUALS"]
	}
},
{
	id: "2bfcffbe-02e8-4906-b66a-2bb90b5cc895",
	dateId: "20281109",
	puzzle: {
		letters: "WDGTYPAUNFMLQXIVRKSBJOEHC",
		words: ["MAGNIFY", "PALM", "CHEKOV", "JOKER", "GAUNT", "BING", "DAUNT", "UNFIX", "QUALM", "WALKER", "RESINY"]
	}
},
{
	id: "8b3a19ba-4382-4e83-932f-77dd91c75bb0",
	dateId: "20281110",
	puzzle: {
		letters: "MNQSLBOAUDPJGWYEVKIFCRTHX",
		words: ["CERTIFY", "VERTIGO", "SQUAWK", "FIX", "JERK", "PERTH", "GAUDY", "MOGULS", "BOGUS", "GUANO"]
	}
},
{
	id: "c904acf9-7c6e-4b93-b1e2-d5e2d47df1d5",
	dateId: "20281111",
	puzzle: {
		letters: "VAFXDYGRELBHCINOTUSWJMKQP",
		words: ["SQUIRE", "JOB", "DELICT", "CRISP", "DEFRAY", "VARIED", "FRISK", "RECTUM", "XRAY", "THRICE", "GRAVY", "LIENS", "WILDER"]
	}
},
{
	id: "0743f991-8ab0-44bc-9725-405cc8ef6609",
	dateId: "20281112",
	puzzle: {
		letters: "XKQCBFEURWHPAVTYILDGSMNJO",
		words: ["APEX", "DAUPHIN", "DOG", "TRAIN", "CURB", "QUALMS", "WRAP", "DAISY", "FEAR", "VAIN", "JOG", "PUKE"]
	}
},
{
	id: "1d109acc-394c-477b-8903-1f4f10bc80cc",
	dateId: "20281113",
	puzzle: {
		letters: "SGDEKBLPMVXOTAJUQRICNWHFY",
		words: ["TRAMPED", "JAPE", "GLORIFY", "CAMPED", "UNWRAP", "KEPT", "WHIR", "BLOT", "BOX", "PATROLS", "VAMPED", "QUOTA"]
	}
},
{
	id: "48ec4ae8-b85b-4957-8bb6-4c281ace586f",
	dateId: "20281114",
	puzzle: {
		letters: "CEUQJSRXOHKGTLPIYVANFDWBM",
		words: ["EXTOL", "VAPOURS", "QUOTA", "JOLT", "BAWDY", "SKID", "CRUXES", "DIGS", "NATO", "HOURS", "MALTY", "FIGS"]
	}
},
{
	id: "97a17915-0294-40ff-8510-4bb5a831a0c9",
	dateId: "20281115",
	puzzle: {
		letters: "TCQFMIUWHLXDVAKGJSNPYOBRE",
		words: ["FLAW", "QUIDS", "PENAL", "BOGY", "VANE", "KHANS", "PALM", "DUX", "CUDS", "JOBS", "DUCT", "RENAL"]
	}
},
{
	id: "8e348e89-e57d-4358-b8c1-8aac43cbe739",
	dateId: "20281116",
	puzzle: {
		letters: "BRANGDVQXJPLUEHCOSIYFMKWT",
		words: ["FOULS", "AXES", "HEX", "BRAN", "SKIT", "EQUITY", "JESUIT", "MOUSEY", "RANG", "CLOSE", "VAN", "POSIT", "WISE", "COULD"]
	}
},
{
	id: "81d7d9bb-3b96-4d3e-9b12-b8c0b526f1e0",
	dateId: "20281117",
	puzzle: {
		letters: "BXWEFKIDNVRSTUGMLQAYJOCHP",
		words: ["STUNG", "CHAP", "BIDE", "COLTS", "SQUAT", "FENDS", "UNWED", "SIX", "SKIRL", "JOLTS", "AUTISM", "ACHY", "VENDS"]
	}
},
{
	id: "3a323384-6fa3-44fb-a2fd-fc4b1fff18b5",
	dateId: "20281118",
	puzzle: {
		letters: "GBSRJLKUEOADQYFNCWMPHTXIV",
		words: ["BUYERS", "BLANCH", "CANT", "WIMPY", "FEUDAL", "JOEY", "MIX", "LACQUERS", "GLAND", "VIM", "BUSK"]
	}
},
{
	id: "be365322-a6a8-42f7-8322-b93eaed3160f",
	dateId: "20281119",
	puzzle: {
		letters: "VLGTPFOYEDWMCHXBIKAUSNJQR",
		words: ["ACOLYTE", "ACHED", "QUACK", "RACED", "JACK", "COMBS", "AXED", "VOW", "FOGEY", "PECK", "NICETY"]
	}
},
{
	id: "7dbc1315-4809-4126-9f22-987f92d66994",
	dateId: "20281120",
	puzzle: {
		letters: "FKDRNPEAYBQUMSCGILJOVHWXT",
		words: ["WHIMSY", "COX", "BRAKED", "VIMS", "QUAKED", "MASCOT", "FEAR", "DARN", "GUARD", "JOT", "PULSAR"]
	}
},
{
	id: "13af3de8-bfaf-4fc1-873e-abe3f14d4c40",
	dateId: "20281121",
	puzzle: {
		letters: "QGSKJUHPBAFITWOLNVDCMXERY",
		words: ["ABODE", "LIVERY", "SPHINX", "FINERY", "BAWDY", "CODER", "JABS", "PITHS", "FILM", "QUIVER", "THUGS", "OAKS"]
	}
},
{
	id: "e199324d-dde9-4488-b78d-b13ec0f06f56",
	dateId: "20281122",
	puzzle: {
		letters: "JGMTEBAKSWRUVLYQIFNOHDCXP",
		words: ["POLKA", "BRAG", "AURIC", "JAMS", "FLOP", "QUID", "YOLKS", "LYNX", "STEW", "HIC", "AVID"]
	}
},
{
	id: "90735e9d-ce7b-4103-93a4-383ca9c370ec",
	dateId: "20281123",
	puzzle: {
		letters: "JOXQUBDKELPVRYNMASITGFCHW",
		words: ["MACHINERY", "PARENT", "JOKERS", "BOXERS", "VARSITY", "GARISH", "QUERY", "DRYISH", "FARE", "LYRICS", "WINERY"]
	}
},
{
	id: "ef2f3186-10e8-4502-9600-74730cf47a69",
	dateId: "20281124",
	puzzle: {
		letters: "QSHYBUTWAJINKPMFXDROEVCLG",
		words: ["SWAB", "LORD", "EXITS", "CLOG", "KNIFE", "SQUINT", "SWAY", "SWAMP", "THAWS", "JAWS", "VEX"]
	}
},
{
	id: "680144c1-991a-4c9f-aea4-4449a7984cd3",
	dateId: "20281125",
	puzzle: {
		letters: "YQSXJUKMINHADLTBRCGEOWFPV",
		words: ["SQUAD", "MIDGET", "CRADLE", "SKY", "HAMLET", "BROW", "VELD", "JILT", "PELT", "GLINT", "ADMIX", "FRO"]
	}
},
{
	id: "0bb75b30-6f21-401b-80a7-c9ea0e982521",
	dateId: "20281126",
	puzzle: {
		letters: "NRTHPFOXQMWVSUJYKEIGBADCL",
		words: ["EDISON", "MUSED", "JUMP", "WORTH", "SQUEAKY", "ADIEUX", "JUICES", "BAKED", "GLIDES", "ROVED", "FORTH"]
	}
},
{
	id: "1029f1b3-37eb-4fdf-afdb-1521d7796af9",
	dateId: "20281127",
	puzzle: {
		letters: "RJOCTDHWBILKSUMENXAQPYVFG",
		words: ["AMBUSH", "ENVY", "BUSK", "DHOW", "QUASH", "ELKS", "COBS", "RHO", "GAMBIT", "FAX", "JOBS", "PENS"]
	}
},
{
	id: "7313e165-7c59-4c05-925f-531073c25637",
	dateId: "20281128",
	puzzle: {
		letters: "FSXYMHADLETBCKNQRIGJPUWOV",
		words: ["TRICKLE", "HACKNEY", "WICK", "JOG", "QUICKEN", "FABRIC", "VOW", "MELD", "AXLE", "SHACKLE", "PRICKLE"]
	}
},
{
	id: "7664665d-8a21-42dd-b984-914a41edf63f",
	dateId: "20281129",
	puzzle: {
		letters: "DGQJKMEUNCSFHLIVTBPORAXYW",
		words: ["TAX", "GEMS", "INQUEST", "BATHES", "ARTFUL", "BLOW", "JUNK", "PLOY", "BATHED", "CLINK", "VATS"]
	}
},
{
	id: "820993cf-c1f6-4447-846e-09946d7c86e7",
	dateId: "20281130",
	puzzle: {
		letters: "FGJRSHADOTMPNXBIULEKYCQWV",
		words: ["CLUMP", "VENDORS", "KELP", "GAD", "YULE", "ANEW", "FAD", "NEXT", "EQUIP", "MAJORS", "HADRON", "ADOBE"]
	}
},
{
	id: "a6484611-07a0-4a53-8c93-8824ff55406c",
	dateId: "20281201",
	puzzle: {
		letters: "FBDENQIJOGLUKYXPWCRMSVATH",
		words: ["WARMTH", "OXYGEN", "JOG", "PLUCKY", "BIDE", "FIB", "QUID", "VARY", "CRAWS"]
	}
},
{
	id: "6c817b4d-a0ed-4ed3-b5a2-44bd10c12725",
	dateId: "20281202",
	puzzle: {
		letters: "COVBPGSERMKWAINFHJUXYLTDQ",
		words: ["HAWKS", "DUN", "FLY", "GOVERN", "COVER", "JAWS", "THAWS", "BEAUX", "PRIES", "QUIRE", "VERMIN"]
	}
},
{
	id: "7aaffa37-d03b-47de-8fb3-8ef76feae16e",
	dateId: "20281203",
	puzzle: {
		letters: "BIXOPRQUFLKJSTCMWYVHDAGEN",
		words: ["FUSTY", "DAYS", "ENVY", "QUIRK", "GAWK", "CLOUTS", "THEN", "FOX", "POUTS", "SQUIB", "JUST", "SWAM"]
	}
},
{
	id: "42ec30b3-afc6-4e71-a55e-2e9813a8aed5",
	dateId: "20281204",
	puzzle: {
		letters: "FQANDUSYRXJCTHIWBEPGKOVLM",
		words: ["JUST", "HELM", "XRAYS", "PIGLETS", "VETS", "STRAND", "WOVE", "SCYTHE", "FUSTY", "WOK", "BETRAYS", "IRAQ"]
	}
},
{
	id: "348776e1-ddb0-47cc-992c-a297e7992518",
	dateId: "20281205",
	puzzle: {
		letters: "QHPSGOUALDVMNIBCREXFTKWJY",
		words: ["HUMANER", "HOME", "PLAIDS", "BLAME", "CREW", "QUALIFY", "JERK", "OVUM", "INERT", "GLIA", "FIXER"]
	}
},
]

export function getTodaysPuzzle() {
    const now = new Date();
    const dateId = "" + now.getFullYear() + (now.getMonth()+1).toString().padStart(2,"0") + now.getDate().toString().padStart(2, "0");

    const todayPuzzleArray = puzzles.filter((p) => {return p.dateId === dateId});

    if (todayPuzzleArray.length != 1) {
        // Always return a default puzzle
        return puzzles[0];
    }

    return todayPuzzleArray[0];
}
